<template>
  <div class="row">
    <div class="col-12 d-flex p-0 justify-content-between align-items-center">
      <div class="col-lg-3 col-sm-4">
        <!-- View switch: "Explorar" (folder tree) vs "Listar" (flat list of the
             user's documents). Both options are always visible side by side and
             the current one is highlighted in the brand green; this used to be a
             dropdown whose "Documentos" title duplicated the page title. -->
        <ul id="table_show" class="card-title2 cd-view-switch">
          <li>
            <button @click="onExploreView" type="button"
                    class="btn cd-view-switch__btn"
                    :class="{ 'is-active': !myDocs }">
              <i class="fas fa-folder-open mr-1"></i>
              {{$t("archivos_carpetas")}}
            </button>
          </li>
          <li>
            <button @click="getMyDocs ()" type="button"
                    class="btn cd-view-switch__btn"
                    :class="{ 'is-active': myDocs }">
              <i class="fas fa-file-alt mr-1"></i>
              {{$t("mis_documentos")}}
            </button>
          </li>
        </ul>
      </div>
      <div style="display: none" class="col-lg-6 mb-3">
        <div class="row">
          <div class="col-12 font14">
            {{$t("FiltrosBusq")}}
            <hr class="mt-1">
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4">
            <label for="">
              {{$t("name")}}
            </label>
          </div>
          <div class="col-lg-8">
            <form v-on:submit.prevent="onSearchFilter">
              <div class="mr-3 d-flex" >
                <input type="text" v-model="filter"  class="form-control  rounded-left rounded-0 border-muted"/>
                <span class="input-group-append" @click="onSearchFilter">
                  <div class="input-group-text  rounded-right rounded-0 bg-white border-left-0 border-muted">
                    <i class="fas fa-search"></i>
                  </div>
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!-- The search box belongs to this row in both views. It used to be
           rendered only for "Explorar" — "Listar" relied on the one DataTables
           draws on top of its own table — and that made the band change height
           when switching views: this row shrank to just the two buttons and an
           extra row with the search appeared further down. -->
      <div class="col-lg-auto nav py-1 h-40 d-flex justify-content-end ml-auto">
        <form id="searchForm" v-on:submit.prevent="onSearchFilter">
          <div class="float-right2 d-flex" >
            <input type="search" v-model="filter" @search="onSearchFilter" :placeholder="$t('Búsqueda')" class="form-control  rounded-left rounded-0 border-muted"/>
            <span class="input-group-append" @click="onSearchFilter">
              <div class="input-group-text  rounded-right rounded-0 bg-white border-left-0 border-muted">
                <i class="fas fa-search"></i>
              </div>
            </span>
          </div>
        </form>
      </div>
    </div>

    <div class="header-explorer col-12">

      <!-- v-if="user.rol_id == 1" -->

      <!-- Command bar: the create actions first, then the ones that act on the
           current selection, then the view controls. "+ Agregar" and "Vista
           documentos" used to be dropdowns, and there was a "select all"
           button: the list header already has its own checkbox for that, and
           the counter below clears the selection. -->
      <div class="cd-command-bar">
        <button @click="onShowModalFolder" type="button" class="btn cd-command-btn">
          <i class="fas fa-folder-plus mr-1"></i>
          {{$t("add_folder")}}
        </button>
        <button @click="onShowModalFile" type="button" class="btn cd-command-btn">
          <i class="fas fa-file-upload mr-1"></i>
          {{$t("add_file")}}
        </button>

        <!-- Everything that acts on the selection is grouped so that the bar
             sees one item instead of ten: it either fits beside the create
             actions, pushed against the right edge, or drops whole to a line of
             its own, which is what happens from a tablet down. Ungrouped, the
             group used to break wherever it ran out of room. -->
        <div class="cd-command-bar__selection">

          <!-- Clears the selection, so no permanent "unselect" button is
               needed. -->
          <button v-if="item.length > 0" @click="onUnSelectAll" type="button"
                  class="cd-command-count" :title="$t('unselect_all')">
            {{item.length}} {{$tc("selected_count", item.length)}}
            <i class="fas fa-times ml-2"></i>
          </button>
  
          <!-- From a tablet down every action for the selection is folded into
               this overflow menu instead of being listed one by one. Clearing
               the selection is not among them: that is what the counter beside
               this menu does. -->
          <base-dropdown v-if="isCommandBarCompact && item.length > 0" tag="div"
                         icon="fas fa-ellipsis-h" menu-align="left">
            <div class="d-flex">
              <ul class="actions_list">
                <li class="nav-item" @click="onDownloadZip">
                  <button type="button" class="btn-file btn mb-0 btn-light" >
                    <i class="fas fa-download mr-1__"></i>
                    {{$t("download")}}
                  </button>
                </li>
                <!-- Folders are renamed here too: the row menu of Explorar always
                     offered it for them, and leaving it out of the other two ways
                     in made the same folder renameable or not depending on the
                     view it was looked at from. -->
                <li class="nav-item" @click="onChangeName()" v-if="item.length == 1">
                  <button type="button" class="btn-file btn mb-0 btn-light">
                    <i class="fas fa-edit mr-1__"></i>
                    {{$t("change_name")}}
                  </button>
                </li>
                <li class="nav-item" @click="onDeleteAllFile" >
                  <button type="button" class="btn-file btn mb-0 btn-light">
                    <i class="fas fa-trash mr-1__"></i>
                    {{$t("Eliminar")}}
                  </button>
                </li>
                <li class="nav-item" @click="onMoveAll">
                  <button type="button" class="btn-file btn mb-0 btn-light">
                    <i class="fas fa-file-export mr-1__"></i>
                    {{$t("move_all")}}
                  </button>
                </li>
                <li class="nav-item" @click="onCopyAll">
                  <button type="button" class="btn-file btn mb-0 btn-light">
                    <i class="fas fa-copy mr-1__"></i>
                    {{$t("copy_to")}}
                  </button>
                </li>
                <li class="nav-item" @click="onShowTags" v-if="item.length > 1">
                  <button type="button" class="btn-file btn mb-0 btn-light">
                    <i class="fas fa-tag mr-1__"></i>
                    {{$t("Etiquetas")}}
                  </button>
                </li>
                <li class="nav-item" @click="onEditFolder" v-if="item.length == 1 && itemSelected.document_type_id == 1">
                  <button type="button" class="btn-file btn mb-0 btn-light" >
                    <i class="fas fa-info-circle mr-1__"></i>
                    {{$t("properties")}}
                  </button>
                </li>
                <li class="nav-item" @click="onShowComments" v-if="item.length == 1 && itemSelected.document_type_id != 1">
                  <button type="button" class="btn-file btn mb-0 btn-light" >
                    <i class="fas fa-comment-alt mr-1__"></i>
                    {{$t("Comments")}}
                  </button>
                </li>
                <li class="nav-item" @click="onShowProperties" v-if="item.length == 1 && isAdmin && itemSelected.document_type_id != 1">
                  <button type="button" class="btn-file btn mb-0 btn-light" >
                    <i class="fas fa-info-circle mr-1__"></i>
                    {{$t("properties")}}
                  </button>
                </li>
              </ul>
            </div>
          </base-dropdown>
  
          <button v-if="!isCommandBarCompact && item.length > 0" @click="onDownloadZip" type="button" class="btn cd-command-btn">
            <i class="fas fa-download mr-1"></i>
            {{$t("download")}}
          </button>
          <button v-if="!isCommandBarCompact && item.length == 1" @click="onChangeName()" type="button" class="btn cd-command-btn">
            <i class="fas fa-edit mr-1"></i>
            {{$t("change_name")}}
          </button>
          <button v-if="!isCommandBarCompact && item.length > 0" @click="onMoveAll" type="button" class="btn cd-command-btn">
            <i class="fas fa-file-export mr-1"></i>
            {{$t("move_all")}}
          </button>
          <button v-if="!isCommandBarCompact && item.length > 0" @click="onCopyAll" type="button" class="btn cd-command-btn">
            <i class="fas fa-copy mr-1"></i>
            {{$t("copy_to")}}
          </button>
          <button v-if="!isCommandBarCompact && item.length > 1" @click="onShowTags" type="button" class="btn cd-command-btn">
            <i class="fas fa-tag mr-1"></i>
            {{$t("Etiquetas")}}
          </button>
          <button v-if="!isCommandBarCompact && item.length == 1 && itemSelected.document_type_id == 1" @click="onEditFolder" type="button" class="btn cd-command-btn">
            <i class="fas fa-info-circle mr-1"></i>
            {{$t("properties")}}
          </button>
          <button v-if="!isCommandBarCompact && item.length == 1 && itemSelected.document_type_id != 1" @click="onShowComments" type="button" class="btn cd-command-btn">
            <i class="fas fa-comment-alt mr-1"></i>
            {{$t("Comments")}}
          </button>
          <button v-if="!isCommandBarCompact && item.length == 1 && isAdmin && itemSelected.document_type_id != 1" @click="onShowProperties" type="button" class="btn cd-command-btn">
            <i class="fas fa-info-circle mr-1"></i>
            {{$t("properties")}}
          </button>
          <button v-if="!isCommandBarCompact && item.length > 0" @click="onDeleteAllFile" type="button" class="btn cd-command-btn">
            <i class="fas fa-trash mr-1"></i>
            {{$t("Eliminar")}}
          </button>
        </div>
      </div>

      <div v-if="folders_.length">
        <h2>Carpetas</h2>
        <ul>
          <folder v-for="folder in folders_" :key="folder.id" :folder="folder" />
        </ul>
      </div>


      <div class="">
        <!-- Breadcrumb row: the path on the left and, on the right, the space
             used and the Lista/Mosaico switch, both of which describe the
             listing right below rather than the command bar above.

             The path itself is shown in both views: "Listar" works on the open
             folder too (getMyDocs sends the breadcrumbs to the API and reloads
             them), so the row says where the listing comes from. What belongs
             only to "Explorar" is hidden one by one below. -->
        <div class="cd-crumb-bar">
          <nav class="breadcrumbs">
            <ul id="breadcrumbs">
              <li @click="onPressRoot" class="pointer breadcrumb-item active text-uppercase font14 ">{{$t("INICIO")}} </li>
              <!-- Deep paths collapse into "INICIO > ... > parent > current":
                   the steps in between move into this menu instead of pushing
                   the row wider. -->
              <base-dropdown v-if="hiddenCrumbs.length" tag="li" menu-align="left"
                             class="breadcrumb-item cd-crumb-more">
                <template slot="title">
                  <span class="cd-crumb-more__dots">&hellip;</span>
                </template>
                <button v-for="bread in hiddenCrumbs" v-bind:key="bread.id" type="button"
                        @click="onSelectFolder (bread)"
                        class="btn-file btn mb-0 btn-light text-secondary">
                  <i class="fas fa-folder mr-1"></i>
                  {{bread.name}}
                </button>
              </base-dropdown>
              <li v-for="(bread,index) in shownCrumbs" @click="onSelectFolder (bread)" v-bind:key="bread.id" v-bind:class="{'text-purple': index+1 == shownCrumbs.length}" class="pointer breadcrumb-item active font14">{{bread.name}}</li>
              <!-- Reload belongs to the folder tree of "Explorar": "Listar" reloads
                   itself whenever the path changes. -->
              <li class="pointer text-rigth" v-if="!myDocs && selectFolder != 0">
                <button type="button" class="cd-icon-btn" @click="onRefresh" title="Recargar">
                  <i class="fas fa-sync-alt"></i>
                </button>
              </li>
              <li style="float:right; display: none" class="pointer text-rigth">

                <div v-if="loading || isAdmin" class="d-flex align-items-center gap-2">
                  <template v-if="s3Usage">
                      <span class="badge bg-secondary badge_custom">
                        {{ s3Usage.gigabytes }} GB
                      </span>

                    <div :disabled="loading" class="progress flex-grow-1" style="height: 20px; min-width: 100px;">
                      <div
                          class="progress-bar"
                          :class="progressColor"
                          :style="{ width: percentageUsed + '%' }"
                      >
                        {{ percentageUsed }}%
                      </div>
                    </div>
                  </template>

                  <button v-if="loading || isAdmin"
                          class="btn btn-sm btn-outline-secondary"
                          @click="getS3Usage"
                          :disabled="loading"
                  >
                    <i class="fas fa-hdd"></i>
                  </button>
                </div>


                <span style="display:none; background: transparent" class="btn-file mb-0 btn-light text-secondary">
                  <div v-if="s3Usage">
                    <p>Espacio utilizado: {{ s3Usage.gigabytes }} GB</p>

                    <div class="progress">
                      <div
                          class="progress-bar"
                          :class="progressColor"
                          role="progressbar"
                          :style="{ width: percentageUsed + '%' }"
                          :aria-valuenow="percentageUsed"
                          aria-valuemin="0"
                          aria-valuemax="100"
                      >
                        {{ percentageUsed }}%
                      </div>
                    </div>
                  </div>

                    <button
                        class="btn btn-sm btn-outline-secondary"
                        @click="getS3Usage"
                        :disabled="loading"
                    >
                      <i class="fas fa-hdd"></i>
                    </button>

                </span>
              </li>
            </ul>
          </nav>

          <div class="cd-view-tools">
            <!-- Space taken by every file together against the contracted space.
                 Administrators only (loadStorageUsage loads nothing for anyone
                 else). Shown in both views, unlike the switch beside it; hidden
                 while the tenant has no settings table. Refreshed by onRefresh,
                 which every upload, copy and deletion ends in. -->
            <span v-if="storageUsage" class="cd-view-tools__space cd-storage"
                  :class="storageLevelClass" :title="$t('storage_usage_title')">
              <i class="fas fa-hdd mr-1"></i>
              {{ $t("storage_usage", { used: storageUsage.used, limit: storageUsage.limit }) }}
              <span class="cd-storage__bar" aria-hidden="true">
                <span class="cd-storage__fill" :style="{ width: storageUsage.percent + '%' }"></span>
              </span>
            </span>
            <div v-show="!myDocs" class="cd-view-switch">
              <button @click="toggleList" type="button"
                      class="btn cd-view-switch__btn"
                      :class="{ 'is-active': !isToggled }">
                <i class="fas fa-list mr-1"></i>
                {{$t("compact_list")}}
              </button>
              <button @click="toggleMosaic" type="button"
                      class="btn cd-view-switch__btn"
                      :class="{ 'is-active': isToggled }">
                <i class="fas fa-th-large mr-1"></i>
                {{$t("mosaic_list")}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--<p>fileView: {{ fileView }}, show: {{ show }}</p>-->

    <!-- Only .border-bottom, not the full .border it used to carry: the card that
         wraps this view already draws a frame in its .card-body, so on the top, left
         and right sides the two boxes showed two lines 15px apart (three on the right,
         where the border-right of #page-content lands as well). The bottom one does
         stay: the .card-body stretches to the foot of the window and its own bottom
         border ends up far below the listing, so without this line the area was left
         open at the bottom. -->
    <div v-show="!myDocs" class="col-12 border-bottom">
      <div class="row h-600">
        <input type="checkbox" v-model="isDrawerOpen" class="menu-maker" name="menu-maker-id" id="menu-maker-id">
        <label for="menu-maker-id" class="menu-holder">
          <div class="hamburger">
            <div class="hamburger-toppings">
              <i class="fas fa-angle-double-right"></i>
            </div>
          </div>
        </label>
        <!--<input type="checkbox" id="drawer-left-toggle" name="drawer-left-toggle"/>
        <label for="drawer-left-toggle" id="drawer-left-toggle-label"></label>-->

        <!--<input :disabled="this.isRoot" :checked="!isMobile() && !this.isRoot" type="checkbox" class="menu-maker2" name="menu-maker-id2" id="menu-maker-id2">
        <label for="menu-maker-id2" class="menu-holder2">
          <div class="hamburger">
            <div class="hamburger-toppings">
              <i class="fas fa-angle-double-left"></i>
            </div>
          </div>
        </label>-->

        <!--<input type="checkbox" id="drawer-right-toggle" name="drawer-right-toggle"/>
        <label v-if="selectFolder != 0 || selectDropZone != '' " for="drawer-right-toggle" id="drawer-right-toggle-label"></label>-->

        <div id="drawer_left" class="border-right d-md-block directory">

          <div class="request d-sm-block" v-if="selectFolder != -1" >
            <div class="border-bottom">


              <!--<p>request_items: {{ request_items }}</p>-->

              <ul class="drawer_left_tabs nav nav-tabs">
                <li class="nav-item" >
                  <span class="nav-link2" @click="onShowDocumentsTab" v-bind:class="{'active' : !isRequestView}"><i class="fas fa-upload fa-fw"></i>{{$t("documents_tabs")}}</span>
                </li>
                <li v-if="itemSelected" class="nav-item">
                  <span class="nav-link2" @click="fileView=2" v-bind:class="{'active' : isRequestView}"><i class="fas fa-clipboard-list fa-fw"></i>{{$t("solicitud_tabs")}}</span>
                </li>
              </ul>
              <!-- Actions for the requested documentation. They lived inside the
                   tab list above, as two unlabelled icons that pushed the tabs
                   around and wrapped onto a second line. -->
              <div class="cd-panel-actions" v-if="isAdmin && (item.document_type_id == 1 && item.length == 1 || fileView == 2 && itemSelected)">
                <button type="button" class="cd-icon-btn"
                        :title="$t('edit')" :aria-label="$t('edit')"
                        @click="onEditDocumentation"
                        v-show="itemSelected.document_type_id == 1">
                  <i class="far fa-edit"></i>
                </button>
                <button type="button" class="cd-icon-btn"
                        :title="$t('download')" :aria-label="$t('download')"
                        v-if="fileView == 2 && itemSelected"
                        @click="onDownloadDocumentation('docx')">
                  <i class="fas fa-download"></i>
                </button>
              </div>
            </div>
          </div>
          <div  class="col-12 px-0 contentListItem ">

            <!-- Never bind :class on the treeview itself: Vue rewrites the whole class
                 attribute of that element when the binding changes, and that wiped the
                 classes Syncfusion writes itself (e-treeview, mytree...). With them
                 gone, every rule of the tree stopped applying until a reload. The
                 static ones travel through cssClass, which the component owns. -->
            <div class="control_wrapper" v-if="!isRequestView">
              <!-- Pinned folders of the user, stored in the API (at most
                   MAX_PINNED_FOLDERS). One quiet chip per folder: the chip opens it,
                   the cross beside it unpins. -->
              <section v-if="pinnedFolders.length" class="cd-pinned-folders"
                       :aria-label="$t('pinned_folders')">
                <p class="cd-pinned-folders__title">
                  <i class="fas fa-thumbtack"></i>
                  {{ $t("pinned_folders") }}
                </p>
                <div v-for="pin in pinnedFolders" :key="pin.id" class="cd-pinned-folder">
                  <button type="button" class="cd-pinned-folder__go"
                          :title="$t('go_to_pinned_folder') + ': ' + pin.name"
                          @click="onGoToPinnedFolder (pin.id)">
                    <i class="fas fa-folder cd-pinned-folder__pin"></i>
                    <span class="cd-pinned-folder__text">{{ pin.name }}</span>
                  </button>
                  <button type="button" class="cd-pinned-folder__unpin"
                          :title="$t('unpin_folder')" @click="unpinFolder (pin.id)">
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </section>

              <!-- TU TREEVIEW EXISTENTE -->
              <ejs-treeview v-if="show"
                            cssClass='mytree file-drop-tree'
                            ref="treeview"
                            id='treeview'
                            :fields="fields"
                            :loadOnDemand="true"
                            :enablePersistence="true"
                            :allowDragAndDrop="true"
                            :allowEditing='false'
                            :allowMultiSelection='true'
                            :nodeDragStop="onDragStop"
                            :nodeClicked='nodeClicked'
                            :nodeEdited='nodeEdited'
                            :dataBound='onTreeDataBound'
                            @nodeSelected="onSelectNode">
                <ejs-contextmenu id='contentmenutree'
                                 target='#treeview'
                                 :items='menuItems'
                                 :beforeOpen='beforeopen'
                                 :select='menuclick'>
                </ejs-contextmenu>
              </ejs-treeview>
            </div>
            <div @dragover.prevent="onRequestDragOver ($event, key)"
                 @dragleave.prevent="onRequestDragLeave ($event)"
                 @drop="onDrop(item)"
                 class="drop-zone row itemRequest cd-request-drop px-3"
                 :class="{ 'is-drag-over': dragOverRequest === key }"
                 v-else-if="isRequestView"  v-for="(item, key) in requestDocumentationItems" v-bind:key="key" >
              <div class="col-12 d-flex align-items-center pl-2 pr-1 py-1">
                <div class="w-100">
                  <div class="d-flex justify-content-between align-items-center">
                    <span class="item-request" @click="onSelectItemRequest (item)"><!--{{key + 1}}. -->{{item.name}}</span>
                    <div class="text-center col-2 p-0">
                      <i title="Eliminar" v-if="item.request_doc.length > 0" class="fas fa-trash pointer text-danger mr-2 text14" @click="onRemoveRequest (item)"></i>
                      <i title="Vincular" class="fas fa-link pointer cd-request-link text14" @click="onSelectRequest (item)"></i>
                    </div>
                  </div>
                  <div v-if="item.request_doc.length > 0" v-bind:key="key">
                    <div v-for="(req, index) in item.request_doc" :key="req.id || index" class="d-flex mr-3 cd-request-meta text-uppercase justify-content-between">
                      <label> <i class="fas fa-link mr-2"></i> {{req.user.name}}</label>
                      <label>{{$t("recibido")}}</label>
                      <!--<label>{{$moment(item.request_doc [0].created_at).fromNow()}}</label>-->
                      <label>{{$moment(req.created_at).format("DD/MM/YYYY HH:mm")}}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="display:none; position: absolute; top: 0" v-if="item.document_type_id == 1 && item.length == 1 || request_documentation.length > 0 &&  fileView == 2">
              <button class="border-0 btn-xs" @click="onEditDocumentation" v-if="isAdmin">
                <i class="far fa-edit fa-fw text-info"></i>
              </button>
            </div>
          </div>
          <div class="menu-btn"></div>
          <div id="display"></div>
        </div>
        <!-- No .border-right: it drew a line right next to the frame of the card, so
             the right side read as a double border. It separated nothing, the right
             drawer it sat against is display:none. -->
        <div id="page-content" class="treeview"
             @dragenter.prevent.stop="onListDragEnter"
             @dragover.prevent.stop="onListDragOver"
             @dragleave.prevent.stop="onListDragLeave"
             @drop.prevent.stop="onListDropFiles">
          <!-- Shown only while files coming from the desktop hover the listing. Its box
               is measured by _syncListDropRect instead of coming from the stylesheet, so
               it always matches the part of the pane on screen whatever the window size
               or the scroll position. It is pointer-events:none so it never steals the
               drop from the container. -->
          <div class="cd-list-drop-overlay" v-if="isListDrag && listDropStyle" :style="listDropStyle">
            <i class="fas fa-cloud-upload-alt"></i>
            <span>{{$t("drop_file_here")}}</span>
          </div>
          <div style="display:none" class="row">
            <div class="col-12">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb d-flex justify-content-between ">
                  <div class="d-flex align-items-center">
                    <li @click="onPressRoot" class="pointer breadcrumb-item active text-uppercase font14 ">{{$t("INICIO")}}</li>
                    <li v-for="(bread,index) in breadcrumbs" @click="onSelectFolder (bread)" v-bind:key="index" v-bind:class="{'text-purple': index+1 == breadcrumbs.length}" class="pointer breadcrumb-item active text-uppercase font14">{{bread.name}}</li>
                  </div>
                  <li class="pointer text-rigth" v-if="selectFolder != 0">
                    <button class="border-0 bg-gray" @click="onRefresh" title="Recargar">
                      <i class="fas fa-sync-alt text-secondary"></i>
                    </button>
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          <div class="row px-2">
            <div id="listView" v-if="!(isToggled)" class="col-lg-12 col-md-12 col-12 px-1 pointer">
              <table class="table table-hover">
                <thead>
                <tr>
                  <th @mouseover="selectTheader()"
                      @mouseleave="unSelectTheader()" align="left">
                    <label class="checkbox_label">
                      <input id="checkAll" type="checkbox" class="checkbox__input" v-model="selectAll">
                      <span class="checkbox__inner"></span>
                    </label>
                  </th>
                  <template v-for="(column,index)  in columns">
                    <!-- Column of its own for the icons of the row (comments,
                         linked request). They used to be stacked on top of the
                         icon of the file, where they covered it and were hard
                         to hit. It holds icons and not a value, so it has
                         neither a heading nor sorting. -->
                    <th class="cd-row-icons" v-if="column == 'name'" v-bind:key="'row-icons-'+index"></th>
                    <!-- The class names the column: the width of the name
                         column is set from variations.scss, and from another
                         file the position of a column is not something to lean
                         on (adding this very column moved it). -->
                    <th v-bind:key="index" :class="'cd-col-'+column">
                      <!-- The direction travels in the class so that the
                           chevron of variations.scss can point the right way:
                           orderedDocs sorts ascending when "reverse" is on. -->
                      <a href="#" @click.prevent=sortBy(column)
                         :class="{ active: isActive(column),
                                   'cd-sort-asc': isActive(column) && reverse,
                                   'cd-sort-desc': isActive(column) && !reverse }">
                        {{$t(column+"_thd")}}
                      </a>
                    </th>
                  </template>
                </tr>
                </thead>
                <tbody>
                <!-- While the row is being renamed it stops being draggable: with
                     draggable="true" the browser turns any drag of the pointer inside
                     the input into a drag of the row, so the name cannot be selected
                     with the mouse. -->
                <tr :draggable="editingId !== document.id" class="draggable-row"
                    @dragstart="onDragStart($event, document)" @dragend="onDragEnd"
                    :class="[document === selectedItem || item.includes(document.id) ? 'active' : '', { 'cd-row-dragging': draggingId === document.id, 'cd-row-drop-target': dropTargetId === document.id }]"
                    @mouseover="onRowHover($event, document)"
                    @contextmenu.prevent="onRowContextMenu($event, document)"
                    @dragover.prevent="onRowDragOver($event, document)"
                    @dragleave="onRowDragLeave($event, document)"
                    @drop.prevent="onRowDrop($event, document)"
                    @mouseleave="unSelectItem()" v-for="(document,index)  in orderedDocs" v-bind:key="index">
                  <td>
                    <!--<input v-if="document === hoverItem || item.includes(document.id)"  :checked="document === itemSelected" @change="onCheckItem ($event, document)" type="checkbox" v-model="item" :value="document.id"/>-->
                    <label class="checkbox_label">
                      <input v-on:click="toggleChecklist(document.id, $event, index)"
                             :checked="item.includes(document.id)"  @change="onCheckItem ($event, document, index)" type="checkbox" class="checkbox__input" v-model="item" :value="document.id"/>
                      <span class="checkbox__inner"></span>
                    </label>
                    <!--<input number type="checkbox" v-model="item" :value="document.id">-->
                  </td>
                  <td>
                    <div @click="document.document_type_id == 1 ? onSelectFolder (document) : onOpenDocument (document.id)" class="px-2 d-flex icon-stack">
                      <i v-if="document.document_type_id == 1" class="fas fa-folder folder-icon font25 "/>
                      <i v-else class="font30 e-list-icon font30"
                         :class="documentIconClass(document)"/>
                      <div class="floating-icons">
                        <span v-bind:id="'badge_list_'+document.id" v-if="document.document_type_id == 1"  class="badge bg-light">{{document.num_files}}</span>
                      </div>
                    </div>
                  </td>
                  <!-- The cell of the icons of the row. Both are a button and
                       nothing else lands here, so each one gets room around it
                       to be clicked comfortably. -->
                  <td class="cd-row-icons">
                    <i @click.stop="handleLinkClick($event,document)" class="fas fa-link cd-request-link" v-if="request_documentation.length > 0 && document.document_type_id != 1 && isDocumentLinked(document.id)"></i>
                    <i @click.stop="handleIconClick($event,document)" class="far fa-comment-dots cd-comment-icon" v-if="document.comments && document.comments.length > 0"></i>
                  </td>
                  <td :class="(document.active == 0) ? '':'no_active_row'">
                    <input style="width: 75%" ref="cellinput" :id = "'edit-cell-'+document.id" type="text" v-show="editingId === document.id"
                           v-model="editCell.name" @keyup.enter="updateName(document.id, document, null)" @keydown.esc="cancelEditing" @blur="onRenameBlur(document)">
                    <!--<div class="input-group">
                      <input :id = "'edit-cell-'+index" ref="cellinput" type="text" v-show="edit == true" v-model="cell" @focus="focused" @blur="edit = false" @keyup.enter="edit == false">
                    </div>-->
                    <!-- Two targets: the name itself opens the folder or the
                         document, and the rest of the cell marks the row. The
                         band is wider than the name, and with a single handler
                         on it clicking well past the text opened the document
                         too. -->
                    <div v-show="editingId !== document.id" class="ellipsis_label ellipsis first_td" @click="onSelectRow (document, index)">
                        <span class="font12 ellipsis_text" @click.stop="document.document_type_id == 1 ? onSelectFolder (document) : onOpenDocument (document.id)">
                          {{document.name}}
                        </span>
                    </div>
                    <div v-if="isMobile() || document === hoverItem || item.includes(document.id)" class="action_buttons">
                      <ul class="file_buttons">
                        <!--<li>
                          <button @click="onShowModalShareFolder($event, document)" type="button" class="">
                            <i class="fas fa-share-alt"></i>
                          </button>
                        </li>-->
                        <base-dropdown @change="onDropDown ($event, document)" icon="fas fa-ellipsis-h">
                          <div class="d-flex" v-if="itemSelected">
                            <ul class="actions_list">
                              <!--<li class="nav-item" @click="onEditFolder" v-if="isAdmin && itemSelected.document_type_id == 1">-->
                              <li class="nav-item" @click="onEditFolder" v-if="isAdmin && itemSelected.document_type_id == 1">
                                <button type="button" class="btn-file btn mb-0 btn-light" >
                                  <i class="fas fa-info-circle mr-1"></i>
                                  {{$t("properties")}}
                                </button>
                              </li>

                              <li class="nav-item" @click="onEditDocumentationDrop" v-if="itemSelected.document_type_id == 1">
                                <button type="button" class="btn_inline btn-file btn mb-0 btn-light" >
                                  <i class="fas fa-plus"></i>
                                  {{$t("item_request")}}
                                </button>
                              </li>
                              <li class="nav-item" @click="onShowComments" >
                                <button type="button" class="btn-file btn mb-0 btn-light" >
                                  <i class="fas fa-comment-alt mr-1"></i>
                                  {{$t("Comments")}}
                                </button>
                              </li>
                              <li class="nav-item" @click="onShowProperties" v-if="isAdmin && itemSelected.document_type_id != 1">
                                <button type="button" class="btn-file btn mb-0 btn-light" >
                                  <i class="fas fa-info-circle mr-1"></i>
                                  {{$t("properties")}}
                                </button>
                              </li>
                              <!-- Administrators only: sharing grants access to the
                                   folder, and contacts may not share. -->
                              <li class="nav-item" v-if="isAdmin">
                                <button @click="onShowModalShareFolder($event, document)" type="button" class="btn-file btn mb-0 btn-light" >
                                  <i class="fas fa-share mr-1"></i>
                                  {{$t("show_path")}}
                                </button>
                              </li>
                              <li class="nav-item" @click="copyPath(itemSelected)">
                                <button type="button" class="btn-file btn mb-0 btn-light" >
                                  <i class="fas fa-link mr-1"></i>
                                  {{$t("copy_path")}}
                                </button>
                              </li>

                              <li class="nav-item" @click="onChangeName(document)" >
                                <button type="button" class="btn-file btn mb-0 btn-light" >
                                  <i class="fas fa-edit mr-1"></i>
                                  {{$t("change_name")}}
                                </button>
                              </li>

                              <li class="nav-item" v-if="itemSelected.document_type_id != 1" @click="onShowSelectFolderModal(index, document, 1)" >
                                <button type="button" class="btn-file btn mb-0 btn-light" >
                                  <i class="fas fa-file-export mr-1"></i>
                                  {{$t("move_file")}}
                                </button>
                              </li>

                              <li class="nav-item" v-if="itemSelected.document_type_id == 1" @click="onShowSelectFolderModal(index, document, 1)" >
                                <button type="button" class="btn-file btn mb-0 btn-light" >
                                  <i class="fas fa-file-export mr-1"></i>
                                  {{$t("move_folder")}}
                                </button>
                              </li>

                              <li class="nav-item" v-if="itemSelected.document_type_id != 1" @click="onShowSelectFolderModal(index, document, 0)" >
                                <button type="button" class="btn-file btn mb-0 btn-light" >
                                  <i class="fas fa-copy mr-1"></i>
                                  {{$t("copy_file")}}
                                </button>
                              </li>

                              <li class="nav-item" v-if="itemSelected.document_type_id == 1" @click="onShowSelectFolderModal(index, document, 0)" >
                                <button type="button" class="btn-file btn mb-0 btn-light" >
                                  <i class="fas fa-copy mr-1"></i>
                                  {{$t("copy_folder")}}
                                </button>
                              </li>
                              <li class="nav-item" v-if="itemSelected.document_type_id != 1" @click="onDownloadFile" >
                                <button type="button" class="btn-file btn mb-0 btn-light" >
                                  <i class="fas fa-download mr-1"></i>
                                  {{$t("descargar")}}
                                </button>
                              </li>
                              <li class="nav-item" @click="onDeleteAllFile" >
                                <button type="button" class="btn-file btn mb-0 btn-light" >
                                  <i class="fas fa-trash mr-1"></i>
                                  {{$t("eliminar")}}
                                </button>
                              </li>
                              <!--<li class="nav-item" >
                                <button type="button" class="btn-file btn mb-0 btn-light" >
                                  <i class="fas fa-info-circle mr-1"></i>
                                  {{$t("administrar_acceso")}}
                                </button>

                              </li>
                              <li class="nav-item" >
                                <button type="button" class="btn-file btn mb-0 btn-light" >
                                  <i class="fas fa-info-circle mr-1"></i>
                                  {{$t("mover_a")}}
                                </button>

                              </li>
                              <li class="nav-item" >
                                <button type="button" class="btn-file btn mb-0 btn-light" >
                                  <i class="fas fa-info-circle mr-1"></i>
                                  {{$t("copiar_a")}}
                                </button>

                              </li>
                              <li class="nav-item" >
                                <button type="button" class="btn-file btn mb-0 btn-light" >
                                  <i class="fas fa-info-circle mr-1"></i>
                                  {{$t("avisarme")}}
                                </button>
                              </li>-->
                              <!--<li class="nav-item" >
                                <button type="button" class="btn-file btn mb-0 btn-light" >
                                  <i class="fas fa-info-circle mr-1"></i>
                                  {{$t("detalles")}}
                                </button>
                              </li>-->
                              <!--<li class="nav-item" @click="onDownloadZip">
                                <button type="button" class="btn-file btn mb-0 btn-light" >
                                  <i class="fas fa-download mr-1"></i>
                                  {{$t("download")}}
                                </button>
                              </li>-->
                            </ul>
                          </div>
                        </base-dropdown>
                      </ul>
                    </div>
                    <!-- The tags are read on a second line, under the name.
                         They come after the menu of the row, which is out of
                         flow and centred against the cell, so the line they
                         clear is the one of the name alone. -->
                    <div class="badge_tag">
                        <!--<multi-select
                            v-show="itemSelected && itemSelected.tag !== undefined"
                            v-model="itemSelected.tag"
                            :items="tags"
                            text-key="name"
                            value-key="id"
                            placeholder="Selecciona etiquetas..."
                            :required="true"
                            @change="onTagsChange"
                            @focus="isInteracting = true"
                            @blur="isInteracting = false"

                            @mousedown.stop
                            @click.stop
                        />-->
                      <span
                          v-for="id in getValidTags(document)"
                          :key="id"
                          class="badge"
                          :class="getTagInfo(id).class"
                      >
                        {{ getTagInfo(id).text }}
                      </span>

                    </div>
                  </td>
                  <!-- Empty for a folder and for anything the backfill has not
                       reached yet, rather than a "0 B" that would read as an
                       empty file. -->
                  <td class="cd-col-size" :class="(document.active == 0) ? '':'no_active_row'">
                    <span class="font12">{{ formatDocumentSize (document.size) }}</span>
                  </td>
                  <td class="cd-col-updated_at" :class="(document.active == 0) ? '':'no_active_row'">
                    <div>
                      <span style="display:none;">{{formatDateUnix(document.updated_at)}}</span>
                      <span class="font12 text-uppercase">
                          <!--{{ $moment(String(document.updated_at)).format('DD-MM-YYYY hh:mm')}}-->
                          {{formatDate(document.updated_at)}}
                        <!--{{getFormattedDate(document.updated_at)}}-->
                        <!--{{document.updated_at}}-->
                        </span>
                    </div>
                  </td>
                  <td class="cd-col-user" :class="(document.active == 0) ? '':'no_active_row'">
                    <!-- The column has a fixed width and cuts the name with an
                         ellipsis, so the whole name is offered in the tooltip. -->
                    <div :title="document.author ? document.author['name'] : ''">
                        <span class="font12 text-uppercase">
                          {{document.author ? document.author["name"] : '&nbsp;'}}
                        </span>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
              <pre style="display: none">
                {{ $data['selectEditDocFolder'] }}
              </pre>
              <pre style="display: none">
                {{ $data['selected'] }}
              </pre>
              <pre style="display: none">
                {{ $data['itemSelected'] }}
              </pre>
            </div>
            <div v-else id="gridView" class="col-lg-12">
              <div class="row d-flex align-items-center2">
                <div :title="document.name" @mouseover="selectItem(document)"
                     @mouseleave="unSelectItem()" class="col px-1 pointer mosaicBox" v-for="(document,index) in documents"  v-bind:key="index">
                  <!--<input type="checkbox" @change="onCheckItem ($event, document)" v-if="isAdmin && document.document_type_id == 1 || document.document_type_id != 1" class="ml-3" v-model="item" :value="document.id">-->
                  <label class="checkbox_label">
                    <input :checked="item.includes(document.id)"  @change="onCheckItem ($event, document, index)" type="checkbox" class="checkbox__input" v-model="item" :value="document.id"/>
                    <span class="checkbox__inner"></span>
                  </label>
                  <!--<input type="checkbox" @change="onCheckItem ($event, document)" class="ml-3 mosaic_checkbox" v-model="item" :value="document.id">-->

                  <div @click="editingId !== document.id ? document.document_type_id == 1 ? onSelectFolder (document) : onOpenDocument (document.id) : ''">
                    <div class="d-flex justify-content-center align-items-end cd-mosaic-icon-row">
                      <!--<i v-if="document.document_type_id == 1" data-icon-name="folderCoverLargeDefaultBack" aria-hidden="true" class="ms-FolderCover-back back_folder"><img src="https://res-1.cdn.office.net/files/fabric-cdn-prod_20220127.003/office-ui-fabric-react-assets/foldericons/lg-bg.svg"></i>
                      <i v-if="document.document_type_id == 1" data-icon-name="folderCoverLargeDefaultFront" aria-hidden="true" class="ms-FolderCover-front front_folder"><img src="https://res-1.cdn.office.net/files/fabric-cdn-prod_20220127.003/office-ui-fabric-react-assets/foldericons/lg-fg.svg"></i>-->
                      <i v-if="document.document_type_id == 1" class="fas fa-folder folder-icon font50 "/>
                      <i v-else class="font50 e-list-icon"
                         :class="documentIconClass(document)"/>
                      <!-- The same two icons as the row of the list, with the
                           linked request on top of the comments. In a tile
                           150px wide they are stacked instead of set side by
                           side, so that they take the height of the icon of
                           the file and not the width of the name. -->
                      <span class="cd-mosaic-icons">
                        <i @click.stop="handleLinkClick($event,document)" class="fas fa-link cd-request-link" v-if="request_documentation.length > 0 && document.document_type_id != 1 && isDocumentLinked(document.id)"></i>
                        <i @click.stop="handleIconClick($event,document)" class="far fa-comment-dots cd-comment-icon" v-if="document.comments && document.comments.length > 0"></i>
                      </span>
                      <span v-bind:id="'badge_'+document.id" v-if="document.document_type_id == 1"  class="badge bg-light">{{document.num_files}} </span>
                    </div>
                    <div :class="(document.active == 0) ? '':'no_active_row'" class="text-center ellipsis" >
                      <input style="width: 75%" ref="cellinput" :id = "'edit-cellM-'+document.id" type="text" v-show="editingId === document.id"
                             v-model="editCell.name" @keyup.enter="updateName(document.id, document, null)" @keydown.esc="cancelEditing" @blur="onRenameBlur(document)">
                      <!--<div class="input-group">
                        <input :id = "'edit-cell-'+index" ref="cellinput" type="text" v-show="edit == true" v-model="cell" @focus="focused" @blur="edit = false" @keyup.enter="edit == false">
                      </div>-->
                      <div v-show="editingId !== document.id" class="ellipsis_label ellipsis first_td" @click="document.document_type_id == 1 ? onSelectFolder (document) : onOpenDocument (document.id)">
                        <span class="font12 ellipsis_text">
                          {{document.name}}
                        </span>
                      </div>
                    </div>
                    <div :class="(document.active == 0) ? '':'no_active_row'" class="text-center">
                      <span style="display:none;">{{formatDateUnix(document.updated_at)}}</span>
                      <span class="font12 text-uppercase">
                          {{ $moment(String(document.updated_at)).format('DD-MM-YYYY hh:mm')}}
                        <!--{{formatDate(document.updated_at)}}_._-->
                        </span>
                    </div>
                    <!-- Empty for a folder, and the line keeps its height all
                         the same so the tiles of a row stay the same size. -->
                    <div :class="(document.active == 0) ? '':'no_active_row'" class="text-center cd-mosaic-size">
                      <span class="font12">{{ formatDocumentSize (document.size) }}</span>
                    </div>
                    <!-- Truncated with an ellipsis like the name of the file
                         (variations.scss), so the title carries the whole
                         name of the person for the cases where it does not
                         fit in the width of the tile. -->
                    <div :title="document.author ? document.author['name'] : ''"
                         :class="(document.active == 0) ? '':'no_active_row'" class="text-center cd-mosaic-author">
                        <span class="font12 text-uppercase">
                      {{document.author ? document.author["name"] : '&nbsp;'}}
                        </span>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <!-- Nothing to list. It sits outside both views so that the same
                 block serves the list and the mosaic: in the list it lands
                 under the header row, which is left in place on purpose (the
                 columns keep the listing recognisable, as OneDrive does). -->
            <div class="col-12 cd-empty-listing" v-if="isListingEmpty">
              <i class="cd-empty-listing__icon"
                 :class="isListingEmptyBySearch ? 'cd-empty-listing__icon--search' : 'cd-empty-listing__icon--folder'"></i>
              <p class="cd-empty-listing__title">
                {{ isListingEmptyBySearch ? $t("empty_search_title") : $t("empty_folder_title") }}
              </p>
              <p class="cd-empty-listing__hint">
                {{ isListingEmptyBySearch ? $t("empty_search_hint") : $t("empty_folder_hint") }}
              </p>
            </div>
          </div>
        </div>
        <div style="display:none" id="drawer_right">
          <div class="request d-sm-block" v-if="selectFolder != -1" >

            <div class="border-bottom">
              <ul class="drawer_right_tabs nav nav-tabs">
                <li class="nav-item" >
                  <span class="nav-link2" @click="onShowDocumentsTab" v-bind:class="{'active' : fileView==1}"><i class="fas fa-upload fa-fw"></i>{{$t("documents_tabs")}}</span>
                </li>
                <li v-if="itemSelected" class="nav-item">
                  <span class="nav-link2" @click="fileView=2" v-bind:class="{'active' : fileView==2}"><i class="fas fa-clipboard-list fa-fw"></i>{{$t("solicitud_tabs")}}</span>
                </li>
                <li v-if="item.document_type_id == 1 && item.length == 1 ||  fileView == 2 && itemSelected">
                  <button style="background-color: transparent" class="border-0" @click="onEditDocumentation" v-show="itemSelected.document_type_id == 1" v-if="isAdmin">
                    <i class="far fa-edit fa-fw text-secondary"></i>
                  </button>
                </li>
              </ul>
              <ul style="display: none" class="nav nav-tabs">
                <li class="nav-item border rounded-top" >
                  <span class="nav-link" @click="fileView=1" v-bind:class="{'active' : fileView==1}"><i class="fas fa-file-upload fa-fw"></i>{{$t("documents_tabs")}}</span>
                </li>
                <li class="nav-item border rounded-top" v-if="request_documentation.length > 0">
                  <span class="nav-link" @click="fileView=2" v-bind:class="{'active' : fileView==2}"><i class="fas fa-copy fa-fw"></i>{{$t("solicitud_tabs")}}</span>
                </li>
                <!--<li class=" p-2 d-flex justify-content-end" v-if="item.length == 1 &&  request_documentation.length >= 0 &&  fileView == 2">
                  <button class="border-0 btn-xs" @click="onEditDocumentation" v-if="isAdmin">
                    <i class="fas fa-plus text-success"></i>
                    {{$t("Add")}}
                  </button>
                </li>-->
                <li class=" p-2 d-flex justify-content-end" v-if="item.document_type_id == 1 && item.length == 1 || request_documentation.length > 0 &&  fileView == 2">
                  <button class="border-0 btn-xs" @click="onEditDocumentation" v-if="isAdmin">
                    <i class="fas fa-plus text-success"></i>
                    {{$t("Edit")}}
                  </button>
                </li>
              </ul>
            </div>
            <div  class="col-12 px-0 contentListItem ">
              <div v-if="fileView == 1">
                <vue-dropzone ref="dropzone" id="dropzone"
                              :options="dropzoneOptions"
                              :include-styling="true"
                              v-on:vdropzone-added-file="onDropzoneFileAdded"
                              v-on:vdropzone-error="uploadFileError"
                              v-on:vdropzone-success="uploadFileSuccess"
                              v-on:vdropzone-complete="fileComplete"
                              v-on:vdropzone-canceled="cancelFile"
                              v-on:vdropzone-queue-complete="UploadSuccess"
                              v-on:vdropzone-sending="sendingEvent"></vue-dropzone>
                <p class="cd-upload-hint">{{ uploadLimitsHint }}</p>
              </div>
              <div class="row itemRequest px-3" v-else-if="fileView == 2"  v-for="(item, key) in requestDocumentationItems" v-bind:key="key" >
                <div class="col-12 d-flex align-items-center pl-2 pr-1 py-1">
                  <div class="w-100">
                    <div class="d-flex justify-content-between align-items-center">
                      <span class="item-request" @click="onSelectItemRequest (item)"><!--{{key + 1}}. -->{{item.name}}</span>
                      <div class="text-center col-2 p-0">
                        <i title="Eliminar" v-if="item.request_doc.length > 0" class="fas fa-trash pointer text-danger mr-2 text14" @click="onRemoveRequest (item)"></i>
                        <i title="Vincular" class="fas fa-link pointer cd-request-link text14" @click="onSelectRequest (item)"></i>
                      </div>
                    </div>
                    <div class="d-flex mr-3 cd-request-meta text-uppercase justify-content-between" v-if="item.request_doc.length > 0" v-bind:key="key">
                      <label> <i class="fas fa-link mr-2"></i> {{item.request_doc [0].user.name}}</label>
                      <label> {{$t("recibido")}}</label>
                      <!--<label>{{$moment(item.request_doc [0].created_at).fromNow()}}</label>-->
                      <label>{{$moment(item.request_doc [0].created_at).format("DD/MM/YYYY")}}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div style="display:none; position: absolute; top: 0" v-if="item.document_type_id == 1 && item.length == 1 || request_documentation.length > 0 &&  fileView == 2">
                <button class="border-0 btn-xs" @click="onEditDocumentation" v-if="isAdmin">
                  <i class="far fa-edit fa-fw text-info"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="myDocs" class="col-12 boder">
      <div id="my_documents_list" class="col-lg-12 col-md-12 col-12 px-1 pointer">

        <table id="exampleFinal" class="display table table-hover" cellspacing="0">
          <thead>
          <tr>
            <th @mouseover="selectTheader()"
                @mouseleave="unSelectTheader()" align="left">
              <label class="checkbox_label2">
                <input id="checkAll" type="checkbox" class="checkbox__input" v-model="selectAll2">
                <span class="checkbox__inner"></span>
              </label>
            </th>
            <th>Tipo</th>
            <th>Nombre</th>
            <th>Tamaño</th>
            <th>Ruta</th>
            <th>Modificado</th>
            <th>Modificado por</th>
          </tr>
          </thead>
        </table>

        <table style="display:none" id="clientsDocs" class="table table-hover">
          <thead>
          <tr>
            <th @mouseover="selectTheader()"
                @mouseleave="unSelectTheader()" align="left">
              <label class="checkbox_label2">
                <input id="checkAll" type="checkbox" class="checkbox__input" v-model="selectAll2">
                <span class="checkbox__inner"></span>
              </label>
            </th>
            <th v-for="(column,index)  in columns2" v-bind:key="index">
              <a href="#" @click.prevent=sortBy(column) :class="{ active : isActive(column) }">
                {{$t(column+"_thd")}}
              </a>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr :class="document === selectedItem || item.includes(document.id) ? 'active' : ''" @mouseover="selectItem(document)"
              @mouseleave="unSelectItem()" v-for="(document,index)  in orderedDocsUser" v-bind:key="index">
            <td>
              <div class="custom-control custom-checkbox">
                <label class="checkbox_label">
                  <input v-on:click="toggleChecklist(document.id,$event, index)"
                         :checked="item.includes(document.id)"
                         @change="onCheckItem ($event, document, index)"
                         v-model="item"
                         type="checkbox"
                         :value="document.id"
                         class="checkbox__input"
                         :id="'checkbox_'+document.id"/>
                  <span class="checkbox__inner"></span>
                </label>
              </div>
            </td>
            <td>
              <div @click="document.document_type_id == 1 ? onSelectFolder (document) : onOpenDocument (document.id)" class="px-2 d-flex justify-content-center align-items-end">
                <i v-if="document.document_type_id == 1" class="fas fa-folder folder-icon font30 "/>
                <i v-else class="font30 e-list-icon font30"
                   :class="documentIconClass(document)"/>
                <i class="far fa-comment-dots cd-comment-icon" v-if="document.comments && document.comments.length > 0"></i>
                <span v-bind:id="'badge_list_'+document.id" v-if="document.document_type_id == 1"  class="badge bg-light">{{document.num_files}}</span>
              </div>
            </td>
            <td :class="(document.active == 0) ? '':'no_active_row'">
              <input style="width: 75%" ref="cellinput" :id = "'edit-cellL-'+document.id" type="text" v-show="editingId === document.id"
                     v-model="editCell.name" @keyup.enter="updateName(document.id, document, null)" @keydown.esc="cancelEditing" @blur="onRenameBlur(document)">
              <!--<div class="input-group">
                <input :id = "'edit-cell-'+index" ref="cellinput" type="text" v-show="edit == true" v-model="cell" @focus="focused" @blur="edit = false" @keyup.enter="edit == false">
              </div>-->
              <div v-show="editingId !== document.id" class="ellipsis_label ellipsis first_td" @click="document.document_type_id == 1 ? onSelectFolder (document) : onOpenDocument (document.id)">
                        <span class="font12 ellipsis_text">
                          {{document.name}}
                        </span>
              </div>
              <div v-if="isMobile() || document === hoverItem || item.includes(document.id)" class="action_buttons">
                <ul class="file_buttons">
                  <!--<li>
                    <button @click="onShowModalShareFolder($event, document)" type="button" class="">
                      <i class="fas fa-share-alt"></i>
                    </button>
                  </li>-->
                  <base-dropdown @change="onDropDown ($event, document)" icon="fas fa-ellipsis-h">
                    <div class="d-flex" v-if="itemSelected">
                      <ul class="actions_list">
                        <!--<li class="nav-item" @click="onEditFolder" v-if="isAdmin && itemSelected.document_type_id == 1">-->
                        <li class="nav-item" @click="onEditFolder" v-if="isAdmin && itemSelected.document_type_id == 1">
                          <button type="button" class="btn-file btn mb-0 btn-light" >
                            <i class="fas fa-info-circle mr-1"></i>
                            {{$t("properties")}}
                          </button>
                        </li>

                        <li class="nav-item" @click="onEditDocumentationDrop" v-if="itemSelected.document_type_id == 1">
                          <button type="button" class="btn_inline btn-file btn mb-0 btn-light" >
                            <i class="fas fa-plus"></i>
                            {{$t("item_request")}}
                          </button>
                        </li>
                        <li class="nav-item" @click="onShowComments" v-if="itemSelected.document_type_id != 1">
                          <button type="button" class="btn-file btn mb-0 btn-light" >
                            <i class="fas fa-comment-alt mr-1"></i>
                            {{$t("Comments")}}
                          </button>
                        </li>
                        <li class="nav-item" @click="onShowProperties" v-if="isAdmin && itemSelected.document_type_id != 1">
                          <button type="button" class="btn-file btn mb-0 btn-light" >
                            <i class="fas fa-info-circle mr-1"></i>
                            {{$t("properties")}}
                          </button>
                        </li>
                        <!--<li class="nav-item" >
                          <button @click="onSelectPathFolder (itemSelected)" type="button" class="btn-file btn mb-0 btn-light" >
                            <i class="fas fa-share mr-1"></i>
                            {{$t("Compartir Ruta")}}
                          </button>
                        </li>-->

                        <!-- Administrators only: sharing grants access to the
                             folder, and contacts may not share. -->
                        <li class="nav-item" v-if="isAdmin">
                          <button @click="onShowModalShareFolder($event, document)" type="button" class="btn-file btn mb-0 btn-light" >
                            <i class="fas fa-share mr-1"></i>
                            {{$t("show_path")}}
                          </button>
                        </li>
                        <li class="nav-item" @click="copyPath(itemSelected)">
                          <button type="button" class="btn-file btn mb-0 btn-light" >
                            <i class="fas fa-link mr-1"></i>
                            {{$t("copy_path")}}
                          </button>
                        </li>
                        <li class="nav-item" @click="onChangeName(document)" >
                          <button type="button" class="btn-file btn mb-0 btn-light" >
                            <i class="fas fa-edit mr-1"></i>
                            {{$t("change_name")}}
                          </button>
                        </li>

                        <li class="nav-item" v-if="itemSelected.document_type_id != 1" @click="onShowSelectFolderModal(index, document, 1)" >
                          <button type="button" class="btn-file btn mb-0 btn-light" >
                            <i class="fas fa-file-export mr-1"></i>
                            {{$t("move_file")}}
                          </button>
                        </li>
                        <li class="nav-item" v-if="itemSelected.document_type_id != 1" @click="onShowSelectFolderModal(index, document, 0)" >
                          <button type="button" class="btn-file btn mb-0 btn-light" >
                            <i class="fas fa-copy mr-1"></i>
                            {{$t("copy_file")}}
                          </button>
                        </li>
                        <li class="nav-item" v-if="itemSelected.document_type_id != 1" @click="onDownloadFile" >
                          <button type="button" class="btn-file btn mb-0 btn-light" >
                            <i class="fas fa-download mr-1"></i>
                            {{$t("descargar")}}
                          </button>
                        </li>
                        <li class="nav-item" @click="onDeleteAllFile" >
                          <button type="button" class="btn-file btn mb-0 btn-light" >
                            <i class="fas fa-trash mr-1"></i>
                            {{$t("eliminar")}}
                          </button>
                        </li>
                        <!--<li class="nav-item" >
                          <button type="button" class="btn-file btn mb-0 btn-light" >
                            <i class="fas fa-info-circle mr-1"></i>
                            {{$t("administrar_acceso")}}
                          </button>

                        </li>
                        <li class="nav-item" >
                          <button type="button" class="btn-file btn mb-0 btn-light" >
                            <i class="fas fa-info-circle mr-1"></i>
                            {{$t("mover_a")}}
                          </button>

                        </li>
                        <li class="nav-item" >
                          <button type="button" class="btn-file btn mb-0 btn-light" >
                            <i class="fas fa-info-circle mr-1"></i>
                            {{$t("copiar_a")}}
                          </button>

                        </li>
                        <li class="nav-item" >
                          <button type="button" class="btn-file btn mb-0 btn-light" >
                            <i class="fas fa-info-circle mr-1"></i>
                            {{$t("avisarme")}}
                          </button>
                        </li>-->
                        <!--<li class="nav-item" >
                          <button type="button" class="btn-file btn mb-0 btn-light" >
                            <i class="fas fa-info-circle mr-1"></i>
                            {{$t("detalles")}}
                          </button>

                        </li>-->
                        <!--<li class="nav-item" @click="onDownloadZip">
                          <button type="button" class="btn-file btn mb-0 btn-light" >
                            <i class="fas fa-download mr-1"></i>
                            {{$t("download")}}
                          </button>
                        </li>-->
                      </ul>
                    </div>
                  </base-dropdown>
                </ul>
              </div>
            </td>
            <td @click="onSelectPathFolder (document)" :class="(document.active == 0) ? '':'no_active_row'">
              <div>
                        <span class="font12 text-uppercase">
                          {{(document.folder_code)}}
                        </span>
              </div>
            </td>
            <td :class="(document.active == 0) ? '':'no_active_row'">
              <div>
                <span style="display:none;">{{formatDateUnix(document.updated_at)}}</span>
                <span class="font12 text-uppercase">
                          <!--{{formatDate3(document.updated_at)}}_*_-->
                          {{ $moment(String(document.updated_at)).format('DD-MM-YYYY hh:mm')}}

                        </span>
              </div>
            </td>

            <td :class="(document.active == 0) ? '':'no_active_row'">
              <div>
                        <span class="font12 text-uppercase">
                          {{document.author ? document.author["name"] : '&nbsp;'}}
                        </span>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- users_folder is NOT cleared on close: it is only ever filled once, by
         the getUsersFolder() call in data(), so emptying it here left this
         modal (and the user list of "editar carpeta") blank from the second
         time it was opened onwards. -->
    <modal class="cd-modal" v-if="showShareModal" :showClose="true" classContent="contentFolder" @close="onCloseShareModal()" :showBtnCancel="false" @accept="onAcceptShareFolder()" :disabledAccept="shareSaving" :title="shareTitle" :size="'xl'" :btnAcceptText="$t('Aceptar')">

      <!-- Who has the folder granted. Hidden when there is no folder to grant
           (a file at the root), where the dialog only sends the mail. -->
      <template v-if="shareFolderId">
        <label class="cd-form-label">{{ $t('share_access_title') }} ({{ shareAccessUsers.length }})</label>
        <ul class="cd-share-access">
          <li v-for="user in shareAccessUsers" :key="user.id"
              class="cd-share-access__item" :class="{ 'is-revoked': isShareRevoked (user.id) }">
            <div class="cd-share-access__who">
              <span>{{ user.name }}</span>
              <span class="email_txt italic_">{{ user.email }}</span>
            </div>
            <span v-if="isShareRevoked (user.id)" class="cd-share-access__tag">{{ $t('share_revoke_pending') }}</span>
            <button type="button" class="cd-share-access__btn" @click="toggleShareRevoke (user.id)"
                    :aria-pressed="isShareRevoked (user.id) ? 'true' : 'false'"
                    :aria-label="(isShareRevoked (user.id) ? $t('share_undo') : $t('share_disable')) + ': ' + user.name">
              {{ isShareRevoked (user.id) ? $t('share_undo') : $t('share_disable') }}
            </button>
          </li>
          <!-- When the list could not be loaded, saying nobody has the folder
               would be false: say that it is unknown instead. -->
          <li v-if="shareAccessFailed" class="cd-share-access__empty">{{ $t('share_access_unknown') }}</li>
          <li v-else-if="!shareAccessUsers.length" class="cd-share-access__empty">{{ $t('share_access_empty') }}</li>
        </ul>
        <label class="cd-form-label">{{ $t('share_with') }}</label>
      </template>

      <input type="search" class="form-control cd-users-search" v-model="searchTerm" :placeholder="$t('share_search_placeholder')">
      <div class="users_share cd-users-grid" id="users_folder_search">
        <div class="cd-users-item" v-for="user in shareUserList" :key="user.id"
             :class="{ 'is-disabled': isShareRevoked (user.id) }">
          <div class="cd-users-check">
            <input :id="'share_user_' + user.id" :value="Number (user.id)" v-model="shareCheckedIds"
                   :disabled="isShareRevoked (user.id)" type="checkbox" />
            <span></span>
          </div>
          <label :for="'share_user_' + user.id">
            {{user.name}}<span v-if="hasShareAccess (user.id)" class="cd-share-has-access">{{ shareAccessLabel (user.id) }}</span>
            <br><span class="email_txt italic_">{{user.email}}</span>
          </label>
        </div>
      </div>
      <!-- Read by copyLinkPath(), which flips it to type="text" to select and
           copy the path. -->
      <input type="hidden" class="float-left" id="path-code" :value="this.onPrintBreadcrumb()">
    </modal>

    <modal class="cd-modal" v-if="showModalRequiredDoc" :showClose="true" classContent="contentFolder" @close="showModalRequiredDoc=false" :showBtnCancel="false" @accept="document_type == 1 ? onSaveEditFolder () : onUploadDocument ()" :disabledAccept="!hasPendingRequestChanges" :title="titleModal" :size="'lg'" :btnAcceptText="$t('Guardar')">

      <base-select @change="onSelectTemplate" v-model="template_id" :items="templates" :label="$t('template')">
      </base-select>

      <div class="cd-req-add">
        <base-input type="text" autocomplete="false" v-model="item_request"/>
        <button class="btn btn-primary" @click="onAddRequest">
          {{$t("add")}}
        </button>
      </div>

      <div style="display: none">
        {{request_items}}
      </div>
      <div class="cd-req-list" v-if="request_items.length > 0">
        <draggable
            :list="request_items"
            :disabled="!enabled"
            class="list-group"
            ghost-class="cd-req-ghost"
            @change="log"
            @start="dragging = true"
            @end="dragging = false"
        >
          <div class="list-group-item cd-req-item d-flex justify-content-between align-items-center"  v-for="(element,index) in request_items" :key="index" v-bind:class="{'cd-req-item-index' : element.isIndex}">
            <div v-show="editOffset != index"
                 class="list-group-item-heading cd-req-item-name">
              <a href="#" class="cd-req-edit" @click.prevent="startEditing(index)">
                <i class="fas fa-edit"></i>
              </a>
              <span>{{ element.name }}</span>
            </div>
            <input v-show="editOffset==index" type="text"
                   :id = "'item-user-'+index"
                   @keydown.enter="updatePost" @keydown.esc="cancelEditing"
                   class="form-control cd-req-edit-input" v-model="editPost.name">
            <button class="btn cd-req-delete" @click="deleteEvent (element, index)">
              <i class="fas fa-times-circle"></i>
            </button>
          </div>
        </draggable>
      </div>
    </modal>

    <modal class="cd-modal" v-if="showSelectFolderModal" :showClose="true" classContent="contentFolder" @close="showSelectFolderModal=false; showFolderTree = false; onUnSelectAll();" :showBtnCancel="false" @accept="onMoveDoc(docIdMoveCopy, docMoveCopy, move_copy)" :title="titleModal" :size="'lg'" :btnAcceptText="titleBtnAccept+docNameMoveCopy">
      <div class="cd-folder-tree">
        <ejs-treeview id='treeview' :loadOnDemand="false" :showCheckBox='false' :nodeClicked='nodeChecked' :keyPress='nodeChecked' v-if="show" ref='treeview' :fields="fields"></ejs-treeview>
      </div>
      <div v-if="!move_copy">
        <hr />
        <base-input id="folderName2" @input="createFolderCode()" type="text" :validated="$v.name.$error" :label="$t('name_folder')" autocomplete="false" v-model="name">
          <template v-slot:textError v-if="$v.name.$error && !$v.name.required"> {{$t('Campo_requerido')}}</template>
        </base-input>
      </div>

    </modal>

    <modal id="folderModal" class="cd-modal" v-if="showModal" :showClose="true" :classContent="document_type == 1 ? 'contentFolder cd-modal-body-tall' : 'contentFolder cd-modal-body-tall cd-modal-body-upload'" @close="showModal=false; showFolderTree = false; newFolderTags = [];" :showBtnCancel="false" @accept="document_type == 1 ? onSaveFolder () : onUploadDocument ()" :title="titleModal" :size="'xl'" :btnAcceptText="$t('Guardar')">
      <!-- <template> rather than a <div>: it renders no element, so the .row
           below stays a direct child of .modal-body and the rule that flattens
           its gutters (variations.scss) reaches it. -->
      <template v-if="document_type == 1">

        <div class="row">
          <div class="col-6" >
            <base-input id="folderName" @input="createFolderCode()" type="text" :validated="$v.name.$error" :label="$t('name_folder')" autocomplete="false" v-model="name">
              <template v-slot:textError v-if="$v.name.$error && !$v.name.required"> {{$t('Campo_requerido')}}</template>
            </base-input>
          </div>
          <div v-show="isAdmin" class="col-6" >
            <!-- The picker only holds the choice: nothing is sent until the Save
                 button of the modal is pressed. Creating, there is no folder to
                 attach them to yet anyway; editing, writing straight away left a
                 form with a Save button that had already saved itself. onSaveFolder
                 stores them once the folder exists and has an id. -->
            <multi-select
                label="Etiquetas"
                v-model="newFolderTags"
                :items="tags"
                text-key="name"
                value-key="id"
                placeholder="Selecciona etiquetas..."
                :required="true"
            />
          </div>
        </div>

        <div v-show="isAdmin">
          <div v-if="!isNew" class="check_noti form-group">
            <hr />
            <label class="cd-form-label">Activar notificaciones para los usuarios:</label>
            <input type="search" class="form-control cd-users-search" v-model="searchTerm">
            <div class="users_folder_list cd-users-list" id="users_folder_noti_search">
              <table id="users_folder_not" width="100%" class="flexy_">
                <tbody width="100%">
                <tr v-for="user in filteredData" :key="user.id">
                  <td>
                    <div class="cd-users-check">
                      <input :id="user.id" :value="user.id" v-model="checkedUsersId" @click="selectUserCheck($event)" type="checkbox" />
                      <span></span>
                    </div>
                    <label :for="user.id">
                      {{user.name}}<br><span :key="index" class="italic_">{{user.email}}</span>
                    </label>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <input id="file" class="d-none" multiple type="file" :accept="uploadAccept" @change="_onFileUpload" />
        <label for="file" class="cd-upload-drop" :class="{'is-dragging': isExternalDrag}"
               @dragenter.prevent.stop="_onDragEnterDrop"
               @dragover.prevent.stop
               @dragleave.prevent.stop="_onDragLeaveDrop"
               @drop.prevent.stop="_onDropFiles">
          <i class="fas fa-upload"></i>
          <span>{{ isExternalDrag ? $t("drop_file_here") : $t("selected_file") }}</span>
        </label>
        <p class="cd-upload-hint">{{ uploadLimitsHint }}</p>
        <div class="invalid-feedback" v-if="error">{{$t('Campo_requerido')}}</div>
        <div class="cd-upload-list" v-if="files.length > 0">
          <div class="cd-upload-item" v-for="(file,key) in files" v-bind:key="key">
            <div class="cd-upload-name">
              <i class="fas fa-file"></i>
              <span class="fileText">{{file.name}}</span>
              <span class="cd-upload-size">({{ _formatSize (file.size) }})</span>
            </div>
            <i class="fas fa-times-circle cd-upload-remove" @click="_onRemoveFile(key)"></i>
          </div>
        </div>
        <p class="cd-upload-total" v-if="files.length > 0">{{ uploadTotalLabel }}</p>
      </template>
    </modal>
    <modal class="cd-modal" v-if="showModalComments" :showfooter="false" :showClose="true" :title="this.$t('Comments')" :size="'lg'" @close="onCloseModal">
      <!-- The id stays: scrollToBottom() looks this container up by it. -->
      <div id="container_comment" class="cd-comments">
        <p class="cd-comments-loading" v-if="isLoadingComments">
          <i class="fa fa-spinner fa-spin"></i>
          {{$t("loading_comments")}}
        </p>
        <div id="commentsList" v-else-if="comments.length > 0">
          <div class="cd-comment" v-for="(item, index) in comments" v-bind:key="index">
            <span class="cd-comment-avatar" v-if="item.user" :title="item.user.name">
              {{getInitials (item.user.name)}}
            </span>
            <div class="cd-comment-body">
              <div class="cd-comment-bubble">{{item.comment}}</div>
              <div class="cd-comment-date">{{item.created_at | moment("calendar")}}</div>
            </div>
          </div>
        </div>
        <p class="cd-comments-empty" v-else>{{$t("sn_comments")}}</p>
      </div>

      <div class="invalid-feedback cd-comment-error" v-if="error_comment">
        {{$t("Campo_requerido")}}
      </div>

      <div class="cd-comment-compose">
        <textarea class="form-control" v-model="comment_text" rows="2"></textarea>
        <button class="btn btn-primary" :disabled="isSavingComment" @click="onSaveComment">
          <i class="fa fa-spinner fa-spin" v-if="isSavingComment"></i>
          <i class="fas fa-paper-plane" v-else></i>
          {{$t("Comentar")}}
        </button>
      </div>
    </modal>
    <modal class="cd-modal" v-if="showProperties" :showfooter="true"  :showClose="true" :title="this.$t('properties')" :size="'md'" :btnAcceptText="$t('Guardar')" :showBtnCancel="false" @close="showProperties=false" @accept="onSaveProperties ()">
      <step-document style="display: none" :document="itemSelected"  @refreshStatus="onShowProperties"></step-document>

      <div class="cd-prop-row">
        <span class="cd-form-label">{{$t("SOLO LECTURA")}}</span>
        <div class="cd-prop-value">
          <base-checkbox :checked="itemSelected.active ? true : false" @input="toggleActiveCheckBox (itemSelected)" />
        </div>
      </div>

      <hr>

      <div class="cd-prop-row">
        <span class="cd-form-label">{{$t("RUTA")}}</span>
        <div class="cd-prop-value">
          {{this.onPrintBreadcrumb()}}
        </div>
      </div>

      <hr>

      <div class="cd-prop-row">
        <span class="cd-form-label">{{$t("Etiqueta")}}</span>
        <div class="cd-prop-value cd-prop-value-wide">
          <!-- Held in propertiesTags until the Save button of the modal is pressed
               (onSaveProperties); picking a tag no longer stores it by itself. -->
          <multi-select
              v-if="itemSelected"
              v-model="propertiesTags"
              :items="tags"
              text-key="name"
              value-key="id"
              placeholder="Selecciona etiquetas..."
              :required="true"
          />
        </div>
      </div>

      <hr>

      <div class="cd-prop-block">
        <span class="cd-form-label">{{$t("HISTORIAL")}}</span>
        <!-- .checkStep is what the per-status icons hang off (the
             ".checkStep li:has(> span[title=...])" rules in this file), so the
             class stays even though its name says nothing about a history
             list. .cd-prop-history carries the v2 restyling. -->
        <div class="checkStep cd-prop-history">
          <ul>
            <li v-for="(item, index) in history" v-bind:key="index">
                    <span v-if="item.user" :title="item.status.name">
                      {{item.status.name}} por <strong>{{item.user.name}}</strong> el <strong>{{item.created_at | moment("DD/MM/YYYY") }}</strong> a las <strong>{{item.created_at | moment("H:mm") }}</strong>
                    </span>
            </li>
          </ul>
        </div>
      </div>

    </modal>

    <modal id="modalTags" class="cd-modal" v-if="showTags" :showfooter="true"  :showClose="true" :title="this.$t('Etiquetas')" :size="'md'" :btnAcceptText="$t('Guardar')" :showBtnCancel="false" @close="showTags=false" @accept="onSaveTagsAll ()">
      <!-- Held in bulkTags until the Save button of the modal is pressed
           (onSaveTagsAll); picking a tag no longer tags the whole selection by
           itself. -->
      <multi-select
          label=""
          v-model="bulkTags"
          :items="tags"
          text-key="name"
          value-key="id"
          placeholder="Selecciona etiquetas..."
          :required="false"
      />
    </modal>

    <dialog-loader v-if="showProgress"
                   :progress="progress"
                   :total="uploadTotal"
                   :done="uploadDone"
                   :file-name="uploadFileName"
                   :finished="uploadFinished"
                   ref="dialogLoader"></dialog-loader>
  </div>
</template>

<script>

// Widest viewport still treated as a tablet, in px. Up to here the folder
// panel, which is 340px wide, starts collapsed so the listing gets the room.
const TABLET_MAX_WIDTH = 993;

// Widest viewport at which the actions on the selection are folded into the
// overflow menu instead of being listed one by one, in px.
//
// The bar tolerates two rows: the actions on the selection are a group of their
// own and drop below the create ones as soon as they do not fit beside them
// (see .cd-command-bar__selection in variations.scss). So what has to be folded
// is not "the bar does not fit in one row" but the row after that: the group no
// longer fitting in a single row of its own, which is when it starts breaking
// into pieces.
//
// In Spanish, the longest of the three languages, the widest case (a single
// file selected as an admin: the counter plus seven actions) needs some 940px
// of row, and the bar only gets the viewport minus the 260px sidebar and the
// padding of its column, about 320px in all.
const COMMAND_BAR_MAX_WIDTH = 1280;

// Folders a user can pin above the tree. The API enforces the same limit
// (PinnedFoldersController::MAX_PINNED); this one only shapes the menu.
const MAX_PINNED_FOLDERS = 4;

// Componente recursivo para renderizar las carpetas
const Folder = {
  props: ['folder'],
  data() {
    return {
      isLoading: false,
      children: [],
      documents: [],
      loaded: false
    };
  },
  methods: {
    async toggleTagsSelect45(item) {
      try {
        const { data } = await this.$axios.post('/update-tag', {
          id: item.id,
          tag: item.tag
        });

        if (data.success) {
          //console.log('Tag actualizado correctamente');
        } else {
          console.error('Error:', data.message);
        }
      } catch (error) {
        console.error('Error en la petición:', error);
      }
    },
    // Función recursiva para cargar documentos de una carpeta y cargar subcarpetas
    async loadDocuments() {
      if (this.loaded) return; // Evita cargar de nuevo si ya se han cargado los documentos

      this.isLoading = true;
      try {
        //const response = await axios.get(`/folders/${this.folder.id}/documents`);
        //this.documents = response.data;
        this.loaded = true;

        // Ahora verificamos si tiene subcarpetas y cargamos de manera recursiva
        const subfolders = await this.fetchSubfolders(this.folder.id);
        for (let subfolder of subfolders) {
          const subfolderComponent = {
            id: subfolder.id,
            name: subfolder.name,
            parent_id: subfolder.parent_id
          };
          const subfolderData = await this.loadSubfolderDocuments(subfolderComponent);
          this.children.push(subfolderData);
        }

        this.isLoading = false;
      } catch (error) {
        console.error('Error loading documents:', error);
        this.isLoading = false;
      }
    },

    // Fetch subfolders for a specific folder
    async fetchSubfolders(parentId) {
      try {
        const response = await axios.get('/folders');
        return response.data.filter(folder => folder.parent_id === parentId);
      } catch (error) {
        console.error('Error fetching subfolders:', error);
        return [];
      }
    },

    // Function to load documents for a subfolder
    async loadSubfolderDocuments(subfolder) {
      const subfolderWithDocs = { ...subfolder, documents: [] };
      const docs = await axios.get(`/folders/${subfolder.id}/documents`);
      subfolderWithDocs.documents = docs.data;
      return subfolderWithDocs;
    }
  },
  template: `
    <li>
    <div>
      <span>{{ folder.name }}</span>
      <span v-if="isLoading">Cargando...</span>
    </div>
    // Si ya se cargaron documentos, los mostramos
    <ul v-if="documents.length > 0">
      <li v-for="doc in documents" :key="doc.id">{{ doc.name }}</li>
    </ul>
    // Mostrar subcarpetas cargadas recursivamente
    <ul v-if="children.length > 0">
      <li v-for="child in children" :key="child.id">
        <span>{{ child.name }}</span>
        <ul>
          <li v-for="doc in child.documents" :key="doc.id">{{ doc.name }}</li>
        </ul>
      </li>
    </ul>
    </li>
  `
};

import $ from 'jquery';
import _ from 'lodash';
//import moment from 'moment';
import moment from 'moment/moment'
import 'moment/locale/es'  // without this line it didn't work
//import Accordion from "@/components/Accordion.vue";
import Modal from "@/components/Modal.vue";
import StepDocument from "@/components/StepDocument.vue";
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import dialogLoader from "@/components/dialogLoader.vue";
import draggable from 'vuedraggable';
import vue2Dropzone from 'vue2-dropzone';
import axios from "axios";
const vuex = JSON.parse (localStorage.getItem ('vuex'));
const token = `Bearer ${vuex.login.token}`;
const tableColumns = ['request_type', 'insolvency', 'honoraries', 'created_at' , 'status', 'options', 'download'];
// Extensions the "Agregar Documentos" modal accepts. Single source of truth: the file
// input builds its accept attribute from this list, and dropped files are checked
// against it too, because the browser does not enforce accept on drag & drop.
const ALLOWED_UPLOAD_EXTENSIONS = [
  'pdf', 'jpeg', 'jpg', 'png', 'gif', 'mp4', 'zip', 'mp3',
  'txt', 'doc', 'xls', 'ppt', 'docx', 'xlsx', 'pptx', 'csv', 'rar'
];
// The icon of the listing is picked by document_type_id, but some extensions share a
// type and have a sprite of their own: a .rar is an archive (type 5) just like a .zip
// and must not show up with the icon of the zip. Here the extension wins over the type.
const EXTENSION_ICON_CLASS = {
  rar: 'e-fe-rar'
};
// Upload limits, enforced here instead of relying on the server: the effective value
// there depends on the php.ini / .htaccess of each installation and they do not agree
// with each other, so the rule lives in one place and the user is warned before a
// single byte travels. 150 MB per file, 500 MB for everything queued together.
const MAX_FILE_SIZE = 150 * 1024 * 1024;
const MAX_UPLOAD_SIZE = 500 * 1024 * 1024;


import { Document, Packer, Paragraph, Table, TableRow, TableCell, WidthType, TextRun } from "docx";
import { saveAs } from "file-saver";

import MultiSelect from './Inputs/MultiSelect.vue';

// Steps of the path that fit before the breadcrumb starts collapsing.
const CRUMBS_VISIBLE = 3;
import { dataTableLengthMenu, dataTableEsLanguage, enhanceDataTableLength } from '../mixins';
import { fileErrorHandling, downloadFileName } from '../utils/fileErrors';
import { handleLimitError, showLimitDialog, formatStorage, STORAGE_LIMIT } from '../utils/limitErrors';

// From these percentages of the contracted space the indicator turns amber, then red.
const STORAGE_WARN_PERCENT = 80;
const STORAGE_FULL_PERCENT = 95;
import { formatSize, formatDocumentSize } from '../utils/fileSize';


export default {
  mixins: [fileErrorHandling],
  computed: {
    // The requested-documentation modal only defers two things to its Save button:
    // the items added inside the modal (isNew) and the removal of the previous list
    // when a template is picked. Renaming and deleting an item already hit the API
    // on the spot, so without either of these there is nothing left to send.
    hasPendingRequestChanges () {
      return this.changeTemplate || (this.request_items || []).some ((item) => item.isNew);
    },
    isPinLimitReached () {
      return this.pinnedFolders.length >= MAX_PINNED_FOLDERS;
    },
    // The contracted-space indicator of the crumb bar. Null while there is no
    // figure to show: not loaded yet, or a tenant with no settings table.
    storageUsage () {
      if (!this.storage || !this.storage.limit_size) return null;

      const used = this.storage.size_used || 0;
      const limit = this.storage.limit_size;

      return {
        used    : formatStorage (used),
        limit   : formatStorage (limit),
        // The exact share, not rounded: rounding made 99,8% read as a full bar
        // while there was still room for a file.
        percent : Math.min (100, used / limit * 100),
      };
    },
    storageLevelClass () {
      if (!this.storageUsage) return null;
      if (this.storageUsage.percent >= STORAGE_FULL_PERCENT) return "cd-storage--full";
      if (this.storageUsage.percent >= STORAGE_WARN_PERCENT) return "cd-storage--warn";
      return null;
    },
    // Porcentaje de uso
    percentageUsed() {
      if (!this.s3Usage) return 0;

      const maxGB = 100; // Puedes modificar este valor según tu límite

      let percent = (this.s3Usage.gigabytes / maxGB) * 100;

      return Math.min(percent.toFixed(2), 100);
    },

    // Clase de color según porcentaje
    progressColor() {
      const p = this.percentageUsed;

      if (p < 50) return "bg-success";
      if (p < 80) return "bg-warning";
      return "bg-danger";
    },
    // Help text of the upload areas. It is built from the constants that _addFiles
    // checks, so the figure on screen cannot drift away from the one enforced.
    uploadLimitsHint () {
      return this.$t ("upload_limits_hint", {
        file: this._formatSize (MAX_FILE_SIZE),
        batch: this._formatSize (MAX_UPLOAD_SIZE),
      });
    },
    // Weight of the whole queue next to the limit it is measured against: this is the
    // figure that decides whether one more file still fits.
    uploadTotalLabel () {
      const total = this.files.reduce ((sum, file) => sum + file.size, 0);
      return this.$t ("upload_total", {
        total: this._formatSize (total),
        max: this._formatSize (MAX_UPLOAD_SIZE),
      });
    },
    // Items listed by the Solicitudes panel. A group (isIndex) is a heading that only
    // organises the template, and nothing can be linked to it, so it belongs in the
    // "Añadir documentación solicitada" modal and not here.
    requestDocumentationItems () {
      if (!Array.isArray (this.request_documentation)) return [];
      return this.request_documentation.filter ((item) => !item.isIndex);
    },
    // The Solicitudes tab only exists while a folder is selected (itemSelected),
    // but fileView could stay at 2 without it -- at the root, for instance --
    // leaving the requests list on screen with no tab marked. The tabs and the
    // panel read this instead of fileView on its own.
    isRequestView () {
      return this.fileView == 2 && !!this.itemSelected;
    },
    // accept attribute for the upload input, derived from ALLOWED_UPLOAD_EXTENSIONS.
    uploadAccept() {
      return ALLOWED_UPLOAD_EXTENSIONS.map ((extension) => `.${extension}`).join (',');
    },
    cell: {
      get: function() {
        return this.value
      },
      set: function(newCellValue) {
        this.$emit('input', isNaN(newCellValue) ? newCellValue : parseInt(newCellValue))
      }
    },
    // Users of the share dialog who can open the folder already, each with the
    // label that says why. Granted here wins over any inherited reason.
    // filteredData for the share dialog, once per user: users_folder has a row
    // per company, and a user in two of them showed twice under the same id,
    // so ticking one ticked both. filteredData itself is left as it is, since
    // "Editar carpeta" uses it too.
    shareUserList() {
      const seen = new Set ();
      return this.filteredData.filter ((user) => {
        const id = Number (user.id);
        if (seen.has (id)) return false;
        seen.add (id);
        return true;
      });
    },
    shareAccessLabels() {
      const labels = new Map ();
      this.shareInherited.forEach ((reason) => {
        labels.set (Number (reason.user_id), this.shareReasonLabel (reason));
      });
      this.shareAccessUsers.forEach ((user) => {
        labels.set (Number (user.id), this.$t ('share_via_here'));
      });
      return labels;
    },
    filteredData() {
      const folder = this.users_folder;

      if (!Array.isArray(folder)) return []; // <-- evita el error

      if (!folder.length) return []; // <-- evita acceso a [0]

      return folder.filter(entry =>
          Object.keys(folder[0]).some(key =>
              ('' + entry[key]).toLowerCase().includes(this.searchTerm.toLowerCase())
          )
      );
    },

    filteredData23() {
      return this.users_folder
          .filter(
              (entry) => this.users_folder.length
                  ? Object.keys(this.users_folder[0])
                      .some(key => ('' + entry[key]).toLowerCase().includes(this.searchTerm.toLowerCase()))
                  : true
          );
    },
    selectAll: {
      get: function () {
        // The length comparison alone reported "all selected" for an empty
        // folder (0 == 0), so the header checkbox came up ticked over a
        // listing with nothing in it to select.
        if (!this.documents || !this.documents.length) return false;
        return this.item.length == this.documents.length;
      },
      set: function (value) {
        var selected = [];

        if (value) {
          this.documents.forEach(function (user) {
            selected.push(user.id);
          });
        }

        this.item=selected;

        //this.selected = selected;
      }
    },
    selectAll2: {
      get: function () {
        // Same guard as selectAll: an empty listing is not "all selected".
        if (!this.documentsUser || !this.documentsUser.length) return false;
        return this.item.length == this.documentsUser.length;
      },
      set: function (value) {
        var selected = [];

        if (value) {
          this.documentsUser.forEach(function (user) {
            selected.push(user.id);
          });
        }

        this.item=selected;

        //this.selected = selected;
      }
    },
    // An empty folder used to render as a bare header row over blank space,
    // which reads exactly like a listing that failed to load. It is said out
    // loud instead, in both views of "Explorar" (list and mosaic).
    //
    // Only a real empty array counts: "documents" is null until the first
    // fetch of the parent page lands, and answering "this folder is empty"
    // while the request is still in flight would be wrong.
    isListingEmpty: function () {
      return Array.isArray (this.documents) && this.documents.length === 0;
    },
    // The search of "Explorar" is server side and scoped to the open folder
    // (see onSearchFilter), so the listing that comes back empty is already
    // the filtered one: saying "the folder is empty" there would be a lie.
    isListingEmptyBySearch: function () {
      return this.isListingEmpty && !!this.filter;
    },
    // Breadcrumb: a path deeper than CRUMBS_VISIBLE keeps only its last two
    // steps on screen and folds the rest into the "..." menu, so a long path
    // stops widening the row. The root ("INICIO") is not part of this array:
    // it is always rendered on its own.
    shownCrumbs: function(){
      if (this.breadcrumbs.length <= CRUMBS_VISIBLE) return this.breadcrumbs;
      return this.breadcrumbs.slice(-2);
    },
    hiddenCrumbs: function(){
      if (this.breadcrumbs.length <= CRUMBS_VISIBLE) return [];
      return this.breadcrumbs.slice(0, -2);
    },
    orderedDocs: function(){
      if (!this.documents) return [];
      return _.orderBy(this.documents, this.sortKey, this.reverse ? "asc" : "desc");
    },
    orderedDocsUser: function(){
      return _.orderBy(this.documentsUser, this.sortKey, this.reverse ? "asc" : "desc");
      //return this.documentsUser;
    },
    /*selectAll: {
      get: function () {
        console.log(this.selected.length);
        return this.item ? this.selected.length == this.item.length : false;
      },
      set: function (value) {
        var selected = [];

        if (value) {
          this.item.forEach(function (user) {
            selected.push(user.id);
          });
        }

        this.selected = selected;
      }
    },
    orderedDocs: function(){
      //return _.orderBy(this.documents, this.sortKey, this.reverse ? "asc" : "desc");
      return this.item.slice().sort();
    },*/
    ...mapGetters({
      user: 'login/user',
    })
  },
  data ()
  {
    return {

      estructuraCopiada: null,   // aquí guardas la estructura
      puedePegarEstructura: false,

      // Whether the actions on the selection are folded into the overflow menu
      // of the command bar. The viewport is the criterion, not the user agent:
      // isMobile() misses any Android or Windows tablet that does not announce
      // itself as one, and it also fires on a desktop-width window as soon as
      // devtools spoofs the agent, which is how the buttons and the menu ended
      // up on screen at the same time.
      isCommandBarCompact: window.matchMedia (`(max-width: ${COMMAND_BAR_MAX_WIDTH}px)`).matches,
      // True from a tablet down, where the folder panel floats over the listing
      // instead of pushing it aside.
      isTabletDown: window.matchMedia (`(max-width: ${TABLET_MAX_WIDTH}px)`).matches,
      // Whether the folder panel (Documentos/Solicitudes) is open. It is 340px
      // wide and pushes the listing aside, so from a tablet down it starts
      // collapsed and the listing gets the whole width. watchBreakpoints keeps
      // this in step with the viewport from here on.
      isDrawerOpen: !window.matchMedia (`(max-width: ${TABLET_MAX_WIDTH}px)`).matches,

      // True while files coming from outside the browser hover the upload drop area.
      isExternalDrag: false,
      // dragenter/dragleave fire for every child element, so they are counted instead
      // of toggled: the drop area only turns off when the counter is back to zero.
      dragCounter: 0,

      // Same pair as above, for the listing itself: files dropped straight on the open
      // folder are uploaded without going through the "Agregar" modal.
      isListDrag: false,
      listDragCounter: 0,
      // Box of the drop frame in viewport coordinates, filled in by _syncListDropRect.
      // It lives here because the overlay is position:fixed and cannot get its size
      // from the stylesheet.
      listDropStyle: null,

      // Rows dragged inside the listing: the id of the row on the move, so it can be
      // dimmed while it travels, and the index of the request it is hovering, so that
      // request lights up as the drop target. draggedRow (set in onDragStart) carries
      // the payload itself and is not used from the template, so it stays out of here.
      draggingId: null,
      dragOverRequest: null,

      folders_: [],
      searchTerm: '',
      searchQuery: null,
      edit: false,
      table:
          {
            columns: [...tableColumns],
            columnsAttachment :
                [
                  'name',
                  'created_at',
                  'url'
                ],
            columnsUser :
                [
                  'name',
                  'position',
                  'Email',
                  'active',
                  'edit_event',
                  'delete_event'
                ]
          },
      tableAttachment : [],
      users_folder: this.getUsersFolder(),
      // State of the share dialog, see onShowModalShareFolder. It has its own
      // title because titleModal is not reactive (it is not declared here), and
      // this one changes while the dialog is open.
      shareTitle: '',
      shareSaving: false,
      shareSession: 0,
      shareAccessFailed: false,
      shareFolderId: null,
      shareAccessUsers: [],
      shareInherited: [],
      shareRevokeIds: [],
      shareCheckedIds: [],
      isAllSelected: false,
      selectedUserIds: [1,2],
      checkedUsersId: [],
      checkedEmailUsersId: [],
      structureCopyData: null,   // Aquí guardamos la estructura copiada
      structureCopyBaseId: null, // ID de la carpeta donde se copió
      // Menu of a row currently pinned to the pointer (see onRowContextMenu), kept so
      // its inline position can be undone when it closes.
      rowContextMenuEl : null,
      // True only while the right click is opening that menu.
      openingRowMenu : false,
      // Folder to reopen in the tree after it is rebuilt (see refreshTree).
      treeContextToRestore : null,
      // Folder a deep link (?path=) asked for, see openLinkedFolder.
      linkedFolderId : null,
      // Folder of the listing the pointer is hovering with something in hand.
      dropTargetId : null,
      // Node the context menu was opened over. Right-clicking does not select in the
      // treeview, so without this the menu acted on whatever node happened to be
      // selected instead of the folder under the pointer.
      ctxNodeId : null,
      menuItems : [
        { text: 'Fijar carpeta', id: 'pin' },
        { separator: true },
        { text: 'Añadir Carpeta' },
        { text: 'Renombrar Carpeta' },
        { text: 'Borrar Carpeta' },
        { separator: true },
        { text: 'Subir archivo', id: 'upload' },
        { text: 'Copiar Estructura', id: 'copiar_estructura' },
        { text: 'Pegar Estructura', id: 'pegar_estructura', disabled: true }
      ],
      index : 1,
      iconClass: {
        2 : 'e-fe-pdf',
        3 : 'e-fe-docx',
        4 : 'e-fe-image',
        5 : 'e-fe-zip',
        6 : 'e-fe-pptx',
        7 : 'e-fe-xlsx',
        8 : 'e-fe-music',
        9 : 'e-fe-video',
        10 : 'e-fe-txt',
        11 : 'e-fe-msg',
      },
      fileTypes: {
        'application/pdf' : 2,
        'image/bmp'       : 4,
        'image/jpg'       : 4,
        'image/jpeg'      : 4,
        'image/png'       : 4,
        'image/gif'       : 4,
        'video/mp4'       : 9,
        'audio/mpeg'      : 8,
        'audio/mp3'       : 8,
        'text/plain'      : 10,
        'application/zip' : 5,
        'application/x-zip-compressed' : 5,
        // Browsers disagree on the MIME type of a RAR: Chrome sends
        // application/vnd.rar and Firefox application/x-rar-compressed.
        'application/vnd.rar' : 5,
        'application/x-rar-compressed' : 5,
        'application/x-rar' : 5,
        'application/msword' : 3,
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document' : 3,
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template' : 3,
        'application/vnd.oasis.opendocument.spreadsheet' : 3,
        'application/vnd.oasis.opendocument.text' : 3,
        'application/rtf' : 3,
        'application/vnd.ms-powerpoint' : 6,
        'application/vnd.openxmlformats-officedocument.presentationml.presentation' : 6,
        'application/vnd.ms-excel'  : 7,
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'  : 7,
        'application/vnd.ms-excel.sheet.macroEnabled.12' : 7,
        'text/csv'  : 7,
        'msg'  : 5
      },
      dropzoneOptions2:{
        // url: 'http://localhost/clevergestweb/public/api/v1/documents/upload_file',
        //url: 'http://localhost/cleverdocs_backend21/public/api/v1/documents/upload_file',
        url: '/public/api/v1/documents/upload_file',
        addRemoveLinks: true,
        removeFile:true,
        parallelUploads: 5,
        //timeout: 99999999,
        //previewTemplate: this.template(),
        //includeStyling: true,
        /*renameFile: function (file) {
          //file.name = new Date().getTime() + '_' + file.name; // results in Uncaught TypeError: Cannot assign to read only property 'name' of object '#<File>'
          // or
          //file.upload.filename = new Date().getTime() + '_' + file.name; // results in Uncaught TypeError: Cannot set property 'filename' of undefined

          const specialCharactersRegex = "'";
          const charactersString = file.name;
          if (charactersString.match(specialCharactersRegex)){
            return charactersString.replace("'", "");
          }else{
            return charactersString;
          }

        },*/
        /*renameFile: function (file){
          var belge = document.getElementById('belge').value;

          var radios = document.getElementsByName('gender');
          for(var i = 0, length = radios.length; i < length; i++){
            if(radios[i].checked){
              var radio = radios[i].value;
            }
          }

          let newName = belge + '_' + radio + '_' + file.name;
          return newName;
        },*/
        maxFilesize: 52783171,
        createImageThumbnails: true,
        autoProcessQueue: true,
        //uploadMultiple: 200,
        autoQueue: true,
        dictCancelUploadConfirmation : "¿Estás seguro de que deseas cancelar esta carga?",
        dictDefaultMessage: "<i class='fas fa-file-upload mr-2'></i>Arrastre el archivo",
        headers: { "Authorization": token }
      },
      dropzoneOptions: {
        //url: 'http://localhost/cleverdocs_backend21/public/api/v1/documents/upload_file',
        url: '/public/api/v1/documents/upload_file',
        thumbnailWidth: 75,
        timeout: 99999999,
        // The dropzone of the Documentos panel is a second way in, so it enforces the
        // same per-file limit as the modal. Dropzone takes it in MB.
        maxFilesize: MAX_FILE_SIZE / (1024 * 1024),
        dictFileTooBig: "Cada archivo puede pesar como máximo {{maxFilesize}} MB ({{filesize}} MB)",
        thumbnailHeight: 75,
        addRemoveLinks: true,
        removeFile:true,
        /*renameFile: function (file) {
          let newName = new Date().getTime() + '_' + file.name;
          return newName;
        },*/
        renameFile: function (file) {
          //const specialCharactersRegex = /[^\w\s]/;
          const specialCharactersRegex = "'";
          const charactersString = file.name;
          if (charactersString.match(specialCharactersRegex)){
            return charactersString.replace("'", "");
          }else{
            return charactersString;
          }
          //return new Date().getTime() + '_' + file.name;
        },
        /*renameFile: function (file) {
          var dt = new Date();
          var time = dt.getTime();
          return time + file.name;
        },
        acceptedFiles: ".jpeg,.jpg,.png,.gif",
        timeout: 60000,
        success: function (file, response) {
          console.log(response);
        },
        error: function (file, response) {
          console.log(response);
          console.log(file);
          return false;
        },*/
        //previewTemplate: this.template(),
        //includeStyling: true,
        //parallelUploads: 20,
        //uploadMultiple: 20,
        //maxFiles: 20,
        // maxFilesize: 50,
        createImageThumbnails: true,
        autoProcessQueue: true,
        //autoQueue: true,
        dictCancelUploadConfirmation : "¿Estás seguro de que deseas cancelar esta carga?",
        dictDefaultMessage: "<i class='fas fa-file-upload mr-2'></i>Arrastre el archivo",
        headers: { "Authorization": token }
      },
      enabled: true,
      isIndex : false,
      dragging: false,
      folders : [],
      showModal : false,
      showShareModal: false,
      document_type : null,
      name : null,
      error : false,
      files : [],
      selectFolder : 0,
      selectEditDocFolder: 0,
      selectDropZone: 0,
      sfolder : {},
      documents : [],
      //itemSelected : null,
      itemDocRequired: null,
      item : [],
      request_documentation : [],
      breadcrumbs : [],
      isAdmin : false,
      isNew : true,
      comments : [],
      showModalComments : false,
      isLoadingComments : false,
      isSavingComment : false,
      comment_text : null,
      error_comment : false,
      document_status : [],
      showTags: false,
      showProperties : false,
      checkedNodes : [],
      show: false,
      docProperties : null,
      filter : "",
      // Set while a folder change empties the box, so the watcher does not read that
      // as a search the user asked for.
      skipFilterWatch : false,
      // Id of the last search fired. A reply that is not the last one is dropped, so a
      // slow search cannot land on top of a folder opened after it.
      searchRequestId : 0,
      // Same guard as searchRequestId, for the folder being opened: axios 0.21 has no
      // support for the `signal` option, so an in-flight request cannot be cancelled
      // and the answer of a folder left behind would otherwise land on top of the
      // listing of the one just opened.
      folderRequestId : 0,
      // The same, for the detail of the node picked in the tree. It is a separate
      // counter because opening a folder runs both chains and one must not discard
      // the other.
      nodeDetailRequestId : 0,
      folder_code : null,
      progress : 0,
      directory : [],
      showProgress : false,
      // Estado del diálogo de subida (dialogLoader). Deliberadamente separado
      // de upload_docs/uploadedFiles, que alimentan los avisos por email.
      uploadTotal : 0,
      uploadDone : 0,
      uploadFileName : '',
      uploadFinished : false,
      templates : [],
      request_id : [],
      template_id : null,
      request_items : [],
      item_request : null,
      itemRequestSelected : null,
      documentResp  : [],
      changeTemplate : false,
      fileView : 1,
      CheckedTypes    : [],
      statusFilter      : "all",
      checkedItem : false,

      endpoint: "client_documents",
      section: "/admin/documentos",
      urlDownload: "/document/download/",
      columnsUser: ["check_all", "file_type", "file_name", "user", "updated_at","path", "show_file", "download_file"],
      columnsRequest : ["name", "delete_event"],

      // Folders the user has pinned, as the API lists them ({ id, name, parent_id }),
      // in the order they were pinned. Replaced whole by every answer of
      // /pinned_folders, never patched here.
      pinnedFolders: [],
      // Guards for the answers of /pinned_folders, see loadPinnedFolders and
      // _mutatePinned: the latest load, the latest pin/unpin sent, and the latest
      // pin/unpin whose answer has been applied.
      pinnedRequestId: 0,
      pinnedMutationId: 0,
      pinnedMutationApplied: 0,
      lastClickedNodeId: null,
      lastSelectedNodeId: null,
      // Drag and drop handlers bound to the tree element, kept so a rebuild can take
      // them off before binding them again.
      treeDropBindings: null,
      originalData: [],       // árbol completo (backup)

      fields: {
        dataSource : {},
        id: 'id',
        parentID: 'parent_id',
        text: 'name',
        iconCss: 'icon',
        child: 'subChild',
        htmlAttributes: 'hasAttribute',
        hasChildren: 'hasChild'
      },
      selected: [],
      //selectAll: false,
      isToggled: false,
      //columns: ["tipo", "nombre", "modificado", "usuario"],
      columns: ["document_type_id", "name", "size", "updated_at", "user"],
      columns2: ["document_type_id", "name", "folder_code", "updated_at", "user"],
      //columns: ["name", "email", "age"],
      users: [/*
        { "id": "1", "age": 21, "name": "Shad Jast", "email": "pfeffer.matt@yahoo.com" },
        { "id": "2", "age": 45, "name": "Duane Metz", "email": "mohammad.ferry@yahoo.com" },
        { "id": "3", "age": 34, "name": "Myah Kris", "email": "evolkman@hotmail.com" },
        { "id": "4", "age": 19, "name": "Dr. Kamron Wunsch", "email": "lenora95@leannon.com" },
        { "id": "5", "age": 29, "name": "David Pella", "email": "lenora95@leannon.com" },
        { "id": "6", "age": 27, "name": "Richard Jacob", "email": "richard.jacob@leannon.com" }*/] ,
      sortKey: "",
      isNodeClicked: false,
      isRoot: true,
      reverse: false,
      search: "",
      isInteracting: false,
      selectedItem: false,
      hoverItem: false,
      hoverTheader:false,
      pathCopy:'',
      showModalRequiredDoc:false,
      showSelectFolderModal:false,
      editOffset: -1,
      // The document being renamed, by id. A row index used to stand here,
      // and it pointed at a position: at another row once the list was
      // reordered, and at a different file once the folder changed.
      editingId: null,
      editPost: {},
      editCell: {},
      editPostOri: {},
      editCellOri: {},
      count: 0,
      upload_docs: 0,
      uploadedFiles: 0,
      deleted_docs: 0,
      //checkbox: false,
      checkboxes: ['Opt 1', 'Opt 2', 'Opt 3', 'Opt 4'],
      checkbox: [],
      onOff: true,
      myDocs:false,
      //userDocs: this.getMyDocs(),
      tableData: [],
      documentsUser:[],

      dataTable: null,
      savedIndex: null,

      checkedNames: [],
      showFolderTree:false,


      s3Usage: null,
      loading: false,
      // { size_used, limit_size } in bytes, from /settings/storage.
      storage: null,

      createdFolder:{},
      createdFolderId:null,
      arrayChild: [],
      items: [],
      auxitems: [],
      history : [],
      // Tags chosen in the folder modal, creating or editing. Nothing is written
      // until Save is pressed: onSaveFolder sends them once the folder exists.
      newFolderTags: [],
      // Tags chosen in the properties modal, held until its Save button.
      propertiesTags: [],
      // Tags chosen in the tags modal, applied to the whole selection on Save.
      bulkTags: [],
      itemSelected: {
        tag: [],
        selectedTagSingle: "",
        tagc: [], // IMPORTANTE: Inicializar como array vacío
        tags: [] // IMPORTANTE: Inicializar como array vacío

      },
      selectedTagSingle: "",
      tagMap: {},
      //tagsDB:  axios.get('/conf/tags_types'), // [{id,name,css_class}, ...]
      tags: [],
      selectedTags: [],
      folderUsers : [],
      move_copy: null,
      structure_copy: null,
      docIdMoveCopy: 0,
      docNameMoveCopy:''
    }
  },
  mounted() {
    this.loadTags();
    this.watchBreakpoints();

    // Any click away from an open context menu dismisses it, whichever button was
    // used. They are captured (third argument) so this runs before the handler of a
    // row or of the tree opens the next one, and mousedown rather than click so the
    // menu is gone as soon as the button goes down.
    document.addEventListener ('mousedown', this.onGlobalPointerDown, true);
    document.addEventListener ('contextmenu', this.onGlobalPointerDown, true);
    // Delegated: the rows of "Listar" are replaced by DataTables on every draw, so
    // there is no lasting element to hang this on.
    document.addEventListener ('change', this.onListCheckboxChange, true);
    //this.getS3Usage();
    this.loadStorageUsage ();

    const tag = this.itemSelected?.tag;
    this.itemSelected.tag = Array.isArray(tag) ? tag : tag ? JSON.parse(tag) : [];

    // Inicializar árbol original cuando el TreeView esté listo
    this.$nextTick(() => {
      //setTimeout(() => {
      const tree = this.$refs.treeview?.ej2Instances;
      if (!tree) {
        console.warn("TreeView no está disponible");
        return;
      }
      if (tree && this.fields.dataSource) {
        this.originalData = JSON.parse(JSON.stringify(this.fields.dataSource));
      }
      //}, 500);
    });
  },
  beforeDestroy () {
    this.unwatchBreakpoints();
    this._unbindTreeDropHandlers();
    document.removeEventListener ('mousedown', this.onGlobalPointerDown, true);
    document.removeEventListener ('contextmenu', this.onGlobalPointerDown, true);
    document.removeEventListener ('change', this.onListCheckboxChange, true);
  },
  watch : {
    // Búsqueda en vivo, igual que en el resto de vistas (tablas
    // DataTables): al escribir, no solo al pulsar Enter/la lupa.
    // Con debounce para no lanzar una petición por cada tecla.
    filter() {
      if (this.skipFilterWatch) {
        this.skipFilterWatch = false;
        return;
      }
      clearTimeout(this.filterDebounce);
      this.filterDebounce = setTimeout(() => {
        this.onSearchFilter();
      }, 300);
    },
    // refreshTree remounts the tree by flipping this false and true again, so this
    // watcher runs once per rebuild. It used to add the drag handlers every time and
    // never take them off, so after N rebuilds a single drop moved the document N
    // times over -- N moves, and the counters of both ends recalculated N times.
    show(newVal) {
      if (!newVal) return;

      this.$nextTick(() => {
        const treeElement = document.getElementById('treeview');

        if (!treeElement) return; // Seguridad extra

        this._unbindTreeDropHandlers();
        this._bindTreeDropHandlers(treeElement);
      });
    },
    indexFolder : function (newVal)
    {
      // The listing of the root reaches the explorer late (the parent page fetches it
      // after mounting it), and on a deep link the folder asked for is already open by
      // then: taking it would throw the user back to the root while the breadcrumb and
      // the tree keep pointing at the folder.
      if (this.linkedFolderId && this.selectFolder == this.linkedFolderId) return;
      this.documents = newVal;
    },
    // Selection made in Vue (select all, a menu action) reflected on the checkboxes
    // DataTables painted.
    item (ids) {
      // The command bar reads the actions of a single marked row from itemSelected, so
      // whatever changes the marks has to keep it on the marked row. Marking everything
      // in a folder holding one element used to leave itemSelected on the folder
      // itself, and the bar then offered -- and applied -- the actions of that folder.
      if (ids.length === 1) {
        const single = this.getDocument (ids [0]);
        if (single) {
          this.itemSelected = single;
          this.itemCheckItemSelected = single;
        }
      }
      if (this.myDocs) this.$nextTick (this._syncListCheckboxes);
    }
  },
  components : {
    Modal,
    Folder,
    MultiSelect,
    StepDocument,
    dialogLoader,
    draggable,
    vueDropzone: vue2Dropzone
  },
  props : {
    indexFolder   : Array,
    root          : String,
    title         : String
  },
  created ()
  {
    this._dropPersistedTreeSelection ();

    if (this.$route.query.path){
      this.openLinkedFolder (this.$route.query.path);
    }else{
      this.documents = this.indexFolder;
      this.folders = this.indexFolder;
      this.isAdmin = this.user.rol_id == 1;
      this.onLoadDocumentStatus ();
      this.onLoadFolders ();
      this.loadTemplateDocumentation ();
    }

    //this.upload_docs = 0;
    //this.deleted_docs = 0;

  },
  updated ()
  {
    if (this.selectFolder == 0) this.folders = this.documents;

  },
  validations ()
  {
    return {
      name: {
        required
      }
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  methods : {
    // Keeps the two widths the view depends on in step with the viewport: the
    // folder panel, which collapses when the window narrows past a tablet and
    // comes back when it widens again, and the shape of the actions of the
    // command bar. They are separate breakpoints because they answer different
    // questions: how much room the listing needs, and whether the buttons of
    // the bar still fit in one row.
    //
    // Only crossing a breakpoint moves the panel, so inside one band it stays
    // wherever the user left it, and v-model keeps isDrawerOpen and the
    // checkbox that drives the CSS in sync with each other.
    watchBreakpoints () {
      this.breakpointWatchers = [
        [TABLET_MAX_WIDTH, (matches) => {
          this.isTabletDown = matches;
          this.isDrawerOpen = !matches;
        }],
        [COMMAND_BAR_MAX_WIDTH, (matches) => { this.isCommandBarCompact = matches; }]
      ].map (([width, apply]) => {
        const media = window.matchMedia (`(max-width: ${width}px)`);
        const listener = (event) => apply (event.matches);
        // addEventListener on a MediaQueryList only arrived in Safari 14, and
        // older iPads are still on 13.
        if (media.addEventListener) media.addEventListener ('change', listener);
        else media.addListener (listener);
        return {media, listener};
      });
    },
    // Drag and drop over the tree: dropping files from the desktop uploads them into
    // the folder, dropping a row of the listing moves it there. The handlers are kept
    // so they can be taken off again -- see the `show` watcher.
    _bindTreeDropHandlers (treeElement) {
      const stop = (event) => { event.preventDefault (); event.stopPropagation (); };

      const markNode = (event) => {
        const node = event.target.closest ('.e-list-item');
        if (node) node.classList.add ('drag-over');
      };

      const unmarkNode = (event) => {
        const node = event.target.closest ('.e-list-item');
        if (node) node.classList.remove ('drag-over');
      };

      const onDrop = async (event) => {
        unmarkNode (event);

        const files = event.dataTransfer.files;
        const targetNode = this.getNodeFromEvent (event);
        if (!targetNode) return;

        // Files coming from the desktop are uploaded into the folder...
        if (files && files.length > 0) {
          await this.uploadFiles (files, targetNode);
          return;
        }

        // ...and a row dragged from the listing is moved into it.
        const dragged = this._readDraggedDocument (event);
        if (dragged) await this.moveDocumentToFolder (dragged, targetNode.id);
      };

      const bindings = [
        ['dragenter', stop], ['dragover', stop], ['dragleave', stop], ['drop', stop],
        ['dragenter', markNode],
        ['dragleave', unmarkNode],
        ['drop', onDrop]
      ];

      bindings.forEach (([name, handler]) => treeElement.addEventListener (name, handler, false));
      this.treeDropBindings = { element: treeElement, bindings: bindings };
    },
    _unbindTreeDropHandlers () {
      const bound = this.treeDropBindings;
      if (!bound) return;

      bound.bindings.forEach (([name, handler]) => bound.element.removeEventListener (name, handler, false));
      this.treeDropBindings = null;
    },
    unwatchBreakpoints () {
      (this.breakpointWatchers || []).forEach (({media, listener}) => {
        if (media.removeEventListener) media.removeEventListener ('change', listener);
        else media.removeListener (listener);
      });
      this.breakpointWatchers = null;
    },
    async loadTags() {
      const { data } = await axios.get('/conf/tags_types');

      this.tags = data;

      this.tagMap = data.reduce((acc, t) => {
        acc[t.id] = {
          text: t.name,
          class: t.css_class
        };
        return acc;
      }, {});
    },
    async getS3Usage() {
      if (this.loading) return;

      this.loading = true;
      this.$store.dispatch ("isLoadingOn");

      try {
        const response = await axios.get("/document/s3/usage");

        // Ejemplo de datos devueltos:
        // {
        //   bytes: 12345678,
        //   kilobytes: 12056.81,
        //   megabytes: 11.77,
        //   gigabytes: 0.01
        // }
        this.s3Usage = response.data;

        /*alert(
            `Espacio utilizado:\n
         ${response.data.megabytes} MB (${response.data.gigabytes} GB)`
        );*/

        this.s3Usage = response.data;

      } catch (error) {
        console.error('Error obteniendo espacio S3:', error);
        this.$notify({
          type: 'error',
          message: 'Error al consultar el espacio'
        });
      } finally {
        this.loading = false;
        this.$store.dispatch ("isLoadingOff");
      }
    },
    getTagInfo(id) {
      return this.tagMap[id] || {
        text: "",
        class: ""
      };
    },

    parseTagString(tagString) {
      if (!tagString) return null;

      // Si ya es array
      if (Array.isArray(tagString)) {
        const clean = tagString
            .map(n => Number(n))
            .filter(n => !isNaN(n) && n > 0);
        return clean.length ? clean : null;
      }

      // Si es string
      if (typeof tagString === "string") {
        try {
          const parsed = JSON.parse(tagString);
          if (Array.isArray(parsed)) {
            const clean = parsed
                .map(n => Number(n))
                .filter(n => !isNaN(n) && n > 0);
            return clean.length ? clean : null;
          }
        } catch (e) {
          // Reparación manual
          const clean = tagString
              .replace(/[^\d,]/g, "")
              .split(",")
              .map(n => Number(n))
              .filter(n => !isNaN(n) && n > 0);

          return clean.length ? clean : null;
        }
      }

      return null;
    },

    getValidTags(document) {
      const tags = this.parseTagString(document.tag);
      return tags ? tags : [];
    },


    parseTagString_old(tagString) {
      if (!tagString) return [];

      // Ya es un array válido?
      if (Array.isArray(tagString)) {
        return tagString
            .map(x => Number(x))
            .filter(x => !isNaN(x));
      }

      // Intentar JSON REAL
      if (typeof tagString === "string") {
        try {
          const parsed = JSON.parse(tagString);
          if (Array.isArray(parsed)) {
            return parsed.map(n => Number(n)).filter(n => !isNaN(n));
          }
        } catch (e) {
          // Reparación manual — solo permite números
          return tagString
              .replace(/[^\d,]/g, "")  // ELIMINA TODO lo que no sea dígito o coma
              .split(",")
              .map(n => Number(n))
              .filter(n => !isNaN(n));
        }
      }

      return [];
    },


    async onTagsChangeAll(selectedValues) {

      // onTagsChange writes against itemSelected, so each document takes its turn
      // there. Awaited one by one, and the original selection put back at the end:
      // otherwise the component was left pointing at the last document of the loop.
      const selectedBefore = this.itemSelected;

      for (const item of this.item)
      {
        const docT = this.getDocument (item);
        if (!docT) continue;

        this.itemSelected = docT;
        await this.onTagsChange (selectedValues);
      }

      this.itemSelected = selectedBefore;
      //this.onLoadBreadcrumb ();

      //this.onSelectFolder(parent.name);
      //this.onRefresh()
    },

    // Right-clicking a row of the listing opens the three-dot menu of that same row,
    // placed at the pointer like any context menu. The options are written once, so
    // both ways of opening it always agree. Only the list has such a menu -- the
    // mosaic draws none per tile, so there the browser keeps its own.
    onRowContextMenu (event, document) {
      const container = event.currentTarget;
      const pointerX = event.clientX;
      const pointerY = event.clientY;

      // The buttons of the row are only rendered while it is hovered, so the menu may
      // not be in the DOM yet when the right click arrives: the row is marked as
      // hovered first and the toggle is looked up once Vue has drawn it. Opening it
      // through its own toggle is what fills in itemSelected (onDropDown).
      this.selectItem (document);
      this.$nextTick (() => {
        const toggle = container.querySelector ('.dropdown-toggle');
        const menu = container.querySelector ('.dropdown-menu');
        if (!toggle || !menu) return;

        // Placed before it is shown. Opening it first and moving it afterwards, the
        // browser got to paint it once at its anchored spot -- to the right of the
        // row -- and only then at the pointer, which looked like the menu sliding in
        // from the right. The menu is measurable while closed because the theme hides
        // it with visibility/opacity, not with display: none.
        this._resetRowMenuPosition ();
        this._placeRowMenuAtPointer (menu, pointerX, pointerY);

        // Opening it fires onDropDown, which puts menus back where the stylesheet
        // wants them: this one was just placed on purpose, so it is spared.
        this.openingRowMenu = true;
        toggle.click ();
        this.openingRowMenu = false;
      });
    },
    // Closes whatever context menu is open, unless the click landed inside it (an
    // entry has to be free to do its job). Clicking a row or a folder reopens the
    // right menu straight after, since this runs on the capture phase.
    onGlobalPointerDown (event) {
      const target = event.target;
      // Guard for events whose target is not an element (a text node, the document
      // itself): closest would not exist there.
      if (!target || typeof target.closest != 'function') return;

      if (!target.closest ('.dropdown-menu')) this._closeRowContextMenu ();

      // Inside the tree the component runs its own menu: it opens it on mousedown and
      // this handler would close it again on the contextmenu that follows, so the
      // menu never got to appear. Only clicks outside the tree close it from here.
      if (!target.closest ('ul.e-contextmenu') && !target.closest ('#treeview')) {
        this._closeTreeContextMenu ();
      }
    },
    // Menu of a row: closed through its own toggle so the state Vue keeps for the
    // dropdown (isOpen) stays in step with what is on screen.
    _closeRowContextMenu () {
      if (!this.rowContextMenuEl) return;

      const dropdown = this.rowContextMenuEl.closest ('.dropdown');
      const toggle = dropdown ? dropdown.querySelector ('.dropdown-toggle') : null;
      if (toggle && dropdown.classList.contains ('show')) toggle.click ();

      this._resetRowMenuPosition ();
    },
    _closeTreeContextMenu () {
      const menu = document.getElementById ('contentmenutree');
      const instance = menu && menu.ej2_instances ? menu.ej2_instances[0] : null;
      if (instance) instance.close ();
    },
    // Takes the menu of the row out of its anchored position and drops it at the
    // pointer, kept inside the window so it never opens half off-screen.
    _placeRowMenuAtPointer (menu, pointerX, pointerY) {
      if (!menu) return;

      menu.classList.add ('cd-row-context-menu');
      this.rowContextMenuEl = menu;

      const box = menu.getBoundingClientRect ();
      const left = Math.min (pointerX, window.innerWidth - box.width - 8);
      const top = Math.min (pointerY, window.innerHeight - box.height - 8);
      menu.style.left = `${Math.max (8, left)}px`;
      menu.style.top = `${Math.max (8, top)}px`;
    },
    // Back to the position the stylesheet gives it, so opening the same menu from the
    // three dots afterwards anchors to the button as usual.
    _resetRowMenuPosition () {
      if (!this.rowContextMenuEl) return;

      this.rowContextMenuEl.classList.remove ('cd-row-context-menu');
      this.rowContextMenuEl.style.left = '';
      this.rowContextMenuEl.style.top = '';
      this.rowContextMenuEl = null;
    },
    onRowHover(e, document) {
      const insideSelect = e.target.closest('.badge_tag, .multiselect, .vue-multiselect');
      if (insideSelect) return;
      this.selectItem(document);
    },
    async onTagsChange(selectedValues) {
      // selectedValues será un array de IDs: [1, 3, 4]
      try {
        const { data } = await this.$axios.post('/document/tags', {
          id: this.itemSelected.id,
          tag: selectedValues
        }, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (data.success) {
          // Actualizar el valor local
          this.itemSelected.tag = selectedValues;

          // Opcional: Mostrar notificación de éxito
          this.$notify({
            type: 'success',
            message: 'Etiquetas actualizadas correctamente'
          });
        } else {
          console.error('Error:', data.message);

          this.$notify({
            type: 'error',
            message: data.message || 'Error al actualizar etiquetas'
          });
        }
      } catch (error) {
        console.error('Error en la petición:', error);

        this.$notify({
          type: 'error',
          message: 'Error al actualizar etiquetas'
        });
      }
    },
    // Tags picked in the folder modal, sent once Save is pressed: on creation, against
    // the folder just created; editing, against the folder being edited. An empty
    // selection is sent too -- that is how the tags of a folder are cleared. The
    // header is what makes it pass the ajax() check of the API.
    _saveFolderTags (folderId) {
      if (!folderId || !Array.isArray (this.newFolderTags))
      {
        return Promise.resolve ();
      }

      return this.$axios.post ('/document/tags', {
        id: folderId,
        tag: this.newFolderTags
      }, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then (() => {
        this.newFolderTags = [];
      })
      .catch ((error) => {
        // The folder itself is already created: the upload must not be reported as
        // failed, but the user has to know the tags did not make it.
        console.error ('Error al guardar las etiquetas de la carpeta:', error);
        this.$notify ({
          group: 'app',
          type: 'error',
          message: this.$t ('folder_tags_error'),
          duration: 5000
        });
      });
    },
    getNodeFromEvent(e) {
      const element = e.target.closest('.e-list-item');
      if (!element) return null;

      const nodeId = element.getAttribute('data-uid');
      return this.$refs.treeview.getNode(nodeId);
    },

    async uploadFiles(files, targetNode) {
      let num_files = 0;
      this.progress = 0;
      this.showProgress = true;
      this.uploadTotal = files.length;
      this.uploadDone = 0;
      this.uploadFileName = '';
      this.uploadFinished = false;
      let progress = 100 / files.length;
      for (let file of files) {
        // Aquí tu lógica de subida
        //this.users_folder = targetNode.id;

        // Ejemplo de llamada a tu API
        const formData = new FormData();
        formData.append('file', file);
        formData.append('parentId', targetNode.id);

        // Sin isLoadingOn/Off aquí: el overlay global de vue-loading-overlay se
        // encendía y apagaba en cada vuelta del bucle, solapado con el diálogo
        // de progreso. El dialogLoader ya cubre la pantalla por sí solo.
        this.uploadFileName = file.name;
        try {
          await axios.post('/documents/upload_drag', formData)
        } catch (error) {
          // Out of contracted space: the files still to come would be refused
          // too, so the batch stops here and what did go up is reported below.
          // Any other error goes on as it did before.
          if (await handleLimitError(this, error)) break;
          throw error;
        }
        num_files = num_files+1;

        this.progress += progress;
        this.uploadDone = num_files;
      }

      this.itemSelected = targetNode;
      // One request instead of one per user of the installation, asking which
      // of them have the notification set on this very folder. That is what the
      // checkboxes show, so the chain above is not read here.
      this.checkedUsersId = [];

      if (this.itemSelected.id) {
        this.$axios.post ("document/folder_notify_users", { folder_id: this.itemSelected.id })
            .then ((response) => {
              this.checkedUsersId = (response.data && response.data.user_ids) || [];
            })
            .catch (() => {
              this.$store.dispatch ('isLoadingOff');
            });
      }
      this.onRefresh();
      this.uploadFinished = true;
      setTimeout (() => {
        this.showProgress = false;
      }, 1500)

      /*this.$notify({
        title: 'Test',
        message: 'Esto debería verse',
        type: 'info',
        duration: 5000
      });*/

      this.$notify({
        group: 'app',
        type: 'success',
        message: `Se han subido ${num_files} de ${files.length} archivos`,
        duration: 5000
      });

    },

    async fetchFolders() {
      try {
        //const response = await axios.get('/folders');
        //this.folders_ = response.data;
        this.folders_ = this.documents;

        // Recursivamente carga documentos para cada carpeta principal
        for (let folder of this.folders_) {
          await this.loadFolderDocuments(folder);
        }
      } catch (error) {
        console.error('Error fetching folders_:', error);
      }
    },

    async loadFolderDocuments(folder) {
      const folderWithDocs = { ...folder, documents: [] };
      const docs = await axios.get(`/folders/${folder.id}/documents`);
      folderWithDocs.documents = docs.data;

      // Si la carpeta tiene subcarpetas, cargarlas recursivamente
      const subfolders = await this.fetchSubfolders(folder.id);
      for (let subfolder of subfolders) {
        const subfolderData = await this.loadSubfolderDocuments(subfolder);
        folderWithDocs.children.push(subfolderData);
      }

      // Agregamos la carpeta con documentos y subcarpetas a la lista
      this.folders_ = this.folders_.map(f => (f.id === folder.id ? folderWithDocs : f));
    },

    async fetchSubfolders(parentId) {
      try {
        const response = await axios.get('/folders');
        return response.data.filter(folder => folder.parent_id === parentId);
      } catch (error) {
        console.error('Error fetching subfolders:', error);
        return [];
      }
    },
    rowClick() {},
    removeSpecialCharacters(charactersString) {
      return charactersString.replace(/[^\w\s]/gi, "");
    },
    checkForSpecialCharacters(charactersString) {
      const specialCharactersRegex = /[^\w\s]/;
      return specialCharactersRegex.test(charactersString);
    },
    scrollToBottom() {
      const container = this.$el.querySelector("#container_comment");
      if (!container) return;
      container.scrollTop = container.scrollHeight;
    },
    loadData(){},
    getUsersFolder (){
      setTimeout (() => {
        let data = {
          contact_id: this.user.client ? this.user.client.id : '1',
        };
        //this.users_folder =[];
        this.checkedUsersId = [];
        this.$axios.post ("document/folder_users",data)
            .then ((response) => {
              this.users_folder = response.data;
            })
            .catch (() => {
              this.$store.dispatch ('isLoadingOff');
            });
      }, 100);

    },
    selectAllUsers () {
      if (this.isAllSelected) {
        this.selectedUserIds = []
        this.isAllSelected = false
      } else {
        this.selectedUserIds = []
        for (var user in this.users_folder) {
          this.selectedUserIds.push(this.users_folder[user].id)
        }
        this.isAllSelected = true
      }
    },
    selectUsers () {
      if (this.selectedUserIds.length !== this.users_folder.length) {
        this.isAllSelected = false
      } else {
        this.isAllSelected = true
      }
    },
    toggleChecklist: function(checklistId, evt, index){
      const savedIndex = this.savedIndex;
      this.savedIndex = index;

      // If this is the first pass or no shift key was
      // pressed, just bail.
      if (savedIndex === null || !evt.shiftKey) return;

      // Shift-clicked the same message :-/
      if (index === savedIndex) return;

      // Get the subset of the message list between the
      // two indicies.
      console.time("toggle range")

      // The rows of the view being clicked, in the order they are on screen.
      const rows = this.myDocs ? this.orderedDocsUser : this.orderedDocs;
      const subset = rows.map(({ id }) => id).slice(
          Math.min(index, savedIndex),
          Math.max(index, savedIndex) + 1
      );

      // The range used to be applied to "selectedItems", which stopped feeding
      // anything when the checkbox moved to v-model="item": shift-clicking marked
      // the clicked row alone. The marks the listing and the command bar read are
      // in "item", so that is what the range writes to. The value of the clicked box
      // is left to v-model, which runs right after this on the change event.
      const checked = evt.currentTarget.checked;
      const marks = new Set(this.item);
      subset.forEach(id => checked ? marks.add(id) : marks.delete(id));
      this.item = Array.from(marks);
      console.timeEnd("toggle range")

    },
    // reload = true asks for the list again with the path that is open now. Without
    // it the body only runs when entering the view, so walking the breadcrumb from
    // "Listar" changed the path and left the same documents on screen.
    getMyDocs: function (reload = false){
      // Emptying the list only makes sense when actually switching to it: now
      // that "Listar" is always visible it can be clicked while already active,
      // and that used to blank the list without reloading it.
      if (!this.myDocs || reload){
        this.documentsUser =[];
        this.myDocs = true;
        //console.log("entra");

        this.$store.dispatch ("isLoadingOn");

        this.$axios.post ("/client_documents_folders",{
          breadcrumbs: this.breadcrumbs
        })
            .then ((response) => {
              this.documentsUser = response.data;
              this.item = [];
              this.stopRenaming ();
              this.fileView = 1;
              this.$store.dispatch ('isLoadingOff');
              this.onLoadBreadcrumb ();
              this.$store.dispatch ("isLoadingOff");
              if(this.myDocs){

                //this.dataTable.remove();

                this.datatable = window.$('#exampleFinal').dataTable({
                  data: this.orderedDocsUser,
                  //ajax: "document.breadcrumb",
                  // Column 5 is "Modificado": it was 4 until the size column was
                  // inserted after the name and pushed everything to its right.
                  order: [[5, 'asc']],
                  // Paging, ordering and filtering redraw the rows from scratch, and
                  // the new checkboxes come up empty: the selection is painted back
                  // on them after every draw.
                  drawCallback: () => this._syncListCheckboxes (),
                  deferRender: true,
                  stateSave: true,
                  destroy: true,
                  columns: [
                    /*{
                      "data": "id", "render": function (data) {

                        return '<a class="btn btn-primary" style="margin-left:30px"  onclick="clicked(event, ' + data + ')">Edit</a>'

                      }
                    },*/
                    //{ "data": "id" },
                    { data: null, orderable: false, render: function (data) {
                        return '<label class="checkbox_label"><input type="checkbox" class="checkbox__input" value="' + data.id + '"><span class="checkbox__inner"></span></label>';
                        //return data.id;
                      },
                    },
                    { data: null, orderable: true, render: function (data) {
                        //return '<input @click="deletePid(' + data.id + ')">Delete</input>';
                        var text = '';
                        switch(data.document_type_id) {
                          case 2:
                            text = "e-fe-pdf";
                            break;
                          case 3:
                            text = "e-fe-docx";
                            break;
                          case 4:
                            text = 'e-fe-image';
                            break;
                          case 5:
                            text = "e-fe-zip";
                            break;
                          case 6:
                            text = "e-fe-pptx";
                            break;
                          case 7:
                            text = "e-fe-xlsx";
                            break;
                          case 8:
                            text = "e-fe-music";
                            break;
                          case 9:
                            text = "e-fe-video";
                            break;
                          case 10:
                            text = "e-fe-txt";
                            break;
                          case 11:
                            text = "e-fe-msg";
                            break;

                          default:
                            text = "e-fe-folder";
                        }

                        // Same rule as documentIconClass: an extension with a sprite
                        // of its own (a .rar inside type 5) wins over the type.
                        var extension = (data.name || '').split('.').pop().toLowerCase();
                        if (data.document_type_id != 1 && EXTENSION_ICON_CLASS[extension])
                          text = EXTENSION_ICON_CLASS[extension];

                        return '<i onclick="rowClick" class="font30 '+ text +' e-list-icon"/>';
                      },
                    },
                    /*{ "data": "document_type_id" ,
                      render: function (data) {
                        return data;

                      }
                    // "render": () => {
                    //     return '<i class="fas fa-chevron-right rotate"></i>';
                    //   },
                  },*/
                    /*{ "data": "name", "width": "30%" ,
                      "render": function(data, type, row, meta) {
                        console.log(meta);
                        return renderDocName(data, row)
                      } },*/
                    { "data": "name", "width": "30%"},
                    // "display" is what the cell shows; every other type is what
                    // DataTables sorts and filters by. Without the distinction the
                    // column would be ordered as the text "1.2 MB", which puts a
                    // 1 MB file before a 900 KB one.
                    { "data": "size", "width": "8%",
                      render: function (data, type) {
                        return type === 'display' ? formatDocumentSize (data) : (data || 0);
                      }
                    },
                    { "data": "folder_code", "width": "30%"  },
                    { "data": "updated_at" , "width": "12%" ,
                      render: function (data) {
                        if (data != null) {
                          //var dtStart = new Date(data);
                          //return dtStart.toLocaleString();
                          //return dtStart.toLocaleDateString('es-ES')+' '+dtStart.toLocaleTimeString('es-ES');
                          /*const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
                          return new Date(data).toLocaleDateString('es', options);*/
                          moment.locale('es');
                          var fecha_convertida = moment(data);
                          return '<span style="display: none">'+ moment(data).unix() +'</span>'+fecha_convertida.format('DD-MM-YYYY HH:mm');
                          //return moment(String(data)).format('YYYY-MM-DD HH:mm');
                          //return data;
                        } else {
                          return "";
                        }
                      }
                    },
                    { "data": "user.name" ,
                      render: function (data) {
                        if (data != null) {
                          return data;
                        } else {
                          return "";
                        }
                      }
                    },
                  ],
                  /*"columnDefs": [
                    { "type": "date", "targets": 4 }
                  ],*/
                  // Misma configuración que el resto de listados de la app
                  // (Contactos, Usuarios, Etiquetas...) en vez del fichero de
                  // idioma que se descargaba de un CDN: además de quitar esa
                  // dependencia externa, hace que la inicialización sea
                  // síncrona y que los controles existan ya en el DOM en la
                  // línea siguiente.
                  lengthMenu: dataTableLengthMenu,
                  language: dataTableEsLanguage
                });

                // variations.scss oculta el <select> nativo de "registros por
                // página" porque toda la app lo sustituye por el desplegable
                // de marca; esta tabla nunca llamaba al sustituto, así que se
                // quedaba con el hueco vacío y sin forma de cambiar el número
                // de filas. Va aquí, pegado al init: es lo primero que hay
                // que hacer con los controles recién creados.
                enhanceDataTableLength();

                // These will update table
                // this.dataTable.clear();
                // It starts off with whatever the header search box holds,
                // which is now the same box in both views: ignoring it would
                // mean arriving from "Explorar" mid-search with a full box and
                // an unfiltered table.
                this.datatable.fnFilter(this.filter || '');
                // .dataTable() (minúscula) devuelve el objeto jQuery con la
                // API antigua (fnDraw, fnFilter...), no el Api de 1.10: el
                // ".draw(true)" que había aquí lanzaba un TypeError en cada
                // entrada a "Listar" y se comía en silencio todo lo que
                // viniera detrás dentro del .then().
                this.datatable.fnDraw();
                //this.dataTable.rows.add(response.data);
                //this.dataTable.DataTable().draw(true);
                //this.LoadDataTable();
              }
            })
            .catch(() => {
              this.$store.dispatch ("isLoadingOff");
            });
      }
    },
    createFolderCode: function (){
      //document.getElementById("folder_code").innerHTML="hola";
      return "";
    },
    template: function () {
      return `<div class="dz-preview dz-file-preview">
                <div class="dz-image">
                    <div data-dz-thumbnail-bg></div>
                </div>
                <div class="dz-details">
                    <div class="dz-size"><span data-dz-size></span></div>
                    <div class="dz-filename"><span data-dz-name></span></div>
                </div>
                <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                <div class="dz-error-message"><span data-dz-errormessage></span></div>
                <div class="dz-success-mark"><i class="fa fa-check"></i></div>
                <div class="dz-error-mark"><i class="fa fa-close"></i></div>
            </div>
        `;
    },
    thumbnail: function(file, dataUrl) {
      var j, len, ref, thumbnailElement;
      if (file.previewElement) {
        file.previewElement.classList.remove("dz-file-preview");
        ref = file.previewElement.querySelectorAll("[data-dz-thumbnail-bg]");
        for (j = 0, len = ref.length; j < len; j++) {
          thumbnailElement = ref[j];
          thumbnailElement.alt = file.name;
          thumbnailElement.style.backgroundImage = 'url("' + dataUrl + '")';
        }
        return "dsf"
      }
    },
    startEditing(index) {
      this.editOffset = index
      this.editPost = this.request_items[index]
      this.editPostOri = JSON.parse(JSON.stringify(this.editPost))
      // set focus ke element input
      this.$nextTick(function(){
        document.getElementById('item-user-'+this.editOffset).focus()
      }.bind(this))
    },
    orderRecursive(items, auxitems) {
      items.forEach((item) => {
        //auxitems.push(element)
        let docT = this.getDocument(item.id);
        if(docT.document_type_id == 1){
          auxitems.push(item);
        }
      })
      auxitems.forEach ((item) => {
        let docT = this.getDocument(item.id);
        if(docT.document_type_id == 1){
          this.$axios (`/documents?where-parent_id=${docT.id}`)
              .then ((response) => {
                this.orderRecursive(response.data, auxitems);
                this.$store.dispatch ('isLoadingOff');
              })
              .catch (() => {
                this.$store.dispatch ('isLoadingOff');
              });
        }
        //if (!docT.active){
        //this.copyDoc(docT.id, docT, move);
        //}

      });

      /* let i=0;
       items.forEach((element) => {
         auxitems.push(element)
       })

       if (items.length > 0) {
         i++;
         this.orderRecursive(items[i], auxitems);
         console.log("...o aqui?");
       } else {
         //
         console.log("aqui entra?...");
       }*/
      //console.log(items);
      // console.log(auxitems);
    },
    loop(i =1){
      //var n = $(".item").length;
      var n = 10;
      var m = n + 5;
      if (i >= m) return; // <<-----
      setTimeout(() => {
        $('.item:nth-child('+i+')').addClass('show');
        var x = i - 2;
        var y = x - 2;
        $('.item:nth-child('+x+')').addClass('show');
        $('.item:nth-child('+y+')').addClass('show');
        this.loop(i+3); // <<------
      }, 100);
    },
    copyStructure(id){

      this.selectFolder = id;
      this.document_type =1;
      this.onSaveFolder();
      this.showSelectFolderModal = false;

    },
    // Copying travels the same way as renaming and moving: copy_file writes the
    // file and answers with the path it was written to, and the row stored for
    // the copy points there. folder_code is left to the backend, which derives
    // it from the folder the copy is created in.
    copyDoc(id, doc, move){
      console.log("copyDoc");
      this.stopRenaming ();
      this.showSelectFolderModal = false;
      this.$store.dispatch ('isLoadingOn');

      this.$axios.post (`/document/copy_file/${id}`, {
        moveId : this.docIdMoveCopy,
        move   : move,
        name   : doc.name
      })
          .then ((response) => {
            const data = {
              name              : doc.name,
              parent_id         : this.docIdMoveCopy,
              user_id           : this.user.id,
              active            : 0,
              document_type_id  : doc.document_type_id
            };
            if (response.data && response.data.url) data.url = response.data.url;
            return this.$axios.post ("/documents", data);
          })
          .then ((response) => {
            this.onChangeStatus (6, response.data.id);
            this.onChangeStatus (6, doc.id);
            this.upload_docs = 1;
            this.onUpdateParentFiles (response.data.parent_id, false);
            this.onRefresh ();
            this.$dialog.alert ({
              body: this.$t ("copy_success"),
            }, { customClass: 'cd-dialog cd-dialog--success' });
          })
          .catch (async (error) => {
            if (await handleLimitError (this, error)) return;
            this._warnDialog (this._nameChangeError (error, "copy_failed"));
          })
          .finally (() => {
            this.$store.dispatch ('isLoadingOff');
          });
    },
    // What the user typed is checked here; the requests are sent by
    // _sendNameChange. Move and copy arrive with a name of their own and go
    // straight there: nothing was typed for them to check.
    updateName (id, doc, move) {
      console.log("updateName");

      if (move != null) {
        this.stopRenaming ();
        this._sendNameChange (id, doc, move, null);
        return;
      }

      // doc is the row itself and the input was bound to it, so what was typed
      // is already in doc.name, and the name it was opened on is the copy kept
      // by onChangeName. Both are read before closing the editor, which drops
      // that copy; and the editor is closed before anything else because what
      // follows can open a dialog, and the blur that comes with it would run
      // this a second time.
      const name = (doc.name || '').trim ();
      const original = ((this.editCellOri && this.editCellOri.name) || doc.name || '').trim ();
      this.stopRenaming ();

      // Renaming to the name it already has is not a rename: there is nothing
      // to save, and the round trip fails on the backend anyway. A blank name
      // is not a name, so it is turned down the same way. Both leave the row
      // with the name the editor was opened on.
      if (!name || name === original) {
        doc.name = original;
        return;
      }

      // A name is a name and not a path: a slash would store the file one level
      // below the folder it belongs to, where nothing reaches it again.
      if (/[\\/]/.test (name)) {
        doc.name = original;
        this._warnDialog (this.$t ("rename_invalid_name"));
        return;
      }

      if (this._siblingNameTaken (name, doc.parent_id, doc.id)) {
        doc.name = original;
        this._warnDialog (this.$t ("rename_name_taken"));
        return;
      }

      doc.name = name;

      // Dropping or changing the extension stores the document under a name its
      // type no longer matches: it is worth asking, because the icon and the
      // viewer go by the type it was uploaded with.
      if (doc.document_type_id != 1 && this._fileExtension (name) !== this._fileExtension (original)) {
        this._confirmDialog (this.$t ("rename_extension_changed"))
            .then (() => { this._sendNameChange (id, doc, null, original); })
            .catch (() => { doc.name = original; });
        return;
      }

      this._sendNameChange (id, doc, null, original);
    },
    _fileExtension (name) {
      const dot = (name || '').lastIndexOf ('.');
      return dot > 0 ? name.slice (dot + 1).toLowerCase () : '';
    },
    // Warnings of the rename are opened out of the event that asked for them.
    // Mounted inside the keyboard event, the keyup of the very Enter that opened
    // one reached the dialog and answered it straight away: the warning only
    // blinked, and the confirmation of a changed extension accepted itself. The
    // inputs listen on keyup rather than keydown for the same reason.
    _warnDialog (body) {
      setTimeout (() => {
        this.$dialog.alert ({ body }, { customClass: 'cd-dialog cd-dialog--warning' });
      }, 0);
    },
    _confirmDialog (body) {
      return new Promise ((resolve, reject) => {
        setTimeout (() => {
          this.$dialog.confirm ({ body }, { customClass: 'cd-dialog cd-dialog--warning' })
              .then (resolve)
              .catch (reject);
        }, 0);
      });
    },
    // Two things with the same name in the same folder cannot be told apart in a
    // listing. The backend turns them down as well, for every way in, but the
    // listing on screen already knows and answering here saves the round trip.
    // The tree only holds folders, so it is read too: a folder can be renamed
    // from there while the listing is showing somewhere else entirely.
    _siblingNameTaken (name, parentId, ignoreId = null) {
      const wanted = (name || '').trim ().toLowerCase ();
      if (!wanted) return false;

      const rows = ((this.myDocs ? this.documentsUser : this.documents) || [])
          .concat (this.directory || []);

      return rows.some ((row) => {
        if (ignoreId != null && String (row.id) === String (ignoreId)) return false;
        // Root folders come out of the tree with no parent_id at all.
        const rowParent = row.parent_id != null ? row.parent_id : 0;
        return String (rowParent) === String (parentId != null ? parentId : 0)
            && (row.name || '').trim ().toLowerCase () === wanted;
      });
    },
    // change_name moves the file and answers with the url it was written to, and
    // that url is what gets stored. Building it here out of the old one is what
    // used to leave rows pointing at a path nothing had ever been written to:
    // the name was split off the old url by parent_id, and a document whose url
    // no longer carried its own parent_id came out of it as rubbish.
    //
    // folder_code does not travel any more either. It is the path of the folder
    // holding the document, so the backend derives it, both here and for
    // everything below a folder that has just been renamed or moved.
    _sendNameChange (id, doc, move, previousName) {
      this.$store.dispatch ('isLoadingOn');
      this.showSelectFolderModal = false;

      this.$axios.post (`/document/change_name/${id}`, {
        moveId : this.docIdMoveCopy,
        move   : move,
        name   : doc.name
      })
          .then ((response) => {
            const stored = {
              parent_id : move == null ? doc.parent_id : this.docIdMoveCopy,
              name      : doc.name
            };
            // Folders hold no file of their own, so they come back without a url.
            if (response.data && response.data.url) stored.url = response.data.url;
            return this.$axios.put ("/documents/" + id, stored);
          })
          .then ((response) => {
            this.onChangeStatus (move == null ? 7 : 5, response.data.id);
            this.upload_docs = this.deleted_docs = 1;
            if (move != null) {
              this.onUpdateParentFiles (response.data.parent_id, false);
              setTimeout (() => {
                this.onUpdateParentFiles (doc.parent_id, true);
              }, 500);
            }
            if (!this.myDocs) this.onRefresh ();
            else this.getMyDocs (true);

            // The tree is rebuilt here and not next to stopRenaming: out there it
            // ran while the two requests were still in flight, so it read back
            // the name the backend had not changed yet and the folder kept its
            // old name in the tree until the whole page was reloaded. The node
            // left selected is the folder being listed, which is where the user
            // still is. Renaming the folder of the listing also changes the path
            // printed over it, which is what later uploads store as their own.
            this.reloadTreeFromBackend (this.selectFolder);
            if (doc.document_type_id == 1 && String (doc.id) === String (this.selectFolder)) {
              this.onLoadBreadcrumb ();
            }

            this.$dialog.alert ({
              body: this.$t (move == null ? "rename_success" : "move_success"),
            }, { customClass: 'cd-dialog cd-dialog--success' });
          })
          .catch ((error) => {
            // The typed name is already on the row, so putting the old one back
            // is the only way of telling that nothing has been stored.
            if (previousName != null) doc.name = previousName;
            this._warnDialog (this._nameChangeError (error, move == null ? "rename_failed" : "move_failed"));
          })
          .finally (() => {
            this.$store.dispatch ('isLoadingOff');
          });
    },
    // What went wrong, in the words of the case at hand: every failure used to be
    // reported as a file that already existed in the folder it was moved to,
    // renames included. fallbackKey is what to say when the backend does not name
    // the cause itself.
    _nameChangeError (error, fallbackKey) {
      const data = (error && error.response && error.response.data) || {};
      if (data.code === 'NAME_TAKEN') return this.$t ("rename_name_taken");
      if (data.code === 'FILE_NOT_FOUND') return this.$t ("rename_file_missing");
      if (data.code === 'INVALID_NAME') return this.$t ("rename_invalid_name");
      return this.$t (fallbackKey);
    },
    updatePost() {
      let data = {
        name            : this.editPost.name,
      };

      this.$axios.put("/folder_documentation/"+this.editPostOri.id, data)
          .then(() => {
            //this.$store.dispatch('isLoadingOff');
          })
          .catch(() => {
            //this.$store.dispatch('isLoadingOff');
          });
      this.editOffset = -1
      this.editPostOri = {}
      this.editPost = {}
    },
    cancelEditing() {
      this.$set(this.request_items, this.editOffset, this.editPostOri)
      this.editOffset = -1
      this.editPostOri = {}
      this.editPost = {}
      // editCell is the row itself, so the input has been writing straight
      // into the listing: cancelling has to put the name back, or the typing
      // stays on screen until something reloads the folder.
      if (this.editCell.name != null && this.editCellOri.name != null) this.editCell.name = this.editCellOri.name;
      this.stopRenaming ();
    },
    /* Copies a deep link to the folder the item lives in:
       /admin/documents?path=<folder id>, the query the created() hook reads
       to open that folder. Folders link to themselves, files to their parent. */
    copyPath (doc) {
      if (!doc || !doc.id) {
        this.onPathCopied (false)
        return
      }
      const folderId = (doc.document_type_id == 1) ? doc.id : doc.parent_id
      const path = folderId
          ? `${window.location.origin}/admin/documents?path=${folderId}`
          : `${window.location.origin}/admin/documents`

      // The async Clipboard API is only available in a secure context.
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText (path)
            .then (() => this.onPathCopied (true))
            .catch (error => {
              console.error ('clipboard API failed:', error)
              this.copyPathFallback (path)
            })
      } else {
        this.copyPathFallback (path)
      }
    },
    copyPathFallback (path) {
      const helper = document.createElement ('textarea')
      helper.value = path
      helper.setAttribute ('readonly', '')
      helper.style.position = 'absolute'
      helper.style.left = '-9999px'
      document.body.appendChild (helper)
      helper.select ()

      let copied = false
      try {
        copied = document.execCommand ('copy')
      } catch (error) {
        console.error ('execCommand copy failed:', error)
      }
      document.body.removeChild (helper)
      this.onPathCopied (copied)
    },
    onPathCopied (copied) {
      this.$notify ({
        type   : copied ? 'success' : 'error',
        message: copied ? this.$t ('path_copied') : this.$t ('path_copy_error')
      })
    },
    copyLinkPath() {
      let testingCodeToCopy = document.querySelector('#path-code')
      testingCodeToCopy.setAttribute('type', 'text')
      testingCodeToCopy.select()

      try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'correctamente' : 'erroneamente';
        var path ="https://cleverdocs.cleverbsolutions.com/storage/app/"+ testingCodeToCopy.value;
        alert(path+' ha sido copiado ' + msg);
      } catch (err) {
        alert('Oops, imposible de copiar');
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
    unSelectTheader(){
      this.hoverTheader = false
    },
    selectTheader(){
      this.hoverTheader = true
    },
    selectItem (item) {
      //this.selectedItem = item
      this.hoverItem = item;
      //console.log(this.hoverItem);
    },
    unSelectItem () {
      //this.selectedItem = false
      this.hoverItem = {}
      //console.log(this.hoverItem);
    },
    formatDate2: function(dt){
      //return moment(dt).format("DD-MM-YYYY")
      return dt != null ? moment(dt, 'DD/MM/YY HH:mm:ss').format('DD-MM-YYYY HH:mm:ss') : null;

    },
    formatDateUnix: function(dt){
      return dt != null ? moment(dt, "DD-MMM-YYYY hh:mm A").unix(): null;
      //return dt != null ? moment(dt, 'DD/MM/YY HH:mm:ss').format('DD/MM/YYYY') : null;

    },
    formatDate: function (dt) {
      return new Intl.DateTimeFormat('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      }).format(new Date(dt)).replace(',', '');
    },
    formatDate_old: function(dt){
      var d1 = new Date(dt);
      return d1;

    },
    formatDate3: function(dt){
      return dt != null ? moment(dt, "DD.MM.YYYY").format("DD/MM/YYYY") : null;
      //return dt != null ? moment(dt, 'DD/MM/YY HH:mm:ss').format('DD/MM/YYYY') : null;

    },
    getFormattedDate(date) {
      //return moment(date, "DD-MM-YY HH:mm:ss").format("DD-MM-YYYY HH:mm:ss");
      return date;
    },
    sendingEvent (file, xhr, formData)
    {
      formData.append ('parent_id', this.selectFolder);
      formData.append ('user_id', this.user.id);
      formData.append ('folder_code', this.onPrintBreadcrumb());
      //this.$refs["dropzone"].removeFile(file);
      var ext = file.name.split('.').pop();
      //file.name = file.name.split('.')[0].replace("'", "")+ext;
      //$(file.previewElement).find(".dz-filename span").html(file.name.split('.')[0].replace("'", "")+ext);
      formData.append ('name', "test.png");
      /*switch(ext){
        case 'pdf':$(file.previewElement).find(".dz-image img").attr("src", "/images/file-icons/pdf.png"); break;
        case 'doc':$(file.previewElement).find(".dz-image img").attr("src", "/images/file-icons/pdf.png"); break;
        case 'docx':$(file.previewElement).find(".dz-image img").attr("src", "/images/file-icons/pdf.png"); break;
        case 'xls':$(file.previewElement).find(".dz-image img").attr("src", "/images/file-icons/pdf.png"); break;
        case 'pdf':$(file.previewElement).find(".dz-image img").attr("src", "/images/file-icons/pdf.png"); break;
      }*/

      if (ext == "pdf") {
        $(file.previewElement).find(".dz-image img").attr("src", "/images/file-icons/pdf.png");
      } else if (ext.indexOf("doc") != -1 || ext.indexOf("docx") != -1) {
        $(file.previewElement).find(".dz-image img").attr("src", "/images/file-icons/docx.svg");
      } else if (ext.indexOf("xls") != -1 || ext.indexOf("xlsx") != -1) {
        $(file.previewElement).find(".dz-image img").attr("src", "/images/file-icons/xlsx.svg");
      }

      this.upload_docs =0;
      this.uploadedFiles = 0;

    },
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    DestroyDatatable(){},
    LoadDataTable ()
    {
      moment.locale('es');


      //$.fn.dataTable.moment('dd-mm-yyyy HH:mm');
      //$.fn.dataTable.moment('DD-MM-YY HH:mm:ss');
      //$.fn.dataTable.moment( 'dd/mm/yyyy hh:mm:ss' );
      //$.fn.dataTable.moment( 'YYYY/MM/DD');

      setTimeout (() => {

        //this.datatable.search('');

        //$('input[type=search]').val('').change();

        /*window.$("#clientsDocs").dataTable ({
          //order: [[5, 'asc']],
          //dom: "Bfrtip",
          dom: "Bfrtp",
          //dom: "B<\"top\"f>rt<\"bottom\"lp><\"clear\">",
          //data: this.orderedDocsUser,
          //dom: 'fBrtip<"clear">l',
          retrieve: true,
          buttons: [
            {
              extend: "excelHtml5",
              title: "Documentos",
              text:
                  '<i class="fas fa-file-excel text-success" title="Excel"></i>',
              exportOptions: {
                columns: [2, 3, 4, 5],
              }
            },
            {
              extend: "pdfHtml5",
              text: '<i class="fas fa-file-pdf text-danger" title="PDF"></i>',
              orientation: "landscape",
              title: "Mis Documentos",
              exportOptions: {
                columns: [ 2, 3, 4, 5],
              },
              customize: function (doc)
              {
                doc.content [1].table.widths = "*";
                doc.styles.tableHeader.alignment = "left";
              }
            },
            {
              extend:    'copyHtml5',
              text:      '<i class="fa fa-clipboard"></i>',
              title:'Documentos',
              titleAttr: 'Copiar',
              className: 'btn btn-app export barras',
            },
            {
              extend: "print",
              title: "Documentos",
              text: '<i class="fas fa-print" title="Imprimir"></i>',
              exportOptions: {
                columns: [ 2, 3, 4, 5],
              }
            }
          ],
        });*/

        //this.dataTable.DataTable().ajax.reload();
        //this.dataTable.draw(true);
        //this.dataTable.DataTable().data.reload();
      }, 1000);
    },
    onSelectAll ()
    {
      this.item = [];
      if (this.myDocs){
        this.documentsUser.forEach ((item) => {
          this.item.push (item.id)
        })
      }else{
        this.documents.forEach ((item) => {
          this.item.push (item.id)
        })
      }
      /*this.documents.forEach ((item) => {
        if (item.document_type_id != 1) this.item.push (item.id)
      })*/
    },
    onCopyAll(){
      if (this.item.length != 1){

        this.item.forEach ((item) => {
          this.getActiveDocuments(item).then(hasActive => {
            if (!hasActive) {
              let doc = {};
              if (this.myDocs){
                doc = this.getDocument(this.itemCheckItemSelected);
              }else{
                doc = this.getDocument(item);
              }
              if (doc.active){
                this.$dialog.alert ({
                  //title: this.$t("warning_not_active"),
                  body: this.$t("¡¡Este archivo ("+doc.name+") es de lectura y no se puede eliminar, mover, copiar o cambiar el nombre!!"),
                }, { customClass: 'cd-dialog cd-dialog--warning' })
              }else{
                this.docMoveCopy = {};
                this.move_copy = 0;
                this.showSelectFolderModal = true;
                this.titleModal = this.$t("select_folder_copy");
                this.titleBtnAccept =  this.$t('copy_btn');
                this.onLoadFolders ();
              }
            }
          });
        });
      }else{
        this.getActiveDocuments(this.item).then(hasActive => {
          if (!hasActive) {
            let doc = {};
            if (this.myDocs){
              doc = this.getDocument(this.itemCheckItemSelected);
            }else{
              doc = this.getDocument(this.item);
            }
            if (doc.active){
              this.$dialog.alert ({
                //title: this.$t("warning_not_active"),
                body: this.$t("¡¡Este archivo ("+doc.name+") es de lectura y no se puede eliminar, mover, copiar o cambiar el nombre!!"),
              }, { customClass: 'cd-dialog cd-dialog--warning' })
            }else{
              this.docMoveCopy = {};
              this.move_copy = 0;
              this.showSelectFolderModal = true;
              this.titleModal = this.$t("select_folder_copy");
              this.titleBtnAccept =  this.$t('copy_btn');
              this.onLoadFolders ();
            }
          }
        });
      }


    },
    onMoveAll(){

      //let hasactive = this.getActiveDocuments(this.item);
      //console.log(hasactive);
      if (this.item.length != 1){

        this.item.forEach ((item) => {
          this.getActiveDocuments(item).then(hasActive => {
            if (!hasActive) {
              let doc = {};
              if (this.myDocs){
                doc = this.getDocument(this.itemCheckItemSelected);
              }else{
                doc = this.getDocument(item);
              }
              if (doc.active){
                this.$dialog.alert ({
                  //title: this.$t("warning_not_active"),
                  body: this.$t("¡¡Este archivo ("+doc.name+") es de lectura y no se puede eliminar, mover, copiar o cambiar el nombre!!"),
                }, { customClass: 'cd-dialog cd-dialog--warning' })
              }else{
                this.docMoveCopy ={};
                this.move_copy = 1;
                this.showSelectFolderModal = true;
                this.titleModal = this.$t("select_folder_move");
                this.titleBtnAccept =  this.$t('move_btn');
                this.onLoadFolders ();
              }
            }
          });
        });

      }else{
        this.getActiveDocuments(this.item).then(hasActive => {
          if (!hasActive) {
            let doc = {};
            if (this.myDocs){
              doc = this.getDocument(this.itemCheckItemSelected);
            }else{
              doc = this.getDocument(this.item);
            }
            if (doc.active){
              this.$dialog.alert ({
                //title: this.$t("warning_not_active"),
                body: this.$t("¡¡Este archivo ("+doc.name+") es de lectura y no se puede eliminar, mover, copiar o cambiar el nombre!!"),
              }, { customClass: 'cd-dialog cd-dialog--warning' })
            }else{
              this.docMoveCopy ={};
              this.move_copy = 1;
              this.showSelectFolderModal = true;
              this.titleModal = this.$t("select_folder_move");
              this.titleBtnAccept =  this.$t('move_btn');
              this.onLoadFolders ();
            }
          }
        });
      }



      /*console.log("onMoveAll");
      console.log(this.item);

      this.item.forEach ((item) => {
        let doc = this.getDocument(item);
        console.log(doc);
      });*/
    },
    onUnSelectAll(){
      this.item = [];
      this.selected = [];
      this.fileView = 1;
    },
    fileComplete(){},
    cancelFile(){},
    toggleFolderTree(){

      //setTimeout (() => {
      //this.users_folder =[];
      // One request instead of one per user of the installation, asking which
      // of them have the notification set on this very folder. That is what the
      // checkboxes show, so the chain above is not read here.
      this.checkedUsersId = [];

      if (this.itemSelected.id) {
        this.$axios.post ("document/folder_notify_users", { folder_id: this.itemSelected.id })
            .then ((response) => {
              this.checkedUsersId = (response.data && response.data.user_ids) || [];
            })
            .catch (() => {
              this.$store.dispatch ('isLoadingOff');
            });
      }

      this.showFolderTree = !this.showFolderTree;
      //}, 100);

    },
    dropFile() {},
    // Dropzone checks maxFilesize by itself, but it has no notion of a batch. What is
    // still queued or travelling is what makes up the current upload (a finished one is
    // no longer part of it, so it must not count against later drops), and a file that
    // does not fit in the 500 MB is taken back out of the queue.
    onDropzoneFileAdded (file) {
      const dropzone = this.$refs["dropzone"];
      if (!dropzone || file.size > MAX_FILE_SIZE) return;

      const pending = [...dropzone.getQueuedFiles (), ...dropzone.getUploadingFiles ()];
      const queued = pending
          .filter ((queuedFile) => queuedFile !== file)
          .reduce ((total, queuedFile) => total + queuedFile.size, 0);

      if (queued + file.size <= MAX_UPLOAD_SIZE) return;

      dropzone.removeFile (file);
      this.$dialog.alert ({
        body: this.$t ("upload_batch_too_large", {
          max: this._formatSize (MAX_UPLOAD_SIZE),
          files: file.name,
        }),
      }, { customClass: 'cd-dialog cd-dialog--warning' });
    },
    // Dropzone hands over the response already parsed as the message. Only the
    // contracted space is reported here; the rest stays as quiet as it was.
    uploadFileError (file, message, xhr) {
      if (xhr && xhr.status === 403 && message && message.code === STORAGE_LIMIT) {
        showLimitDialog (this, message);
      }
    },
    uploadFileSuccess(file){
      this.upload_docs++;
      this.uploadedFiles++;
      this.$refs["dropzone"].removeFile(file);
      this.onRefresh();
      //this.getEmailsNotifications(1, "folder");
    },
    UploadSuccess(){
      this.onUpdateParentDate(this.selectFolder);
      this.onUpdateParentFiles(this.selectFolder, false);
      this.onRefresh();
      //this.$refs["dropzone"].removeAllFiles();
      //this.onSaveFolder();

      this.getEmailsNotifications(1, "folder");
      this.$dialog.alert({
        //title: this.$t("add_file"),
        body: this.$t("add_file_text"),
      }, { customClass: 'cd-dialog cd-dialog--success' })

    },
    onUpdateParent (){
      return "done it";
    },
    onClickInitPath (){
      //alert("vamos no ");
      //alert("The checked node's id: " + treeObj2.checkedNodes); // To alert the checked node's id.
      //var checkedNode = ['3621'];
      //treeObj2.uncheckAll(checkedNode);
      //this.itemSelected.parent_id = args;
    },
    onShowModalShareFolder(event, document){
      this.itemSelected = document;
      // Titled after the folder being shared. For a file that is the folder
      // holding it, whose name comes with the access list (applyShareAccess).
      this.shareTitle = (document.document_type_id == 1)
          ? this.$t ('share_title', { name: document.name })
          : this.$t ('Compartir');
      this.files = [];
      this.document_type = null;
      this.checkedEmailUsersId = [];
      this.resetShareAccess ();
      this.showShareModal = true;

      // Sharing also grants access. A folder is granted itself and a file the
      // folder holding it, which is where the link in the mail takes the user.
      // A file at the root has no such folder: the dialog then only sends mail.
      this.shareFolderId = (document.document_type_id == 1) ? document.id : (document.parent_id || null);
      if (this.shareFolderId) this.loadShareAccess (this.shareFolderId, this.shareSession);
    },
    // Who has the folder granted (shareAccessUsers, the ones the dialog can take
    // it away from) and who can open it anyway through a folder above, INICIO or
    // being an administrator (shareInherited, only greyed out).
    loadShareAccess (folderId, session) {
      this.$store.dispatch ('isLoadingOn');
      this.$axios.post ("document/folder_access", { folder_id: folderId })
          .then ((response) => {
            // The dialog may have been closed, or opened again, meanwhile.
            if (this.shareSession !== session) return;
            this.applyShareAccess (response.data);
          })
          .catch ((error) => {
            console.error ('folder_access failed:', error);
            if (this.shareSession !== session) return;
            this.shareAccessFailed = true;
            this._warnDialog (this.$t ('share_access_load_error'));
          })
          .finally (() => {
            this.$store.dispatch ('isLoadingOff');
          });
    },
    applyShareAccess (data) {
      this.shareAccessUsers = (data && Array.isArray (data.users)) ? data.users : [];
      this.shareInherited = (data && Array.isArray (data.inherited)) ? data.inherited : [];
      if (data && data.folder_name) this.shareTitle = this.$t ('share_title', { name: data.folder_name });
    },
    // Every open and close starts a new session, so a reply that arrives after
    // it is ignored instead of landing on whatever the dialog shows by then.
    resetShareAccess () {
      this.shareSession++;
      this.shareAccessFailed = false;
      this.shareFolderId = null;
      this.shareAccessUsers = [];
      this.shareInherited = [];
      this.shareRevokeIds = [];
      this.shareCheckedIds = [];
      // Shared with the user list of "Editar carpeta", which left it filled in.
      this.searchTerm = '';
    },
    // Users who can open the folder already, granted here or through a folder
    // above. They can still be ticked: they are only sent the mail again.
    hasShareAccess (userId) {
      return this.shareAccessLabels.has (Number (userId));
    },
    shareAccessLabel (userId) {
      return this.shareAccessLabels.get (Number (userId)) || '';
    },
    shareReasonLabel (reason) {
      if (reason.via === 'admin') return this.$t ('share_via_admin');
      if (reason.via === 'folder' && reason.folder_name) return this.$t ('share_via_folder', { name: reason.folder_name });
      if (reason.via === 'root') return this.$t ('share_via_root');
      return this.$t ('share_via_inherited');
    },
    // Revoking waits for "Aceptar", so it can be undone until then. Compared as
    // numbers: the user list of the dialog may carry the id as a string.
    isShareRevoked (userId) {
      return this.shareRevokeIds.some (id => Number (id) === Number (userId));
    },
    // Marking a user to revoke also unticks them: a link to a folder they are
    // about to lose would not open.
    toggleShareRevoke (userId) {
      if (this.isShareRevoked (userId)) {
        this.shareRevokeIds = this.shareRevokeIds.filter (id => Number (id) !== Number (userId));
        return;
      }
      this.shareRevokeIds = [...this.shareRevokeIds, userId];
      this.shareCheckedIds = this.shareCheckedIds.filter (id => Number (id) !== Number (userId));
    },
    // Closing without accepting drops whatever was ticked or marked to revoke.
    closeShareModal () {
      this.showShareModal = false;
      this.checkedEmailUsersId = [];
      this.resetShareAccess ();
    },
    // The X of the dialog. Ignored while saving: the save closes it itself.
    onCloseShareModal () {
      if (this.shareSaving) return;
      this.closeShareModal ();
    },
    // "Aceptar" of the share dialog. Access first and mail after: if the grants
    // cannot be saved, nobody is sent a link to a folder they cannot open.
    async onAcceptShareFolder () {
      if (this.shareSaving) return;

      // Taken now: itemSelected and the breadcrumb can change while the
      // requests are out.
      const session = this.shareSession;
      const item = this.itemSelected;
      const folderPath = this.onPrintBreadcrumb ();
      const recipients = this.shareRecipients ();
      const revokeIds = [...this.shareRevokeIds];
      const hasFolder = !!this.shareFolderId;
      // Whoever can open the folder already is only sent the mail again.
      const grantIds = hasFolder
          ? recipients.filter (user => !this.hasShareAccess (user.id)).map (user => user.id)
          : [];

      if (!recipients.length && !revokeIds.length) {
        this.closeShareModal ();
        return;
      }

      this.shareSaving = true;
      this.$store.dispatch ('isLoadingOn');
      try {
        const accessChanged = grantIds.length > 0 || revokeIds.length > 0;
        if (accessChanged && !(await this.saveShareAccess (grantIds, revokeIds))) return;

        const failed = await this.sendShareMails (recipients, item, folderPath);
        if (recipients.length > failed.length) this.onChangeStatus (8, item.id);

        if (this.shareSession === session) this.closeShareModal ();
        this.reportShareResult (accessChanged, grantIds.length, recipients.length, failed);
      } finally {
        this.shareSaving = false;
        this.$store.dispatch ('isLoadingOff');
      }
    },
    // Ticked users with the address the mail goes to, once each: users_folder
    // has a row per company, so a user in two companies is listed twice. Those
    // with access already are included, to be sent the mail again; those marked
    // to revoke are not.
    shareRecipients () {
      const ticked = new Set (this.shareCheckedIds.map (Number));
      const byId = new Map ();
      (this.users_folder || []).forEach ((user) => {
        const id = Number (user.id);
        if (ticked.has (id) && !this.isShareRevoked (id) && !byId.has (id)) byId.set (id, { id, email: user.email });
      });
      return [...byId.values ()];
    },
    saveShareAccess (grantIds, revokeIds) {
      return this.$axios.post ("document/folder_access/save", {
            folder_id      : this.shareFolderId,
            grant_user_ids : grantIds,
            revoke_user_ids: revokeIds,
          })
          .then (() => true)
          .catch ((error) => {
            console.error ('folder_access/save failed:', error);
            this._warnDialog (this.$t ('share_save_error'));
            return false;
          });
    },
    // The request the dialog always sent, one per recipient; resolves to the
    // recipients that failed. The item goes as a copy: it used to be given the
    // breadcrumb as folder_code in place, which left the row changed.
    sendShareMails (recipients, item, folderPath) {
      const sharedItem = { ...item, folder_code: folderPath };
      const requests = recipients.map ((user) => this.$axios.post ("document/email_notify", {
            email_user    : user.email,
            itemSelected  : sharedItem,
            notify        : 1,
            user          : null,
            type          : 'sharefolder',
            comment       : this.comment_text,
            numberUploaded: this.uploadedFiles,
          })
          .then (() => null)
          .catch ((error) => {
            console.error ('email_notify failed:', error);
            // Never empty, or the filter below would count it as sent.
            return user.email || `#${user.id}`;
          }));
      return Promise.all (requests).then ((results) => results.filter (Boolean));
    },
    // "Access given" only when someone was granted the folder: mailing again
    // users who had it already is just "link sent".
    reportShareResult (accessChanged, grantCount, mailCount, failed) {
      if (failed.length) {
        const key = accessChanged ? 'share_mail_failed_saved' : 'share_mail_failed';
        this._warnDialog (this.$t (key, { emails: failed.join (', ') }));
        return;
      }
      let body = this.$t ('share_saved');
      if (mailCount) body = grantCount ? this.$t ('share_done') : this.$t ('share_sent');
      this.$dialog.alert ({ body }, { customClass: 'cd-dialog cd-dialog--success' });
    },
    onShowModalFolder ()
    {
      //this.$refs.search.focus();
      this.document_type = 1
      this.titleModal = this.$t("add_folder");
      this.showModal = true;
      this.upload_docs = 0;
      this.name = null;
      this.template_id = null,
          this.folder_code = this.itemSelected ? this.itemSelected.folder_code : null;
      this.request_items = [];
      this.checkedUsersId = [];
      this.newFolderTags = [];
      this.id = null;
      this.changeTemplate = false;

      setTimeout(function () {
        document.getElementById('folderName').focus()
      }, 300)
    },
    toggleList(){
      //console.log(this);
      this.isToggled = false;
    },
    toggleMosaic(){
      //console.log(this);
      this.isToggled = true;
    },
    onShowModalFile(){
      // Was reading isRoot, which is set to false on the first tree node click and is
      // never set back to true: after visiting any folder the check stopped blocking
      // the root. selectFolder is the reliable signal, onPressRoot resets it to 0.
      // Only files are restricted here; folders can be created at the root level.
      if (this._isRootLevel ()){

        this.$dialog.alert ({
          //title: this.$t("warning_not_active"),
          body: this.$t("¡¡En este nivel no se puede subir archivos...entra dentro de una carpeta para ello!!"),
        }, { customClass: 'cd-dialog cd-dialog--warning' })
      }else{
        this.titleModal = this.$t("add_file");
        this.files = [];
        this._resetDragState ();
        this.document_type = null;
        this.showModal = true;
      }
    },
    updateDocuments (data)
    {
      // documentsList changes the folder by writing selectFolder and calling
      // this, without going through onSelectFolder, so the request has to be
      // cleared here too.
      this.clearRequestSelection ();
      this.documents = data;
      this.documentResp = data;
    },

    async toggleTagsSelectAll(folders){
      folders.forEach ((item) => {
        let docT = this.getDocument(item);
        this.toggleTagsSelect(docT);
      });
    },

    async toggleTagsSelect(item, type){
      if (type=="clientes"){
        item.tag = item.tagc;
      }else{
        item.tag = item.tags;
      }

      const value = this.itemSelected.selectedTagSingle;
      const num = Number(value);

      this.selectedValues2 = Array.isArray(value)
          ? value.map(n => Number(n)).filter(n => !isNaN(n))
          : !isNaN(num)
              ? [num]
              : [];

      try {
        const { data } = await this.$axios.post('/document/tags', {
          id: this.itemSelected.id,
          tag: this.selectedValues2
        }, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (data.success) {

          // Actualizar el valor local
          this.itemSelected.tag = this.selectedValues2;

          // Opcional: Mostrar notificación de éxito
          this.$notify({
            type: 'success',
            message: 'Etiquetas actualizadas correctamente'
          });
        } else {
          console.error('Error:', data.message);

          this.$notify({
            type: 'error',
            message: data.message || 'Error al actualizar etiquetas'
          });
        }
      } catch (error) {
        console.error('Error en la petición:', error);

        this.$notify({
          type: 'error',
          message: 'Error al actualizar etiquetas'
        });
      }
    },
    toggleActiveCheckBox(document){

      let data = {
        active            : !document.active,
      };

      this.$axios.put("/documents/"+document.id, data)
          .then(() => {
            //this.$store.dispatch('isLoadingOff');
          })
          .catch(() => {
            //this.$store.dispatch('isLoadingOff');
          });

    },
    onChangeStatus(status,doc_id){
      this.$store.dispatch('isLoadingOn');
      let data = {
        'document_id' : doc_id,
        'status_id'    : status
      }
      this.$axios.post("/document/status", data)
          .then(() => {
            this.$store.dispatch('isLoadingOff');
          })
          .catch(() => {
            this.$store.dispatch('isLoadingOff');
          })
    },

    handleLinkClick(event, document){
      this.fileView=2
      if (!Array.isArray(this.request_documentation)) return false;

      for (const item of this.request_documentation) {

        if (Array.isArray(item.request_doc) && item.request_doc.length > 0) {

          const encontrado = item.request_doc.find(doc => doc.document_id === document.id);

          if (encontrado) {
            // Was a native browser alert(). It now uses the same dialog as the rest
            // of the app: main.js registers 'cd-dialog cd-dialog--info' as the default
            // customClass, which is the right variant here (informative, nothing has
            // gone wrong), so no options argument is needed. It shows no title on
            // purpose, the message alone reads fine next to the icon.
            this.$dialog.alert({
              body: this.$t("document_linked_request", {
                name: item.name ?? this.$t("sin_nombre"),
              }),
            });

            // Devolvemos el request_id
            return encontrado.request_id;
          }
        }
      }

      return false;
    },

    handleIconClick(event, document) {
      if (event){
        this.item =[];
        this.selected = []
        //this.onLoadRequestDocumentation (document.id);
        this.itemCheckItemSelected = document;
        this.itemSelected = document;
        this.item = [];
        if (!this.selected.includes(document.id)) {
          if (!this.item.includes(document.id)) {
            /*if (this.item.includes(document.id)) {
              //this.item.splice(this.item.findIndex(v => v === document.id), 0);
            } else {
              this.item.push(document.id);
              this.selected.push(document.id);
            }*/
            this.item.push(document.id);
            this.selected.push(document.id);
          }
        }
      }
      this.onShowComments();
    },

    focused: function() {},

    ensureTreeViewClasses() {
      const treeElement = document.getElementById('treeview');

      if (treeElement) {
        // Restaurar clases esenciales
        if (!treeElement.classList.contains('e-control')) {
          treeElement.classList.add('e-control');
        }
        if (!treeElement.classList.contains('e-treeview')) {
          treeElement.classList.add('e-treeview');
        }
      }
    },

    // Pinned folders live in the API, per user: they follow the user to any
    // session and are dropped by the server as soon as the user can no longer
    // open the folder. Pinning is only a shortcut -- the tree stays complete and
    // keeps its drag and drop, and the breadcrumbs keep showing.
    //
    // Loaded with every load of the tree (onLoadFolders), so a folder renamed,
    // moved or deleted shows up as it now is, or goes.
    loadPinnedFolders () {
      const requestId = ++this.pinnedRequestId;

      return this.$axios.get ('/pinned_folders')
          .then ((response) => {
            // Only the latest load counts, and none that a pin or unpin answered
            // after it was sent (see _mutatePinned).
            if (requestId !== this.pinnedRequestId) return;
            this._setPinnedFolders (response.data);
          })
          .catch ((error) => {
            // The chips are a shortcut and the explorer works without them, so a
            // failed load leaves the list as it was instead of stopping anything.
            console.warn ('No se han podido cargar las carpetas fijadas:', error);
          });
    },

    isPinned (folderId) {
      return this.pinnedFolders.some ((pin) => String (pin.id) === String (folderId));
    },

    pinFolder (folderId) {
      return this._mutatePinned (() => this.$axios.post ('/pinned_folders', { folder_id : Number (folderId) }))
          .catch ((error) => this._warnDialog (this._pinErrorMessage (error)));
    },

    unpinFolder (folderId) {
      return this._mutatePinned (() => this.$axios.delete (`/pinned_folders/${folderId}`))
          .catch ((error) => this._warnDialog (this._pinErrorMessage (error)));
    },

    // A pin or unpin answers with the list right after the change, so it is
    // applied even when a load went out in the meantime -- sharing the load's
    // "latest wins" guard dropped it whenever the tree reloaded at the same time,
    // and the chip never showed up. It is the load that yields instead: any load
    // still on its way is older than this answer, so it is told to be ignored.
    // Between two changes, only the later one sent may write.
    _mutatePinned (send) {
      const mutationId = ++this.pinnedMutationId;

      return send ().then ((response) => {
        this.pinnedRequestId++;
        if (mutationId < this.pinnedMutationApplied) return;

        this.pinnedMutationApplied = mutationId;
        this._setPinnedFolders (response.data);
      });
    },

    // Every answer of /pinned_folders is the whole list as the server now has it,
    // so it replaces ours instead of being merged into it.
    _setPinnedFolders (list) {
      this.pinnedFolders = Array.isArray (list) ? list : [];
    },

    _pinErrorMessage (error) {
      const response = error && error.response;
      if (response && response.data && response.data.code === 'PIN_LIMIT') return this.$t ('pin_limit_reached');
      if (response && response.status === 403) return this.$t ('pin_forbidden');
      return this.$t ('pin_failed');
    },

    // Opens a pinned folder the way a click on it in the tree does: the node is
    // selected, and nodeSelected -> onSelectNode loads it, instead of a second way
    // of opening a folder that could drift from it.
    onGoToPinnedFolder (folderId) {
      const tree = this.$refs.treeview?.ej2Instances;
      if (!tree) return;

      const nodeId = String (folderId);

      // Not in the tree the user has: moved or gone since the list was loaded. The
      // list is asked for again instead of selecting a node that is not there.
      if (!this._treeData ().some ((node) => String (node.id) === nodeId)) {
        this.loadPinnedFolders ();
        return;
      }

      // The branch is opened through expandedNodes, as onTreeDataBound does: with
      // loadOnDemand a folder deep down is not rendered yet, and ensureVisible left
      // the tree collapsed. Added to what is already open, so the rest of the panel
      // stays as the user left it.
      const ancestors = this._treeAncestors (nodeId);
      if (ancestors.length > 0) {
        tree.expandedNodes = [...new Set ([...(tree.expandedNodes || []), ...ancestors])];
      }

      // Assigning the node that is already selected fires nothing, so the selection
      // is cleared first: clicking the chip has to open the folder every time.
      if (tree.selectedNodes && String (tree.selectedNodes[0]) === nodeId) {
        tree.selectedNodes = [];
        this.lastSelectedNodeId = null;
      }
      tree.selectedNodes = [nodeId];

      this._scrollTreeNodeIntoView (nodeId);
    },

    flattenTree__(nodes, result = []) {
      for (const node of nodes) {
        result.push(node);

        if (node.children && node.children.length > 0) {
          this.flattenTree(node.children, result);
        }

        // MUY IMPORTANTE: eliminar children
        delete node.children;
      }
      return result;
    },

    // ✅ Función auxiliar para contar nodos recursivamente
    countNodes(node) {
      if (!node) return 0;

      let count = 1; // Este nodo

      const children = node.children || [];
      children.forEach(child => {
        count += this.countNodes(child);
      });

      return count;
    },

    // ✅ Debugging mejorado para ver TODA la profundidad
    debugTreeStructure(nodes) {
      const printNode = (node, level = 0) => {
        const children = node.children || [];

        children.forEach(child => {
          printNode(child, level + 1);
        });
      };

      nodes.forEach(node => printNode(node));
    },

    getPathToNode(nodes, targetId, currentPath = []) {
      if (!Array.isArray(nodes)) return null;

      for (const node of nodes) {
        const nodePath = [...currentPath, node.id];

        // Si encontramos el nodo, devolver el camino
        if (String(node.id) === String(targetId)) {
          return nodePath;
        }

        // Buscar en hijos
        const children = node.children || node.subChild || node.child || [];
        if (children.length > 0) {
          const found = this.getPathToNode(children, targetId, nodePath);
          if (found) return found;
        }
      }

      return null;
    },

    forceTreeRepaint() {
      this.$nextTick(() => {
        const tree = this.$refs.treeview?.ej2Instances;
        if (!tree) {
          return;
        }

        // 1️⃣ Refresh lógico
        tree.refresh();

        // 2️⃣ Forzar repaint REAL del navegador
        const el = tree.element;
        el.style.visibility = "hidden";
        el.offsetHeight; // 🔥 fuerza reflow
        el.style.visibility = "visible";

        // 3️⃣ Recalcular iconos / nodos
        if (tree.updateNodeText) {
          tree.updateNodeText();
        }
      });
    },


    refreshTreeView() {
      this.$nextTick(() => {
        const tree = this.$refs.treeview?.ej2Instances;
        if (!tree) {
          return;
        }

        // 🔥 Forzar recálculo completo
        tree.refresh();

        // Truco clave: forzar repaint del contenedor
        const el = tree.element;
        el.style.display = "none";
        el.offsetHeight; // reflow
        el.style.display = "";
      });
    },

    findNodeRecursive(nodes, id) {
      if (!Array.isArray(nodes)) return null;

      for (const node of nodes) {
        if (String(node.id) === String(id)) {
          return node;
        }

        const children =
            node.children ||
            node.subChild ||
            node.child ||
            [];

        if (children.length > 0) {
          const found = this.findNodeRecursive(children, id);
          if (found) return found;
        }
      }

      return null;
    },

    nodeChecked: function(args, e) {
      if(args == 0){
        e.target.classList.add('e-active');
      }
      var treeObj = document.getElementById('treeview').ej2_instances[0];
      var checkedNode = [args.node];
      if (args.event.target.classList.contains('e-fullrow') || args.event.key == "Enter") {
        var getNodeDetails = treeObj.getNode(args.node);
        this.folder_code = (this.onGetFolderCode(getNodeDetails.id) != null) ? this.onGetFolderCode(getNodeDetails.id)+' / '+getNodeDetails.text : ' / '+getNodeDetails.text;
        //console.log(this.onGetFolderCode(getNodeDetails.id)+' / '+getNodeDetails.text);
        this.docIdMoveCopy = getNodeDetails.id;
        this.docNameMoveCopy = ' a '+ getNodeDetails.text;
        if (getNodeDetails.isChecked == 'true') {
          treeObj.uncheckAll(checkedNode);
        } else {
          treeObj.checkAll(checkedNode);
        }
      }
    },

    onShowSelectFolderModal(index, doc, move) {
      this.getActiveDocuments(this.item).then(hasActive => {
        if (!hasActive) {
          if (doc.active){
            this.$dialog.alert ({
              //title: this.$t("warning_not_active"),
              body: this.$t("¡¡Este archivo ("+doc.name+") es de lectura y no se puede eliminar, mover, copiar o cambiar el nombre!!"),
            }, { customClass: 'cd-dialog cd-dialog--warning' })
          }else{
            this.docMoveCopy =doc;
            this.move_copy = move;
            this.showSelectFolderModal = true;
            this.titleModal = move ? this.$t("select_folder_move") : this.$t("select_folder_copy");
            this.titleBtnAccept =  move ? this.$t('move_btn') :  this.$t('copy_btn');
          }
        }
      });
    },

    updateFolderDates(id) {
      this.$store.dispatch('isLoadingOn');
      const payload = { documents_id: Array.isArray(id) ? id : [id] };

      const req = this.$axios.post('/update_date_folders', payload);

      // Side-effects opcionales
      req.then(() => {}).catch(() => {}).finally(() => {
        // The veil is turned on by this method and used to be turned off only in the
        // catch: when the request went through it stayed on for good. Moving a folder
        // ends here, which is why the loader never went away after a move.
        this.$store.dispatch('isLoadingOff');
      });

      // Devuelve Promise<boolean> (true si todo OK)
      return req.then(({ data }) => !!data.ok).catch(() => false);
    },

    updateNumFiles(id) {
      const payload = { documents_id: Array.isArray(id) ? id : [id] };

      const req = this.$axios.post('/update_num_files', payload);

      // Side-effects opcionales
      req.then(({ data }) => {
        //console.log('update_num_files:', data.updated); // { id: num_files, ... }
        this.numFilesById = data.updated || {};
      }).catch(err => {
        console.error('update_num_files error', err);
        this.$store.dispatch('isLoadingOff');
      });

      // Devuelve Promise<boolean> (true si todo OK)
      return req.then(({ data }) => !!data.ok).catch(() => false);
    },

    getFilesCount(id) {
      // Siempre envío array para ser consistente con tu API
      const payload = { documents_id: Array.isArray(id) ? id : [id] };

      const req = this.$axios.post('/count_files', payload);

      // Side-effects opcionales
      req.then(({ data }) => {
        // p.ej. guardar el detalle por rootId:
        this.filesCountByRoot = data.counts || {};
      }).catch(err => {
        console.error('count_files error', err);
        this.$store.dispatch('isLoadingOff');
      });

      // Devuelve Promise<number> con el total del/los root(s)
      return req
          .then(({ data }) => Number(data.total_files || 0))
          .catch(() => 0);
    },

    onMoveDoc (id, doc, move) {
      if(this.structure_copy){
        this.copyStructure(id);
      }else{
        this.item.forEach ((item) => {
          let docT = this.getDocument(item);
          if (docT.active){
            if (move){
              /*this.$dialog.alert ({
                //title: this.$t("warning_not_active"),
                body: this.$t("¡¡Este archivo ("+docT.name+") es de lectura y no se puede eliminar, mover, copiar o cambiar el nombre!!"),
              })*/
            }
          }else{
            if (move){
              this.updateName(docT.id, docT, move);
            }else{
              this.copyDoc(docT.id, docT, move);
            }
          }
        });

      }

      //this.getMyDocs();
      //this.LoadDataTable();
    },
    // The input opens on the document being renamed and on nothing else. It
    // used to open on a saved row index, which pointed at whatever happened
    // to sit in that position: another row of the same folder, or a row of
    // the next folder once you had navigated away.
    onChangeName (doc) {
      // A row menu hands over its own document; the command bar hands over
      // nothing, and the target is then the only marked item.
      const target = doc || this.getDocument (this.item [0]);
      if (!target) return;
      if (target.active){
        this.$dialog.alert ({
          body: this.$t("¡¡Este archivo ("+target.name+") es de lectura y no se puede eliminar, mover, copiar o cambiar el nombre!!"),
        }, { customClass: 'cd-dialog cd-dialog--warning' })
        return;
      }
      this.editingId = target.id;
      this.editCell = target;
      this.editCellOri = JSON.parse (JSON.stringify (target));
      this.$nextTick (() => {
        const input = document.getElementById (this.renameInputId (target.id));
        if (input) input.focus ();
      });
    },
    // Explorar and Listar are both always in the DOM (v-show, not v-if), so
    // each view needs an id of its own: sharing one made getElementById
    // answer with the hidden input of Explorar while "Listar" was open.
    renameInputId (id) {
      if (this.myDocs) return 'edit-cellL-' + id;
      return (this.isToggled ? 'edit-cellM-' : 'edit-cell-') + id;
    },
    // Renaming belongs to a document, not to a row, and it does not outlive
    // the listing it was opened on: leaving the folder or reloading has to
    // drop it, or the input comes back on whatever holds that place now.
    stopRenaming () {
      this.editingId = null;
      this.editCell = {};
      this.editCellOri = {};
    },
    // Clicking away from the input saves, the same as pressing enter: leaving a
    // half-typed name on screen with no way of telling whether it had been kept
    // is worse than either outcome. updateName turns down a name that is blank
    // or unchanged on its own, so those clicks only close the editor.
    // Enter and escape both end at stopRenaming, and hiding the input there
    // makes it lose the focus too: without this guard the blur that follows
    // would run a second time over a row that is no longer being edited.
    onRenameBlur (doc) {
      if (!doc || this.editingId !== doc.id) return;
      this.updateName (doc.id, doc, null);
    },
    onDownloadFile () {
      let doc = this.getDocument(this.item);
      let doc_id = doc.id;
      this.$store.dispatch ('isLoadingOn');
      this.$axios ({
        url: '/document/download_file/'+doc_id, //your url
        method: 'GET',
        responseType: 'blob', // important
      }).then((response) => {
        //console.log(response.data);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        link.setAttribute('download', downloadFileName(response, doc.name));
        document.body.appendChild(link);
        link.click();
        this.onChangeStatus(1,doc_id);
      })
      .catch((error) => {
        this.onFileError (error, doc.name);
      })
      // Every exit has to switch the overlay off, not just the happy path.
      .finally(() => {
        this.$store.dispatch ('isLoadingOff');
      });
    },

    // Rebuilds the folder tree from the database, leaving the user on the folder
    // they were on and with the branches they had open still open.
    //
    // The folders are asked for through onLoadFolders, which is what knows which
    // endpoint answers for this role. This used to read /documents on its own:
    // the whole listing of every document just to keep the folders out of it,
    // and, for a client, the entire tree of the installation instead of the
    // folders assigned to them. It also left this.directory behind, so the name
    // just changed was still the old one everywhere that list is read.
    async reloadTreeFromBackend(selectNodeId = null) {
      this.$store.dispatch('isLoadingOn');

      try {
        const previous = document.getElementById('treeview')?.ej2_instances?.[0];
        const expanded = previous ? (previous.expandedNodes || []).slice() : [];

        await this.onLoadFolders();

        // The backup the "fijar carpeta" and "copiar estructura" paths read.
        this.originalData = JSON.parse(JSON.stringify(this.fields.dataSource || []));

        // Forcing the rebuild: the treeview holds its own copy of the datasource
        // and does not redraw itself when it is replaced.
        this.show = false;
        await this.$nextTick();
        this.show = true;
        await this.$nextTick();

        // Clearing the persisted state, or the old structure comes back with it.
        const treeObj = document.getElementById('treeview')?.ej2_instances?.[0];
        if (treeObj?.clearPersistData) {
          treeObj.clearPersistData();
        }

        if (treeObj && expanded.length) {
          treeObj.expandAll(expanded);
        }

        if (selectNodeId && treeObj) {
          treeObj.selectedNodes = [String(selectNodeId)];
        }

      } catch (e) {
        this.mostrarMensaje(
            'Error al recargar el árbol desde BD',
            'error'
        );
      } finally {
        this.$store.dispatch('isLoadingOff');
      }
    },

    // Deleting from the listing: one request carrying everything that is
    // ticked, and the server takes each subtree whole.
    //
    // What used to be here walked the tree from the browser, and got it wrong
    // twice over. This listing posted once per ticked id without walking
    // anything, so ticking a folder orphaned everything below it. And
    // onDeleteFolderFile, which did walk, only ever deleted leaves: the
    // "num_files != 0" branch fetched the children and started again, never
    // reaching the container itself. On top of that the walk only got as far as
    // the tab stayed open.
    onDeleteAllFile () {
      const ids = (Array.isArray (this.item) ? this.item : [this.item])
          .filter ((id) => id !== null && id !== undefined);

      if (!ids.length) return;

      // The selected rows themselves: getActiveDocuments only looks at what
      // hangs below them. One read-only document is enough for the server to
      // refuse the whole call, so it is said here and nothing is sent.
      const locked = ids.map ((id) => this.getDocument (id)).filter ((doc) => doc && doc.active == 1);

      if (locked.length)
      {
        this.$dialog.alert ({
          body : this.$t ("delete_read_only_blocked", { names : locked.map ((doc) => doc.name).join (", ") }),
        }, { customClass : 'cd-dialog cd-dialog--warning' })
        return;
      }

      const first = this.getDocument (ids[0]);
      const parentId = first ? first.parent_id : this.selectFolder;

      this.getActiveDocuments (ids).then (hasActive => {
        if (hasActive) return;   // getActiveDocuments has already warned

        this.$dialog.confirm ({
          // El mensaje viajaba en "title", sin body. Con el restyling el
          // título se pinta en verde y a 1.25rem (estilo de encabezado),
          // así que la pregunta se mueve al cuerpo, que es su sitio y donde
          // está en el resto de diálogos.
          //
          // The question now says what is actually about to happen. It used to
          // be "este archivo", in the singular and about a file, for a tick
          // that can carry several rows and whole folders with everything
          // inside them -- which is precisely what nobody was being told.
          body: this.deleteConfirmMessage (ids),
          okText: this.$t("Aceptar"),
          cancelText: this.$t("Cancelar"),
        },
        { customClass: 'cd-dialog cd-dialog--danger' })
            .then (() => this.runDelete (ids, parentId))
      });
    },
    // One row or several, a file or a folder: the warning about losing the
    // contents only belongs on the ones that have contents.
    deleteConfirmMessage (ids) {
      if (ids.length > 1) return this.$t ("delete_selection_confirm", { count : ids.length });

      const doc = this.getDocument (ids[0]);
      const name = doc ? doc.name : '';

      return doc && doc.document_type_id == 1
          ? this.$t ("delete_folder_confirm", { name : name })
          : this.$t ("delete_file_confirm", { name : name });
    },
    // The request itself, shared by the listing and by the tree. It resolves to
    // true only once the server has confirmed, so that a caller does not touch
    // the view for a deletion that was refused.
    runDelete (ids, parentId) {
      // A root folder, or a row already stored without a parent, has none to go
      // back to but the root itself.
      const backTo = this._folderOrRoot (parentId);
      this.$store.dispatch ('isLoadingOn');

      return this.$axios.post (`/delete_documents`, { "documents_id" : ids })
          .then (() => {
            this.itemSelected = null;
            this.item = [];

            // For the tree this is also the move back to the parent folder: the
            // one on screen may be the one that has just gone.
            this.selectFolder = backTo;

            this.onRefresh ();
            this.onLoadBreadcrumb ();
            this.$store.dispatch ('isLoadingOff');

            // The tree is rebuilt from the database. The node used to be taken
            // out by hand as soon as the dialog was confirmed, without waiting
            // for the answer and without putting it back on failure, so a
            // folder left the view while it was still there.
            this.reloadTreeFromBackend (backTo);

            return true;
          })
          .catch ((error) => {
            this.$store.dispatch ('isLoadingOff');

            // 409: something inside what was to be deleted is read-only, and
            // nothing was deleted. The server checks it as well as the earlier
            // query, because one call now carries the whole tree and a single
            // locked file at any depth is enough to stop it.
            const data = error.response && error.response.data;

            this.$dialog.alert ({
              body : data && data.error === 'read_only'
                  ? this.$t ("read_only_inside")
                  : this.$t ("delete_failed"),
            }, { customClass : 'cd-dialog cd-dialog--warning' })

            return false;
          });
    },
    onAddRequest () {
      if (this.item_request)
      {
        this.request_items.push ({
          name : this.item_request,
          isNew : true,
          isIndex : false
        });
        this.item_request = null;
      }
    },
    onDragStart(e, item) {

      // Si el drag empieza desde un control interactivo, NO arrastres la fila
      const interactive = e.target.closest('input, textarea, select, button, a, .badge_tag, .multiselect, .vue-multiselect');
      if (interactive) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      this.draggedRow = item;
      this.draggingId = item.id;
      var nodeId = [];
      nodeId.push(item.id);
      this.item = nodeId;
      //this.onCheckItem(event, row, 1);

      // Guarda el dato que se está arrastrando (por si lo necesitas)
      e.dataTransfer.setData('text/plain', JSON.stringify(item));

      // The pointer carries a small chip with the icon and the name of what is being
      // dragged. Left to the browser, the drag image is a snapshot of the <tr>: it is
      // as wide as the whole table, so it came up as a long faded streak across the
      // listing that said nothing about what was on the move.
      const ghost = this._buildDragGhost(item);
      e.dataTransfer.setDragImage(ghost, 14, 14);
      // The image is painted during dragstart, so the node only has to exist for this
      // event: it is dropped on the next tick.
      setTimeout(() => {
        if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
      }, 0);
    },
    // Chip used as the drag image. It is built by hand and hung off <body> because
    // setDragImage needs a node the browser has actually rendered; .cd-drag-ghost parks
    // it off-screen and out of the flow for the instant it is needed. Its rule cannot
    // live in a scoped block either, since this node is not part of the template.
    _buildDragGhost (item) {
      const ghost = document.createElement ('div');
      ghost.className = 'cd-drag-ghost';

      // Same icons as the listing: Font Awesome for a folder, the file-type sprites of
      // .e-fe-* for a document. A type with no sprite falls back to a generic file.
      const icon = document.createElement ('span');
      if (item.document_type_id == 1)
      {
        icon.className = 'fas fa-folder folder-icon cd-drag-ghost__glyph';
      }
      else if (this.documentIconClass(item))
      {
        icon.className = 'e-list-icon cd-drag-ghost__icon ' + this.documentIconClass(item);
      }
      else
      {
        icon.className = 'far fa-file cd-drag-ghost__glyph';
      }

      const name = document.createElement ('span');
      name.className = 'cd-drag-ghost__name';
      name.textContent = item.name;

      ghost.appendChild (icon);
      ghost.appendChild (name);
      document.body.appendChild (ghost);

      return ghost;
    },
    // The dragged row and any lit-up drop target go back to normal when the drag is
    // over, whether it ended on a drop or was cancelled with Esc.
    onDragEnd () {
      this.draggingId = null;
      this.dragOverRequest = null;
      this.dropTargetId = null;
    },
    // A request only lights up for a document dragged from the listing: files coming
    // from the desktop are not linked to a request (onDrop ignores them), and a folder
    // is refused with a warning, so neither of the two gets the highlight.
    onRequestDragOver (event, key) {
      if (this._isExternalFileDrag (event)) return;
      if (!this.draggedRow || this.draggedRow.document_type_id == 1) return;

      this.dragOverRequest = key;
    },
    // dragleave bubbles up from every child the pointer crosses inside the request, so
    // the highlight is only dropped once the pointer has really left it. relatedTarget
    // would say where the pointer went, but Chrome leaves it empty on dragleave, so the
    // pointer position is what decides.
    onRequestDragLeave (event) {
      const row = event.currentTarget;
      const next = event.relatedTarget;
      if (next && row.contains (next)) return;

      const box = row.getBoundingClientRect ();
      const isInside = event.clientX >= box.left && event.clientX <= box.right &&
                       event.clientY >= box.top && event.clientY <= box.bottom;
      if (isInside) return;

      this.dragOverRequest = null;
    },
    onDrop(zone) {
      this.dragOverRequest = null;
      if (this.draggedRow) {
        if (this.draggedRow.document_type_id == 1){
          this.$dialog.alert({
            body: this.$t("drop_folder_not_allowed"),
          }, { customClass: 'cd-dialog cd-dialog--warning' });
          return false;
        }
        this.onSelectRequest (zone);
        // aquí puedes hacer lo que necesites, como mover, eliminar o procesar
        this.draggedRow = null;
      }
    },
    onDropDown(event, document){
      // A menu opened from the three dots (or one being closed) goes back to the
      // position the stylesheet gives it. The one the right click is placing right
      // now is the exception, or it would snap back to the button.
      if (!this.openingRowMenu) this._resetRowMenuPosition ();
      //console.log(document);
      //console.log(this.itemSelected);
      if (event){
        this.item =[];
        this.selected = []
        //this.onLoadRequestDocumentation (document.id);
        this.itemCheckItemSelected = document;
        this.itemSelected = document;
        this.item = [];
        if (!this.selected.includes(document.id)) {
          if (!this.item.includes(document.id)) {
            /*if (this.item.includes(document.id)) {
              //this.item.splice(this.item.findIndex(v => v === document.id), 0);
            } else {
              this.item.push(document.id);
              this.selected.push(document.id);
            }*/
            this.item.push(document.id);
            this.selected.push(document.id);
          }
        }
      }
      //console.log("***_____****");
      this.savedIndex = null;
    },
    onEditDocumentationDrop () {
      if (this.itemSelected){
        this.document_type = 1;
        this.titleModal = this.$t("edit_req_doc")+" para "+this.itemSelected.name;
        this.name = this.itemSelected.name;
        this.id = this.itemSelected.id;
        this.folder_code = this.itemSelected.folder_code;
        this.selectEditDocFolder = this.itemSelected.parent_id;
        this.template_id = null,
            this.request_items = _.sortBy(this.itemSelected.request_documentation, 'position_list');
        /*this.template_id = null,
            this.request_items = this.itemDocRequired.request_documentation;*/
        this.showModalRequiredDoc = true;
        this.changeTemplate = false;
      }
    },

    onDownloadDocumentation() {

      // 🔹 Mapa rápido de documentos por id (para obtener el nombre del archivo vinculado)
      // Ajusta `this.documents` y los campos `id` / `name` si en tu código se llaman distinto.
      const documentsById = (this.documents || []).reduce((acc, d) => {
        acc[d.id] = d;
        return acc;
      }, {});

      const rows = [];

      // 🔹 Fila de cabecera
      /*rows.push(
          new TableRow({
            children: [
              new TableCell({ children: [new Paragraph("Solicitud")] }),
              new TableCell({ children: [new Paragraph("Estado")] }),
              new TableCell({ children: [new Paragraph("Nombre archivo vinculado")] }),
            ],
          })
      );*/

      const headerCellStyle = {
        shading: {
          fill: "4472C4", // azul Word
        },
      };

      const headerText = (text) =>
          new Paragraph({
            children: [
              new TextRun({
                text,
                bold: true,
                color: "FFFFFF", // texto blanco
              }),
            ],
            alignment: "left",
          });

      rows.push(
          new TableRow({
            children: [
              new TableCell({
                ...headerCellStyle,
                children: [headerText("Solicitud")],
              }),
              new TableCell({
                ...headerCellStyle,
                children: [headerText("Estado")],
              }),
              new TableCell({
                ...headerCellStyle,
                children: [headerText("Nombre archivo vinculado")],
              }),
            ],
          })
      );


      // 🔹 Recorrer las solicitudes
      this.request_documentation.forEach((doc) => {
        // ⬇️ Ajusta estos campos a los que realmente tengas en `request_documentation`
        /*const carpeta =
            this.itemSelected?.name ||
            doc.carpeta ||
            doc.folder_name ||
            doc.carpeta_name ||
            ""; // intenta varios posibles */
        const solicitud = doc.request_name || doc.name || "";
        /*const estado = doc.status ||
            doc.carpeta ||
            doc.folder_name ||
            "";*/

        // Si tiene archivos vinculados → una fila por cada archivo
        if (Array.isArray(doc.request_doc) && doc.request_doc.length > 0) {
          doc.request_doc.forEach((reqDoc) => {
            // 🔹 Intentar sacar el nombre del archivo desde `documentsById`
            let nombreArchivo = "";

            if (reqDoc.document_id && documentsById[reqDoc.document_id]) {
              nombreArchivo = documentsById[reqDoc.document_id].name || "";
            } else {
              // Campos de fallback si vienen ya en el propio `reqDoc`
              nombreArchivo =
                  reqDoc.document_name ||
                  reqDoc.name ||
                  reqDoc.filename ||
                  "Archivo sin nombre";
            }
            const estado = 'Vinculado';

            rows.push(
                new TableRow({
                  children: [
                    //new TableCell({ children: [new Paragraph(carpeta)] }),
                    new TableCell({ children: [new Paragraph(solicitud)] }),
                    new TableCell({ children: [new Paragraph(estado)] }),
                    new TableCell({ children: [new Paragraph(nombreArchivo)] }),
                  ],
                })
            );
          });
        } else {
          const estado = 'No Vinculado';
          // Sin archivos vinculados → una fila con "Sin archivo"
          rows.push(
              new TableRow({
                children: [
                  //new TableCell({ children: [new Paragraph(carpeta)] }),
                  new TableCell({ children: [new Paragraph(solicitud)] }),
                  new TableCell({ children: [new Paragraph(estado)] }),
                  new TableCell({ children: [new Paragraph("")] }),
                ],
              })
          );
        }
      });

      // 🔹 Crear tabla
      const table = new Table({
        width: { size: 100, type: WidthType.PERCENTAGE },
        rows,
      });

      // 🔹 Crear documento
      const doc = new Document({
        sections: [
          {
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Listado de solicitud de documentación para la carpeta "+this.itemSelected?.name+"",
                    bold: true,
                  }),
                ],
                spacing: { after: 300 },
              }),
              table,
            ],
          },
        ],
      });

      // 🔹 Descargar
      Packer.toBlob(doc).then((blob) => {
        const filename = `solicitudes_${
            this.itemSelected?.name || "descarga"
        }.docx`;
        saveAs(blob, filename);
      });
    },

    onDownloadDocumentation__() {

      let content = "";

      this.request_documentation.forEach((doc, index) => {
        content += `=== Solicitud ${index + 1} ===\n`;
        for (const [key, value] of Object.entries(doc)) {
          if (key !== 'request_doc') {
            if (key === 'name') content += `${key}: ${value}\n`;
          }
        }

        if (Array.isArray(doc.request_doc) && doc.request_doc.length > 0) {
          content += `-- Archivo vinculado (${doc.request_doc.length}) --\n`;
          doc.request_doc.forEach((reqDoc, i) => {
            content += `  [${i + 1}] document_id: ${reqDoc.document_id}\n`;
            content += `       created_at: ${reqDoc.created_at}\n`;
            if (reqDoc.user) {
              content += `       Usuario:\n`;
              content += `         nombre: ${reqDoc.user.name}\n`;
              content += `         email: ${reqDoc.user.email}\n`;
            }
          });
        } else {
          content += `-- Archivo vinculado: vacío --\n`;
        }

        content += "\n";
      });

      // Crear el documento Word correctamente
      const paragraphs = content.split("\n").map(line => new Paragraph(line));
      const doc = new Document({ sections: [{ properties: {}, children: paragraphs }] });

      Packer.toBlob(doc).then(blob => {
        const filename = `documentacion_${this.itemSelected?.name || 'descarga'}.docx`;
        saveAs(blob, filename);
      });
    },

    onEditDocumentation () {
      if (!$.isEmptyObject(this.itemSelected)){
        this.document_type = 1;
        this.titleModal = this.$t("edit_req_doc")+" para "+this.itemSelected.name;
        this.name = this.itemSelected.name;
        this.id = this.itemSelected.id;
        this.folder_code = this.itemSelected.folder_code;
        this.selectEditDocFolder = this.itemSelected.parent_id;
        /*this.template_id = null,
             this.request_items = _.sortBy(this.itemSelected.request_documentation, 'position_list');*/
        this.template_id = null,
            this.request_items = _.sortBy(this.request_documentation, 'position_list');
        this.template_id = null,
            this.request_items = _.sortBy(this.request_documentation, 'position_list');
        /*if (!this.isNodeClicked){
          console.log("----oneditdocumentation----");
          this.template_id = null,
              this.request_items = _.sortBy(this.itemSelected.request_documentation, 'position_list');
        }else{
          this.template_id = null,
              this.request_items = this.itemDocRequired.request_documentation;
        }*/
        this.showModalRequiredDoc = true;
        this.changeTemplate = false;
        this.isNodeClicked = true;
      }
      /*this.document_type = 1;
      this.titleModal = this.$t("edit_req_doc")+" para "+this.itemSelected.name;
      this.name = this.itemSelected.name;
      this.id = this.itemSelected.id;
      this.folder_code = this.itemSelected.folder_code;
      this.template_id = null,
          this.request_items = this.itemSelected.request_documentation;
      this.showModalRequiredDoc = true;
      this.changeTemplate = false;*/
    },
    onEditFolder () {
      this.isNew = false;
      this.document_type = 1;
      this.titleModal = this.$t("edit_folder");
      this.name = this.itemSelected.name;
      this.id = this.itemSelected.id;
      this.folder_code = this.itemSelected.folder_code;
      this.template_id = null,
          this.request_items = _.sortBy(this.itemSelected.request_documentation, 'position_list');
      /*this.template_id = null,
          this.request_items = this.itemSelected.request_documentation;*/

      // NORMALIZA LOS TAGS AQUÍ TAMBIÉN
      this.itemSelected.tag = this.parseTagString(this.itemSelected.tag);
      this.itemSelected.selectedTagSingle = this.parseTagString(this.itemSelected.tag);

      // The picker starts on the tags the folder already carries. A copy: editing it
      // must not touch the row of the listing before the form is saved.
      this.newFolderTags = [...(this.itemSelected.tag || [])];

      this.showModal = true;
      this.changeTemplate = false;
      this.toggleFolderTree();
    },
    onGetNumberDocs (id) {
      let me = this;
      //console.log(this.isToggled);
      this.$axios (`/documents?where-parent_id=${id}`)
          .then ((response) => {
            this.$store.dispatch ('isLoadingOff');
            //const count = count(response.data);
            //console.log(response.data.length);
            me.count = response.data.length;

            if(this.isToggled)
            {
              var badgediv = document.getElementById("badge_"+id);
              badgediv.innerHTML=response.data.length;
              if (response.data.length == 0){
                //console.log("hidding mosaic badges");
                badgediv.style.display = 'none';
              }
            }else{
              var badgediv2 = document.getElementById("badge_list_"+id);
              badgediv2.innerHTML=response.data.length;
              if (response.data.length == 0){
                //console.log("hidding list badges");
                badgediv2.style.display = 'none';
              }
            }

          })
          .catch (() => {
            this.$store.dispatch ('isLoadingOff');
          });

    },
    onSelectPathFolder (document) {
      this.stopRenaming ();
      if (this.selectFolder != document.id)
      {
        // Same as onSelectFolder: the request of the previous folder goes first.
        this.clearRequestSelection ();
        this.clearSearchFilter ();
        this.itemDocRequired = document;
        this.itemSelected = document;
        this.onLoadRequestDocumentation (document.parent_id);
        this.sfolder = document;
        this.$store.dispatch ('isLoadingOn');
        this.$axios (`/documents?where-parent_id=${document.parent_id}`)
            .then ((response) => {
              this.$store.dispatch ('isLoadingOff');
              this.documents = response.data;
              this.item = [];
              this.documentResp = this.documents;
              this.selectFolder = document.parent_id;
              this.fileView = 1;
              // In "Listar" the list is what has to follow the path, and the request
              // travels by breadcrumbs: it waits for them instead of firing before
              // they are updated, which is why the old call did nothing.
              this.onLoadBreadcrumb ().then (() => {
                if (this.myDocs) this.getMyDocs (true);
              });
              this.showOptions = false;
            })
            .catch (() => {
              this.$store.dispatch ('isLoadingOff');
            });
      }
      // Clicking the crumb of the folder already open: in "Listar" it reloads the
      // list, because onRefresh switches back to "Explorar" and picking a crumb is
      // no reason to change view.
      else if (this.myDocs) this.getMyDocs (true);
      else this.onRefresh ();
    },
    onSelectFolder (doc) {
      this.stopRenaming ();

      if (this.selectFolder != doc.id)
      {
        // Who may see the folder belongs to the folder being opened, so it is asked
        // for here and not before the check: reclicking the folder already on screen
        // used to fire this request again for nothing.
        this.$axios.post (`/document/users_folder`, { parent_id: doc.id })
            .then ((response) => {
              this.folderUsers = response.data;
            })
            .catch (() => {
              this.$store.dispatch ('isLoadingOff');
            });

        // Cleared before the documentation of the new folder is loaded, see
        // clearRequestSelection.
        this.clearRequestSelection ();
        this.clearSearchFilter ();
        this.itemDocRequired = doc;
        this.itemSelected = doc;
        this.onLoadRequestDocumentation (doc.id);
        this.sfolder = doc;
        //this.$store.dispatch ('isLoadingOn');
        const requestId = ++this.folderRequestId;
        this.$axios (`/documents?where-parent_id=${doc.id}`)
            .then ((response) => {
              //this.$store.dispatch ('isLoadingOff');
              // Another folder was opened while this was travelling: its listing is
              // the one on screen and this answer must not overwrite it.
              if (requestId !== this.folderRequestId) return;

              this.documents = response.data;
              this.item = [];
              this.documentResp = this.documents;
              this.selectFolder = doc.id;
              this.fileView = 1;
              // Same as onSelectPathFolder: "Listar" reloads its list for the folder
              // just picked, once the breadcrumbs of the new path have arrived.
              this.onLoadBreadcrumb ().then (() => {
                if (this.myDocs) this.getMyDocs (true);
              });
              this.showOptions = false;
              const treeObj = document.getElementById('treeview').ej2_instances[0];

              // 🔥 Asegurar mismo tipo
              const nodeId = String(doc.id);

              // Selecting the node fires nodeSelected, and that handler opens the
              // folder all over again. The tree is only being kept in step with a
              // folder that is already open, so onSelectNode is told beforehand that
              // this node is the current one and has nothing left to do.
              this.lastSelectedNodeId = nodeId;
              treeObj.selectedNodes = [nodeId];
              //treeObj.ensureVisible(nodeId);

              // Expande todo y ya está
              //treeObj.expandAll();

            })
            .catch (() => {
              this.$store.dispatch ('isLoadingOff');
            });
      }
      // Same as onSelectPathFolder: staying in "Listar" instead of being thrown
      // back to "Explorar" by onRefresh.
      else if (this.myDocs) this.getMyDocs (true);
      else this.onRefresh ();
    },
    onSelectTemplate () {
      this.changeTemplate = true;
      this.$store.dispatch ('isLoadingOn');
      this.$axios ("/template_request?where-template_id=" + this.template_id)
          .then ((response) => {
            let data =  response.data;
            data.forEach ((item) => {
              item.isNew = true;
            });
            this.request_items = data;
            this.$store.dispatch ('isLoadingOff');
          })
          .catch (() => {
            this.$store.dispatch ('isLoadingOff');
          })
    },
    onRemoveRequestFolder () {
      this.$axios.delete ("/folder_request/" + this.id)
          .then (() => {

          })
    },
    deleteEvent (item, index) {
      this.request_items.splice (index, 1);
      if (!item.isNew)
      {
        this.$store.dispatch ('isLoadingOn');
        this.$axios
            .delete ("/folder_documentation/" + item.id)
            .then (() => {
              this.$store.dispatch ('isLoadingOff');
            })
      }
    },
    onSelectItemRequest (item) {
      if (item.request_doc.length == 0){

        this.$axios (`/documents?where-parent_id=${this.selectFolder}`)
            .then ((response) => {
              if (this.myDocs){
                this.documentsUser = response.data
              }else{
                this.documents = response.data
              }
              this.item = [];
              this.fileView = 2;
              //this.$store.dispatch ('isLoadingOff');
            })
            .catch (() => {
              this.$store.dispatch ('isLoadingOff');
            });
      }

      this.documents = [];
      for (let row in item.request_doc)
      {
        this.documentResp.forEach ((document) => {
          if (document.id == item.request_doc [row].document_id){
            this.documents.push (document);
          }
        })
      }
      this.itemRequestSelected = item;
    },
    // Drops the selected request. Selecting one narrows "documents" down to the
    // files linked to it, and onLoadRequestDocumentation reapplies the selection
    // at the end of every load, so anything that moves to another folder has to
    // clear it first: that is what kept forcing the "Solicitudes" tab, with the
    // request of the folder just left, on each folder change.
    clearRequestSelection () {
      this.itemRequestSelected = null;
    },
    // The "Documentos" tab only flipped fileView, leaving the listing filtered by
    // the request, so it looked as if there were no way back other than refresh.
    onShowDocumentsTab () {
      const wasFilteredByRequest = !!this.itemRequestSelected;
      this.fileView = 1;
      this.clearRequestSelection ();
      // Only worth touching the listing when a request was filtering it:
      // documentResp is empty at the root, and copying it over would blank the
      // list instead of restoring it.
      if (!wasFilteredByRequest) return;
      this.documents = [...this.documentResp];
      // "Listar" is a DataTable built by getMyDocs: reassigning the array does
      // not reach it, the table has to be rebuilt.
      if (this.myDocs) this.getMyDocs (true);
    },
    onSelectRequest (item) {
      let self = this;
      if (this.item.length == 0)
      {
        this.$dialog.alert ({
          //title: this.$t("CargarDocumentacion"),
          body: this.$t("CargarDocumentacionTextError"),
        })
        return false;
      }
      if (this.getDocument(this.item).active == 1)
      {
        this.$dialog.alert ({
          //title: this.$t("warning_not_active"),
          body: this.$t("warning_not_activeTextError"),
        }, { customClass: 'cd-dialog cd-dialog--warning' })
        return false;
      }
      let data = {
        "documents_id" : this.item,
        "request_type_id" : item.id
      };
      this.$dialog.confirm ({
        //title: self.$t("CargarDocumentacion"),
        body: self.$t("CargarDocumentacionText"),
        okText: self.$t("Sí"),
        cancelText: self.$t("No"),
      })
          .then (
              function ()
              {
                self.$store.dispatch ('isLoadingOn');
                self.$axios
                    .post ("/document_request", data)
                    .then (() => {
                      self.item = [];
                      self.onLoadRequestDocumentation (self.selectFolder);
                      self.$store.dispatch ('isLoadingOff');
                    })
                    .catch (() => {
                      self.$store.dispatch ('isLoadingOff');
                    })
              }
          )
    },
    onRemoveRequest (item) {
      let self = this;
      this.$dialog
          .confirm ({
            backdropClose: false,
            //title: this.$t("CargarDocumentacion"),
            body: this.$t("UncheckItemDocumentation"),
          },
          // Las opciones van en el SEGUNDO argumento: el plugin mete el
          // primero entero dentro de options.message, de donde solo lee
          // "title" y "body". Lo que se cuele ahí se ignora en silencio.
          { customClass: 'cd-dialog cd-dialog--danger' })
          .then (() => {
            self.$axios.delete ("/document_request/" + item.id)
                .then (() => {
                  self.onLoadRequestDocumentation (self.selectFolder);
                })
          })
    },
    isDocumentLinked(id) {
      // Por si acaso el array no está cargado aún
      if (!Array.isArray(this.request_documentation)) return false;

      for (const item of this.request_documentation) {
        //console.log(item);

        if (Array.isArray(item.request_doc) && item.request_doc.length > 0) {
          // Si solo quieres comprobar el primero:
          // console.log(item.request_doc[0].document_id);
          // console.log("----------------------------------------");
          // if (item.request_doc[0].document_id === id) return true;

          // Mejor: comprobar TODOS los documentos de request_doc
          const encontrado = item.request_doc.some(doc => {
            //console.log(doc.document_id);
            //console.log("----------------------------------------");
            return doc.document_id === id;
          });

          if (encontrado) {
            return true;
          }
        }
      }

      return false;
    },
    // Returns the request: the documentation of the folder is asked for once here and
    // both the listing of requests and the editor read from that single answer.
    // onSelectNode used to fetch the very same url a second time for request_items.
    onLoadRequestDocumentation (id) {
      return this.$axios ("/folder_documentation?where-folder_id=" + id)
          .then ((response) => {
            //this.request_documentation = response.data;
            this.request_documentation = _.sortBy(response.data, 'position_list');
            // A copy of its own: the editor reorders, adds to and edits request_items,
            // and that must not reach the list the folder was loaded with.
            this.request_items = this.request_documentation.slice ();
            let self = this;
            this.request_documentation.forEach ((item) => {
              if (item.request_doc.length > 0) self.request_id.push (item.request_doc [0].request_id);
            });
            if (this.itemRequestSelected) self.onSelectItemRequest (this.itemRequestSelected);
          })
          .catch (() => {
            // The folder opens all the same: it simply comes up with no documentation
            // requested, which is also what an empty answer looks like.
            this.request_documentation = [];
            this.request_items = [];
          })
    },
    onOpenDocument (id) {
      this.$store.dispatch ('isLoadingOn');
      this.$axios (`/document/download/${id}`)
          .then ((response) => {
            this.$store.dispatch ('isLoadingOff');
            let file = response.data;
            if (file.type == "BASE64")
            {
              var byteCharacters = atob (file.url);
              var byteNumbers = new Array (byteCharacters.length);
              for (var i = 0; i < byteCharacters.length; i++)
              {
                byteNumbers[i] = byteCharacters.charCodeAt (i);
              }
              var byteArray = new Uint8Array (byteNumbers);
              var file64 = new Blob (
                  [byteArray], {type: 'application/pdf;base64'}
              );
              var fileURL = URL.createObjectURL (file64);
              window.open (fileURL);
            }
            else window.open (file.url);
          })
          // Until the backend started checking the object exists, this catch
          // never ran: the call answered 200 and the user met S3's NoSuchKey
          // XML inside the tab window.open had already spawned.
          .catch ((error) => {
            this.$store.dispatch ('isLoadingOff');
            this.onFileError (error, this.getDocumentName (id));
          })
    },
    // Best effort: the name is only there to make the warning concrete, so a
    // document that is not in the current listing just yields a generic one.
    getDocumentName (id) {
      const doc = this.getDocument (id);
      return doc && doc.name ? doc.name : null;
    },
    onCheckItem (event, document, index) {
      // v-model has already updated this.item by the time the change event
      // reaches here, so the state of the box is the state of the row.
      this.applyCheckState (event.target.checked, document, index);
    },
    // What follows a row being marked or unmarked, shared by its checkbox and
    // by the click on the part of the name cell with no text.
    applyCheckState (checked, document, index) {
      this.savedIndex = index;
      if (checked) this.itemCheckItemSelected = document;
      else this.itemCheckItemSelected = this.item.length == 1 ? this.getDocument (this.item [0]) : null;
      if (checked) this.itemSelected = document;
      else this.itemSelected = this.item.length == 1 ? this.getDocument (this.item [0]) : null;
      if (this.item.length == 0) this.fileView = 1;
    },
    // Clicking the name cell away from the name marks the row, the same as its
    // checkbox: marking is the only selection the listing has (the green row
    // plus the actions of the command bar). Here the box is not the one
    // reporting the change, so this.item is updated first.
    onSelectRow (document, index) {
      const checked = !this.item.includes (document.id);
      this.item = checked
          ? [...this.item, document.id]
          : this.item.filter (id => id !== document.id);
      this.applyCheckState (checked, document, index);
    },
    getUserName (id) {
      //console.log(this.getDocument(id).user_id);
      //console.log(this.folders);
      return this.getDocument(id).user_id;
    },

    getActiveDocuments(id) {

      const payload = {
        documents_id: Array.isArray(id) ? id : [id],
      };

      const req = this.$axios.post('/active_documents', payload);

      // Side-effects (logs, guardar datos, alerta)
      req.then(({ data }) => {
        this.activeChildrenByParent = data.by_parent || {};

        if (data.any_active) {
          this.$dialog.alert({
            body: this.$t("read_only_inside"),
          }, { customClass: 'cd-dialog cd-dialog--warning' });
        }
      }).catch(err => {
        console.error('active_documents error', err);
        this.$store.dispatch('isLoadingOff');
      });

      // Valor de retorno: Promise<boolean>
      return req
          .then(({ data }) => !!data.any_active)
          .catch(() => false);
    },
    getDocument (id) {
      if (this.myDocs){
        for (let row in this.orderedDocsUser)
        {
          if (this.orderedDocsUser [row].id == id) return this.orderedDocsUser [row];
        }
        //return id;
      }else{
        //console.log(this.structure_copy);
        for (let row in this.documents)
        {
          if (this.documents [row].id == id) return this.documents [row];
        }
      }
      return null;
    },
    // Leaving a folder drops the search: the box used to keep its text while the new
    // folder was listed in full, which reads as a filter that is being ignored. The
    // watcher is muted for that assignment so it does not fire a search of its own.
    clearSearchFilter () {
      clearTimeout (this.filterDebounce);
      this.searchRequestId++;
      if (this.filter === "") return;
      this.skipFilterWatch = true;
      this.filter = "";
    },
    onSearchFilter () {

      // "Listar" is a DataTables table fed once, on entry, with a fixed array
      // (see getMyDocs): reloading "documentsUser" from the server would not
      // reach it. So the shared search box filters it the same way its own
      // (now hidden) search box did — client side, over the rows already
      // loaded.
      if (this.myDocs){
        if (this.datatable) this.datatable.fnFilter(this.filter || "");
        return;
      }

      this.$store.dispatch ('isLoadingOn');
      const requestId = ++this.searchRequestId;
      let endpoint;
      /*if (this.isAdmin) endpoint = "/search_documents";
      else endpoint = "/client/documents";*/
      endpoint = "/search_documents";

      this.item = [];
      // Searching used to jump to "Solicitudes" whenever the folder had any,
      // which is not what typing in the box asks for. The selection goes as
      // well, otherwise the next load of the documentation would bring the
      // filtered listing back.
      this.fileView = 1;
      this.clearRequestSelection ();
      let filter = "";

      if (this.filter != "") filter = "?search="+this.filter;

      // "parentFilter" siempre usaba "&", asumiendo que "filter" ya había
      // puesto el "?" delante. Al vaciar la búsqueda (filter=""), la URL
      // quedaba mal formada ("/search_documents&where-parent_id=0", sin
      // "?"), la petición fallaba y la lista se quedaba vacía en vez de
      // volver a mostrar todo. Se usa "?" o "&" según si ya hay query string.
      let parentFilter = (filter === "" ? "?" : "&") + "where-parent_id="+this.selectFolder;

      this.$axios (endpoint + filter + parentFilter)
          .then ((response) => {
            this.$store.dispatch ('isLoadingOff');
            // A folder opened while this was in flight already replaced the listing.
            if (requestId !== this.searchRequestId) return;
            this.documents = response.data;
            // Kept in step with the listing: documentResp is what onShowDocumentsTab
            // restores when a request stops filtering, and it used to hold the listing
            // from before the search.
            this.documentResp = this.documents;
          })
          .catch (() => {
            this.$store.dispatch ('isLoadingOff');
          });
    },
    onSaveEditFolder() {
      // Saving with nothing added used to send the document unchanged and reload the
      // listing for nothing. Nothing pending, nothing to do: just close the modal.
      if (!this.hasPendingRequestChanges) {
        this.showModalRequiredDoc = false;
        return;
      }
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$store.dispatch('isLoadingOn');

        let data;
        if (this.isAdmin) {
          let newFolders = this.request_items.filter((item) => {
            return item.isNew;
          });
          if (this.id && this.changeTemplate) this.onRemoveRequestFolder();
          data = {
            name: this.name,
            parent_id: this.selectEditDocFolder,
            user_id: this.user.id,
            active: 0,
            document_type_id: this.document_type,
            folder_code: this.folder_code,
            request_folder: newFolders
          };
        } else {
          data = {
            name: this.name,
            parent_id: this.selectEditDocFolder,
            user_id: this.user.id,
            active: 0,
            document_type_id: this.document_type
          };
        }

        let request;
        if (this.id) request = this.$axios.put("/documents/" + this.id, data);
        else request = this.$axios.post("/documents", data);

        request
            .then(() => {
              this.showModal = false;
              this.showModalRequiredDoc = false;
              this.name = null;
              this.folder_code = null;
              this.folder = {};
              this.$v.$reset();
              this.onLoadRequestDocumentation(this.id);
              this.onRefresh();

              // ✅ CORRECCIÓN: Esperar a que el componente esté montado
              this.$nextTick(() => {
                this.onLoadFolders();
              });

              this.$store.dispatch('isLoadingOff');
            })
            .catch(() => {
              this.$store.dispatch('isLoadingOff');
            });
      }
    },
    onSaveEditFolder_old() {
      this.$v.$touch ();
      if (!this.$v.$invalid)
      {
        this.$store.dispatch ('isLoadingOn');
        let data;
        if (this.isAdmin)
        {
          let newFolders = this.request_items.filter ((item) => {
            return item.isNew;
          });
          if (this.id && this.changeTemplate) this.onRemoveRequestFolder ();
          data = {
            name              : this.name,
            parent_id         : this.selectEditDocFolder,
            user_id           : this.user.id,
            active            : 0,
            document_type_id  : this.document_type,
            folder_code       : this.folder_code,
            request_folder    : newFolders
          };
        }
        else
        {
          data = {
            name              : this.name,
            parent_id         : this.selectEditDocFolder,
            user_id           : this.user.id,
            active            : 0,
            document_type_id  : this.document_type
          };
        }
        //console.log(this.folderUsers);
        for(let key in this.folderUsers){
          //console.log(this.folderUsers[key]);

          let data ={
            folder_name: this.name,
            email_user:this.folderUsers[key].email,
            name_user:this.folderUsers[key].name,
            user: this.folderUsers[key],
          };

          this.$axios.post ("document/email_solicitud",data)
              .then (() => {
              })
              .catch (() => {
                this.$store.dispatch ('isLoadingOff');
              });
        }
        let request;
        if (this.id) request = this.$axios.put ("/documents/" + this.id, data);
        else request = this.$axios.post ("/documents", data);
        request
            .then (() => {
              this.showModal = false;
              this.showModalRequiredDoc = false;
              this.name = null;
              this.folder_code = null;
              this.folder = {};
              this.$v.$reset ();
              this.onLoadRequestDocumentation (this.id);
              this.onRefresh ();
              this.onLoadFolders ();
              //this.onLoadFolders ();
              this.$store.dispatch ('isLoadingOff');
            })
            .catch (() => {
              this.$store.dispatch ('isLoadingOff');
            });
      }
    },
    onSaveFolder () {
      this.$v.$touch ();
      if (!this.$v.$invalid)
      {
        // Creating a second folder with the name of one that is already there
        // leaves two rows nothing can tell apart. The modal stays open with the
        // name in it, so the user only has to change that.
        if (this._siblingNameTaken (this.name, this.selectFolder, this.id)) {
          this._warnDialog (this.$t ("folder_name_taken"));
          return;
        }

        this.$store.dispatch ('isLoadingOn');
        // The same test that picks POST over PUT below: a new folder is opened once
        // it is stored, an edited one leaves the user where they were.
        const creating = !this.id;
        // Never an empty parent: the backend stores it as NULL, not as the root.
        const parentId = this._folderOrRoot (this.selectFolder);
        let data = {};
        if (this.isAdmin)
        {
          let newFolders = this.request_items.filter ((item) => {
            return item.isNew;
          });
          if (this.id && this.changeTemplate) this.onRemoveRequestFolder ();
          data = {
            name              : this.name,
            active            : this.active,
            parent_id         : parentId,
            user_id           : this.user.id,
            updated_at        : new Date().toISOString().slice(0, 19).replace('T', ' '),
            document_type_id  : this.document_type,
            folder_code       : this.onPrintBreadcrumb(),
            request_folder    : newFolders
          };
        }
        else
        {
          data = {
            name              : this.name,
            active            : this.active,
            parent_id         : parentId,
            user_id           : this.user.id,
            updated_at        : new Date().toISOString().slice(0, 19).replace('T', ' '),
            folder_code       : this.onPrintBreadcrumb(),
            document_type_id  : this.document_type
          };
        }
        // Sending the view back to the root 1.5 s later would pull the user out of
        // a folder just created there, so it is kept for edits only.
        if (!creating && data.parent_id ==0){

          setTimeout (() => {
            this.onPressRoot();
          }, 1500);
        }
        this.createdFolder = data;

        // The row as the server stored it, folder_code included, for opening it.
        let savedFolder = null;
        let request;
        if (this.id) request = this.$axios.put ("/documents/" + this.id, data);
        else request = this.$axios.post ("/documents", data);
        request
            .then(response => {
              savedFolder = response.data;
              this.createdFolderId = response.data.id;
              // The tags chosen in the modal go through the same endpoint the
              // properties form uses, now that there is an id to attach them to.
              // Chained (not fired and forgotten) so the listing is only refreshed
              // once they are stored.
              return this._saveFolderTags (response.data.id);
            })
            .then (() => {
              if (this.structure_copy != 1){
                this.showModal = false;
                this.showModalRequiredDoc = false;
                this.name = null;
                this.folder_code = null;
                this.folder = {};
                this.$v.$reset ();
                this.checkedUsersId = [];
                this.showFolderTree = false;
                //this.getEmailsNotifications(1, "folder");
                this.$store.dispatch ('isLoadingOff');
                this.showSelectFolderModal = false;
                // The rebuild of the tree waits for the folder list, so the new one
                // is already in it.
                const createdId = this.createdFolderId;
                if (creating) {
                  // A new folder is where the user is left, and it is opened here, the
                  // way the listing opens one. Selecting it in the tree used to be what
                  // opened it, until the rebuild learned not to reopen the folder
                  // already on screen: Syncfusion only fires nodeSelected once the tree
                  // has finished loading, and dataBound comes just before that, so it
                  // is not something to count on. The listing of the parent is not
                  // reloaded either: an answer arriving late would replace the
                  // listing of the new folder with it.
                  this.onLoadFolders ().then (() => {
                    this.refreshTree (createdId);
                    this.onSelectFolder (savedFolder);
                  });
                } else {
                  this.onRefresh ();
                  this.onLoadFolders ().then (() => this.refreshTree (createdId));
                }
              }else{
                setTimeout (() => {
                  this.onGetRecursivityFolder();
                }, 500);
              }
            })
            .catch ((error) => {
              this.$store.dispatch ('isLoadingOff');
              this.showSelectFolderModal = false;
              // Saying nothing here left a modal that looked as if it had saved.
              this._warnDialog (this._nameChangeError (error, "folder_save_failed"));
            });

        this.refreshTree();
      }
    },
    // nodeId is the folder the tree should land on once it is rebuilt; without it,
    // wherever the user already was.
    refreshTree(nodeId = null) {
      // Remounting throws the tree away and builds it from scratch, so the folder the
      // user was in -- and the path opened down to it -- was lost: after creating a
      // folder the panel came back collapsed. The position is noted here and put back
      // in onTreeDataBound, once the new tree has its data.
      const target = nodeId || this.selectFolder;
      this.treeContextToRestore = target ? String (target) : null;

      this.show = false;   // ocultamos el componente
      this.$nextTick(() => {
        this.show = true;  // lo volvemos a montar desde cero
      });
    },
    // Fires whenever the tree finishes binding its data, remount included.
    onTreeDataBound () {
      const nodeId = this.treeContextToRestore;
      if (!nodeId) return;

      const tree = this.$refs.treeview?.ej2Instances;
      if (!tree) return;

      // A folder just created is not in the data of the tree until onLoadFolders
      // answers, so the pending restore is kept for the next binding rather than
      // spent on a node that is not there yet.
      const known = this._treeData ().some ((node) => String (node.id) == nodeId);
      if (!known) return;

      this.treeContextToRestore = null;

      try {
        // The ancestors are expanded one by one instead of leaning on ensureVisible:
        // with loadOnDemand the branch is not there yet and that call left the tree
        // collapsed (measured on a copy of it). expandedNodes opens exactly the path,
        // not the descendants of the folder.
        const ancestors = this._treeAncestors (nodeId);
        if (ancestors.length > 0) tree.expandedNodes = ancestors;

        // What is restored here is the position of the tree, not the folder: that one
        // is already open and its listing is already on screen. Selecting the node
        // fires nodeSelected, so onSelectNode is told beforehand that this is the
        // current node -- otherwise every rebuild of the tree reopened, from scratch,
        // the folder the user had been in.
        this.lastSelectedNodeId = nodeId;
        tree.selectedNodes = [nodeId];

        // The scroll of the panel belongs to .contentListItem, not to the tree (its
        // own overflow was removed so the panel has a single scrollbar), so
        // ensureVisible has nothing to scroll and the folder stayed out of sight when
        // it sat far down the list. Scrolling through the DOM walks up to whichever
        // ancestor actually scrolls.
        this._scrollTreeNodeIntoView (nodeId);
      } catch (error) {
        // A folder that is no longer in the tree (deleted, moved) is no reason to
        // break the rebuild: the tree simply comes up at its root.
        console.warn ('No se ha podido restaurar la posición del árbol:', error);
      }
    },
    // The rows of "Listar" are painted by DataTables, outside Vue: their checkboxes
    // are plain HTML, so they neither followed `item` -- ticking "select all" said
    // "xx selected" with every box empty -- nor changed it when clicked. Both
    // directions are wired here.
    // Only the ones in the body: the "select all" of the header lives inside this
    // same table and carries no id in its value, so it was being unticked here on
    // every sync -- it is driven by its own computed (selectAll2).
    _syncListCheckboxes () {
      document.querySelectorAll ('#exampleFinal tbody .checkbox__input').forEach ((input) => {
        input.checked = this.item.some ((id) => String (id) == String (input.value));
      });
    },
    // Clicking one of those checkboxes updates the selection Vue keeps.
    onListCheckboxChange (event) {
      const input = event.target;
      if (!input || typeof input.matches != 'function') return;
      // Body only, for the same reason: the header checkbox is handled by Vue and
      // its value is not a document id.
      if (!input.matches ('#exampleFinal tbody .checkbox__input')) return;

      const id = input.value;
      if (!id) return;

      // Reassigned rather than mutated so the watcher and the "select all" checkbox
      // (a computed over item) both see the change.
      const selected = this.item.filter ((current) => String (current) != String (id));
      if (input.checked) selected.push (isNaN (Number (id)) ? id : Number (id));
      this.item = selected;
    },
    // A folder of the listing is a drop target too: dropping a row on it moves it
    // in, exactly as dropping it on that folder in the tree. Only folders take it --
    // there is nothing to move something into inside a document.
    // Only what already lives in the tree is aimed at a row, though: files coming from
    // outside the browser always belong to the folder that is open, whatever row they
    // happen to be dropped on, so the rows stay out of the way of that gesture.
    onRowDragOver (event, document) {
      // Files from the desktop: no highlight, and no dropEffect either. The event goes
      // on to onListDragOver, which lights the frame of the pane and sets the cursor.
      if (this._isExternalFileDrag (event)) {
        this.dropTargetId = null;
        return;
      }

      // Not a target: a document takes nothing in, and a folder cannot go into
      // itself. Any highlight left on another row is cleared, or it stayed lit while
      // the pointer had already moved on to a row that accepts nothing.
      if (document.document_type_id != 1
          || (this.draggedRow && String (this.draggedRow.id) == String (document.id))) {
        this.dropTargetId = null;
        return;
      }

      if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
      this.dropTargetId = document.id;
    },
    onRowDragLeave (event, document) {
      // Moving between the cells of the same row fires dragleave too, so the
      // highlight is only dropped when the pointer really left the row.
      if (event.currentTarget && event.currentTarget.contains (event.relatedTarget)) return;
      if (String (this.dropTargetId) == String (document.id)) this.dropTargetId = null;
    },
    onRowDrop (event, document) {
      this.dropTargetId = null;

      // Files from the desktop are not the row's business: the drop is left to bubble
      // up to #page-content, where onListDropFiles uploads them into the folder that is
      // open. That is also why the row no longer stops the event -- a listing with no
      // free space left is all rows, and stopping the drop there lost the upload.
      if (this._isExternalFileDrag (event)) return;

      if (document.document_type_id != 1) return;

      const dragged = this._readDraggedDocument (event);
      if (dragged) this.moveDocumentToFolder (dragged, document.id);
    },
    // Moves a document or a folder into a folder of the tree. Both gestures end up
    // here -- dragging inside the tree and dragging a row of the listing onto it --
    // so the request, the checks and the refreshing are written once.
    // parentId 0 (or null) means the root.
    moveDocumentToFolder (item, parentId) {
      const movedId = item && item.id != null ? item.id : null;
      if (movedId == null) return Promise.resolve ();

      const target = parentId == null ? 0 : parentId;
      const originId = item.parent_id != null ? item.parent_id : item.parentID;

      // Already there: nothing to do, and no refresh to justify.
      if (String (originId) == String (target)) return Promise.resolve ();

      // A folder cannot be dropped into itself, nor into one of its own descendants:
      // the branch would be cut off from the tree.
      if (String (movedId) == String (target)) return Promise.resolve ();
      if (this._treeAncestors (target).includes (String (movedId))) {
        this.$dialog.alert ({
          body: this.$t ("move_into_itself"),
        }, { customClass: 'cd-dialog cd-dialog--warning' });
        return Promise.resolve ();
      }

      this.$store.dispatch ('isLoadingOn');

      // Two things with the same name cannot live in the same folder, so what the
      // destination already holds is read first and the move is refused with a
      // warning -- rather than letting the API store a duplicate.
      return this.$axios (`/documents?where-parent_id=${target}`)
          .then ((response) => {
            const name = String (item.name != null ? item.name : '').trim ().toLowerCase ();
            const taken = (response.data || []).some ((doc) =>
                String (doc.id) != String (movedId)
                && String (doc.name != null ? doc.name : '').trim ().toLowerCase () == name);

            if (taken) {
              this.$dialog.alert ({
                body: this.$t ("move_name_taken", { name: item.name }),
              }, { customClass: 'cd-dialog cd-dialog--warning' });
              // Nothing moves, and nothing is refreshed either.
              return null;
            }

            // A file travels in storage too, not only in the listing: this used
            // to write parent_id and nothing else, so the file stayed where it
            // was and its url with it, and the row and the file it points at
            // drifted apart. change_name moves it and answers with the path it
            // was written to, and that is what gets stored. A folder holds no
            // file of its own, so for it the move is only a change of hands.
            const isFolder = String (item.document_type_id) === '1';

            return (isFolder
                ? Promise.resolve ({ data: {} })
                : this.$axios.post (`/document/change_name/${movedId}`, {
                    move   : true,
                    moveId : target,
                    name   : item.name
                  }))
                .then ((moved) => {
                  // folder_code does not travel: the backend derives it from the
                  // folder the document lands in, and walks down a moved folder
                  // writing the new path over everything inside it.
                  const payload = { parent_id: target };
                  if (moved.data && moved.data.url) payload.url = moved.data.url;
                  return this.$axios.put (`/documents/${movedId}`, payload);
                });
          })
          .then ((response) => {
            // Refused above: the chain carries on so the veil is turned off, but
            // there is nothing else to do.
            if (!response) return null;

            // Counters of the folders at both ends; the stored path of the
            // document travelled with the requests above.
            this.changeUrlAndFolderCode (movedId, target, response.data);

            // Counters of both ends: the folder it left and the one it landed in.
            if (originId != null) this.onUpdateParentFiles (originId, true);
            this.onUpdateParentFiles (target, false);
            this.onUpdateParentDate (target);

            this.$notify ({
              group: 'app',
              type: 'success',
              message: this.$t ("move_done"),
              duration: 4000
            });

            // Listing of the folder on screen, and the tree rebuilt from the server so
            // the branch shows where the item now lives -- left on the moved one.
            this.onRefresh ();
            return this.onLoadFolders ().then (() => this.refreshTree (movedId));
          })
          .catch ((error) => {
            console.error ('Error al mover:', error);
            this.$notify ({
              group: 'app',
              type: 'error',
              message: this.$t ("move_error"),
              duration: 5000
            });
          })
          .finally (() => {
            this.$store.dispatch ('isLoadingOff');
          });
    },
    // Row of the listing being dragged: onDragStart writes the document as JSON in
    // the dataTransfer, so the tree can tell it apart from files coming from the
    // desktop (those arrive in dataTransfer.files).
    _readDraggedDocument (event) {
      if (!event.dataTransfer) return null;

      try {
        const raw = event.dataTransfer.getData ('text/plain');
        if (!raw) return null;

        const parsed = JSON.parse (raw);
        return parsed && parsed.id != null ? parsed : null;
      } catch (error) {
        // Anything else dropped on the tree (plain text, a link) is not ours.
        return null;
      }
    },
    // Brings a node of the tree into view. Expanding the branch renders in its own
    // time, so the node is looked up a few times before giving up instead of only
    // once, right after asking for the selection.
    _scrollTreeNodeIntoView (nodeId, attemptsLeft = 5) {
      this.$nextTick (() => {
        const node = document.querySelector (`#treeview li[data-uid="${nodeId}"]`);

        if (!node) {
          if (attemptsLeft > 0) {
            setTimeout (() => this._scrollTreeNodeIntoView (nodeId, attemptsLeft - 1), 120);
          }
          return;
        }

        // 'nearest' scrolls the least it can: the panel moves only if the folder is
        // off-screen, and the page itself is left where it was.
        node.scrollIntoView ({ block: 'nearest', inline: 'nearest' });
      });
    },
    // enablePersistence keeps the selected node, the checked ones and the opened branch
    // in localStorage and puts them back every time the tree renders. The listing does
    // not follow: a reload always lands on the root, so the tree came up marking in
    // green a folder the user was no longer in. The selection is dropped from the saved
    // state before the tree is built -- afterwards the component has already painted it
    // and writing selectedNodes does not take it back. The opened branch is left in
    // place: it matches nothing in particular and saves reopening the path.
    // Syncfusion stores the state under moduleName + element id ("treeview" + "treeview
    // "), optionally suffixed with the version of the persistence format.
    _dropPersistedTreeSelection () {
      try {
        Object.keys (window.localStorage)
              .filter ((key) => key.indexOf ('treeviewtreeview') === 0)
              .forEach ((key) => {
                const state = JSON.parse (window.localStorage.getItem (key));

                if (!state || !state.selectedNodes || state.selectedNodes.length === 0) return;

                state.selectedNodes = [];
                window.localStorage.setItem (key, JSON.stringify (state));
              });
      } catch (error) {
        // Unreadable state (a private window, a half-written entry) is not worth
        // breaking the explorer over: the tree simply comes up as it was saved.
        console.warn ('No se ha podido limpiar la selección guardada del árbol:', error);
      }
    },
    // Folders the tree is working with: the mounted component holds the fresher copy
    // (getParents writes to both), and this.fields is the fallback while it is being
    // rebuilt.
    _treeData () {
      const tree = this.$refs.treeview?.ej2Instances;
      const fromTree = tree && tree.fields ? tree.fields.dataSource : null;

      if (Array.isArray (fromTree) && fromTree.length > 0) return fromTree;
      return this.fields.dataSource || [];
    },
    // Path of ids from the root down to the folder, taken from the data the tree is
    // built with (parent_id is the field it uses for the hierarchy).
    _treeAncestors (nodeId) {
      const byId = {};
      this._treeData ().forEach ((node) => {
        byId[String (node.id)] = node;
      });

      const ancestors = [];
      let current = byId[String (nodeId)];
      while (current && current.parent_id !== undefined && current.parent_id !== null) {
        ancestors.unshift (String (current.parent_id));
        current = byId[String (current.parent_id)];
      }
      return ancestors;
    },
    onUpdateParentDate(document_id){

      this.updateFolderDates(document_id).then(() => {
      });
    },
    onUpdateParentFiles(document_id){
      //document.active = this.$refs.activeSelected.checked;
      //this.$refs.activeSelected.checked ?  console.log('isActivated') :  console.log('isNotActivated');

      this.updateNumFiles(document_id).then(() => {
      });


      /*if(document_id !=0){

        this.$axios("/documents/"+document_id, )
            .then((response) => {
              console.log(response.data);
              let data_res = response.data;
              //this.$store.dispatch('isLoadingOff');
              let data = {}
              if (decrease){
                console.log("decrease");
                data = {
                  user_id                : this.user.id,
                  num_files              : (data_res.num_files-this.deleted_docs)>=0 ? data_res.num_files-this.deleted_docs : 0
                };
              }else{
                console.log("no decrease");
                data = {
                  user_id                : this.user.id,
                  num_files              : data_res.num_files+this.upload_docs
                };
              }
              console.log(data);
              this.$axios.put("/documents/"+document_id, data)
                  .then((response) => {
                    console.log(response.data);
                  })
                  .catch(() => {
                    //this.$store.dispatch('isLoadingOff');
                  });

              if (data_res.parent_id != 0){
                console.log(data_res.parent_id);
                console.log("update folder number1");
                this.onUpdateParentFiles(data_res.parent_id, decrease);
                //if (data_res.document_type_id != 1)this.onUpdateParentFiles(data_res.parent_id, decrease);
              }
            })
            .catch(() => {
              //this.$store.dispatch('isLoadingOff');
            });
      }*/
      //let doc = this.getDocument(document_id);

      //this.upload_docs=0;
    },
    onSaveFolder2 () {
      this.$v.$touch ();
      if (!this.$v.$invalid)
      {
        this.$store.dispatch ('isLoadingOn');
        let data;
        if (this.isAdmin)
        {
          let newFolders = this.request_items.filter ((item) => {
            return item.isNew;
          });
          if (this.id && this.changeTemplate) this.onRemoveRequestFolder ();
          data = {
            name              : this.name,
            active            : 0,
            parent_id         : this.selectEditDocFolder,
            user_id           : this.user.id,
            document_type_id  : this.document_type,
            folder_code       : this.folder_code,
            request_folder    : newFolders
          };
        }
        else
        {
          data = {
            name              : this.name,
            active            : 0,
            parent_id         : this.selectEditDocFolder,
            user_id           : this.user.id,
            document_type_id  : this.document_type
          };
        }
        let request;
        if (this.id) request = this.$axios.put ("/documents/" + this.id, data);
        else request = this.$axios.post ("/documents", data);
        request
            .then (() => {
              this.showModal = false;
              this.showModalRequiredDoc = false;
              this.name = null;
              this.folder_code = null;
              this.folder = {};
              this.$v.$reset ();
              this.onRefresh ();
              this.onLoadFolders ();
              //this.onLoadFolders ();
              this.$store.dispatch ('isLoadingOff');
            })
            .catch (() => {
              this.$store.dispatch ('isLoadingOff');
            });
      }
    },
    onUploadDocument () {
      this.error = false;
      if (this.files.length < 1)
      {
        this.error = true;
        return false;
      }
      let num_files = 0;
      this.progress = 0;
      this.showProgress = true;
      this.uploadTotal = this.files.length;
      this.uploadDone = 0;
      // Aquí las subidas van en paralelo (Promise.all), así que no hay un
      // "archivo actual" que mostrar. El diálogo oculta esa línea si va vacía.
      this.uploadFileName = '';
      this.uploadFinished = false;
      let progress = 100 / this.files.length;
      const promises = [];
      for (let row in this.files)
      {
        this.createdFolder = this.files [row];
        const formData = new FormData ();
        formData.append ("parent_id", this.selectFolder);
        formData.append ("name", this.files [row].name);
        formData.append ("user_id", this.user.id);
        //formData.append ("active", this.files [row].active);
        formData.append ("folder_code", this.onPrintBreadcrumb());
        formData.append ("active", 0);
        if (this.files [row].type ==''){
          formData.append ("document_type_id", 5);
        }else{
          formData.append ("document_type_id", this.getFileType (this.files [row].type));
        }
        formData.append ("file", this.files [row]);
        promises.push(new Promise((resolve, reject) => {

          this.$axios
              .post("/documents/upload", formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
              })

              .then(() => {

                this.progress += progress;
                this.uploadDone++;

                num_files = num_files+1;
                resolve();

              })

              .catch(async (error) => {

                // Out of contracted space. The uploads run in parallel, so the
                // rest of the batch is already on its way; each one refused is
                // left out of the count, and only one warning is shown.
                if (await handleLimitError(this, error)) {
                  resolve();
                  return;
                }

                // 🔴 Si el archivo ya existe
                if (error.response && error.response.status === 409) {

                  // vuejs-dialog resolves on OK and REJECTS on cancel, so the
                  // cancellation has to be caught here: it is a normal answer,
                  // not a failure. Letting it escape would reject the whole
                  // Promise.all and report a working upload as broken.
                  let confirmOverwrite = true;

                  try {
                    await this.$dialog.confirm({
                      body: error.response.data.message ||
                          this.$t("upload_overwrite_text"),
                    }, { customClass: 'cd-dialog cd-dialog--warning' });
                  } catch (cancelled) {
                    confirmOverwrite = false;
                  }

                  if (confirmOverwrite) {

                    formData.append("force", 1);

                    try {

                      await this.$axios.post(
                          "/documents/upload",
                          formData,
                          { headers: { 'Content-Type': 'multipart/form-data' } }
                      );

                      this.progress += progress;
                      this.uploadDone++;
                      // An overwrite is an upload too. It was bumping uploadDone
                      // (the progress dialog) but not num_files (the final
                      // notification), so overwriting the only file reported
                      // "0 of 1 uploaded".
                      num_files = num_files+1;

                      resolve();

                    } catch (err2) {

                      // A bigger file over the old one can go past the space too.
                      if (await handleLimitError(this, err2)) {
                        resolve();
                        return;
                      }

                      console.error("Error al sobrescribir:", err2);
                      reject(err2);
                    }

                  } else {

                    resolve(); // no bloquear Promise.all
                  }

                } else if (error.response && error.response.status === 422) {

                  // The API applies the same type and size rules as the interface. Its
                  // reason is the useful message here, so it is shown as it comes, and
                  // the rest of the batch carries on: one refused file must not report
                  // the whole upload as broken.
                  await Promise.resolve(this.$dialog.alert({
                    body: error.response.data.message || this.$t("invalid_file_type"),
                  }, { customClass: 'cd-dialog cd-dialog--warning' })).catch(() => {});

                  resolve();

                } else {

                  console.error("Error real de subida:", error);
                  reject(error);
                }
              });

        }));
      }
      Promise
          .all (promises)
          .then (() => {
            this.showModal = false;
            this.upload_docs = this.files.length;
            this.uploadedFiles = this.files.length;
            this.$store.dispatch('isLoadingOff');
            this.onRefresh ();
            this.onUpdateParentDate(this.selectFolder);
            this.onUpdateParentFiles(this.selectFolder, false);
            this.getEmailsNotifications(1, "folder");
            this.uploadFinished = true;
            let self = this;
            setTimeout (() => {
              self.showProgress = false;
              this.files = [];
            }, 500)

            this.$notify({
              group: 'app',
              type: 'success',
              message: `Se han subido ${num_files} de ${this.files.length} archivos`,
              duration: 5000
            });

          })
          .catch (() => {
            this.showProgress = false;
            // Si no, un intento posterior arrancaría con el check verde puesto.
            this.uploadFinished = false;

            setTimeout (() => {
              this.onRefresh ();
              this.$store.dispatch('isLoadingOff');
            }, 1000)

            this.$notify({
              group: 'app',
              type: 'success',
              message: `Se han subido ${num_files} de ${this.files.length} archivos`,
              duration: 5000
            });

          });


    },
    _onFileUpload (event) {
      let files = event.target.files;
      if (files.length == 0)
      {
        this.error = true;
        return false;
      }
      this._addFiles (files);
    },
    // Shared by the file input and the drop areas: keeps the files that pass the type
    // and size rules and warns about the rest. Nothing is uploaded here, the queued
    // files are sent when the modal is saved (onUploadDocument).
    // Returns a promise that settles once the warnings have been dismissed, so the
    // direct drop on the listing can wait for them before opening the progress dialog
    // on top.
    _addFiles (fileList, rejectedNames = []) {
      const accepted = [];
      const rejected = [...rejectedNames];   // wrong extension, or a dropped folder
      const tooLarge = [];                   // over the limit on its own
      const overflowed = [];                 // would push the whole batch over the limit
      // The files already queued count towards the batch: the modal keeps them between
      // drops, and the size of the upload is the sum of all of them.
      let queued = this.files.reduce ((total, file) => total + file.size, 0);

      for (const file of Array.from (fileList || []))
      {
        if (!this._isAllowedFile (file))
        {
          rejected.push (file.name);
          continue;
        }
        if (file.size > MAX_FILE_SIZE)
        {
          tooLarge.push (file.name);
          continue;
        }
        if (queued + file.size > MAX_UPLOAD_SIZE)
        {
          overflowed.push (file.name);
          continue;
        }

        queued += file.size;
        accepted.push (file);
      }

      if (accepted.length > 0)
      {
        this.files.push (...accepted);
        this.error = false;
      }

      const warnings = [];
      if (rejected.length > 0)
        warnings.push (`${this.$t ("invalid_file_type")}: ${rejected.join (", ")}`);
      if (tooLarge.length > 0)
        warnings.push (this.$t ("file_too_large", {
          max: this._formatSize (MAX_FILE_SIZE),
          files: tooLarge.join (", "),
        }));
      if (overflowed.length > 0)
        warnings.push (this.$t ("upload_batch_too_large", {
          max: this._formatSize (MAX_UPLOAD_SIZE),
          files: overflowed.join (", "),
        }));

      // One dialog per reason, shown one after another. They are not merged into a
      // single body because that would need html: true, and a file name is text the
      // user chose: it has no business being interpreted as markup.
      return warnings.reduce ((chain, body) => chain.then (() =>
          Promise.resolve (this.$dialog.alert ({ body },
              { customClass: 'cd-dialog cd-dialog--warning' })).catch (() => {})
      ), Promise.resolve ());
    },
    _isAllowedFile (file) {
      const extension = file.name.split (".").pop ().toLowerCase ();
      return ALLOWED_UPLOAD_EXTENSIONS.includes (extension);
    },
    // Readable size, shared by the limit texts and by the queue of the modal. The
    // figures now come from utils/fileSize so that the size column of the listings
    // prints them exactly the same way; this wrapper keeps the six call sites of
    // the upload texts untouched.
    _formatSize (bytes) {
      return formatSize (bytes);
    },
    // Size of a document for a cell of the listing: empty for a folder and for
    // anything uploaded before the size was stored.
    formatDocumentSize (value) {
      return formatDocumentSize (value);
    },
    _onDragEnterDrop () {
      this.dragCounter += 1;
      this.isExternalDrag = true;
    },
    _onDragLeaveDrop () {
      this.dragCounter -= 1;
      if (this.dragCounter <= 0) this._resetDragState ();
    },
    _onDropFiles (event) {
      this._resetDragState ();

      if (!event.dataTransfer) return;

      const { files, directories } = this._splitDroppedEntries (event.dataTransfer);
      this._addFiles (files, directories);
    },
    // A dropped folder reaches the browser as a File too, and one named "backup.zip"
    // would sneak through the extension check as a broken upload. The entry API is the
    // only reliable way to tell them apart, and it lives on the items list: it has to be
    // read synchronously, while the drop event is still being handled.
    _splitDroppedEntries (transfer) {
      const items = transfer.items;
      if (!items || items.length == 0) return { files: Array.from (transfer.files || []), directories: [] };

      const files = [];
      const directories = [];
      for (const item of Array.from (items))
      {
        if (item.kind != "file") continue;

        const file = item.getAsFile ();
        const entry = item.webkitGetAsEntry ? item.webkitGetAsEntry () : null;

        if (entry && entry.isDirectory) directories.push (entry.name);
        else if (file) files.push (file);
      }
      return { files, directories };
    },
    _resetDragState () {
      this.dragCounter = 0;
      this.isExternalDrag = false;
    },
    // --- Drop straight on the listing ---------------------------------------
    // Rows are draggable too (onDragStart, to move documents onto a tree node) and
    // those drags travel over this same container. A drag only counts as an upload
    // when it carries files from outside the browser, which is what "Files" means in
    // dataTransfer.types: the row drag only ever sets "text/plain".
    _isExternalFileDrag (event) {
      const types = event.dataTransfer ? event.dataTransfer.types : null;
      if (!types) return false;
      return Array.from (types).includes ("Files");
    },
    // Uploading at the root level is not allowed: a document always hangs from a
    // folder. selectFolder is the reliable signal here, it goes back to 0 whenever the
    // INICIO breadcrumb is pressed.
    _isRootLevel () {
      return this.selectFolder == 0 || this.selectFolder == null;
    },
    // The root is parent 0 in the database, but it reaches here empty from more than
    // one place: Syncfusion hands a root node over with parentID null ('' when it cannot
    // find the node), and a row saved with parent_id NULL brings it back as null. Sent as
    // it is, that empty value is what stored folders with parent_id NULL, which show up
    // in the tree and never in the root listing.
    _folderOrRoot (id) {
      return (id === null || id === undefined || id === '') ? 0 : id;
    },
    // Places the frame over the pane, clamped to what the window actually shows. The
    // frame used to be an absolutely positioned child of #page-content, but that pane
    // is a scroll container (overflow-x: auto makes overflow-y compute to auto), so the
    // frame was sized to its visible padding box and anchored to the scroll origin: it
    // covered a slice of the listing on a narrow window and drifted away as soon as the
    // pane was scrolled. Measuring the pane keeps the frame on the listing instead.
    _syncListDropRect (element) {
      if (!element) return;

      const rect = element.getBoundingClientRect ();
      const left = Math.max (rect.left, 0);
      const top = Math.max (rect.top, 0);
      const width = Math.min (rect.right, document.documentElement.clientWidth) - left;
      const height = Math.min (rect.bottom, document.documentElement.clientHeight) - top;

      // Pane completely out of view: no frame at all rather than one of negative size.
      if (width <= 0 || height <= 0)
      {
        this.listDropStyle = null;
        return;
      }

      const style = {
        top: `${top}px`,
        left: `${left}px`,
        width: `${width}px`,
        height: `${height}px`,
      };

      // dragover fires over and over while the file hovers the pane: the object is only
      // replaced when the box really moved, so the overlay is not re-rendered for
      // nothing.
      const current = this.listDropStyle;
      if (current
          && current.top == style.top && current.left == style.left
          && current.width == style.width && current.height == style.height) return;

      this.listDropStyle = style;
    },
    onListDragEnter (event) {
      if (!this._isExternalFileDrag (event)) return;
      this.listDragCounter += 1;
      // No green frame where the drop would be rejected anyway.
      if (this._isRootLevel ()) return;
      this._syncListDropRect (event.currentTarget);
      this.isListDrag = true;
    },
    onListDragOver (event) {
      if (!event.dataTransfer) return;
      if (!this._isExternalFileDrag (event)) return;
      event.dataTransfer.dropEffect = this._isRootLevel () ? "none" : "copy";
      // Nothing else fires while the file hovers the pane, so this is also what keeps
      // the frame in place when the listing is scrolled in the middle of the drag.
      if (this.isListDrag) this._syncListDropRect (event.currentTarget);
    },
    onListDragLeave (event) {
      if (!this._isExternalFileDrag (event)) return;
      this.listDragCounter -= 1;
      if (this.listDragCounter <= 0) this._resetListDragState ();
    },
    onListDropFiles (event) {
      const isFileDrag = this._isExternalFileDrag (event);
      this._resetListDragState ();

      if (!isFileDrag) return;

      if (this._isRootLevel ())
      {
        this.$dialog.alert ({
          body: this.$t ("¡¡En este nivel no se puede subir archivos...entra dentro de una carpeta para ello!!"),
        }, { customClass: 'cd-dialog cd-dialog--warning' });
        return;
      }

      const { files, directories } = this._splitDroppedEntries (event.dataTransfer);

      // onUploadDocument sends whatever sits in this.files, the same queue the modal
      // fills in, so it has to start empty: a cancelled modal can leave files behind.
      this.files = [];
      this._addFiles (files, directories).then (() => {
        // Everything dropped was rejected: nothing left to send.
        if (this.files.length == 0) return;
        // parent_id comes from selectFolder, so the upload lands in the open folder
        // whatever row the files were dropped on.
        this.onUploadDocument ();
      });
    },
    _resetListDragState () {
      this.listDragCounter = 0;
      this.isListDrag = false;
      this.listDropStyle = null;
    },
    _onRemoveFile (position) {
      this.files.splice (position, 1);
    },
    // A MIME type missing from the map returned undefined, and the backend then tried
    // to insert the string "undefined" into document_type_id: the INSERT failed and the
    // upload was lost with a 500. An unknown type now falls back to 5 (generic), the
    // same value onUploadDocument uses when the MIME type comes in empty.
    // Icon class of a document: the extension of the name comes first
    // (EXTENSION_ICON_CLASS) and, with no sprite of its own for it, the type decides.
    documentIconClass (document) {
      const extension = (document.name || '').split ('.').pop ().toLowerCase ();
      return EXTENSION_ICON_CLASS [extension] || this.iconClass [document.document_type_id];
    },
    getFileType (file_type) {
      const document_type_id = this.fileTypes [file_type];
      return document_type_id === undefined ? 5 : document_type_id;
    },
    // Back to "Explorar" from the view switch. Not a bare onRefresh because
    // that one reloads the folder ignoring the search box, and the box is now
    // shared by both views: if it came with text, the search has to be kept
    // instead of showing the whole folder under a full box.
    onExploreView (){
      this.myDocs = false;
      if (this.filter) this.onSearchFilter();
      else this.onRefresh();
    },
    // Landing from a deep link (/admin/documents?path=<id>), the one copyPath builds
    // and the one the share mail carries. The explorer is set up here exactly like the
    // common branch of created() sets it up -- role, statuses, tree and templates --
    // and then the folder is opened by hand.
    // The listing used to come up empty because the branch leaned on onRefresh, and
    // onRefresh is guarded by isRoot: that flag starts as true and only turns false
    // once a node of the tree has been clicked, so on a fresh tab the request for the
    // contents of the folder was never fired and the link appeared to do nothing.
    openLinkedFolder (folderId)
    {
      const id = Number (folderId);

      this.isAdmin   = this.user.rol_id == 1;
      this.documents = this.indexFolder;
      this.folders   = this.indexFolder;
      this.onLoadDocumentStatus ();
      this.loadTemplateDocumentation ();

      // The tree is asked for before it is known whether the folder can be opened: it
      // is the same panel both outcomes need, and holding it back for a round trip
      // would leave the explorer half painted. The restore is armed here, ahead of
      // onLoadFolders, because onTreeDataBound spends it the moment the tree binds its
      // data and that can happen before the check below answers. The tree expands the
      // path down to the folder and selects it there, see onTreeDataBound.
      this.treeContextToRestore = id ? String (id) : null;
      this.onLoadFolders ();

      // An id that is not a number cannot be asked about: there is nothing for the
      // backend to look up, so the link is taken as broken without spending a request.
      if (!id)
      {
        this.fallbackToRootListing ('missing');
        return;
      }

      this.resolveLinkedTarget (id);
    },
    // document/link_target tells a folder that is gone (404) apart from one that is
    // merely empty: the listing of its children answers 200 with an empty array and
    // the breadcrumb answers 500, so either of them would happily paint a folder that
    // does not exist. It also answers 403 when the user has no access to it, which
    // documents/{id} never did: whoever had their access taken away still landed in
    // the folder through the link of the share mail. The answer is reused in
    // showLinkedFolder instead of reading the same row a second time.
    resolveLinkedTarget (id)
    {
      this.$axios.post ("document/link_target", { id: id })
          .then ((response) => {
            const doc = response.data;

            if (doc.document_type_id == 1) return this.showLinkedFolder (id, doc);

            // The link points at a document, not at a folder. The id does exist, so
            // instead of claiming it does not, the folder holding it is opened: the
            // same mapping copyPath applies when it builds the link in the first place.
            const parent = Number (doc.parent_id);
            if (!parent) return this.fallbackToRootListing (null);

            // The tree may already have bound against the document id, which is not
            // among its nodes; refreshTree re-arms the restore and makes it bind again.
            this.refreshTree (String (parent));
            return this.resolveLinkedTarget (parent);
          })
          .catch (async (error) => {
            // Checked before classifyFileError, which is shared with the downloads
            // and has no "forbidden" of its own.
            if (error && error.response && error.response.status === 403) {
              this.fallbackToRootListing ('forbidden');
              return;
            }

            const kind = await this.classifyFileError (error);

            // "session" means the axios interceptor is already replacing the page with
            // the login screen, and a dialog on top of that only gets in the way.
            if (kind !== 'session') this.fallbackToRootListing (kind);
          });
    },
    // The folder is there, so the link opens as it always did. `folder` is the answer
    // already in hand from the check, not a second read of the same row.
    showLinkedFolder (id, folder)
    {
      this.itemSelected    = folder;
      this.itemDocRequired = folder;
      this.sfolder         = folder;

      this.isRoot         = false;
      this.selectFolder   = id;
      this.linkedFolderId = id;
      this.item           = [];

      this.$axios (`/documents?where-parent_id=${id}`)
          .then ((response) => {
            this.documents    = response.data;
            this.documentResp = response.data;
            this.fileView     = 1;
          })
          .catch (() => {
            this.$store.dispatch ('isLoadingOff');
          });

      this.onLoadRequestDocumentation (id);
      this.onLoadBreadcrumb ();
    },
    // A link that cannot be opened is no reason to leave the user on a blank screen:
    // the root listing is what created() would have shown anyway. What was missing is
    // the dialog -- falling back in silence left a folder that is gone looking exactly
    // like one that is simply empty, with a breadcrumb pointing nowhere.
    //
    // Nothing belonging to the folder is written here on purpose: isRoot stays true so
    // onRefresh keeps working on the root, and linkedFolderId stays null so the
    // indexFolder watcher still delivers the root listing when the parent page
    // finishes fetching it (on the contacts explorer that arrives after this runs,
    // because there the component mounts without a v-if).
    //
    // kind comes from classifyFileError: "missing" is a 404/410, the folder really is
    // not there; "failed" is anything else (the network dropped, the backend is down)
    // and telling that user the folder does not exist would be a lie; null is a
    // legitimate fall back to the root (a document hanging off the root), no warning.
    // "forbidden" is set by resolveLinkedTarget on a 403: the folder exists but the
    // user has no access to it (any more), which only an administrator can change.
    fallbackToRootListing (kind)
    {
      // onTreeDataBound keeps the restore pending when the node is not in the data
      // yet, so a node that will never be there has to be dropped by hand or it would
      // steal the next selection the user makes.
      this.treeContextToRestore = null;
      this.$store.dispatch ('isLoadingOff');

      this.clearLinkedPath ();

      if (kind === 'missing')
        this._fileDialog (this.$t ('linked_path_not_found'), 'linked_path_not_found_title');
      else if (kind === 'forbidden')
        this._fileDialog (this.$t ('linked_path_forbidden'), 'linked_path_forbidden_title');
      else if (kind === 'failed')
        this._fileDialog (this.$t ('linked_path_error'));
    },
    // The stale query is dropped so a reload does not repeat the error, and with
    // replace so the back button does not walk straight back into the broken link. The
    // route record does not change, so the component is not remounted and created()
    // does not run again. The rejection is swallowed because a navigation the router
    // refuses (already left the page, identical url) leaves nothing to recover from,
    // and vue-router 3 reports it as an unhandled promise otherwise.
    clearLinkedPath ()
    {
      const query = Object.assign ({}, this.$route.query);
      delete query.path;

      const navigation = this.$router.replace ({ query: query });
      if (navigation && navigation.catch) navigation.catch (() => {});
    },
    // Silent on failure: the indicator is information, and a listing that loads
    // must not be spoiled by it. The last figure stays on screen instead.
    // Administrators only: the space is the installation's, and a contact would
    // see the whole of it when their own share may be a tiny part.
    loadStorageUsage () {
      if (!this.user || this.user.rol_id != 1) return;

      this.$axios.get ("/settings/storage")
          .then ((response) => {
            this.storage = response.data;
          })
          .catch (() => {});
    },
    onRefresh (){
      // Every upload, copy and deletion ends here, so the space in use follows them.
      this.loadStorageUsage ();
      this.myDocs ? this.myDocs = !this.myDocs :'';
      // The root listing is not served by the folder endpoint but by the one the
      // view was mounted with, which is also the one that answers for a client.
      // Skipping the root altogether, which is what happened before, left a
      // rename or a delete made there on screen with the old data until the whole
      // page was reloaded.
      // isRoot only turns false once a node of the tree has been clicked, so browsing
      // through the listing left it true and this reloaded the root over the folder
      // that was open. selectFolder is the reliable signal, the same one _isRootLevel
      // is already trusted with everywhere else.
      const request = this._isRootLevel ()
          ? this.$axios (`/${this.root}`)
          : this.$axios (`/documents?where-parent_id=${this.selectFolder}`);

      //this.$store.dispatch ('isLoadingOn');
      request
          .then ((response) => {
            if (this.myDocs){
              this.documentsUser = response.data
            }else{
              this.documents = response.data
              this.documentResp = response.data
            }
            this.item = [];
            this.stopRenaming ();
            this.fileView = 1;
            //this.$store.dispatch ('isLoadingOff');
            //this.onLoadBreadcrumb ();
          })
          .catch (() => {
            this.$store.dispatch ('isLoadingOff');
          });
    },
    onSeeBreadcrumbs(){
      this.onOff = !this.onOff
    },
    onPrintBreadcrumb (){
      //console.log("onPrintBreadcrumb");
      let str="";
      this.breadcrumbs.forEach ((bread) => {
        str = str+' / '+bread.name;
      });
      return str;
    },

    toggleTag(tag) {
      const idx = this.selectedTags.indexOf(tag);
      if (idx > -1) {
        this.selectedTags.splice(idx, 1);
      } else {
        this.selectedTags.push(tag);
      }
    },

    // Returns the request so a caller can act once the new path is in place: the
    // list of "Listar" is asked for by breadcrumbs, so it cannot be reloaded before
    // they arrive.
    onLoadBreadcrumb (){
      //this.$refs.treeObj.selectedNodes = ["4"];
      return this.$axios ("/breadcrumb/" + this.selectFolder)
          .then ((response) => {
            this.breadcrumbs = response.data.breadcrumb;
          })
          .catch (() => {
            this.breadcrumbs = [];
          });
    },
    onPressRoot (){
      this.clearRequestSelection ();

      // --- Solo la parte del TreeView protegida ---
      const treeEl = document.getElementById('treeview');
      if (treeEl && treeEl.ej2_instances) {
        const treeObj = treeEl.ej2_instances[0];
        treeObj.selectedNodes = [0];
        treeObj.collapseAll();
      }
      // --- Fin del bloque protegido ---
      //this.$refs.treeview.ej2Instances.uncheckAll();

      //if (this.isAdmin)
      //{
      this.$store.dispatch ('isLoadingOn');
      this.$axios (`/${this.root}`)
          .then ((response) => {
            if (this.myDocs){
              this.documentsUser = response.data
            }else{
              this.documents = response.data
            }
            this.item = [];
            this.breadcrumbs = [];
            this.selectFolder = 0;
            this.fileView = 1;
            this.request_documentation = [];
            this.itemSelected = null;
            this.$store.dispatch ('isLoadingOff');
            // Assigning documentsUser is not enough in "Listar": the list is a
            // DataTable built by getMyDocs, and without rebuilding it the previous
            // folder stayed on screen.
            if (this.myDocs) this.getMyDocs (true);
          })
          .catch (() => {
            this.$store.dispatch ('isLoadingOff');
          });
      //}
    },
    onShowComments(){
      this.onLoadComments();
      this.showModalComments = true;
      this.onReadComments();

    },
    onCloseModal() {
      this.showModalComments = false;
      this.isLoadingComments = false;
      this.isSavingComment = false;
      this.comments       = [];
      this.comment_text   = null
      this.error_comment  = false;

      if (!this.myDocs) this.onRefresh();
    },
    onLoadComments(){
      this.isLoadingComments = true;
      this.$axios("/comments?where-document_id="+this.itemSelected.id)
          .then((response) => {
            this.comments = response.data;
            this.isLoadingComments = false;

            //let elmnt = document.getElementById('commentsList');
            //elmnt.scrollIntoView(false);

            setTimeout (() => {
              this.scrollToBottom();
            }, 1000);

          })
          .catch(() => {
            this.isLoadingComments = false;
          });
    },
    onReadComments(){
      if(this.isAdmin){
        this.$axios("/read_comments/"+this.itemSelected.id)
            .then(() => {
            })
      }
    },
    onSaveComment(){
      if(!this.comment_text){
        this.error_comment = true;
        return false;
      }
      this.isSavingComment = true;
      let data = {
        comment : this.comment_text,
        document_id : this.itemSelected.id,
      };
      this.$axios.post("/comments",data)
          .then(() => {
            this.isSavingComment = false;
            this.onLoadComments();
            this.error_comment = false;
            this.getEmailsNotifications(2, "comments");
            this.onRefresh();
            this.comment_text = null;
          })
          .catch(() => {
            this.isSavingComment = false;
          });
    },
    getEmailsNotifications(noti_type,email_type){
      //console.log(this.itemSelected.name);
      //console.log(this.users_folder);
      //console.log(this.createdFolder);
      //console.log(this.comments);
      //console.log(this.comment_text);
      //console.log("----------------------");
      //console.log(this.onPrintBreadcrumb());
      this.itemSelected.folder_code = this.onPrintBreadcrumb();
      let comment_send = this.comment_text;
      if (email_type == 'sharefolder'){
        for (let key in this.checkedEmailUsersId) {
          let data ={
            email_user:this.checkedEmailUsersId[key],
            itemSelected: this.itemSelected,
            notify : noti_type,
            user: null,
            type:email_type,
            comment : comment_send,
            numberUploaded : this.uploadedFiles,
          };
          this.$axios.post ("document/email_notify",data)
              .then (() => {
                this.onChangeStatus(8,this.itemSelected.id);
              })
              .catch (() => {
                this.$store.dispatch ('isLoadingOff');
              });
        }
        this.showShareModal = false;
      }
      else if (email_type == 'treefolder'){

        for (let key in this.checkedEmailUsersId) {
          let data ={
            email_user:this.checkedEmailUsersId[key].email,
            itemSelected: this.itemSelected,
            notify : noti_type,
            user: this.checkedEmailUsersId[key],
            type:email_type,
            comment : comment_send,
            numberUploaded : this.uploadedFiles,
          };
          this.$axios.post ("document/email_notify",data)
              .then (() => {
                this.onChangeStatus(8,this.itemSelected.id);
              })
              .catch (() => {
                this.$store.dispatch ('isLoadingOff');
              });
        }
      }
      else{
        this.checkedUsersId = [];

        const folderId = email_type == "folder" || email_type == "sharefolder"
            ? this.itemSelected.id
            : this.itemSelected.parent_id;

        // At the root there is nothing above to inherit a setting from, which
        // is where the old walk ended up anyway once it ran out of parents.
        if (!folderId) return;

        // One request for the whole chain. This used to be a POST per user of
        // the installation, and since that endpoint answers an empty list
        // rather than an error, reading user_id off it threw, the catch mistook
        // the exception for a failure and fetched the parent with
        // GET /documents/{id} to try the level above, up to ten times. A single
        // upload into a folder four deep came to a few hundred requests.
        this.$axios.post("document/folder_notify_users", { folder_id: folderId })
            .then((response) => {
              const userIds = (response.data && response.data.inherited_user_ids) || [];

              userIds.forEach((userId) => {
                const user = (this.users_folder || []).find((candidate) => candidate.id == userId);
                if (!user) return;

                // checkedUsersId, the v-model of the notify checkboxes, is left
                // alone here on purpose. The line that filled it threw on every
                // empty answer, so this path has never actually written to it,
                // and filling it now would tick boxes nobody ticked.
                this.$axios.post("document/email_notify", {
                  comment: comment_send,
                  comments: this.comments,
                  user: user,
                  itemSelected: this.itemSelected,
                  notify: noti_type,
                  type: email_type,
                  numberUploaded: this.uploadedFiles,
                  createdFolder: this.createdFolder
                })
                    .catch(() => {
                      this.$store.dispatch('isLoadingOff');
                    });
              });
            })
            .catch(() => {
              this.$store.dispatch('isLoadingOff');
            });
      }
    },
    getInitials(name){
      let string = name.split(" ");
      return string.length > 1 ? string[0].charAt()+string[1].charAt() : name[0]+name[1];
    },
    onLoadDocumentStatus(){
      this.$axios("/conf/document_status")
          .then((response) =>{
            this.document_status = response.data;
          })
    },
    onCheckHistory(){
      this.$store.dispatch('isLoadingOn');
      this.$axios("document/status?where-document_id="+this.itemSelected.id)
          .then((response) => {
            //console.log(response.data);
            this.history = response.data;
            //this.refresh();
            this.$store.dispatch('isLoadingOff');
          })
    },
    // Save button of the properties modal: the tags picked there are written now,
    // and only now. Closing with the cross leaves the document as it was.
    async onSaveProperties () {
      await this.onTagsChange (this.propertiesTags);
      this.onRefresh ();
      this.onLoadFolders ();
      this.showProperties = false;
    },
    // Save button of the tags modal: the selection is applied to every document
    // picked in the listing.
    async onSaveTagsAll () {
      await this.onTagsChangeAll (this.bulkTags);
      this.onRefresh ();
      this.onLoadFolders ();
      this.showTags = false;
    },
    onShowTags(){
      this.showTags = true;

      // NORMALIZA LOS TAGS AQUÍ TAMBIÉN
      this.itemSelected.tag = this.parseTagString(this.itemSelected.tag);
      this.itemSelected.selectedTagSingle = this.parseTagString(this.itemSelected.tag);

      // Copy, so the rows of the listing are only written once Save is pressed.
      this.bulkTags = [...(this.itemSelected.tag || [])];
    },
    onShowProperties(){
      this.showProperties = true;
      this.onCheckHistory();

      // NORMALIZA LOS TAGS AQUÍ TAMBIÉN
      this.itemSelected.tag = this.parseTagString(this.itemSelected.tag);
      this.itemSelected.selectedTagSingle = this.parseTagString(this.itemSelected.tag);

      // Copy, so the row of the listing is only written once Save is pressed.
      this.propertiesTags = [...(this.itemSelected.tag || [])];

      /*const tags = this.parseTagString(this.itemSelected.tag);

      this.itemSelected.selectedTagSingle =
          Array.isArray(tags) && tags.length ? tags[0] : "";*/
    },
    log() {
    },
    onDownloadAll(){
      // One dialog for the whole selection, not one per broken file. Both lists
      // are reset here so a second run does not report the previous one again.
      this._missingFiles = [];
      this._failedFiles = [];
      let pending = this.item.length;
      let formData = new FormData();

      formData.append('selected_data', this.selected);
      formData.append('item_data', this.item);
      this.item.forEach((f,x) => {
        formData.append('item'+(x+1), f);
        const doc = this.getDocument(f);

        this.$store.dispatch ('isLoadingOn');
        //this.onOpenDocument(this.getDocument(f).id);
        this.$axios ({
          url: '/document/download_file/'+doc.id, //your url
          method: 'GET',
          responseType: 'blob', // important
        }).then((response) => {
          //console.log(response.data);
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;

          link.setAttribute('download', downloadFileName(response, doc.name));
          document.body.appendChild(link);
          link.click();
          this.onChangeStatus(1,doc.id);
          //window.URL.revokeObjectURL(blob);
        })
        .catch(async (error) => {
          const kind = await this.classifyFileError (error);
          if (kind === "missing") this._missingFiles.push (doc.name);
          else if (kind === "failed") this._failedFiles.push (doc.name);
        })
        // Same as onDownloadFile: the overlay is switched off on every exit,
        // otherwise one failed file leaves it on for the whole selection.
        .finally(() => {
          this.$store.dispatch ('isLoadingOff');
          pending--;
          if (pending === 0) this.reportDownloadFailures ();
        });
      });
    },
    // Called once the whole selection has been resolved. Missing files win over
    // generic failures: that is the message that actually explains what happened.
    reportDownloadFailures () {
      if (this._missingFiles.length) this.showFileMissing (this._missingFiles);
      else if (this._failedFiles.length) this._fileDialog (this.$t ("file_download_error"));
    },
    onDownloadZip(){
      let formData = new FormData();
      this.$store.dispatch('isLoadingOn');
      //console.log(this.selected.length);
      if(this.item.length == 1 ){
        let doc = this.getDocument(this.item);
        if (doc.document_type_id!=1){
          // onDownloadAll runs its own isLoadingOn/Off pair per file, so the
          // one opened above at the top of this method has to be closed here.
          // Without this the loading counter never got back to 0 on this branch
          // (a single non-folder file) and the overlay stayed on forever.
          this.onDownloadAll();
          this.$store.dispatch ('isLoadingOff');
        }else{
          formData.append ('items', this.item);
          formData.append ('clientsDocs', this.myDocs);
          this.$axios .post('/document/zip_and_download',
              formData, {
                responseType: 'blob', // important
                headers: {
                  "Content-Type": "multipart/form-data"
                }
              }).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            const file_name = `Archivos_${new Date().toLocaleDateString().slice(0,10)}_${new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', hour12: false})}.zip`;
            link.setAttribute('download',  file_name); //or any other extension
            document.body.appendChild(link);
            link.click();
            //window.URL.revokeObjectURL(blob);
            this.$store.dispatch ('isLoadingOff');
          }).catch ((error) => {
            this.$store.dispatch ('isLoadingOff');
            this.onFileError (error);
          });
        }
      }else{
        formData.append ('items', this.item);
        this.$axios .post('/document/zip_and_download',
            formData, {
              responseType: 'blob', // important
              headers: {
                "Content-Type": "multipart/form-data"
              }
            }).then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const file_name = `Archivos_${new Date().toLocaleDateString().slice(0,10)}_${new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', hour12: false})}.zip`;
          link.setAttribute('download', file_name); //or any other extension
          document.body.appendChild(link);
          link.click();
          //window.URL.revokeObjectURL(blob);
          this.$store.dispatch ('isLoadingOff');
        }).catch ((error) => {
          this.$store.dispatch ('isLoadingOff');
          this.onFileError (error);
        });
      }
    },
    // Returns the request: rebuilding the tree right after creating a folder has to
    // wait for this list, or the new folder is not in it yet.
    onLoadFolders(){
      // Alongside the tree, not chained to it: whoever waits for the folders (the
      // rebuild after creating one) has no reason to wait for the chips as well.
      this.loadPinnedFolders ();

      if(this.isAdmin){
        return this.$axios("documents?where-document_type_id=1")
            .then((response)=>{
              let data = response.data;
              this.getParents(data)
            })
      }
      else{
        return this.$axios("/client/folders")
            .then((response)=>{
              let data = response.data;
              this.getParents(data)
            })
      }
    },
    getParents(data){
      let keys = [];
      for(let row in data){
        if(!keys.includes(data[row].parent_id))
          keys.push(data[row].parent_id);
      }
      data.forEach((item)=>{
        if(keys.includes(item.id))
          item.hasChild = true;
        item.icon = 'icon-svg icon-folder-filled folder-icon';
        if(item.parent_id == 0)
          delete item.parent_id;
        if(!this.isAdmin)
          item.expanded = true;
      });

      // Both copies of the datasource are updated. The one of the mounted component
      // is what redraws the tree now; this.fields is what a remount builds the new
      // tree from, and leaving it behind is why a folder just created did not show up
      // in the tree that refreshTree rebuilt.
      this.fields.dataSource = data;
      if(this.show && this.$refs.treeview && this.$refs.treeview.ej2Instances){
        this.$refs.treeview.ej2Instances.fields.dataSource = data;
      }

      this.directory = data;
      this.show = true;
    },
    getParents_old(data){
      let keys = [];
      for(let row in data){
        if(!keys.includes(data[row].parent_id))
          keys.push(data[row].parent_id) ;
      }
      data.forEach((item)=>{
        if(keys.includes(item.id))
          item.hasChild = true;
        item.icon = 'icon-svg icon-folder-filled folder-icon';
        if(item.parent_id == 0)
          delete item.parent_id;
        if(!this.isAdmin)
          item.expanded = true;
      });
      if(this.show)
        this.$refs.treeview.ej2Instances.fields.dataSource = data;
      else
        this.fields.dataSource = data;
      this.directory = data;
      this.show = true;
    },
    onSelectNode23(event) {
      const nodeId = event.nodeData.id;

      if (nodeId === 0) {
        this.documents = this.indexFolder;
      } else {
        const data = { ...event.nodeData };
        data.folder_code = this.onGetFolderCode(data.id);
        this.onSelectFolder(data);
      }

      this.isRoot = false;
    },
    onSelectNode(event) {
      // Syncfusion hands the id over as a string, while the ids kept around here reach
      // the component as numbers: comparing them with === let the very same node
      // through again, which is what the guard below is there to stop.
      const nodeId = String (event.nodeData.id);

      // 🔁 Si se vuelve a clicar el mismo nodo, no hacemos nada
      if (String (this.lastSelectedNodeId) === nodeId) {
        return;
      }

      // axios 0.21 has no support for the `signal` option, so the AbortController that
      // used to stand here cancelled nothing: every answer arrived regardless and the
      // slowest one won. A request id is what actually keeps a stale answer out, the
      // same guard the search already uses.
      const requestId = ++this.nodeDetailRequestId;

      this.lastSelectedNodeId = nodeId;
      this.$store.dispatch('isLoadingOn');

      this.$axios(`/documents/${nodeId}`)
          .then((response) => {
            if (requestId !== this.nodeDetailRequestId) return null;

            this.itemSelected = response.data;
            this.itemSelected.folder_code = event.nodeData.folder_code;
            this.itemDocRequired = response.data;
            return this.$axios(`/user/${this.itemSelected.user_id}`);
          })
          .then((response2) => {
            if (!response2 || requestId !== this.nodeDetailRequestId) return;

            this.itemSelected.author = response2.data;
            this.itemSelected.comments = [];
            // The documentation of the folder used to be asked for again right here.
            // onLoadRequestDocumentation already fetches it on the folder-opening path
            // below and now fills request_items too, so every click was paying for two
            // identical /folder_documentation requests.
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.$store.dispatch('isLoadingOff');
          });

      if (nodeId === '0') {
        this.documents = this.indexFolder;
      } else if (String (this.selectFolder) !== nodeId) {
        // Only when this is not the folder already open. onSelectFolder selects the
        // node itself to keep the tree in step with the listing, and that selection
        // comes back here: opening the folder again from this point ran the whole
        // cascade a second time and ended in onRefresh, which reloaded the folder the
        // user had just left on top of the listing that had just arrived.
        const data = { ...event.nodeData };
        data.folder_code = this.onGetFolderCode(data.id);
        this.onSelectFolder(data);
      }

      this.isRoot = false;

      // From a tablet down the panel floats over the listing, so leaving it
      // open would cover the folder that has just been opened. It gets out of
      // the way once it has done its job, which is what a panel over the
      // content is expected to do.
      if (this.isTabletDown) this.isDrawerOpen = false;
    },
    onGetFolderCode (id){
      let Code = "";
      for (let row in this.directory)
      {
        if (this.directory[row].id == id)
        {
          return this.directory[row].folder_code;
        }
      }
      return Code;
    },
    nodeEdited: function(args) {
      console.log("nodeEdited");
      const newName = (args.newText || '').trim ();
      const oldName = args.oldText;

      // A folder with no name cannot be picked out of the tree again, and a
      // slash forks the path every listing walks.
      if (newName === "") {
        args.cancel = true;
        return;
      }
      if (/[\\/]/.test (newName)) {
        args.cancel = true;
        this._warnDialog (this.$t ("rename_invalid_name"));
        return;
      }
      // A folder just added carries the placeholder name of the tree and nothing
      // of it in the database, so it is stored even when the text is left as it
      // came: otherwise accepting the box without typing left a nameless folder.
      if (newName === oldName && !this.newFolderId) return;

      // The folder being edited is the node itself. "Añadir Carpeta" stores the
      // folder before opening this box, so the id is always there and editing
      // never creates: falling back to a POST, which is what happened whenever
      // this.id had been left empty by another flow, added a second folder
      // instead of renaming the one on screen.
      const folderId = args.nodeData.id || this.newFolderId || this.id;
      const wasNew = !!this.newFolderId;
      this.newFolderId = "";
      if (!folderId) {
        args.cancel = true;
        return;
      }

      const parentId = args.nodeData['parentID'] != null ? args.nodeData['parentID'] : '0';

      // Two folders with the same name in the same branch cannot be told apart.
      // The editor is reopened on the name that was turned down so it can be
      // corrected, instead of dropping what was typed.
      if (this._siblingNameTaken (newName, parentId, folderId)) {
        args.cancel = true;
        this._warnDialog (this.$t ("folder_name_taken"));
        if (wasNew) this.newFolderId = folderId;
        return;
      }

      // folder_code is not sent: it is the path of the folder holding this one
      // and the backend derives it. What used to travel from here was the
      // breadcrumb of the listing minus its last step, which had nothing to do
      // with the folder being renamed unless it happened to sit right there.
      const data = {
        name              : newName,
        parent_id         : parentId,
        user_id           : this.user.id,
        document_type_id  : 1
      };

      this.$store.dispatch ('isLoadingOn');
      this.$axios.put ("/documents/" + folderId, data)
          .then (() => {
            this.name = null;
            this.folder_code = null;
            this.folder = {};
            this.id = null;

            // Renaming the folder of the listing also changes the path printed
            // over it, and that path is what later uploads store as their own.
            const breadcrumb = String (this.selectFolder) === String (folderId)
                ? this.onLoadBreadcrumb ()
                : Promise.resolve ();

            return breadcrumb.then (() => {
              this.onRefresh ();
              // The tree keeps its own copy of the folders, and so does
              // this.directory: without rebuilding them the old name stayed
              // everywhere they are read until the page was reloaded.
              return this.reloadTreeFromBackend (this.selectFolder);
            });
          })
          .catch ((error) => {
            // The treeview has already painted the new name. Putting the old one
            // back is the only way of telling that nothing has been stored.
            const treeObj = document.getElementById('treeview')?.ej2_instances?.[0];
            if (treeObj?.updateNode) treeObj.updateNode (String (folderId), oldName);
            // A folder just added is still waiting for a name of its own, so the
            // editor is handed back rather than leaving it as "Nueva Carpeta".
            if (wasNew) this.newFolderId = folderId;
            this._warnDialog (this._nameChangeError (error, "rename_failed"));
          })
          .finally (() => {
            this.$store.dispatch ('isLoadingOff');
          });
    },
    getFolderNotification:function(){
    },
    selectEmailUserCheck:function(e){
      var email = e.target.value;
      var selected = event.target.checked;

      if (selected){
        this.checkedEmailUsersId.push(email);
      }else{
        this.checkedEmailUsersId.splice(email,0);
      }
    },
    selectUserCheck__2:function(e){
      var id = e.target.value;
      var selected = event.target.checked;
      let data = {
        user_id: id,
        folder_id: this.itemSelected.id,
        notify : selected ? '1' : '0',
      };
      this.$axios.post("/client/folder_check_user", data)
          .then(() => {
            //this.$store.dispatch('isLoadingOff');
          })
          .catch(() => {
            //this.$store.dispatch('isLoadingOff');
          });
    },


    nodeClicked(args) {

      if (!args || !args.node || !args.event) return;

      // 🔥 1️⃣ IGNORAR CLICK DERECHO / CONTEXT MENU (LO PRIMERO)
      const mouseEvent = args.event;
      if (
          mouseEvent.type === 'contextmenu' ||
          mouseEvent.button === 2
      ) {
        return;
      }

      // 🔥 2️⃣ IGNORAR CLICK EN ICONO EXPAND / COLLAPSE
      const target = mouseEvent.target;
      if (
          target.classList.contains("e-icon-expandable") ||
          target.classList.contains("e-icon-collapsible")
      ) {
        return;
      }

      const tree = this.$refs.treeview?.ej2Instances;
      if (!tree) return;

      const uid = args.node.getAttribute("data-uid");
      if (!uid) return;

      const nodeData = tree.getNode(uid);
      if (!nodeData?.id) return;

      const clickedId = nodeData.id;

      this.lastClickedNodeId = clickedId;
    },

    nodeClicked2: function(args) {

      if (args.event.which === 3) {
        var treeObj = document.getElementById('treeview').ej2_instances[0];
        treeObj.selectedNodes = [args.node.getAttribute('data-uid')];
        //treeObj.getTreeData(treeObj.selectedNodes);
      }
    },
    copiarEstructuraNodo(nodeId) {
      const tree = this.$refs.treeview;

      // getTreeData suele devolver array plano: [root, child1, child2, ...]
      const flat = tree.getTreeData(nodeId);

      if (!Array.isArray(flat) || flat.length === 0) return null;

      // Detectar claves típicas (Syncfusion suele usar id / parentID o pid)
      const idKey =
          flat[0].id !== undefined ? "id" :
              flat[0].nodeId !== undefined ? "nodeId" :
                  flat[0].uid !== undefined ? "uid" :
                      "id";

      const parentKey =
          flat[0].parentID !== undefined ? "parentID" :
              flat[0].pid !== undefined ? "pid" :
                  flat[0].parentId !== undefined ? "parentId" :
                      "parentID";

      const textKey =
          flat[0].text !== undefined ? "text" :
              flat[0].name !== undefined ? "name" :
                  "text";

      // 1) Crear mapa id -> nodo normalizado
      const map = new Map();
      flat.forEach(n => {
        map.set(n[idKey], { text: (n[textKey] ?? "").toString(), children: [] });
      });

      // 2) Enlazar hijos con su padre
      let root = null;
      flat.forEach(n => {
        const id = n[idKey];
        const parentId = n[parentKey];

        if (parentId === undefined || parentId === null || parentId === "" || parentId === 0) {
          // en algunos casos root viene sin parent
          // pero como estamos copiando desde nodeId, la raíz "real" será el primero (ver abajo)
          return;
        }

        const parent = map.get(parentId);
        const child = map.get(id);

        if (parent && child) {
          parent.children.push(child);
        }
      });

      // 3) La raíz del subtree que queremos copiar:
      // normalmente el primer elemento corresponde al nodeId solicitado
      const requestedRootId = flat[0][idKey];
      root = map.get(requestedRootId);

      return root || null;
    },
    normalizarNodo(nodo) {
      if (!nodo) return null;

      const children = Array.isArray(nodo.child)
          ? nodo.child
              .map(child => this.normalizarNodo(child))
              .filter(Boolean)
          : [];

      return {
        text: nodo.text ?? nodo.name ?? '',
        children
      };
    },

    getCompleteSubTree_(rootId, allData) {
      if (!rootId || !Array.isArray(allData)) {
        console.warn("❌ rootId o allData inválidos", rootId);
        return [];
      }

      const rootIdStr = String(rootId);

      // Detectar la key real del ID
      const idKey =
          allData[0]?.id !== undefined ? "id" :
              allData[0]?.nodeId !== undefined ? "nodeId" :
                  allData[0]?.uid !== undefined ? "uid" :
                      "id";

      const parentKey =
          allData[0]?.parentID !== undefined ? "parentID" :
              allData[0]?.parent_id !== undefined ? "parent_id" :
                  allData[0]?.pid !== undefined ? "pid" :
                      "parentID";

      // Crear mapa NORMALIZADO
      const map = {};
      allData.forEach(n => {
        map[String(n[idKey])] = {
          ...n,
          children: []
        };
      });

      // 🔎 DEBUG útil (déjalo mientras)
      if (!map[rootIdStr]) {
        console.error("❌ rootId no existe en originalData", {
          rootId,
          ejemploIds: Object.keys(map).slice(0, 10),
          idKey,
          parentKey
        });
        return [];
      }

      const buildNode = (nodeIdStr) => {
        const node = map[nodeIdStr];
        if (!node) return null;

        const cleanNode = {
          id: node[idKey],
          text: node.text || node.name || "",
          name: node.name || node.text || "",
          icon: node.icon || "icon-svg icon-folder-filled folder-icon",
          folder_code: node.folder_code,
          document_type_id: node.document_type_id,
          user_id: node.user_id,
          active: node.active,
          num_files: node.num_files,
          hasChild: false,
          children: []
        };

        // Buscar hijos
        const directChildren = allData.filter(n =>
            String(n[parentKey]) === nodeIdStr
        );

        if (directChildren.length > 0) {
          cleanNode.hasChild = true;
          cleanNode.children = directChildren
              .map(child => buildNode(String(child[idKey])))
              .filter(Boolean);
        }

        return cleanNode;
      };

      const rootNode = buildNode(rootIdStr);

      if (!rootNode) {
        console.warn("❌ No se pudo construir el subárbol");
        return [];
      }


      return [rootNode];
    },
    // ========== COPIAR ESTRUCTURA ==========
    copiar_estructura(targetNodeId) {
      try {
        const subTree = this.getCompleteSubTree_(targetNodeId, this.originalData);

        if (!subTree || subTree.length === 0) {
          console.warn("❌ Subárbol vacío");
          this.mostrarMensaje('No se pudo copiar la estructura', 'warning');
          return;
        }

        // Clonar profundamente para evitar mutaciones
        const flatData = this.flattenTree(JSON.parse(JSON.stringify(subTree)));

        // ✅ Guardar estructura completa
        this.estructuraCopiada = {
          flatData: flatData,
          solicitudesPorCarpeta: {}, // NUEVO
          rootId: targetNodeId,
          timestamp: new Date(),
          nodeCount: flatData.length
        };


        this.mostrarMensaje(
            `✅ ${flatData.length} carpeta${flatData.length !== 1 ? 's' : ''} copiada${flatData.length !== 1 ? 's' : ''}`,
            'success'
        );

      } catch (error) {
        console.error("❌ Error al copiar estructura:", error);
        this.mostrarMensaje('Error al copiar la estructura', 'error');
      }
    },

    selectUserCheck (e) {
      const userId = e.target.value;
      const selected = e.target.checked;

      if (!this.itemSelected?.id) return;

      this.crearNotificacionUsuario(
          userId,
          this.itemSelected.id,
          selected
      );
    },

    crearNotificacionUsuario (userId, folderId, notify = true) {
      const data = {
        user_id: userId,
        folder_id: folderId,
        notify: notify ? '1' : '0'
      };

      return this.$axios.post("/client/folder_check_user", data)
          .catch(err => {
            console.warn(
                '⚠️ No se pudo crear notificación',
                { userId, folderId, notify },
                err
            );
          });
    },
    limpiarSolicitud (solicitud) {
      const clean = { ...solicitud };

      delete clean.id;
      delete clean.folder_id;
      delete clean.created_at;
      delete clean.updated_at;

      return clean;
    },

    // ========== PEGAR ESTRUCTURA ==========
    async pegar_estructura(targetNodeId) {

      const tree = document.getElementById('treeview')?.ej2_instances?.[0];
      if (!tree) {
        this.mostrarMensaje('TreeView no disponible', 'error');
        return;
      }

      if (
          !this.estructuraCopiada ||
          !Array.isArray(this.estructuraCopiada.flatData)
      ) {
        this.mostrarMensaje('No hay estructura copiada', 'warning');
        return;
      }

      const source = this.estructuraCopiada.flatData;
      const solicitudesPorCarpeta =
          this.estructuraCopiada.solicitudesPorCarpeta || {};

      let targetRealId = targetNodeId;
      try {
        const tData = tree.getTreeData(targetNodeId);
        if (Array.isArray(tData) && tData.length && tData[0]?.id != null) {
          targetRealId = tData[0].id;
        }
      } catch (e) {
        console.warn('No se pudo resolver targetNodeId, usando el original');
      }
      targetRealId = String(targetRealId);

      const sourceMap = {};
      source.forEach(n => {
        sourceMap[String(n.id)] = n;
      });

      const withDepth = source.map(n => ({
        ...n,
        __depth: this.calcularDepth(n, sourceMap)
      }));
      withDepth.sort((a, b) => a.__depth - b.__depth);

      const idMap = {};

      try {
        for (const node of withDepth) {

          const oldId = String(node.id);
          const nodeName =
              (node.name ?? node.text ?? '').toString().trim() || 'Nueva Carpeta';

          const oldParent = node.parent_id ?? node.parentID ?? null;
          const parent_id = oldParent
              ? idMap[String(oldParent)]
              : targetRealId;

          if (!parent_id) continue;

          const solicitudesOriginales = solicitudesPorCarpeta[oldId] || [];

          const request_folder = solicitudesOriginales.map(solicitud => ({
            ...this.limpiarSolicitud(solicitud),
            active: 0
          }));


          // folder_code is derived by the backend from parent_id, like everywhere
          // else a folder is created.
          const payload = {
            name: nodeName,
            parent_id: parent_id,
            user_id: this.user.id,
            active: 0,
            document_type_id: 1,
            request_folder
          };


          payload.users = this.estructuraCopiada.checkedUsersId;


          const response = await this.$axios.post('/documents', payload);
          const newId = String(response.data.id);

          idMap[oldId] = newId;

          // 🔥 CREAR NOTIFICACIONES PARA USUARIOS COPIADOS
          if (
              Array.isArray(this.estructuraCopiada.checkedUsersId) &&
              this.estructuraCopiada.checkedUsersId.length > 0
          ) {
            for (const userId of this.estructuraCopiada.checkedUsersId) {
              await this.crearNotificacionUsuario(userId, newId, true);
            }
          }


          const item = {
            id: newId,
            name: nodeName,
            text: nodeName,
            icon: 'icon-svg icon-folder-filled folder-icon',
            parent_id,
            parentID: parent_id,
            hasChild: !!node.hasChild
          };

          tree.addNodes([item], parent_id, null);
          tree.fields.dataSource.push(item);

          if (Array.isArray(this.originalData)) {
            this.originalData.push({
              ...item,
              id: newId,
              parent_id: String(parent_id),
              parentID: String(parent_id),
              text: item.name,
              name: item.name,
              hasChild: false
            });
          }

          if (typeof tree.expandAll === 'function') {
            tree.expandAll([String(parent_id)]);
          }
        }

        tree.selectedNodes = [String(targetRealId)];
        tree.ensureVisible(String(targetRealId));

        this.mostrarMensaje(
            `✅ ${withDepth.length} carpeta${withDepth.length !== 1 ? 's' : ''} pegada${withDepth.length !== 1 ? 's' : ''} correctamente`,
            'success'
        );

        this.estructuraCopiada = null;
        this.puedePegarEstructura = false;

        await this.reloadTreeFromBackend(targetNodeId);

      } catch (error) {
        console.error('❌ Error al pegar estructura:', error);
        this.mostrarMensaje('Error al pegar la estructura', 'error');
      }
    },

    calcularDepth(node, map) {
      let depth = 0;
      let current = node;

      while (current.parent_id || current.parentID) {
        const parentId = current.parent_id || current.parentID;
        current = map[parentId];
        if (!current) break;
        depth++;
      }

      return depth;
    },

    // ========== HELPER: Aplanar árbol jerárquico ==========
    flattenTree(tree) {
      const result = [];

      const flatten = (nodes, level = 0) => {
        if (!nodes || !Array.isArray(nodes)) return;

        nodes.forEach(node => {
          // Agregar nodo actual
          result.push({
            id: node.id,
            name: node.name,
            text: node.text || node.name,
            parentID: node.parentID || node.parent_id,
            parent_id: node.parentID || node.parent_id,
            folder_code: node.folder_code,
            document_type_id: node.document_type_id,
            user_id: node.user_id,
            active: node.active,
            num_files: node.num_files || 0,
            hasChild: node.children && node.children.length > 0,
            icon: node.icon,
            level: level // ✅ Útil para debugging
          });

          // Procesar hijos recursivamente
          if (node.children && node.children.length > 0) {
            flatten(node.children, level + 1);
          }
        });
      };

      flatten(tree);
      return result;
    },

    menuclick: function(args) {
      var treevalidate = document.getElementById('treeview').ej2_instances[0];
      // The folder the menu was opened over (beforeopen), falling back to the
      // selected one for any path that did not come through the menu.
      var targetNodeId = this.ctxNodeId || treevalidate.selectedNodes[0];

      // Handled before the line below, which pinning has no use for. Writing
      // item[0] by index is not seen by Vue: item silently becomes a one-item
      // selection while itemSelected may be null (after a drag and drop, say),
      // and the re-render that the new pin triggers then read
      // itemSelected.document_type_id in the command bar and threw.
      if (args.item.id === 'pin') {
        if (this.isPinned (targetNodeId)) this.unpinFolder (targetNodeId);
        else this.pinFolder (targetNodeId);
        return;
      }

      this.item[0] = targetNodeId;

      if (args.item.text == "Añadir Carpeta") {

        /******************************************/
        var nodeId = "";
        console.log("nodeId-->"+nodeId);
        // folder_code is not sent: the path of a folder is the path of the one
        // holding it, which the backend derives from parent_id. What travelled
        // from here were the two halves of the breadcrumb of the listing, in the
        // wrong order, of whatever folder happened to be open at the time.
        var data = {
          parent_id         : targetNodeId,
          user_id           : this.user.id,
          document_type_id  : 1
        };
        console.log(targetNodeId);
        console.log(data);
        console.log(this.id);

        let request;
        if (this.id){
          request = this.$axios.put ("/documents/" + this.id, data);
        }else request = this.$axios.post ("/documents", data);
        request
            .then ((response) => {
              //args.nodeData = response.data;
              this.newFolderId =response.data['id'];
              //this.id = response.data['id'];
              //console.log(this.id);
              //console.log(args.nodeData['parent_id']);
              //console.log(args.nodeData['id']);
              //treeObj = document.getElementById('treeview').ej2_instances[0];
              //treeObj.refreshNode(args.nodeData['id']);

              //treeObj.selectedNodes = [response.data.parent_id];
              //treeObj.expandAll([response.data.parent_id]);
              //treeObj.ensureVisible(response.data.parent_id);

              //document.getElementById(args.nodeData['id']).innerHTML = "Hello, world";
              //document.getElementById('treeview_active').next('ul.e-list-parent').setAttribute('data-uid', response.data.id);
              //document.getElementById('treeview_active').parent().next('ul').find('li').setAttribute('data-uid', response.data.id);

              //setTimeout (() => {
              var nodeId = "" +response.data['id']+"";
              //var nodeId = "tree_" + this.index;
              var item = { id: nodeId, name: "Nueva Carpeta" , icon: 'icon-svg icon-folder-filled folder-icon'};
              treevalidate.addNodes([item], targetNodeId, null);
              this.index++;
              treevalidate.fields.dataSource.push(item);
              treevalidate.beginEdit("" +response.data['id']+"");
              nodeId = "";
              //}, 300);
              var treeObj = document.getElementById('treeview').ej2_instances[0];
              //treeObj.refreshNode(args.nodeData['id']);

              treeObj.selectedNodes = [response.data.parent_id];
              treeObj.expandAll([response.data.parent_id]);
              treeObj.ensureVisible(response.data.parent_id);
            })
            .catch (() => {
            });

        /**************************************/

        this.id = '';
      }
      else if (args.item.text == "Copiar Estructura_old") {

        this.structure_copy = 0;

        //this.fetchFolders();

        this.documents.forEach ((item) => {
          //console.log(item.id);
          let docT = this.getDocument(item.id);
          //console.log(docT.document_type_id);
          if (docT.document_type_id == 1){
            this.structure_copy = 1;
            this.docMoveCopy = {};
            this.move_copy = 0;
            this.showSelectFolderModal = true;
            this.titleModal = this.$t("select_folder_copy_folder");
            this.titleBtnAccept =  this.$t('copy_folder_btn');

          }
          //if (!docT.active){
          //this.copyDoc(docT.id, docT, move);
          //}
        });
        if(!this.structure_copy){

          this.$dialog.alert ({
            //title: this.$t("warning_not_active"),
            body: this.$t("¡¡No hay estructura para copiar!!"),
          }, { customClass: 'cd-dialog cd-dialog--warning' });
        }

        //this.onLoadFolders ();
        var treeObj = document.getElementById('treeview').ej2_instances[0];
        //treeObj.refreshNode(args.nodeData['id']);

        treeObj.refresh();
        treeObj.selectedNodes = [this.createdFolder.parent_id];
        treeObj.expandAll([this.createdFolder.parent_id]);
        treeObj.ensureVisible(this.createdFolder.parent_id);

      }
      else if (args.item.text == "Copiar Estructura_") {

        const nodeId = args.nodeData.id;                 // ID seleccionado
        const tree = document.getElementById('treeview').ej2_instances[0];

        // Obtener el nodo seleccionado
        const selectedNode = tree.getNode(nodeId);

        if (!selectedNode) {
          this.$dialog.alert({ body: "Nodo inválido" }, { customClass: 'cd-dialog cd-dialog--danger' });
          return;
        }

        // Obtener sus hijos (subcarpetas)
        const children = tree.getTreeData(nodeId);

        if (!children || children.length === 0) {
          this.$dialog.alert({ body: "¡¡No hay estructura para copiar!!" }, { customClass: 'cd-dialog cd-dialog--warning' });
          return;
        }

        // Guardamos la estructura para pegarla luego
        this.structureCopyBaseId = nodeId;
        this.structureCopyData = JSON.parse(JSON.stringify(children)); // clon profundo


        this.$dialog.alert({
          body: "Estructura copiada correctamente."
        }, { customClass: 'cd-dialog cd-dialog--success' });
      }
      else if (args.item.text === "Copiar Estructura") {

        const tree = this.$refs.treeview;

        const allData =
            tree.fields?.dataSource ||
            tree.dataSource ||
            [];

        if (!Array.isArray(allData) || allData.length === 0) {
          console.error("❌ TreeView no tiene dataSource cargado");
          this.mostrarMensaje("Error: TreeView sin datos", "error");
          return;
        }

        const realRootId = this.resolveRealIdFromTree(targetNodeId);
        const flatData = this.buildFlatSubtreeFromDataSource(realRootId, allData);

        if (!flatData.length) {
          this.mostrarMensaje("No se pudo copiar la estructura", "warning");
          return;
        }

        // 🔥 NUEVO: copiar usuarios checkeados
        const checkedUsersCopiados = Array.isArray(this.checkedUsersId)
            ? [...this.checkedUsersId]
            : [];

        this.estructuraCopiada = {
          flatData,
          solicitudesPorCarpeta: this.estructuraCopiada?.solicitudesPorCarpeta || {},
          checkedUsersId: checkedUsersCopiados, // 👈 AQUÍ
          rootId: realRootId,
          timestamp: new Date(),
          nodeCount: flatData.length
        };

        this.puedePegarEstructura = true;

        this.mostrarMensaje(
            `✅ ${flatData.length} carpeta${flatData.length !== 1 ? "s" : ""} copiada${flatData.length !== 1 ? "s" : ""}`,
            "success"
        );
      }
      else if (args.item.text == "Pegar Estructura__") {

        if (!this.structureCopyData) {
          this.$dialog.alert({ body: "No hay estructura copiada." }, { customClass: 'cd-dialog cd-dialog--warning' });
          return;
        }

        const targetNodeId = args.nodeData.id;  // Nodo donde pegaremos
        const tree = document.getElementById('treeview').ej2_instances[0];

        // Clonamos los datos para no modificarlos directamente
        const newStructure = JSON.parse(JSON.stringify(this.structureCopyData));

        // Reasignamos IDs y parentIds para evitar colisiones
        const reassignIds = (nodes, parentId) => {
          nodes.forEach(node => {
            node.id = "new_" + Math.random().toString(36).substring(2, 9);
            node.parentId = parentId;

            if (node.children && node.children.length) {
              reassignIds(node.children, node.id);
            }
          });
        };

        reassignIds(newStructure, targetNodeId);

        // Añadir al TreeView
        newStructure.forEach(n => {
          tree.addNodes([n], targetNodeId);
        });

        // Expandimos destino
        tree.expandAll([targetNodeId]);

        this.$dialog.alert({
          body: "Estructura pegada correctamente."
        }, { customClass: 'cd-dialog cd-dialog--success' });
      }
      else if (args.item.text == "Borrar Carpeta") {
        let self = this;

        // The name comes from the node under the pointer, so the question says
        // which folder it is about. It used to be a bare "¿Desea borrar esta
        // carpeta?", hardcoded in Spanish and saying nothing about the
        // subfolders and files going with it.
        const targetNode = treevalidate.getNode(targetNodeId);
        const targetName = targetNode ? (targetNode.text || targetNode.name) : "";

        // La forma abreviada con string no admite opciones, y el plugin la
        // trata como el "body", así que pasarla a objeto es equivalente.
        this.$dialog.confirm(
              { body: this.$t("delete_folder_confirm", { name: targetName }) },
              { customClass: 'cd-dialog cd-dialog--danger' }
            )
            .then(function() {
              // The node is not taken out of the tree here any more. It used to
              // go as soon as the dialog was confirmed, before the server had
              // said anything and with nothing to put it back, so a refused
              // deletion still left the folder off the screen. runDelete rebuilds
              // the tree from the database, which also restores the selection.
              //
              // The parent is the one of the node under the pointer. It used to be
              // parent_folder, the parent of the last node opened with a left click:
              // a different folder whenever the one deleted had not been opened
              // first, and null for a root folder, which left selectFolder null and
              // the next folder created stored with parent_id NULL.
              self.onDeleteTreeFolder(self._folderOrRoot(targetNode && targetNode.parentID), targetNodeId);
            })
      }
      else if (args.item.text == "Renombrar Carpeta") {
        treevalidate.beginEdit(targetNodeId);
        this.id = targetNodeId;
      }
      else  if (args.item.id === 'upload') {
        const treeObj = this.$refs.treeview.ej2Instances;
        const selectedNodes = treeObj.selectedNodes;

        if (!selectedNodes || selectedNodes.length === 0) {
          alert('Selecciona un nodo primero.');
          return;
        }

        const selectedNode = selectedNodes[0];

        // Crear input file dinámico
        const input = document.createElement('input');
        input.type = 'file';
        input.multiple = true;
        input.onchange = (e) => this.uploadFiles(e.target.files, selectedNode);
        input.click();
      }
      else if (args.item.text === 'Pegar Estructura') {
        if (!this.puedePegarEstructura) {
          this.mostrarMensaje('No hay estructura para pegar', 'warning');
          return;
        }

        this.pegar_estructura(targetNodeId);

        /*const treeView1 = this.$refs.treeview;

        treeView1.addNodes([
          { id: '12', name: 'New Parent', parent_id: targetNodeId, hasChild: true },
          { id: '13', name: 'New Child1', parent_id: '12' },
        ]);*/
      }
    },
    buildFlatSubtreeFromDataSource(rootId, allData) {
      const rootStr = String(rootId);

      // índice de hijos: parent -> [children]
      const childrenByParent = new Map();
      const byId = new Map();

      for (const n of allData) {
        const id = String(n.id);
        const parent = n.parentID ?? n.parent_id ?? null;

        byId.set(id, n);

        const pKey = parent === null || parent === undefined ? null : String(parent);
        if (!childrenByParent.has(pKey)) childrenByParent.set(pKey, []);
        childrenByParent.get(pKey).push(n);
      }

      const rootNode = byId.get(rootStr);
      if (!rootNode) return [];

      // BFS para obtener todos los descendientes
      const queue = [rootStr];
      const visited = new Set();
      const result = [];

      while (queue.length) {
        const currentId = queue.shift();
        if (visited.has(currentId)) continue;
        visited.add(currentId);

        const node = byId.get(currentId);
        if (!node) continue;

        result.push(node);

        const kids = childrenByParent.get(currentId) || [];
        for (const k of kids) {
          queue.push(String(k.id));
        }
      }

      // Normalizar parent_id dentro del subárbol:
      // - raíz => parent_id null
      // - resto => parent_id (del datasource) en string
      const idSet = new Set(result.map(n => String(n.id)));

      const normalized = result.map(n => {
        const id = String(n.id);
        const rawParent = n.parentID ?? n.parent_id ?? null;
        const parentStr = rawParent === null || rawParent === undefined ? null : String(rawParent);

        const clean = {
          ...n,
          id,                         // id como string (estable)
          parent_id: id === rootStr ? null : (idSet.has(parentStr) ? parentStr : null),
          parentID: id === rootStr ? null : (idSet.has(parentStr) ? parentStr : null),
        };

        // Recalcular hasChild según descendientes en subárbol
        clean.hasChild = (childrenByParent.get(id) || []).some(c => idSet.has(String(c.id)));

        // OJO: si tu TreeView está en modo flat, NO metas children aquí
        delete clean.children;

        return clean;
      });

      return normalized;
    },

    resolveRealIdFromTree(targetNodeId) {
      const tree = this.$refs.treeview;

      // Si targetNodeId ya es un id real, getTreeData suele devolverlo igual
      try {
        const arr = tree.getTreeData(targetNodeId);
        if (Array.isArray(arr) && arr.length && arr[0].id !== undefined && arr[0].id !== null) {
          return String(arr[0].id);
        }
      } catch (e) {
        // si falla, asumimos que targetNodeId ya era id real
      }

      return String(targetNodeId);
    },

    // ✅ BONUS: Función auxiliar para mostrar mensajes
    mostrarMensaje() {

      // Si usas algún sistema de notificaciones (toast, alert, etc.)
      // Ejemplo con Syncfusion Toast:
      // if (this.$refs.toast) {
      //     this.$refs.toast.show({
      //         title: tipo === 'success' ? 'Éxito' : tipo === 'error' ? 'Error' : 'Aviso',
      //         content: mensaje,
      //         cssClass: `e-toast-${tipo}`
      //     });
      // }
    },
    activarOpcionPegar() {
      this.contextMenuItems = this.contextMenuItems.map(item => {
        if (item.text === 'Pegar Estructura') {
          return { ...item, disabled: false };
        }
        return item;
      });
    },
    onGetRecursivityFolder: function (){
      let vm = this;
      var newObj = [];
      //vm.recursive(vm.documents, newObj, 0);
      vm.structure_copy = 0;
      this.$store.dispatch ('isLoadingOff');
      this.refreshTree();
      return newObj;
    },
    recursive: function (obj, newObj, level) {
      let vm = this;

      obj.forEach(function(o) {
        if (o.document_type_id == 1){
          vm.$axios (`/documents?where-parent_id=${o.id}`)
              .then ((response) => {
                vm.arrayChild = response.data;
                vm.name = o.name;
                vm.active = 0;
                vm.selectFolder = vm.createdFolderId;
                vm.document_type= 1;
                vm.onSaveFolder();

                setTimeout (() => {
                  vm.recursive(response.data, newObj, level + 1);
                }, 500);

                vm.$store.dispatch ('isLoadingOff');
              })
              .catch (() => {
                vm.$store.dispatch ('isLoadingOff');
              });
          newObj.push(o);
          //vm.recursive(o, newObj, level + 1);
          //console.log(vm.arrayChild);
          //vm.recursive(vm.arrayChild, newObj, level + 1);
        }else{
          return false;
        }
      });
    },
    // Deleting a folder from the tree's context menu.
    //
    // It no longer loads the parent listing first just to leave the id in
    // this.item and call another method: the request goes straight out, and
    // runDelete moves the view to the parent once the server has confirmed.
    //
    // The read-only check the listing runs is not repeated here: the server
    // refuses on its own with a 409 and runDelete reports it.
    onDeleteTreeFolder: function (parentId, id) {
      this.clearRequestSelection ();
      this.showOptions = false;

      return this.runDelete ([id], parentId);
    },
    beforeopen: function(args) {
      var treevalidate = document.getElementById('treeview').ej2_instances[0];
      // The folder under the pointer is the one the menu is about. It is remembered
      // rather than selected so that opening the menu does not also navigate to it.
      var targetLi = args.event && args.event.target
          ? args.event.target.closest ('li.e-list-item')
          : null;
      this.ctxNodeId = targetLi
          ? targetLi.getAttribute ('data-uid')
          : (treevalidate.selectedNodes[0] || null);
      var targetNodeId = this.ctxNodeId;
      var targetNode = targetNodeId
          ? document.querySelector('[data-uid="' + targetNodeId + '"]')
          : null;
      // Right-clicked away from any folder (or on a node no longer in the tree):
      // there is nothing to act on, so the menu stays closed. This used to read
      // classList of a node that was not there and throw, and the exception left the
      // menu without opening at all -- which is why it looked like it had gone.
      if (!targetNode) {
        args.cancel = true;
        return;
      }
      var contentmenutree = document.getElementById('contentmenutree').ej2_instances[0];
      if (targetNode.classList.contains('borrar')) {
        contentmenutree.enableItems(['Borrar Carpeta'], false);
      }
      else {
        contentmenutree.enableItems(['Borrar Carpeta'], true);
      }
      if (targetNode.classList.contains('renombrar')) {
        contentmenutree.enableItems(['Renombrar Carpeta'], false);
      }
      else {
        contentmenutree.enableItems(['Renombrar Carpeta'], true);
      }
      // The pin item speaks about the folder under the pointer, not about whether
      // anything is pinned: "Desfijar" for one of the pinned ones, and once the
      // limit is reached, "Fijar" is shown disabled with the limit in it.
      const isTargetPinned = this.isPinned (targetNodeId);
      const canPin = isTargetPinned || !this.isPinLimitReached;
      const newText = isTargetPinned
          ? 'Desfijar carpeta'
          : (canPin ? 'Fijar carpeta' : `Fijar carpeta (máx. ${MAX_PINNED_FOLDERS})`);

      const updateItemById = (items) => {
        for (const it of items) {
          if (it.id === 'pin') {
            it.text = newText;
            return true;
          }

          // 📂 Copiar estructura (siempre activo)
          if (it.id === 'copiar_estructura') {
            it.text = 'Copiar estructura';
            it.disabled = false;
          }

          // 📋 Pegar estructura (depende del estado)
          if (it.id === 'pegar_estructura') {
            it.disabled = !this.puedePegarEstructura;
            it.text = this.puedePegarEstructura
                ? 'Pegar estructura'
                : 'Pegar estructura (copie primero)';
          }

          if (it.items && it.items.length) {
            if (updateItemById(it.items)) return true;
          }
        }
        return false;
      };

      if (updateItemById(contentmenutree.items)) {
        contentmenutree.dataBind(); // 🔥 aplica el cambio en el menú ya renderizado
      }

      // Syncfusion 18 has no `disabled` on menu items: enableItems is what greys one
      // out. It works on the rendered item, so it goes after dataBind, which
      // re-renders the menu; true makes it look the item up by id, not by text.
      contentmenutree.enableItems (['pin'], canPin, true);
    },
    onEditing(args) {
      var treeObj = document.getElementById('treeview').ej2_instances[0];
      treeObj.selectedNodes = [args.node.getAttribute('data-uid')];
      //check whether node is root node or not
      /*if (args.node.parentNode.parentNode.nodeName !== "LI") {
        args.cancel = true;
      }*/
      this.onSaveFolder();
    },
    changeUrlAndFolderCode(id, parent, doc){
      Object.keys(doc.num_files || {}).forEach(() => {
        this.upload_docs = this.deleted_docs = 1;
        this.onUpdateParentFiles(parent, false);
        setTimeout (() => {
          this.onUpdateParentFiles(parent, true);
        }, 500);
      });
      /*this.$axios.post (`/document/change_url_folder_code/${id}`, data)
          .then ((response) => {
            this.$store.dispatch ('isLoadingOff');
            console.log(response.data);
            this.$axios.put("/documents/"+id, data)
                .then((response) => {
                  console.log(response.data);
                  console.log("+++++++++++++++");
                  this.$store.dispatch ('isLoadingOff');
                })
                .catch(() => {
                  this.$store.dispatch('isLoadingOff');
                });
          })
          .catch (() => {
            this.$store.dispatch ('isLoadingOff');
          })*/
    },
    moveNodeInTree(nodes, nodeId, newParentId) {
      let movedNode = null;

      // 1. Encontrar y QUITAR el nodo del árbol
      const removeNode = (items) => {
        for (let i = 0; i < items.length; i++) {
          if (String(items[i].id) === String(nodeId)) {
            movedNode = items.splice(i, 1)[0];
            return true;
          }

          const children = items[i].children || items[i].subChild || [];
          if (children.length && removeNode(children)) {
            return true;
          }
        }
        return false;
      };

      removeNode(nodes);

      if (!movedNode) {
        console.error("No se pudo encontrar el nodo a mover");
        return;
      }

      // Actualizar el parent_id del nodo
      movedNode.parent_id = newParentId;
      movedNode.parentID = newParentId;

      // 2. INSERTAR el nodo en su nuevo parent
      if (newParentId === 0 || newParentId === null) {
        // Mover a ROOT
        nodes.push(movedNode);
      } else {
        // Buscar el nuevo parent e insertar
        const insertNode = (items) => {
          for (const item of items) {
            if (String(item.id) === String(newParentId)) {
              if (!item.children) item.children = [];
              item.children.push(movedNode);
              item.hasChild = true;
              return true;
            }

            const children = item.children || item.subChild || [];
            if (children.length && insertNode(children)) {
              return true;
            }
          }
          return false;
        };

        if (!insertNode(nodes)) {
          console.error("No se pudo encontrar el nuevo parent");
          nodes.push(movedNode); // Fallback a ROOT
        }
      }
    },
    onDragStop(args) {
      const tree = this.$refs.treeview?.ej2Instances;
      if (!tree) {
        console.warn("TreeView no está disponible");
        return;
      }

      const dragged = Array.isArray(args.draggedNodeData)
          ? args.draggedNodeData[0]
          : args.draggedNodeData;

      const document_id = dragged?.id;
      if (!document_id) return;

      let parent_id = null;
      let isRootDrop = false;

      const treeElement = tree.element;
      const mouseY = args.event?.clientY;


      // 🔥 ROOT DROP REAL:
      // Si sueltas en la zona superior del TreeView,
      // antes del primer nodo visible
      const firstNode = treeElement.querySelector("li.e-list-item");

      if (mouseY && firstNode) {
        const firstRect = firstNode.getBoundingClientRect();

        if (mouseY < firstRect.top + 5) {
          isRootDrop = true;
          parent_id = null;
        }
      }

      // 🔹 Si NO es root, usar lógica normal
      if (!isRootDrop) {
        if (args.droppedNodeData?.id) {
          parent_id = args.droppedNodeData.id;
        } else if (args.dropTarget) {
          const li = args.dropTarget.closest?.("li.e-list-item");
          const uid = li?.getAttribute?.("data-uid");
          const targetNode = uid ? tree.getNode(uid) : 0;
          parent_id = targetNode?.parentID ?? 0;
        }
      }


      // Same path as dragging a row of the listing onto the tree: it checks the move,
      // updates the stored path and the counters, and refreshes the listing and the
      // tree, which is what was missing here -- the request went through but the
      // branch was left as it was.
      this.moveDocumentToFolder ({
        id: document_id,
        // nodeData calls it text; name is kept as a fallback for other callers.
        name: dragged.text != null ? dragged.text : dragged.name,
        parent_id: dragged.parentID,
        // Only folders live in the tree, and what is moved has to say so: a file
        // is also moved in storage, a folder is not.
        document_type_id: 1
      }, parent_id);
    },
    onDragStop2 (args) {
      let document_id = args.draggedNodeData.id;
      let parent_id = args.droppedNodeData.id;
      if (parent_id != document_id)
      {
        this.$axios.put ("/documents/" + document_id, {'parent_id' : parent_id})
            .then ((response) => {
              this.onRefresh ();
              this.changeUrlAndFolderCode(document_id, parent_id, response.data);

              //change files url and folder_code
            })
      }
    },
    loadTemplateDocumentation () {
      this.$axios("/template_request_documentation")
          .then((response)=>{
            this.templates = response.data;
          })
    },
    convertCurrency (amount){
      return new Intl.NumberFormat ('de-DE', { style: 'currency', currency: 'EUR' }).format(amount);
    },
    clicked: function(){
      alert("random");
    },
    sortBy: function(sortKey){
      this.reverse = (this.sortKey == sortKey) ? ! this.reverse : false;
      this.sortKey = sortKey;
      /*this.documents.sort((a, b) => {
        if (Date.parse(a.updated_at) > Date.parse(b.updated_at)) {
          return 1
        } else if (Date.parse(a.updated_at) < Date.parse(b.updated_at)) {
          return -1
        } else {
          return 0
        }
      })*/
    },
    isActive: function(column){
      return this.sortKey == column;
    }
  }
}

document.addEventListener('click', function (e) {
  for (let t = e.target; t && t != this; t = t.parentNode) {
    if (t.matches("#exampleFinal tbody tr")) {
      //alert("hello")
      break
    }
  }
}, false)
/*function renderDocName(data, row){
  console.log(data);
  console.log(row);
  // var item = '<div><div id="${row.id}" value="${row.value}" @click="reset">' +
  //                '<p><strong>'+data+'</strong></p></div></div>';
  // return item;
  return '<a v-on:click="clicked()" style="margin-left:30px">' + data + '</a>';
}*/
$( document ).ready( function() {
  /*document.querySelectorAll('input[name="choose_robot"]').forEach(radio => {
    radio.addEventListener('change', function() {
      document.querySelectorAll('input[name="choose_robot"]').forEach(r => r.removeAttribute('checked'));
      this.setAttribute('checked', 'checked');
    });
  });*/

  $( '#tagSelect' ).on( 'change', function() {
    alert("tagSelect");
  });

})

</script>

<style>
.right
{
  right: 0;
  position: absolute;
}
fieldset[disabled]{
  background: #f7f7f7;
}
fieldset[disabled] .e-input {
  background: #f8f8f8 !important;
}
#dropzone{
  height: 565px !important;
}
.rotate90{
  transform :rotate(90deg);
  width: 60px;
  padding: 0;
  margin: 0;
  position: absolute;
  left: 2px;
  top: 70px;
}
.step-circle{
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/* --------------------------------------------------------------------------
   "Añadir documentación solicitada" modal (v2 restyling)
   --------------------------------------------------------------------------
   Everything here is prefixed with .cd-modal on purpose: this <style> block
   is not scoped, and the other three modals of this view have not been
   migrated yet. The shared chrome (header, body, footer, fields, buttons)
   comes from the .cd-modal section of variations.scss; only what is specific
   to this modal lives here.
*/

/* Text field + "Add" button on a single line. The field is a base-input,
   which wraps its input in a .form-group carrying a bottom margin, so the
   button would sit above the baseline of the field without cancelling it.
   The margin is !important because variations.scss declares it that way. */
.cd-modal .cd-req-add {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
}
.cd-modal .cd-req-add > .form-group {
  flex: 1;
  margin-bottom: 0 !important;
}
/* Same shape as the footer buttons (see the cd-modal-footer mixin in
   variations.scss), so "Añadir" and "Guardar" read as the same control. */
.cd-modal .cd-req-add .btn {
  height: 38px;
  min-width: auto;
  margin: 0;
  padding: 0 20px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 500;
  box-shadow: none;
}

/* Reorderable list of requested items. The 2px padding leaves room for the
   focus ring of the inline edit input, which the scroll container would
   otherwise clip; the negative margin keeps the list flush with the rest of
   the body. */
.cd-req-list {
  max-height: 340px;
  overflow-y: auto;
  padding: 2px;
  margin: 0 -2px;
}

/* Bootstrap draws .list-group-item as a flush stack: square corners, shared
   borders and a -1px bottom margin, with :first-child / :last-child rules
   that tie on specificity with a two-class selector. Going through
   .cd-req-list adds the third class needed to win regardless of the order in
   which webpack injects this block. */
.cd-modal .cd-req-list .cd-req-item {
  margin-bottom: 0.375rem;
  padding: 0.5rem 0.75rem;
  border: 1px solid var(--cd-border-light);
  border-radius: 8px;
  background-color: #fff;
  color: var(--cd-text-body);
  cursor: grab;
}
.cd-modal .cd-req-list .cd-req-item:last-child {
  margin-bottom: 0;
}
.cd-modal .cd-req-list .cd-req-item:hover {
  border-color: var(--cd-border-green-soft);
  background-color: var(--cd-surface-green-soft);
}
.cd-modal .cd-req-list .cd-req-item:active {
  cursor: grabbing;
}

/* Section headings inside the list (element.isIndex). They used to borrow
   .bg-gray + .titleColor, both defined in the non-scoped <style> of other
   views, so they only painted if one of those components happened to be
   loaded. */
.cd-modal .cd-req-list .cd-req-item-index {
  border-color: var(--cd-border-green-soft);
  background-color: var(--cd-surface-green-soft);
  color: var(--cd-brand-green-dark);
  font-weight: 500;
}

.cd-modal .cd-req-item-name {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
  overflow-wrap: anywhere;
}

/* Drag handle. Drawn as a background image instead of an icon-font glyph so
   it does not depend on which FontAwesome build is loaded, the same approach
   the select chevrons use in variations.scss. Purely an affordance: the drag
   target is the whole row, not this dot grid. */
.cd-modal .cd-req-item-name::before {
  content: "";
  flex: 0 0 auto;
  width: 10px;
  height: 16px;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='16' viewBox='0 0 10 16' fill='%238a8f9c'><circle cx='3' cy='4' r='1.3'/><circle cx='7' cy='4' r='1.3'/><circle cx='3' cy='8' r='1.3'/><circle cx='7' cy='8' r='1.3'/><circle cx='3' cy='12' r='1.3'/><circle cx='7' cy='12' r='1.3'/></svg>");
  background-repeat: no-repeat;
  background-position: center;
}

.cd-modal .cd-req-edit {
  flex: 0 0 auto;
  color: var(--cd-text-muted);
  font-size: 0.9rem;
  line-height: 1;
}
.cd-modal .cd-req-edit:hover,
.cd-modal .cd-req-edit:focus {
  color: var(--cd-brand-green);
}

/* The delete button only carries .btn, so it picks up the template's own
   button chrome (2px border, padding, min-width). Stripped back to a bare
   icon; the three classes beat those rules without !important. */
.cd-modal .cd-req-list .cd-req-delete {
  min-width: auto;
  margin: 0;
  padding: 0 0 0 0.5rem;
  border: 0;
  background: none;
  box-shadow: none;
  color: var(--cd-text-muted);
  font-size: 1rem;
  line-height: 1;
}
.cd-modal .cd-req-list .cd-req-delete:hover,
.cd-modal .cd-req-list .cd-req-delete:focus {
  background: none;
  color: #dc3545;
}

/* Inline rename field. The v2 box already comes from .cd-modal .form-control;
   only the height is trimmed so the row does not jump while editing. */
.cd-modal .cd-req-list .cd-req-edit-input {
  padding: 0.25rem 0.6rem;
  font-size: 0.9rem;
}

/* Placeholder left behind by vuedraggable while a row is being dragged. */
.cd-modal .cd-req-list .cd-req-ghost {
  border-color: var(--cd-brand-green);
  background-color: var(--cd-surface-green-soft);
  opacity: 0.6;
}

/* --------------------------------------------------------------------------
   "Propiedades" modal (v2 restyling)
   --------------------------------------------------------------------------
   Label/value rows separated by the full-bleed <hr> that .cd-modal already
   styles. The labels reuse the global .cd-form-label so the four titles share
   the typography of every other field title, which also evens out the i18n
   keys: three are written in caps ("SOLO LECTURA", "RUTA", "HISTORIAL") and
   one is not ("Etiqueta"), and text-transform hides the difference.
*/
.cd-modal .cd-prop-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.cd-modal .cd-prop-row .cd-form-label {
  flex: 0 0 auto;
  margin-bottom: 0;
}

.cd-modal .cd-prop-value {
  min-width: 0;
  color: var(--cd-text-body);
  font-size: 0.95rem;
  text-align: right;
  overflow-wrap: anywhere;
}

/* The tag picker needs real width, unlike the checkbox and the path text. */
.cd-modal .cd-prop-value-wide {
  flex: 1 1 auto;
  max-width: 62%;
}

/* Stacked block, for a value that does not fit next to its own label. */
.cd-modal .cd-prop-block .cd-form-label {
  margin-bottom: 0.75rem;
}

.cd-modal .cd-prop-history {
  max-height: 220px;
  overflow-y: auto;
  color: var(--cd-text-body);
  font-size: 0.9rem;
}

/* .checkStep zeroes the margins of ul/li but leaves the browser's default
   left padding in place (the rule is commented out over there), and the
   status icons are pulled 1.5em back out of it. The padding is pinned down
   here so that offset lands where it should instead of depending on the
   default. */
.cd-modal .cd-prop-history ul {
  margin: 0;
  padding-left: 1.75rem;
}

.cd-modal .cd-prop-history li + li {
  margin-top: 0.4rem;
}

/* .checkStep paints the fallback icon blue (#0074D9) and every recognised
   status grey; they all read as one muted list here. */
.cd-modal .cd-prop-history li:before {
  color: var(--cd-text-muted);
}

/* --------------------------------------------------------------------------
   "Comentarios" modal (v2 restyling)
   --------------------------------------------------------------------------
   A thread that scrolls with a compose box pinned under it. The modal carries
   no footer, so the send button lives in the body.
*/

/* The height was an inline "height: 350px; overflow-y: scroll", which fixed
   the panel at 350px whatever it held and kept a scrollbar track down the
   right edge even on an empty thread. */
.cd-modal .cd-comments {
  min-height: 120px;
  max-height: 340px;
  overflow-y: auto;
  margin-bottom: 1rem;
}

.cd-modal .cd-comment {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 1rem;
}
.cd-modal .cd-comment:last-child {
  margin-bottom: 0;
}

/* Was .bg-dark plus .p-25 (a 0.8rem padding) to fake a circle out of the
   initials; a fixed box centres them without depending on how long the text
   inside is. */
.cd-modal .cd-comment-avatar {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: var(--cd-brand-green);
  color: #fff;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
}

.cd-modal .cd-comment-body {
  flex: 1 1 auto;
  min-width: 0;
}

/* Was .alert.alert-info: a blue notice box, which read as a warning rather
   than as somebody's message. The square top-left corner points the bubble
   back at its avatar. */
.cd-modal .cd-comment-bubble {
  padding: 0.6rem 0.9rem;
  border: 1px solid var(--cd-border-light);
  border-radius: 10px;
  border-top-left-radius: 2px;
  background-color: var(--cd-surface-green-soft);
  color: var(--cd-text-body);
  font-size: 0.95rem;
  overflow-wrap: anywhere;
}

.cd-modal .cd-comment-date {
  margin-top: 0.25rem;
  color: var(--cd-text-muted);
  font-size: 0.78rem;
}

/* Empty state. It used to be a .border .border-bottom-0 box, which drew three
   sides of a rectangle around the message. */
.cd-modal .cd-comments-empty {
  margin: 0;
  padding: 2.5rem 1rem;
  color: var(--cd-text-muted);
  font-size: 0.95rem;
  text-align: center;
}

/* Same box as the empty state so the panel does not change height when the
   thread finishes loading. */
.cd-modal .cd-comments-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin: 0;
  padding: 2.5rem 1rem;
  color: var(--cd-text-muted);
  font-size: 0.95rem;
}

.cd-modal .cd-comment-error {
  margin-bottom: 0.5rem;
}

/* Stacked: the textarea takes the full width and the button sits under it,
   right-aligned like the footer button of the other modals. */
.cd-modal .cd-comment-compose {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-top: 1rem;
  border-top: 1px solid var(--cd-border-light);
}
.cd-modal .cd-comment-compose textarea.form-control {
  width: 100%;
  resize: vertical;
}
/* Same shape as the footer buttons of every other migrated modal.
   align-self keeps it at its own width: the column stretches its items by
   default, which would run the button the whole way across. */
.cd-modal .cd-comment-compose .btn {
  align-self: flex-end;
  flex: 0 0 auto;
  height: 38px;
  min-width: auto;
  margin: 0;
  padding: 0 20px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 500;
  box-shadow: none;
}
.cd-modal .cd-comment-compose .btn i {
  margin-right: 6px;
}

/* --------------------------------------------------------------------------
   "Selecciona una carpeta..." modal (v2 restyling)
   --------------------------------------------------------------------------
   Only the panel holding the tree lives here; the tree's own hover and
   selection colours are in the .cd-modal section of variations.scss, since
   the "generar usuario" modal has an ejs-treeview too.

   The tree carried no height of its own, so the modal grew with the number of
   folders until it ran off the screen.
*/
.cd-modal .cd-folder-tree {
  max-height: 340px;
  overflow-y: auto;
  padding: 0.5rem;
  border: 1px solid var(--cd-border-light);
  border-radius: 8px;
}

/* --------------------------------------------------------------------------
   "Editar carpeta" modal (v2 restyling)
   --------------------------------------------------------------------------
   Same modal serves two jobs: editing a folder (document_type == 1) and
   uploading files. Both are covered here.
*/

.cd-modal .cd-users-search {
  margin-bottom: 0.5rem;
}

/* The panel of notifiable users. It used to be a white card with its own drop
   shadow floating on a white body, which read as a second surface for no
   reason; a plain outline matches the other fields.

   Deliberately without a max-height of its own: this file declares a bare
   ".modal-body { max-height: 500px; overflow-y: auto }", so giving the list
   its own scroll puts one scrollbar inside another. The body keeps being the
   only thing that scrolls, as it was before the restyling. */
.cd-modal .cd-users-list {
  border: 1px solid var(--cd-border-light);
  border-radius: 8px;
  box-shadow: none;
}

/* Two columns. They were laid out with "tr { width: 50%; float: left }",
   which lets a row with a long name push its neighbour down and leaves a gap
   in the column beside it. Grid keeps both columns in step. */
.cd-modal .cd-users-list tbody {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.cd-modal .cd-users-list tr {
  display: block;
  width: auto;
  float: none;
}
.cd-modal .cd-users-list td {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.45rem 0.7rem;
  border-bottom: 1px solid var(--cd-border-light);
}
.cd-modal .cd-users-list tr label {
  margin-bottom: 0;
  color: var(--cd-text-body);
  font-size: 0.8rem;
  line-height: 1.35;
  cursor: pointer;
  overflow-wrap: anywhere;
}

/* Anchor for the real <input>, which .users_folder_list positions absolutely.
   Without a positioned ancestor it was laid out against the modal overlay:
   still at its static spot, but out of the flow, 30x30 and z-index 2 — so it
   spilled well past the 18px box it is meant to cover and swallowed the
   clicks of the rows around it. That is why ticking one user ticked another.
   Sizing the box here and pinning the input to it keeps every hit area inside
   its own row. */
.cd-modal .cd-users-check {
  position: relative;
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  margin-top: 1px;
}
.cd-modal .users_folder_list input[type=checkbox],
.cd-modal .users_share input[type=checkbox] {
  top: 0;
  left: 0;
  width: 18px;
  height: 18px;
  margin: 0;
}

/* The checkbox is a hidden input plus a <span> painting the control — the
   same mechanism as .cd-checkbox — but it was drawn as a red circle holding a
   white X when unchecked, turning green with a tick when checked. A list of
   twenty users therefore opened as twenty red crosses, which reads as a list
   of errors rather than as "notifications off". Repainted as the square
   checkbox used everywhere else in the app.

   The rules being overridden reach three classes with their pseudo-elements
   (".users_folder_list input[type=checkbox]:checked + span::after"), so each
   selector here goes through .cd-modal to stay above them. */
.cd-modal .users_folder_list input[type=checkbox] + span,
.cd-modal .users_share input[type=checkbox] + span {
  width: 18px;
  height: 18px;
  margin: 0;
  border: 1px solid var(--cd-border-green-soft);
  border-radius: 4px;
  background: #fff;
  box-shadow: none;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}
.cd-modal .users_folder_list input[type=checkbox]:checked + span,
.cd-modal .users_share input[type=checkbox]:checked + span {
  border-color: var(--cd-brand-green);
  background: var(--cd-brand-green);
}

/* Half of the X. The tick only needs one bar, so this one is dropped and
   ::after below is reshaped into it. */
.cd-modal .users_folder_list input[type=checkbox] + span::before,
.cd-modal .users_folder_list input[type=checkbox]:checked + span::before,
.cd-modal .users_share input[type=checkbox] + span::before,
.cd-modal .users_share input[type=checkbox]:checked + span::before {
  display: none;
}

/* Tick: two borders of a rotated box, as in .cd-checkbox__mark. "right" is
   reset because the original bar was positioned from that edge. */
.cd-modal .users_folder_list input[type=checkbox] + span::after,
.cd-modal .users_folder_list input[type=checkbox]:checked + span::after,
.cd-modal .users_share input[type=checkbox] + span::after,
.cd-modal .users_share input[type=checkbox]:checked + span::after {
  top: 45%;
  left: 50%;
  right: auto;
  width: 5px;
  height: 9px;
  background: none;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: translate(-50%, -50%) rotate(45deg) scale(0);
  transition: transform 0.15s ease;
}
.cd-modal .users_folder_list input[type=checkbox]:checked + span::after,
.cd-modal .users_share input[type=checkbox]:checked + span::after {
  transform: translate(-50%, -50%) rotate(45deg) scale(1);
}

/* Share modal ("Compartir «folder»", formerly "Enviar vínculo") ---------
   Same user list as the folder editor above, but built out of divs instead
   of a table, and hanging off .users_share — a near-copy of the
   .users_folder_list rules with its own sizes. Only the container and rows
   are new here; the checkbox itself is already covered by the shared
   selectors above. */
.cd-modal .cd-users-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  border: 1px solid var(--cd-border-light);
  border-radius: 8px;
  overflow: hidden;
}
.cd-modal .cd-users-item {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.45rem 0.7rem;
  border-bottom: 1px solid var(--cd-border-light);
}
/* Last row of the grid: the final item, plus the one beside it when the
   count is even. Without this their border doubles up with the container's. */
.cd-modal .cd-users-item:last-child,
.cd-modal .cd-users-item:nth-last-child(2):nth-child(odd) {
  border-bottom: 0;
}
.cd-modal .cd-users-item label {
  margin-bottom: 0;
  color: var(--cd-text-body);
  font-size: 0.8rem;
  line-height: 1.35;
  cursor: pointer;
  overflow-wrap: anywhere;
}

/* Users marked to lose their access: greyed out and not selectable. */
.cd-modal .cd-users-item.is-disabled label {
  color: var(--cd-text-muted);
  cursor: not-allowed;
}
.cd-modal .users_share input[type=checkbox]:disabled {
  cursor: not-allowed;
}
.cd-modal .users_share input[type=checkbox]:disabled + span {
  border-color: var(--cd-border-light);
  background: var(--cd-border-light);
}
/* Says why the user can open the folder already; it may carry a folder name of any length,
   so it wraps inside its column instead of staying on one line. */
.cd-modal .cd-share-has-access {
  display: inline-block;
  max-width: 100%;
  margin-left: 6px;
  padding: 1px 6px;
  border-radius: 4px;
  background: var(--cd-border-light);
  color: var(--cd-text-body);
  font-size: 0.7rem;
  overflow-wrap: anywhere;
}

/* Who has the folder granted, above the user list. Same outline and row
   rhythm as .cd-users-grid so both lists read as one family. */
.cd-modal .cd-share-access {
  margin: 0 0 1rem;
  padding: 0;
  list-style: none;
  border: 1px solid var(--cd-border-light);
  border-radius: 8px;
}
.cd-modal .cd-share-access__item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.45rem 0.7rem;
  border-bottom: 1px solid var(--cd-border-light);
}
.cd-modal .cd-share-access__item:last-child {
  border-bottom: 0;
}
.cd-modal .cd-share-access__who {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
  color: var(--cd-text-body);
  font-size: 0.8rem;
  line-height: 1.35;
  overflow-wrap: anywhere;
}
/* Marked to be revoked on "Aceptar". */
.cd-modal .cd-share-access__item.is-revoked .cd-share-access__who {
  color: var(--cd-text-muted);
  text-decoration: line-through;
}
/* Amber of the warning dialogs ($cd-surface-amber-soft); the text is a darker
   step of $cd-amber, which on that background would not be legible. */
.cd-modal .cd-share-access__tag {
  flex: 0 0 auto;
  padding: 2px 8px;
  border-radius: 4px;
  background: #fdf3e2;
  color: #8a5a0f;
  font-size: 0.7rem;
  white-space: nowrap;
}
.cd-modal .cd-share-access__btn {
  flex: 0 0 auto;
  padding: 3px 12px;
  border: 1px solid var(--cd-border-green-soft);
  border-radius: 4px;
  background: #fff;
  color: var(--cd-brand-green-dark);
  font-size: 0.75rem;
  line-height: 1.4;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.cd-modal .cd-share-access__btn:hover,
.cd-modal .cd-share-access__btn:focus {
  background: var(--cd-surface-green-soft);
  outline: none;
}
.cd-modal .cd-share-access__btn:focus-visible {
  box-shadow: 0 0 0 3px var(--cd-border-green-soft);
}
.cd-modal .cd-share-access__empty {
  padding: 0.6rem 0.7rem;
  color: var(--cd-text-muted);
  font-size: 0.8rem;
}

/* Upload mode ---------------------------------------------------------- */

/* Was a .bg-light bar with "flex items-center" — Tailwind class names that
   this project does not ship, so they never did anything. */
.cd-modal .cd-upload-drop {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  width: 100%;
  padding: 1.5rem 1rem;
  border: 1px dashed var(--cd-border-green-soft);
  border-radius: 8px;
  background-color: var(--cd-surface-green-soft);
  color: var(--cd-text-body);
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.cd-modal .cd-upload-drop:hover {
  border-color: var(--cd-brand-green);
}
/* While files are hovering the area. The ring is drawn with an inset shadow instead
   of a thicker border so the box does not resize and shift the content underneath. */
.cd-modal .cd-upload-drop.is-dragging {
  border-style: solid;
  border-color: var(--cd-brand-green);
  box-shadow: inset 0 0 0 1px var(--cd-brand-green);
  color: var(--cd-brand-green-dark);
}
.cd-modal .cd-upload-drop i {
  color: var(--cd-brand-green);
}
/* Limits of the upload, spelled out under the drop area of the modal and of the
   Documentos panel. Quiet on purpose: it is there to be read before choosing a file,
   not to compete with the area itself. */
.cd-upload-hint {
  margin: 0.4rem 0 0;
  color: var(--cd-text-muted);
  font-size: 12px;
  text-align: center;
}

/* Drop area over the listing ------------------------------------------------ */

/* top/left/width/height are set inline by _syncListDropRect, on purpose: the frame is
   taken out of #page-content (a scroll container) so that its size follows the pane on
   any window width and stays put while the listing scrolls. Nothing is hardcoded here,
   there is no size to keep in sync with the layout. */
#page-content .cd-list-drop-overlay {
  position: fixed;
  /* The measured box is the pane itself, so the border and the padding have to fit
     inside it: there is no global border-box rule in the project to rely on. */
  box-sizing: border-box;
  /* Above the listing and the left drawer (z-index 9), below the modals. */
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  /* The overlay must never become the drag target itself: with pointer events on, it
     would fire dragleave the moment it appears and the frame would flicker. */
  pointer-events: none;
  border: 2px dashed var(--cd-brand-green);
  border-radius: 6px;
  /* A translucent tint instead of --cd-surface-green-soft: that one is a flat colour
     meant for solid surfaces and would hide the file list underneath. */
  background-color: rgba(46, 158, 79, 0.07);
  color: var(--cd-brand-green-dark);
  font-size: 15px;
  /* The pane gets narrow on a phone: the label wraps instead of running over the
     dashed border. */
  padding: 0 10px;
  text-align: center;
}
#page-content .cd-list-drop-overlay i {
  font-size: 34px;
  color: var(--cd-brand-green);
}
/* Narrow pane: the icon and the label are scaled down so that both still fit. */
@media (max-width: 40em) {
  #page-content .cd-list-drop-overlay {
    font-size: 13px;
  }
  #page-content .cd-list-drop-overlay i {
    font-size: 24px;
  }
}

/* Dragging a row ------------------------------------------------------------ */

/* Chip the pointer carries while a row is dragged, built in _buildDragGhost. It is
   parked off-screen because setDragImage only accepts a node the browser has painted,
   and it is taken out of the flow so it never adds a scrollbar on the way. */
.cd-drag-ghost {
  position: fixed;
  top: 0;
  left: -9999px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  /* The chip is meant to read at a glance next to the pointer, so a long file name is
     cut instead of stretching it into the same band the browser snapshot produced. */
  max-width: 260px;
  padding: 6px 10px;
  border: 1px solid var(--cd-border-green-soft);
  border-radius: 6px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
  color: var(--cd-text-body);
  font-size: 13px;
  font-weight: 600;
  /* The drag image is only a picture: it must never take the drop away from what is
     underneath it. */
  pointer-events: none;
}
/* File-type sprite. It reuses the .e-fe-* backgrounds of the listing, so only the box
   has to be brought down from the 40px of .e-list-icon to the size of the chip. */
.cd-drag-ghost .cd-drag-ghost__icon {
  flex: 0 0 auto;
  height: 22px;
  width: 22px;
  background-size: 22px 22px;
}
/* Folder or unknown type: a Font Awesome glyph instead of a sprite. */
.cd-drag-ghost .cd-drag-ghost__glyph {
  flex: 0 0 auto;
  width: 22px;
  text-align: center;
  font-size: 18px;
}
.cd-drag-ghost .cd-drag-ghost__name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* Request lit up as the drop target while a document hovers it (onRequestDragOver).
   Dropping a document on a request is otherwise a blind move: nothing said which of
   them was about to take the file. */
.cd-request-drop {
  position: relative;
  /* A stacking context of its own, so the highlight below can be pushed behind the
     content of the request without falling behind the panel as well. */
  z-index: 0;
}
/* The highlight is painted by a layer of its own instead of on the row: the row is a
   Bootstrap .row, so its box already sticks out 15px on each side (the gutters it
   cancels for its columns) and a background of its own would run under the border of
   the panel. The layer is inset by those same 15px, which lands it on the edges of the
   panel, and it sits behind the content, out of reach of the pointer, so it can never
   take the drop away from the row. */
.cd-request-drop.is-drag-over::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 15px;
  right: 15px;
  /* Behind the name and the icons of the request, which are in the flow and would
     otherwise be covered: a positioned layer paints over them by default. */
  z-index: -1;
  /* Same pill as the folders of the tree above (section 10.1 of variations.scss). */
  border-radius: 6px;
  background-color: var(--cd-surface-green-soft);
  box-shadow: inset 0 0 0 1px var(--cd-brand-green);
  pointer-events: none;
}

/* Empty listing ------------------------------------------------------------- */

.cd-empty-listing {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* Enough height for the block not to hug the header row, without pushing the
     pane into a scroll of its own on a short window. */
  min-height: 220px;
  padding: 2.5rem 1rem;
  text-align: center;
}
/* Tabler icons (MIT), drawn with a mask so the colour comes from the CSS, the
   same mechanism as the .icon-svg icons of the sidebar and the navbar. The base
   rule carries no mask-image: each variant below brings its own glyph. */
.cd-empty-listing__icon {
  display: block;
  width: 56px;
  height: 56px;
  margin-bottom: 1rem;
  /* Lighter than the text: the icon frames the message, it is not the message. */
  background-color: #c4c9d4;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-size: contain;
  mask-size: contain;
}
/* tabler "folder-open" */
.cd-empty-listing__icon--folder {
  -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round'><path d='M5 19l2.757 -7.351a1 1 0 0 1 .936 -.649h12.307a1 1 0 0 1 .986 1.164l-.996 5.211a2 2 0 0 1 -1.964 1.625h-14.026a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v2'/></svg>");
  mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round'><path d='M5 19l2.757 -7.351a1 1 0 0 1 .936 -.649h12.307a1 1 0 0 1 .986 1.164l-.996 5.211a2 2 0 0 1 -1.964 1.625h-14.026a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v2'/></svg>");
}
/* tabler "search-off", the same lens as the search box with the glyph struck
   through, so an empty search does not read as an empty folder. */
.cd-empty-listing__icon--search {
  -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round'><path d='M5.039 5.062a7 7 0 0 0 9.91 9.89m1.584 -2.434a7 7 0 0 0 -9.038 -9.057'/><path d='M21 21l-6 -6'/><path d='M3 3l18 18'/></svg>");
  mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round'><path d='M5.039 5.062a7 7 0 0 0 9.91 9.89m1.584 -2.434a7 7 0 0 0 -9.038 -9.057'/><path d='M21 21l-6 -6'/><path d='M3 3l18 18'/></svg>");
}
.cd-empty-listing__title {
  margin: 0;
  color: var(--cd-text-body);
  font-size: 15px;
  font-weight: 600;
}
.cd-empty-listing__hint {
  /* The template gives every <p> a bottom margin; the block is centred as a
     whole, so the last line must not add a tail below it. */
  margin: 0.35rem 0 0;
  max-width: 340px;
  color: var(--cd-text-muted);
  font-size: 13px;
}

/* Upload mode. The body becomes a column so that the queue is the only part that
   scrolls: everything else keeps its height (flex-shrink: 0) and the list takes what
   is left. The modal therefore grows file after file until the body hits the cap and
   only then does the list start scrolling.

   The cap is the window minus the chrome of the modal (header ~93px, footer ~76px and
   the vertical margins of .modal-dialog), so a margin is always left above and below.
   The 710px of .cd-modal-body-tall is overridden on purpose: that cap suits a form,
   while here the reason to grow is the list of files and it should be able to use the
   whole window. Measured on a copy of this layout, the modal takes 577px of a 620px
   window and 1057px of a 1100px one, footer included and nothing cut off. */
.cd-modal .modal-body.cd-modal-body-upload {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 260px);
}
.cd-modal .modal-body.cd-modal-body-upload > *:not(.cd-upload-list) {
  flex-shrink: 0;
}
.cd-modal .cd-upload-list {
  overflow-y: auto;
  margin-top: 0.75rem;
}
/* min-height: 0 is what lets a flex item shrink below its content: without it the list
   would push the body past the cap instead of scrolling. */
.cd-modal .modal-body.cd-modal-body-upload .cd-upload-list {
  min-height: 0;
}
/* The total sits under the list, outside the scrolling area, so it stays in sight
   while the queue is scrolled. */
.cd-modal .cd-upload-total {
  margin: 0.5rem 0 0;
  color: var(--cd-text-body);
  font-size: 13px;
  font-weight: 600;
  text-align: right;
}
.cd-modal .cd-upload-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.5rem 0.75rem;
  margin-bottom: 0.375rem;
  border: 1px solid var(--cd-border-light);
  border-radius: 8px;
}
.cd-modal .cd-upload-item:last-child {
  margin-bottom: 0;
}
.cd-modal .cd-upload-name {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
  overflow-wrap: anywhere;
}
/* The size trails the name as a secondary detail: quiet, and it never wraps on its
   own line away from the file it belongs to. */
.cd-modal .cd-upload-size {
  flex-shrink: 0;
  color: var(--cd-text-muted);
  font-size: 12px;
  white-space: nowrap;
}
.cd-modal .cd-upload-name i {
  flex: 0 0 auto;
  color: var(--cd-text-muted);
}
.cd-modal .cd-upload-remove {
  flex: 0 0 auto;
  color: var(--cd-text-muted);
  cursor: pointer;
}
.cd-modal .cd-upload-remove:hover {
  color: #dc3545;
}

.contentListItem{
  height: 570px;
  /* El overflow y la barra de scroll fina se definen en la sección 10 de
     variations.scss, junto al resto del panel de carpetas. */
}
.request .breadcrumb{
  margin-bottom: 0;
}
.bg-gray{
  background: #e9ecef;
}
button.bg-gray:focus {
  outline: none;
}
.itemRequest{
  min-height: 35px;
}
/* Request link icon, both the one that links a document from the Solicitudes
   drawer and the one marking an already linked document in the listing. It gets
   its own class because the brand green (#2E9E4F) is not Bootstrap's
   .text-success (#28a745), so there is no utility class to reuse here. */
.cd-request-link{
  color: var(--cd-brand-green);
}
/* Icon marking a document that carries comments. The navy is only used here, so
   it lives in this rule instead of in the palette of variations.scss. */
.cd-comment-icon{
  color: #002f5f;
}
/* Line under a request telling who delivered the document and when. It is
   metadata inside a narrow drawer, so it sits one step below the item name.
   The gap goes with it: the three labels are spread with
   justify-content-between and, once the name filled the row, they were left
   with no space between them and ran together ("RECIBIDO27/08/2026"). */
.cd-request-meta{
  font-size: 11px;
  gap: 6px;
}
.checkItem{
  font-size: 22px;
}
.form-check .form-check-label{
  line-height: 20px;
}
.form-group{
  margin-bottom : 5px;
}
.contentFolder .form-group{
  margin-bottom : 0px;
}
.breadcrumb{
  cursor: pointer;
}
.directory .e-list-parent:first-child{
  min-height: 560px;
}
#treeview,
.treeview
{
  /*max-height: 580px !important;
  overflow: hidden scroll;*/
}
#treeview{
  height: 100%;
  overflow: auto;
}
span.e-list-text {
  text-transform: uppercase;
}
.text-purple{
  color: rgb(50, 49, 48);
  font-weight: bold;
}
.btn-file, .btn-file:focus, .btn-file:hover {
  border: none !important;
  background-color: transparent;
  outline: none;
}
.ItemRequest .table td{
  padding: 8px 8px;
}
.btn-file:hover{
  background-color: #f0f0f0;
}
.font50{
  font-size: 50px;
}
.fonticon110{
  font-size: 110px;
}
.text14{
  font-size: 14px;
}
.h-600{
  min-height: 600px;
}
.folder-icon{
  color: #eac559;
}
.text16{
  font-size: 16px;
}
.p-25{
  padding: 0.8rem;
}
.h-40{
  min-height: 40px;
}
/*Icons */
.e-list-icon {
  display: block;
  height: 25px;
  width: 25px;
  background-size: contain;
  background-position: center;
}
.e-fe-pdf {
  background-image: url("/images/file-icons/pdf.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.e-fe-docx {
  background-image: url("/images/file-icons/docx.svg");
  background-repeat: no-repeat;
}
.e-fe-pptx {
  background-image: url("/images/file-icons/pptx.svg");
  background-repeat: no-repeat;
}
.e-fe-xlsx {
  background-image: url("/images/file-icons/xlsx.svg");
  background-repeat: no-repeat;
}
.e-fe-image {
  background-image: url("/images/file-icons/image.svg");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.e-fe-rar {
  background-image: url("/images/file-icons/rar.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.e-fe-zip {
  background-image: url("/images/file-icons/zip.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.e-fe-txt {
  background-image: url("/images/file-icons/txt.svg");
  background-repeat: no-repeat;
}
.e-fe-msg {
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMyMjc5NGE7fS5jbHMtMntmaWxsOiNmZmY7fS5jbHMtM3tmaWxsOiNjYWZmZTE7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9YTUw8L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIyLDBINEEyLDIsMCwwLDAsMiwyVjMwYTIsMiwwLDAsMCwyLDJIMjhhMiwyLDAsMCwwLDItMlY4WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTcuNzEsMTQuODFsMS4xLDIuNzdMOS45LDE0LjgxaDEuODlMOS44LDE5bDIuMTMsNC4zNEgxMEw4Ljc1LDIwLjQ3LDcuNTMsMjMuMzhINS42M0w3Ljc3LDE5bC0yLTQuMjNaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMTUuMjEsMTQuODFsMS4yMiw2aDBsMS4yMy02aDIuNTZ2OC41N0gxOC42NlYxNi41NGgwbC0xLjUyLDYuODRIMTUuNzdsLTEuNTItNi44NGgwdjYuODRIMTIuNjRWMTQuODFaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMjEuNDgsMTQuODFoMS43M1YyMmgzLjA2djEuNDJIMjEuNDhaIi8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNMjIsMFY3YTEsMSwwLDAsMCwxLDFoN1oiLz48L3N2Zz4=");
  background-repeat: no-repeat;
}
.e-fe-music {
  background-image: url("/images/file-icons/music.svg");
  background-repeat: no-repeat;
}
.e-fe-video {
  background-image: url("/images/file-icons/video.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.e-fe-js {
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM4MmJiMjI7fS5jbHMtMntmaWxsOiNmZmY7fS5jbHMtM3tmaWxsOiNlOWZmYjg7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9KUzwvdGl0bGU+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjIsMEg0QTIsMiwwLDAsMCwyLDJWMzBhMiwyLDAsMCwwLDIsMkgyOGEyLDIsMCwwLDAsMi0yVjhaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMTUuMTQsMjFhMi41NywyLjU3LDAsMCwxLS42NCwxLjk1LDIuODMsMi44MywwLDAsMS0xLjk0LjU4LDIuODQsMi44NCwwLDAsMS0xLjEzLS4xOSwxLjYsMS42LDAsMCwxLS42OS0uNTMsMiwyLDAsMCwxLS4zNi0uNzksNSw1LDAsMCwxLS4wOS0xdi0uMzhoMS41OHYuMjdhMi41OCwyLjU4LDAsMCwwLC4xNSwxLC42MS42MSwwLDAsMCwuNjIuMzMuNjEuNjEsMCwwLDAsLjYyLS4zMywyLjU4LDIuNTgsMCwwLDAsLjE1LTFWMTQuODFoMS43M1oiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0xNy42NiwyMWEzLjE2LDMuMTYsMCwwLDAsMCwuNTUsMS4xOSwxLjE5LDAsMCwwLC4xOC40MSwxLDEsMCwwLDAsLjM2LjI3LDEuNDksMS40OSwwLDAsMCwuNTYuMDksMS4wNiwxLjA2LDAsMCwwLC43MS0uMjYsMSwxLDAsMCwwLC4zMi0uNzksMS40NiwxLjQ2LDAsMCwwLS4wOC0uNSwxLDEsMCwwLDAtLjI2LS4zOEEyLjI1LDIuMjUsMCwwLDAsMTksMjBjLS4yLS4wOS0uNDQtLjE4LS43My0uMjhhNi43LDYuNywwLDAsMS0xLS40MiwyLjgsMi44LDAsMCwxLS43MS0uNTMsMi4xLDIuMSwwLDAsMS0uNDEtLjcxLDIuOTQsMi45NCwwLDAsMS0uMTMtLjkzLDIuMzgsMi4zOCwwLDAsMSwuNzEtMS45LDIuODYsMi44NiwwLDAsMSwxLjk0LS42Miw0LDQsMCwwLDEsMS4wNi4xMywyLjE5LDIuMTksMCwwLDEsLjg0LjQsMS44NywxLjg3LDAsMCwxLC41NS43MiwyLjQ2LDIuNDYsMCwwLDEsLjIsMS4wNXYuMjRIMTkuN2ExLjc2LDEuNzYsMCwwLDAtLjIyLS45NC43OS43OSwwLDAsMC0uNzItLjMzLDEuMTQsMS4xNCwwLDAsMC0uNDguMDkuNzkuNzksMCwwLDAtLjMxLjIyLjg2Ljg2LDAsMCwwLS4xNS4zMiwxLjUsMS41LDAsMCwwLDAsLjM3LDEuMjQsMS4yNCwwLDAsMCwuMTYuNjYsMS41OCwxLjU4LDAsMCwwLC43Mi41bDEuMzQuNThhMy45MywzLjkzLDAsMCwxLC44LjQ1LDIuMTUsMi4xNSwwLDAsMSwuNS41LDEuNzksMS43OSwwLDAsMSwuMjYuNiwzLjgyLDMuODIsMCwwLDEsLjA3LjcyLDIuMzQsMi4zNCwwLDAsMS0uNzksMiwzLjQ2LDMuNDYsMCwwLDEtMi4xOS42MiwyLjg0LDIuODQsMCwwLDEtMi4wOS0uNjQsMi40NywyLjQ3LDAsMCwxLS42My0xLjgyVjIwLjdoMS43M1oiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0yMiwwVjdhMSwxLDAsMCwwLDEsMWg3WiIvPjwvc3ZnPg==");
  background-repeat: no-repeat;
}
.e-fe-css {
  background-image: url("data:image/svg+xml;base64,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");
  background-repeat: no-repeat;
}
.e-fe-html {
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM4MjNhOWI7fS5jbHMtMntmaWxsOiNlY2JkZmY7fS5jbHMtM3tmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9IVE1MPC90aXRsZT48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yMiwwSDRBMiwyLDAsMCwwLDIsMlYzMGEyLDIsMCwwLDAsMiwySDI4YTIsMiwwLDAsMCwyLTJWOFoiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0yMiwwVjdhMSwxLDAsMCwwLDEsMWg3WiIvPjxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTIwLjY0LDI2Ljc3bC0xLjI4LTEuNTRMMjQuNDQsMjFsLTUuMDgtNC4yMywxLjI4LTEuNTQsNiw1YTEsMSwwLDAsMSwwLDEuNTRaIi8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNMTEuMjgsMjYuNzdsLTYtNWExLDEsMCwwLDEsMC0xLjU0bDYtNSwxLjI4LDEuNTRMNy40OCwyMWw1LjA4LDQuMjNaIi8+PHJlY3QgY2xhc3M9ImNscy0zIiB4PSI3Ljc1IiB5PSIyMCIgd2lkdGg9IjE2LjQ5IiBoZWlnaHQ9IjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04LjI2IDMxLjQyKSByb3RhdGUoLTc1Ljk1KSIvPjwvc3ZnPg==");
  background-repeat: no-repeat;
}
.e-fe-php {
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM3MzcxY2M7fS5jbHMtMntmaWxsOiNmZmY7fS5jbHMtM3tmaWxsOiNkY2RjZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9QSFA8L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIyLDBINEEyLDIsMCwwLDAsMiwyVjMwYTIsMiwwLDAsMCwyLDJIMjhhMiwyLDAsMCwwLDItMlY4WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTEwLjA2LDE0LjgxYTIuNDcsMi40NywwLDAsMSwxLjExLjIyLDIuMTEsMi4xMSwwLDAsMSwuNzMuNTgsMi4zOSwyLjM5LDAsMCwxLC4zOS44MiwzLjgxLDMuODEsMCwwLDEsLjEyLjk1LDIuOTIsMi45MiwwLDAsMS0uMiwxLjE1LDIsMiwwLDAsMS0uNTUuOCwyLjE3LDIuMTcsMCwwLDEtLjg2LjQ3QTMuODEsMy44MSwwLDAsMSw5LjY5LDIwSDguNzZ2My40Mkg3VjE0LjgxWm0tLjUzLDMuODdhMS4xNSwxLjE1LDAsMCwwLC44NC0uMzEsMS4zMiwxLjMyLDAsMCwwLC4zMS0xLDEuNTMsMS41MywwLDAsMC0uMjctMSwxLjEzLDEuMTMsMCwwLDAtLjkzLS4zNEg4Ljc2djIuNloiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0xNSwxNC44MXYzLjI3aDJWMTQuODFoMS43M3Y4LjU3SDE3VjE5LjU3SDE1djMuODFIMTMuMjZWMTQuODFaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMjMsMTQuODFhMi40NywyLjQ3LDAsMCwxLDEuMTEuMjIsMi4xMSwyLjExLDAsMCwxLC43My41OCwyLjM5LDIuMzksMCwwLDEsLjM5LjgyLDMuODEsMy44MSwwLDAsMSwuMTIuOTUsMi45MiwyLjkyLDAsMCwxLS4yLDEuMTUsMiwyLDAsMCwxLS41NS44LDIuMTcsMi4xNywwLDAsMS0uODYuNDcsMy44MSwzLjgxLDAsMCwxLTEuMTEuMTZoLS45M3YzLjQySDE5Ljk0VjE0LjgxWm0tLjUzLDMuODdhMS4xNSwxLjE1LDAsMCwwLC44NC0uMzEsMS4zMiwxLjMyLDAsMCwwLC4zMS0xLDEuNTMsMS41MywwLDAsMC0uMjctMSwxLjEzLDEuMTMsMCwwLDAtLjkzLS4zNGgtLjcydjIuNloiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0yMiwwVjdhMSwxLDAsMCwwLDEsMWg3WiIvPjwvc3ZnPg==");
  background-repeat: no-repeat;
}
.e-fe-exe {
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM0YjQ4NGM7fS5jbHMtMntmaWxsOiNmZmY7fS5jbHMtM3tmaWxsOiNkNmQ2ZDY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9FeGU8L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIyLDBINEEyLDIsMCwwLDAsMiwyVjMwYTIsMiwwLDAsMCwyLDJIMjhhMiwyLDAsMCwwLDItMlY4WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTExLjgyLDE2LjIySDguNzZ2MmgyLjg4djEuNDJIOC43NlYyMmgzLjE4djEuNDJIN1YxNC44MWg0Ljc4WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTE0LjM2LDE0LjgxbDEuMSwyLjc3LDEuMDktMi43N2gxLjg5bC0yLDQuMjMsMi4xNCw0LjM0SDE2LjY0TDE1LjQsMjAuNDdsLTEuMjIsMi45MWgtMS45TDE0LjQyLDE5bC0yLTQuMjNaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMjQsMTYuMjJIMjF2MmgyLjg4djEuNDJIMjFWMjJoMy4xOHYxLjQySDE5LjI1VjE0LjgxSDI0WiIvPjxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTIyLDBWN2ExLDEsMCwwLDAsMSwxaDdaIi8+PC9zdmc+");
  background-repeat: no-repeat;
}
.e-fe-msi {
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM0ZGJjYzE7fS5jbHMtMntmaWxsOiNmZmY7fS5jbHMtM3tmaWxsOiNhZmVmZWQ7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9NU0k8L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIyLDBINEEyLDIsMCwwLDAsMiwyVjMwYTIsMiwwLDAsMCwyLDJIMjhhMiwyLDAsMCwwLDItMlY4WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTkuNjQsMTQuODFsMS4yMiw2aDBsMS4yMy02aDIuNTZ2OC41N0gxMy4xVjE2LjU0aDBsLTEuNTIsNi44NEgxMC4yTDguNjgsMTYuNTRoMHY2Ljg0SDcuMDdWMTQuODFaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMTcuMzEsMjFhMi4zOSwyLjM5LDAsMCwwLC4wNS41NS45LjksMCwwLDAsLjE4LjQxLjg5Ljg5LDAsMCwwLC4zNS4yNywxLjQ5LDEuNDksMCwwLDAsLjU2LjA5LDEuMDYsMS4wNiwwLDAsMCwuNzEtLjI2LDEsMSwwLDAsMCwuMzItLjc5LDEuNDYsMS40NiwwLDAsMC0uMDgtLjUsMSwxLDAsMCwwLS4yNi0uMzgsMiwyLDAsMCwwLS40Ny0uMzFjLS4yLS4wOS0uNDQtLjE4LS43My0uMjhhNi43LDYuNywwLDAsMS0xLS40MiwyLjU4LDIuNTgsMCwwLDEtLjctLjUzLDIsMiwwLDAsMS0uNDItLjcxLDIuOTQsMi45NCwwLDAsMS0uMTMtLjkzLDIuNDIsMi40MiwwLDAsMSwuNzEtMS45LDIuODYsMi44NiwwLDAsMSwxLjk0LS42MiwzLjksMy45LDAsMCwxLDEuMDYuMTMsMi4xOSwyLjE5LDAsMCwxLC44NC40LDIsMiwwLDAsMSwuNTYuNzJBMi42MiwyLjYyLDAsMCwxLDIxLDE2Ljk0di4yNEgxOS4zNWExLjY4LDEuNjgsMCwwLDAtLjIyLS45NC43OS43OSwwLDAsMC0uNzItLjMzLDEuMTQsMS4xNCwwLDAsMC0uNDguMDkuNjkuNjksMCwwLDAtLjMuMjIuNzQuNzQsMCwwLDAtLjE2LjMyLDEuNSwxLjUsMCwwLDAsMCwuMzcsMS4xNiwxLjE2LDAsMCwwLC4xNy42NiwxLjQ3LDEuNDcsMCwwLDAsLjcyLjVsMS4zMy41OGEzLjY3LDMuNjcsMCwwLDEsLjguNDUsMiwyLDAsMCwxLC41LjUsMS43OSwxLjc5LDAsMCwxLC4yNi42LDMuMTQsMy4xNCwwLDAsMSwuMDcuNzIsMi4zNCwyLjM0LDAsMCwxLS43OSwyLDMuNDYsMy40NiwwLDAsMS0yLjE5LjYyLDIuODQsMi44NCwwLDAsMS0yLjA5LS42NCwyLjQ3LDIuNDcsMCwwLDEtLjYzLTEuODJWMjAuN2gxLjczWiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTIyLjIzLDE0LjgxSDI0djguNTdIMjIuMjNaIi8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNMjIsMFY3YTEsMSwwLDAsMCwxLDFoN1oiLz48L3N2Zz4=");
  background-repeat: no-repeat;
}
.e-fe-unknown {
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmZjg2MmM7fS5jbHMtMntvcGFjaXR5OjAuNDU7fS5jbHMtM3tmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9FeGNsYW1hdG9yeTwvdGl0bGU+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjIsMEg0QTIsMiwwLDAsMCwyLDJWMzBhMiwyLDAsMCwwLDIsMkgyOGEyLDIsMCwwLDAsMi0yVjhaIi8+PGcgY2xhc3M9ImNscy0yIj48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0yMiwwVjdhMSwxLDAsMCwwLDEsMWg3WiIvPjwvZz48cG9seWdvbiBjbGFzcz0iY2xzLTMiIHBvaW50cz0iMTcuNDcgMjAgMTQuNSAyMCAxNCA4IDE4IDggMTcuNDcgMjAiLz48Y2lyY2xlIGNsYXNzPSJjbHMtMyIgY3g9IjE2IiBjeT0iMjQiIHI9IjIiLz48L3N2Zz4=");
  background-repeat: no-repeat;
}
.e-fe-rtf {
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMwMDkwZDg7fS5jbHMtMntmaWxsOiNmZmY7fS5jbHMtM3tmaWxsOiNjNWVmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9SVEY8L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIyLDBINEEyLDIsMCwwLDAsMiwyVjMwYTIsMiwwLDAsMCwyLDJIMjhhMiwyLDAsMCwwLDItMlY4WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTExLjIzLDE0LjgxYTIuNDIsMi40MiwwLDAsMSwxLjY4LjU0LDIuMTYsMi4xNiwwLDAsMSwuNiwxLjY3LDIuNjMsMi42MywwLDAsMS0uMzUsMS40MSwxLjYzLDEuNjMsMCwwLDEtMS4wOC43djBhMS42NSwxLjY1LDAsMCwxLC45NS40MiwxLjgzLDEuODMsMCwwLDEsLjM3LDEuMDVjMCwuMTYsMCwuMzMsMCwuNTJzMCwuNCwwLC42M2MwLC40NSwwLC44LjA3LDFhLjY2LjY2LDAsMCwwLC4zMS40OXYuMDhIMTJBMSwxLDAsMCwxLDExLjgsMjNhMy43MywzLjczLDAsMCwxLDAtLjQ4bDAtMS42NWExLjQsMS40LDAsMCwwLS4yNS0uNzksMSwxLDAsMCwwLS43Ny0uMjlIOS43NnYzLjYzSDhWMTQuODFabS0uNzUsMy43NGExLjQzLDEuNDMsMCwwLDAsMS0uMjksMS4yNSwxLjI1LDAsMCwwLC4zNC0xLDEuMDYsMS4wNiwwLDAsMC0xLjItMS4xOUg5Ljc2djIuNDdaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMTkuNTEsMTYuMjJIMTcuNjR2Ny4xNkgxNS45MVYxNi4yMkgxNFYxNC44MWg1LjQ3WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTI1LDE0LjgxdjEuNDFIMjJ2MmgyLjg4djEuNDJIMjJ2My43MkgyMC4yNVYxNC44MVoiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0yMiwwVjdhMSwxLDAsMCwwLDEsMWg3WiIvPjwvc3ZnPg==");
  background-repeat: no-repeat;
}
.e-fe-xml {
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMyMjc5NGE7fS5jbHMtMntmaWxsOiNmZmY7fS5jbHMtM3tmaWxsOiNjYWZmZTE7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9YTUw8L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIyLDBINEEyLDIsMCwwLDAsMiwyVjMwYTIsMiwwLDAsMCwyLDJIMjhhMiwyLDAsMCwwLDItMlY4WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTcuNzEsMTQuODFsMS4xLDIuNzdMOS45LDE0LjgxaDEuODlMOS44LDE5bDIuMTMsNC4zNEgxMEw4Ljc1LDIwLjQ3LDcuNTMsMjMuMzhINS42M0w3Ljc3LDE5bC0yLTQuMjNaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMTUuMjEsMTQuODFsMS4yMiw2aDBsMS4yMy02aDIuNTZ2OC41N0gxOC42NlYxNi41NGgwbC0xLjUyLDYuODRIMTUuNzdsLTEuNTItNi44NGgwdjYuODRIMTIuNjRWMTQuODFaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMjEuNDgsMTQuODFoMS43M1YyMmgzLjA2djEuNDJIMjEuNDhaIi8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNMjIsMFY3YTEsMSwwLDAsMCwxLDFoN1oiLz48L3N2Zz4=");
  background-repeat: no-repeat;
}
.e-switch-wrapper {
  height: 25px;
  width: 50px;
}
.e-switch-wrapper input{
  display: none;
}
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
  color: #495057;
  background-color: #e1e1e1;
  border-color: #e1e1e1;
  font-weight: bold;
}
.nav-tabs{
  text-transform: uppercase;
  font-size: 20px;
  color: #495057;
  cursor: pointer;
}
.nav .nav-item .nav-link:hover, .nav .nav-item .nav-link:focus {
  background-color: #fafafa;
}
.request .nav-link{
  padding: 0.4rem 0.5rem;
}
.item-request
{
  font-size: 12px;
  cursor: pointer;
  /* Only the colour of the text: animating "all" also animated the background
     of the rule below, and that is what made the hover of the item blink (the
     same reason the .btn rule of _misc.scss no longer animates "all"). Half a
     second with a bouncy curve made it far more visible here than anywhere
     else. */
  transition: color .5s cubic-bezier(.34,1.61,.7,1);
  color: #343A40;
}
.item-request:hover
{
  background-color: #F5F5F5;
}
.item-request-active
{
  color: #FFF;
  background-color: #317AB9;
}

#elipse_div{
  max-width: 200px;
  width:100%;
  /*border:1px solid black;*/
  overflow:hidden;
  white-space: nowrap;
}
#elipse_div span:hover{text-decoration: underline}
/*********************************/
.toggle {
  text-decoration: none;
  font-size: 1.2em !important;
  color: rgba(0, 0, 0, 0.61);
  -webkit-transition: all 0.15s ease-out 0;
  -moz-transition: all 0.15s ease-out 0;
  transition: all 0.45s ease-out 0;
  position: absolute;
  left: 10px;
  z-index: 1;
  cursor: pointer;
}
/******************************/

.sidebar2 {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: -220px;
  -webkit-transition: all 0.15s ease-out 0;
  -moz-transition: all 0.15s ease-out 0;
  transition: all 0.15s ease-out 0;
  width: 14rem;
}

.sidebar2 a:hover {
  color: rgba(0, 0, 0, 0.61);
}

#slide:checked + .container .sidebar2 {
  left: 0px;
}

#slide:checked + .container .toggle {
  left: 215px;
}

#slide {
  display: none;
}
#treeview ul{
  padding: 0 0 0 10px;}
/*****************************/
.breadcrumb-item + .breadcrumb-item::before{
  content: ">";
}
.breadcrumb-item + .breadcrumb-item {
  padding-left: 0;
}
#treeview ul{
  padding: 0 0 0 10px;
}
.breadcrumb{padding: 0.25rem 0.5rem; margin-bottom: 0;background: transparent;}
.menu-btn {
  display: none;
  position: relative;
  top: 50%;
  left: 100%;
  width: 30px;
  height: 30px;
  background: url(http://www.movingpixelsdesign.com/codepen/Chevron_btn-left.png) no-repeat;
  background-size: cover;
  cursor: pointer;
}
#label_slide{
  position: relative;
  top: 0;
  left: 0;
  width: 30px;
  height: 30px;
}

/********************************/

.menu-maker, .menu-maker2 {
  display: none;
}
.menu-maker:checked ~ div.treeview
{
  width: 100%;
}

.menu-maker:checked ~ div.sidebar_left
{
  transform: translate3d(0px, 0px, 0px);
}

.menu-holder {
  display: block;
  width: 15px;
  transition: all 0.12s linear;
  -webkit-transition: all 0.12s linear;
  -moz-transition: all 0.12s linear;
  -o-transition: all 0.12s linear;
  -ms-transition: all 0.12s linear;
  left: 0px;
  position: absolute;
  z-index: 10;
}

.menu-holder2 {
  display: block;
  width: 15px;
  transition: all 0.12s linear;
  -webkit-transition: all 0.12s linear;
  -moz-transition: all 0.12s linear;
  -o-transition: all 0.12s linear;
  -ms-transition: all 0.12s linear;
  right: 3px;
  position: absolute;
}

.menu-maker:checked + .menu-holder .hamburger {
  background: transparent;
}

.hamburger {
  position: absolute;
  z-index: 9;
  width: 18px;
  height: 18px;
  cursor: pointer;
  background: white;
}
.hamburger .hamburger-toppings {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  margin: 0 auto;
  height: 20px;
}
.hamburger span {
  display: block;
  width: 20px;
  height: 2px;
  margin: 5px auto 0;
  background-color: #ccc;
}
.menu-maker:checked ~ .menu {
  transform: translate3d(0, 0, 0);
}

.container3 {
  transition: all 0.12s linear;
  -webkit-transition: all 0.12s linear;
  -moz-transition: all 0.12s linear;
  -o-transition: all 0.12s linear;
  -ms-transition: all 0.12s linear;
}

.container2 {
  transition: all 0.12s linear;
  -webkit-transition: all 0.12s linear;
  -moz-transition: all 0.12s linear;
  -o-transition: all 0.12s linear;
  -ms-transition: all 0.12s linear;
}
.container2 p {
  margin: 0;
}
.menu-maker:checked ~ .sidebar_left {
  transform: translate3d(0px, 0px, 0px);
}
div.treeview{ background-color: #fff}
.menu-maker:checked ~ .side {
  width: 75%;
}
.menu {
  position: absolute;
  height: 100%;
  width: 270px;
  transform: translate3d(-270px, 0, 0);
  padding-top: 40px;
  transition: all 0.12s linear;
  -webkit-transition: all 0.12s linear;
  -moz-transition: all 0.12s linear;
  -o-transition: all 0.12s linear;
  -ms-transition: all 0.12s linear;
}

.menu-maker:checked + .menu-holder .hamburger .fa-angle-double-right:before {
  content: "\f100";
}
.menu-maker2:checked + .menu-holder2 .hamburger .fa-angle-double-left:before {
  content: "\f101";
}

/**********************************/
.--switch {
  position: relative;
  display: inline-block;
  width: 70px;
  height: 35px;
}

.--switch input {
  display:none;
}

.--slider .fa-list {
  color: #FFFFFF;
  position:absolute;
  left:15px;
  font-size:16px;
  display:none;
}
.--slider .fa-th-large {
  color: #FFFFFF;
  position:absolute;
  font-size:16px;
  right:15px;
}

.--slider {
  position: absolute;
  cursor: pointer;
  display:flex;
  align-items:center;
  top:0;
  left:0;
  right:0;
  bottom:0;
  background-color: #b78d8c;
  -webkit-transition: .4s;
  transition: .4s;
  border-radius:50px;
}

.--slider:before {
  position: absolute;
  content:"";
  height: 27px;
  width: 27px;
  left: 4px;
  bottom: 4px;
  border-radius:50%;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

.--switch input:checked + .--slider .fa-list {
  display:block;
}

.--switch input:checked + .--slider .fa-th-large {
  display:none;
}

.--switch input:checked + .--slider {
  background-color: #93c7b8;
}

.--switch input:focus + .--slider {
  box-shadow: 0 0 1px #93c7b8;
}

.--switch input:checked + .--slider:before {

  -webkit-transform: translateX(35px);
  -ms-transform: translateX(35px);
  transform: translateX(35px);
}

#listView .table a, #exampleFinal a, #clientsDocs a {color: #5d5d5d; flex: 0 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 600;
  font-size: 14px;
}
.mosaic_box {
  flex: 0 0 176px;
  max-width: 176px;
  margin: 4px;
  border-style: none;
  border-width: 0px;
}
.mosaic_checkbox{float: right}
/**************************************/
.second_td{width: 10%}
#listView .first_td, #gridView .first_td {
  width: 50%;
  position: absolute;
}
#listView .ellipsis, #gridView .ellipsis {
  position: relative;
  float: left;
  width: 75%;
}
#gridView .ellipsis {
  position: relative;
  float: left;
  width: 100%;
  height: 30px;
}

#gridView .ellipsis:before {
  content: none;
  visibility: hidden;
}
#listView .ellipsis:before, #gridView .ellipsis:before {
  content: '&nbsp;';
  visibility: hidden;
}
#listView .ellipsis span, #gridView .ellipsis span {
  position: absolute;
  left: 0;
  right: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* The band of the name shares the cell with the three-dot menu, which floats to
   its right. As a fixed 75% it left the menu a quarter of the cell whatever the
   cell measured: on a narrow listing that was not enough room and the menu
   dropped below the name, while the name itself was cut far earlier than it
   needed to be. Reserving the width of the button instead works at any width,
   and the room is reserved even while the button is not on screen (it only
   appears on hover or once the row is marked) so the name does not re-flow
   under the pointer. */
#listView .ellipsis {
  width: calc(100% - 40px);
}
/* In the listing the name is its own click target (it opens the folder or the
   document), so its box has to end where the text ends. Stretched between left
   and right it covered the whole band, and it also carries width: 100% from
   .ellipsis_text, hence the width here. It still gets cut with an ellipsis,
   now against the width of the band. */
#listView .ellipsis span {
  position: static;
  display: inline-block;
  width: auto;
  max-width: 100%;
  /* An inline-block whose overflow is not visible aligns its bottom edge with
     the baseline of the line, which lifted the name above the rest of the row.
     Aligned to the top it fills the height of the band, which is the 2.5em
     line-height of .ellipsis_label, and the text is centred inside it by its
     own leading, exactly where it sat while the box was absolute. */
  vertical-align: top;
}
/* The height of the band used to come from this hidden pseudo-element, because
   the name was out of flow; the name gives it now, and leaving it would only
   push the text to the right (its content is the literal string "&nbsp;", not a
   space). The mosaic view keeps its own, its name is still stretched. */
#listView .ellipsis:before {
  content: none;
}
.number_files{position: absolute; bottom: 0}
.fa-stack[data-count]:after{
  position:absolute;
  right:0%;
  top:1%;
  content: attr(data-count);
  font-size:15%;
  padding:.6em;
  border-radius:999px;
  line-height:.75em;
  color: white;
  background:rgba(255,0,0,.85);
  text-align:center;
  min-width:2em;
  font-weight:bold;
}
input.mosaic_checkbox{
  position: absolute;
}
.checkbox_label {
  position: relative;
  overflow: hidden;
}

.checkbox__input {
  position: absolute;
  top: -100px;
  left: -100px;
}

/* Same look as every other checkbox of the app: a square box with a 4px
   radius, the soft green border, and brand green with a white tick once
   checked (see the input[type="checkbox"] rule of section 6 in
   variations.scss). That global rule cannot reach these: the real input is
   parked off-screen (.checkbox__input above) and what is actually seen is
   this <span>, which was drawn as a circle and so read as a radio button.
   The colours come from the :root custom properties declared at the top of
   variations.scss, since this <style> block is plain CSS and has no access
   to its SCSS variables. */
.checkbox__inner {
  display: inline-block;
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 1px solid var(--cd-border-green-soft);
  background: #fff no-repeat center;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}

.checkbox__input:checked + .checkbox__inner {
  border-color: var(--cd-brand-green);
  background-color: var(--cd-brand-green);
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='white' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'><path d='M3.5 8.5l3 3l6 -6'/></svg>");
  background-size: 12px 12px;
}

/* The real input is off-screen, so it never shows a focus ring of its own;
   the box gets it instead, same as the global checkbox. */
.checkbox__input:focus-visible + .checkbox__inner {
  border-color: var(--cd-brand-green);
  box-shadow: 0 0 0 3px rgba(46, 158, 79, 0.2);
}
/*.card label{position: absolute; right: 0}*/
.checkbox_label{
  position: absolute;
  right: 5px;
}
#listView .checkbox_label{
  position: absolute;
  left: 5px;
  top:40%;
  font-weight: bold;
  width: 20px;
}
#my_documents_list .checkbox_label{
  position: absolute;
  left: 5px;
  top:40%;
  font-weight: bold;
  width: 20px;
}
.sidebar_left{
  padding: 0;
}
/*******************/
/*.wrapper_docs {
  display: flex;
  min-height: 50%;
}

.sidebar_docs {
  transform: translate3d(-300px, 0px, 0px);
  position: absolute;
  width: 25%;
  color: #eee;
  left: 0;
  height: 100%;
  transition: all .3s;
}

.content_docs {
  flex: 1;
  padding: 30px 30px;
  transform: translate3d(0, 0, 0);
  transition: transform .3s;
}

input[data-function*='swipe'] {
  position: absolute;
  opacity: 0;
}

label[data-function*='swipe'] {
  position: absolute;
  top: 30px;
  left: 20px;
  z-index: 1;
  display: block;
  width: 30px;
  height: 30px;
  font: 30px/30px fontawesome;
  text-align: center;
  color: #444;
  cursor: pointer;
  transform: translate3d(0, 0, 0);
  transition: transform .3s;
}

input[data-function*='swipe']:checked ~ label[data-function*='swipe'] {
  transform: translate3d(300px, 0, 0);
}

input[data-function*='swipe']:checked ~ .content_docs {
  transform: translate3d(295px, 0px, 0px);
}

input[data-function*='swipe']:checked ~ .sidebar_docs {
  transform: translate3d(0px, 0px, 0px);
}
input[data-function*='swipe']:checked ~ .sidebar .menu li {
  width: 100%;
}*/
.ellipsis_text{
  width:100%;box-sizing:border-box;overflow:hidden;text-overflow:ellipsis;
  white-space: nowrap;
}
.mosaicBox{
  flex: 0 0 150px;
  max-width: 150px;
  /*min-width: 176px;*/
  margin: 5px;
  border-style: none;
  border-width: 0px;
  padding: 5px;
}

#gridView .e-list-icon{
  height: 50px;
  width: 50px;
  background-size: contain;
  background-position: center;
}
#gridView{
  overflow-x: auto;
  max-height: 600px;
}
.align-items-center2{
  justify-content: flex-start;
}
/***********************************************/

#drawer-left-toggle, #drawer-right-toggle {
  position: absolute;
  opacity: 0;
}

#drawer-left-toggle-label {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  left: 0px;
  height:35px;
  width: 35px;
  display: block;
  background: rgba(255,255,255,.0);
  z-index: 1;
}


#drawer-right-toggle-label {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  right: 0px;
  height:35px;
  width: 35px;
  display: block;
  background: rgba(255,255,255,.0);
  z-index: 1;
}
/* adds our "hamburger" menu icon */

#drawer-left-toggle-label:before {
  content: '';
  display: block;
  position: absolute;
  height: 2px;
  width: 24px;
  background: #8d8d8d;
  left: 13px;
  top: 9px;
  box-shadow: 0 6px 0 #8d8d8d, 0 12px 0 #8d8d8d;
}


#drawer-right-toggle-label:before {
  content: '';
  display: block;
  position: absolute;
  height: 2px;
  width: 24px;
  background: #8d8d8d;
  right: 13px;
  top: 9px;
  box-shadow: 0 6px 0 #8d8d8d, 0 12px 0 #8d8d8d;
}

/* drawer menu pane - note the 0px width */

#drawer_left {
  position: absolute;
  /*top: 0;*/
  left:-340px;
  height: 100%;
  width: 340px;
  /*margin-top: 30px;*/
  -webkit-overflow-scrolling: touch;
  z-index: 9;
}

#drawer_right {
  position: absolute;
  /*top: 0;*/
  right:-340px;
  height: 100%;
  width: 340px;
  /*margin-top: 30px;*/
  -webkit-overflow-scrolling: touch;
  z-index: auto;
}

/* actual page content pane */

#page-content {
  overflow-x: auto;
  margin-left: 0px;
  /*margin-top: 15px;*/
  /*height: calc(100% - 15px);*/
  padding: 0px 15px;
  width: 100%;
}

/* checked styles (menu open state) */

#drawer-left-toggle:checked ~ #drawer-left-toggle-label {
  height: 40px;
  width: 40px;
  /*width: calc(100% - 300px); */
  background: rgba(255,255,255,.8);
}

#drawer-right-toggle:checked ~ #drawer-right-toggle-label {
  height: 40px;
  width: 40px;
  /*width: calc(100% - 300px); */
  background: rgba(255,255,255,.8);
}

#drawer-left-toggle:checked ~ #drawer-left-toggle-label {
  left: 260px;
}

#drawer-right-toggle:checked ~ #drawer-right-toggle-label {
  right: 340px;
}

#menu-maker-id:checked ~ #drawer_left {
  left: 0px;
  box-shadow: 5px 0 5px -5px #333;
  height: 100%;
}

#menu-maker-id2:checked ~ #drawer_right {
  right: 0px;
}

#menu-maker-id:checked ~ #page-content {
  margin-left: 340px;
}

#menu-maker-id2:checked ~ #page-content {
  margin-right: 200px;
}

/* The folder panel needs a background of its own now that it can float over the
   listing. It never had one: the white behind it is the card of the page, and
   over the table the rows would show through the tree. */
#drawer_left {
  background-color: #fff;
}
/* Tablet or narrower: the panel floats over the listing instead of pushing it
   aside, where there is not enough width for both. The panel is already out of
   the flow (position: absolute, further up), so this only has to keep the
   listing from being shifted; and not shifting it means the table no longer
   recalculates its columns every time the panel is opened or closed.
   The width matches TABLET_MAX_WIDTH in the script above, which is what decides
   that the panel starts collapsed here. */
@media (max-width: 993px) {
  #menu-maker-id:checked ~ #page-content {
    margin-left: 0;
  }
}
/****************************/
#my_documents_list > table > thead > tr > th:nth-child(2){
  width: 50px;
  text-align: center !important;
}
#my_documents_list > table > thead > tr > th:nth-child(3){
  width: 40%;
}
#my_documents_list > table > thead > tr > th:nth-child(4){
  width: 30%;
}

/*#listView .table tbody td:first-child, #listView .table thead th:first-child{
  padding-left: 5px;
}*/
#listView > table > thead > tr > th:nth-child(2){
  width: 50px;
  text-align: center !important;
}
/* Column of the icons of the row (comments, linked request). It is as narrow as
   the two icons it can hold, and it is there whether the row has icons or not:
   the point of giving them a column is that the name always starts at the same
   place, so an empty cell is the normal case and not a hole to be closed. */
#listView > table > thead > tr > th.cd-row-icons,
#listView > table > tbody > tr > td.cd-row-icons{
  width: 56px;
  min-width: 56px;
  white-space: nowrap;
  /* Against the left edge of the column, and with no padding of its own to keep
     them there: the icons speak of the file of the row, so they are read next
     to it and not adrift in the middle of a column. */
  text-align: left;
  padding-left: 0;
  /* The rest of the cells of the row are aligned to the top (Bootstrap), which
     is where their text starts; here there is a pair of icons and no text, so
     they are lined up with the icon of the file beside them instead. */
  vertical-align: middle;
}
/* The icons are the only thing that gets clicked in the cell, so they are given
   room around them instead of being hit at the size of the glyph. */
#listView > table > tbody > tr > td.cd-row-icons > i{
  font-size: 14px;
  padding: 4px 2px;
  cursor: pointer;
}
#listView > table > thead > tr > th:nth-child(4){
  width: 50%;
}

#listView > table > tbody > tr > td:nth-child(4){
  width: 100%;
}
/* "Modificado" and "Modificado por" get a room of their own, fixed, instead of
   the width of whatever they happen to hold: the timestamp always has the same
   length, the name of the person does not, and letting the longest name of the
   page decide the column made it -- and the name column beside it -- change
   width every time the listing changed. The width of both is a constant now,
   and the name of the person is cut with an ellipsis when it does not fit; the
   whole value stays reachable in the tooltip of the cell.
   The name column keeps asking for the whole width of the table (the rule right
   above), so it is the one that absorbs what is left over.
   Picked by class and not by position: these were nth-child(5) and (6), and the
   size column took over both numbers the moment it was added -- the widths moved
   onto the columns beside them and the name of the person went back to wrapping
   into two lines. The class travels with the column (the header writes it from
   the "columns" list), so it survives the next one too. */
#listView > table > thead > tr > th.cd-col-size,
#listView > table > tbody > tr > td.cd-col-size{
  width: 110px;
  min-width: 110px;
  white-space: nowrap;
}
#listView > table > thead > tr > th.cd-col-updated_at,
#listView > table > tbody > tr > td.cd-col-updated_at{
  width: 190px;
  min-width: 190px;
  white-space: nowrap;
}
#listView > table > thead > tr > th.cd-col-user,
#listView > table > tbody > tr > td.cd-col-user{
  width: 230px;
  min-width: 230px;
  white-space: nowrap;
}
/* The ellipsis needs a block allowed to be narrower than its own text: the cell
   cannot be, so the wrapper inside it does the cutting. */
#listView > table > tbody > tr > td.cd-col-user > div{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#listView{max-height: 200px}
/*****************************/
/*table.glyphicon-hover .file_actions {
  visibility: hidden;
}
table.glyphicon-hover td:hover .file_actions {
  visibility: visible;
}*/
.file_buttons{
  padding: 0;
  text-align: right;
  list-style: none; margin:0;
  display: inline-flex;
}
.file_buttons li button{
  /*margin-left: 10px;*/
  width: 100%;
  text-align: left;
  border: none;

}
#page-content .dropdown-toggle::after{display: none}
.file_actions{
  float: right;
  position: relative;
  background-color: #fff;
}
.file_actions button
{
  border: none;
  background: none;
}
.file_actions .dropdown-toggle
{
  border: none;
  background: none;
  padding: 0;
}
.table-responsive{overflow-x: hidden}
.file_buttons li button{
  /*margin-left: 5px;*/
  padding: 5px 10px;
  background: transparent;
}
.hamburger-toppings i{font-size: 20px !important}
/* The menu of the dropdown has no padding of its own, so the entries used to
   start right against its edges. */
.actions_list{/*display: inline-flex; */list-style: none; padding: 6px; width: 100%}
.actions_list li{width: 100%}
/* Air between entries, which read as a single block of text without it. */
.actions_list li + li{
  margin-top: 2px;
}
/* Entries of the action menus (the three-dot menus of the listing and of the
   command bar). They take the text colour of the command-bar buttons up top, so
   the same command reads the same wherever it is invoked from, and their icons
   share one fixed box: every label then starts at the same place whatever the
   width of the glyph, and the gap keeps it off the icon. */
.actions_list button{
  display: flex;
  align-items: center;
  width: 100%;
  gap: 8px;
  padding: 7px 10px;
  border-radius: 4px;
  /* The template dims every .btn to 0.8, and the command-bar buttons undo it
     too: without this the same colour looks paler here than up there. */
  opacity: 1;
  font-size: 14px;
  text-align: left;
  color: var(--cd-text-body);
  /* One line per entry. The menu is sized to fit its contents, so forbidding
     the wrap is what widens it to the longest label: no width to pick by hand,
     and a longer label later cannot break in two either. */
  white-space: nowrap;
}
/* Same hover as the command-bar buttons: soft green ground and darker green
   text. Both properties have to be declared because .btn-file and .btn-light
   bring their own hover and would otherwise win over the rule above. */
.actions_list button:hover,
.actions_list button:focus{
  color: var(--cd-brand-green-hover);
  background-color: var(--cd-surface-green-soft);
}
.actions_list button i{
  /* Same box for every icon, glyph against its left edge. */
  flex: 0 0 16px;
  text-align: left;
  font-size: 0.95em;
  /* Some of these icons carry mr-1 and others nothing, so the margin is dropped
     here and the whole separation comes from the gap above. Bootstrap's spacing
     utilities are declared !important, hence the one here. */
  margin: 0 !important;
}
.text-secondary{font-size: 15px;}
.circle_share{
  border: 2px solid #cdcdcd;
  width: 10%;
  /* margin: 0 auto; */
  border-radius: 50%;
  padding: 10px;
}
.circle_share:hover{background-color: #f0f0f0}
button.dropdown-toggle{/*padding: 3px 10px*/}
.ellipsis_label{float: left; line-height: 2.5em}
.action_buttons{float: right; position: static}
/* Las pestañas Documentos/Solicitudes del panel (recuadro blanco, subrayado
   verde del template e iconos azules fijos) se estilan ahora en la sección 10
   de variations.scss, con el resto del panel de carpetas. */
#listView .table > thead > tr > th, #exampleFinal > thead > tr > th, #clientsDocs > thead > tr > th{text-transform: none}
/* The menu hangs to the right of its button, with the arrow below pointing back
   at it. The offset follows the width of the button instead of being a fixed
   distance: the arrow is 12px wide and hangs off the left of the menu, so this
   leaves its tip exactly at the right edge of the button. With the fixed 30px
   it used to have, the arrow covered the dots as soon as the icon grew wider
   than the offset. */
#page-content .dropdown-menu{    top: -5px;
  left: calc(100% + 12px); min-width: 220px}
/* Folder of the listing under the pointer while something is being dragged onto it.
   Same reading as the node of the tree in that state: soft green ground with the
   brand ring, because dropping here does something (it moves the item in) and should
   not look like a plain hover. */
tr.cd-row-drop-target > td {
  background-color: var(--cd-surface-green-soft, #f2f8f3) !important;
  box-shadow: inset 0 1px 0 var(--cd-brand-green, #2E9E4F), inset 0 -1px 0 var(--cd-brand-green, #2E9E4F);
}
tr.cd-row-drop-target > td:first-child {
  box-shadow: inset 1px 1px 0 var(--cd-brand-green, #2E9E4F), inset 0 -1px 0 var(--cd-brand-green, #2E9E4F);
}
tr.cd-row-drop-target > td:last-child {
  box-shadow: inset -1px 1px 0 var(--cd-brand-green, #2E9E4F), inset 0 -1px 0 var(--cd-brand-green, #2E9E4F);
}

/* Row menu opened with the right button: it sits at the pointer like any context
   menu instead of staying anchored to the three-dot button. The coordinates are set
   inline by onRowContextMenu; what this rule does is drop the anchoring of the two
   lines above and the little arrow that pointed at the button, which would otherwise
   hang off a menu that is no longer next to it. */
#page-content .dropdown-menu.cd-row-context-menu {
  position: fixed;
  top: 0;
  left: 0;
  margin: 0;
  /* Anchored, the menu was as wide as its options (220px). Fixed positioning drops
     that shrink-to-fit width and the flex row inside stretches into whatever space is
     left to the right of the pointer -- measured, it went from 220px to 1205px on a
     1280px window. max-content sizes it to its own options again, with a cap so a
     long name cannot stretch it either. */
  width: max-content;
  max-width: 420px;
  z-index: 1001;
}
#page-content .dropdown-menu.cd-row-context-menu:before,
#page-content .dropdown-menu.cd-row-context-menu:after {
  display: none;
}
div.action_buttons > .dropdown-toggle{padding: 0px}
#page-content .dropdown-menu:before {
  border-right: 11px solid rgba(0, 0, 0, 0.2);
  border-top: 11px solid rgba(0, 0, 0, 0);
  border-bottom: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  left: -12px !important;
  right: auto !important;
  top: 5px;
}
#page-content .dropdown-menu:after {
  border-right: 11px solid #FFFFFF;
  border-top: 11px solid rgba(0, 0, 0, 0);
  border-bottom: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  left: -11px !important;
  right: auto !important;
  top: 5px;
}
/* On the last rows of the listing there is no room left below the button, and
   the menu came up cut off by the bottom edge of the pane, which scrolls.
   BaseDropdown measures that room when the menu opens and marks the ones that
   have to open upwards: those hang from the bottom of the button instead of
   from its top, with the arrow moved down so it keeps pointing back at it. */
#page-content .dropdown-up .dropdown-menu{
  top: auto;
  bottom: -5px;
}
#page-content .dropdown-up .dropdown-menu:before,
#page-content .dropdown-up .dropdown-menu:after{
  top: auto;
  bottom: 5px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 47px;
  height: 27px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: rgb(73, 130, 5);
}

input:focus + .slider {
  box-shadow: 0 0 1px #101010;
}

input:checked + .slider:before {
  -webkit-transform: translateX(20px);
  -ms-transform: translateX(20px);
  transform: translateX(20px);
}

.slider.round {
  border-radius: 40px;
}

.slider.round:before {
  border-radius: 50%;
}
/* A selected row is marked by tinting the whole row soft green, instead of the
   green bar that used to sit on the right edge of its last cell. The tint is
   the same surface green as the active Lista/Mosaico button, so both selected
   states read as one colour. The hover selector is listed as well so the
   .table-hover shade does not darken the tint while the pointer is over the
   row. */
.table > tbody > tr.active,
.table.table-hover > tbody > tr.active:hover{
  background-color: var(--cd-surface-green-soft);
}
.table > tbody > tr.active > td{
  color: #0e0e0e;
  font-weight: bold;
}
.no_opacity{
  opacity: 0;
}
opacity{
  opacity: 1;
}
.no_active_row{
  color: #999;
}
/*.checkbox_label{
  display: none;
}*/
.mosaicBox:hover{
  background-color: #f0f0f0;
}
.checkbox__input:checked + .mosaicBox{
  color: red;
}
thead .checkbox_label {
  position: absolute !important;
  top: 13px !important;
  left: 10px !important;
}
.btn_inline{
  white-space: nowrap;
  text-align: center;
}
/*********************************/
.front_folder {
  display: block;
  position: absolute;
  left: -3px;
  right: -3px;
  bottom: -4px;
}
.back_folder {
  display: block;
  position: absolute;
  left: -3px;
  right: -3px;
  bottom: -4px;
}
/* Los estilos de los $dialog.alert/confirm viven ahora en la sección 8 de
   variations.scss (.cd-dialog), que los aplica a toda la app. Las reglas que
   había aquí quedaban por debajo en especificidad, salvo el margin-top, que
   descuadraba el padding superior del cuerpo. */
/*
input:checked{
  height: 50px;
  width: 50px;
}*/
</style>
<style>
/*#dropzone .dz-preview {
  display: flex;
}
#dropzone .dz-preview .dz-image {
  padding: 10px;
  width: 25% !important;
}

#dropzone .dz-preview .dz-details {
  padding: 10px 0;
}
#dropzone .dz-error-message{
  display: none;
}*/
/*#dropzone .dz-remove:before {
  content: "\f013";
  font-family: "Font Awesome 5 Free";
  font-style: normal;
  font-variant-caps: normal;
  font-variant-ligatures: normal;
  font-weight: 900;
  height: 16px;
  line-height: 16px;
  text-rendering: auto;
  width: 16px;
  -webkit-font-smoothing: antialiased;
}*/
#dropzone {
  letter-spacing: 0.2px;
  color: #777;
  transition: background-color .2s linear;
  height: 200px;
  padding: 5px;
}

#dropzone .dz-preview {
  width: 100%;
  min-height: 50px;
  display: inline-block;
  border-bottom:1px solid #cdcdcd;
  padding: 2px 5px;
  margin: 0;
  box-shadow: 0 4px 2px -2px gray;
  background-color: white;
}
#dropzone .dz-preview .dz-image {
  width: 50px;
  height: 50px;
  margin: 0 10px;
  float: left;
}
#dropzone .dz-preview .dz-image > div {
  width: inherit;
  height: inherit;
  border-radius: 50%;
  background-size: contain;
}
#dropzone .dz-preview .dz-image > img {
  width: 100%;
}

#dropzone .dz-preview .dz-details {
  transition: opacity .2s linear;
  text-align: left;
  float: left;
  padding: 0 !important;
  opacity: 1;
  min-width: auto;
  position: relative;
  line-height: inherit;
  background-color: transparent;
  color: #999;
}
#dropzone .dz-success-mark, .dz-error-mark{
  /*display: none;*/
  position: absolute;
  top: 4px !important;
  right: 0;
  padding: 0px;
  width: 20% !important;
  margin-right: 20px;
}
#dropzone .dz-error-message{
  float: right;
  font-size: x-small;
  top: 50px !important;
}
/*#dropzone .dz-remove {
  content: '';
  display: block;
  text-decoration:none;
  background-image: url("https://www.pngfind.com/pngs/m/47-471196_icon-trash-png-font-awesome-trash-o-transparent.png");
  background-repeat: no-repeat;
}*/
#dropzone .dz-filename {
  width:215px;
  margin:0 auto;
  /*border:solid 1px #d4d4d4;
  padding:10px;*/
  overflow:hidden;
  text-overflow:ellipsis;
  overflow:hidden;
  white-space:nowrap;
}
.dropzone .dz-preview .dz-details .dz-size {
  margin-bottom: 0;
}

#dropzone .dz-preview .dz-remove:before {
  content: "\f1f8";
  font-family: "FontAwesome";
  font-size: 20px;
}
#dropzone .dz-preview .dz-remove:hover {
  text-decoration: none;
}
.dropzone .dz-preview .dz-remove{
  opacity: 1 !important;
  color: #999 !important;
  position: relative !important;
  border: none !important;
  bottom: 0 !important;
  font-size: 0 !important;
  padding: 0 !important;
  letter-spacing:normal !important;
}
.dropzone .dz-preview .dz-remove:after{
  content: " ";
}
.dropzone .dz-preview .dz-success-mark svg, .dropzone .dz-preview .dz-error-mark svg {
  display: block;
  width: 20px;
  height: 25px;
}
.dropzone .dz-preview .dz-success-mark svg path {
  fill: #5cb85c;
}
.dropzone .dz-preview .dz-error-mark svg  path {
  fill: #dc3545;
}
.dropzone .dz-preview .dz-progress
{
  left: 60% !important;
  top: 20% !important;
  border-radius: 4px;
}

.dropzone .dz-preview .dz-progress {
  background: linear-gradient(-45deg, #ccc, #73a373, #30af30, #5cb85c);
}
.dropzone .dz-preview .dz-progress .dz-upload {
  background: #5cb85c;
}

/* smartphones, touch screens */
@media (hover: none) {
  /*body {
    background-color: lightblue;
  }*/
}

@media (max-height: 880px) {
  /*body {
    background-color: #5cb85c;
  }*/
}
@media (max-width: 40em) {
  #searchForm{width: 100%}
  #searchForm input{width: 100%}
}

/*****marquee**********/
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: Arial, Helvetica, sans-serif;
}
.breadcrumbs li {
  display: inline-block;
}
button {
  padding: 1px 3px;
  border: none;
  border-radius: 0px;
}
#breadcrumbs {padding-left: 0; margin-bottom: 0}
#table_show{list-style: none; padding: 0}
#exampleFinal > thead > tr > th:nth-child(2), #clientsDocs > thead > tr > th:nth-child(2){
  width: 50px;
  text-align: center !important;
}

#clientsDocs > tbody > tr> td:nth-child(1){
  width: 5%;
  padding: 0;
  padding-left: 10px;
}

#clientsDocs > tbody > tr > td:nth-child(2){
  padding: 0;
}
#clientsDocs > tbody > tr > td:nth-child(3){
  width: 30%;
}
#clientsDocs > tbody > tr > td:nth-child(5){
  width: 12%;
}
#clientsDocs > tbody > tr > td:nth-child(6){
  width: 15%;
}

.users_share{
  /*background: #fff;
  border-radius:5px;
  box-shadow: 0 2px 3px 0 rgba(0,0,0,.1);*/
}

.users_share input[type=checkbox] {
  cursor: pointer;
  height: 20px;
  margin:4px 0 0;
  position: absolute;
  opacity: 0;
  width: 20px;
  z-index: 2;
}

.users_share input[type=checkbox] + span {
  background: #e74c3c;
  border-radius: 50%;
  box-shadow: 0 2px 3px 0 rgba(0,0,0,.1);
  display: inline-block;
  height: 20px;
  margin:8px 0 0;
  position:relative;
  width: 20px;
  transition: all .2s ease;
}

.users_share input[type=checkbox] + span::before,.users_share input[type=checkbox] + span::after{
  background:#fff;
  content:'';
  display:block;
  position:absolute;
  width:4px;
  transition: all .2s ease;
}

.users_share input[type=checkbox] + span::before{
  height:12px;
  left:8px;
  top:4px;
  -webkit-transform:rotate(-45deg);
  transform:rotate(-45deg);
}

.users_share input[type=checkbox] + span::after{
  height:12px;
  right:8px;
  top:4px;
  -webkit-transform:rotate(45deg);
  transform:rotate(45deg);
}

.users_share input[type=checkbox]:checked + span {
  background:#2ecc71;
}

.users_share input[type=checkbox]:checked + span::before{
  height: 9px;
  left: 5px;
  top: 8px;
  -webkit-transform:rotate(-47deg);
  transform:rotate(-47deg);
}

.users_share input[type=checkbox]:checked + span::after{
  height: 13px;
  right: 6px;
  top: 5px;
}

.users_share input[type=submit] {
  background-color: #2ecc71;
  border: 0;
  border-radius: 4px;
  color: #FFF;
  cursor: pointer;
  display: inline-block;
  font-size:16px;
  text-align: center;
  padding: 12px 20px 14px;
}
/******************************/
.users_folder_list{
  background: #fff;
  border-radius:5px;
  box-shadow: 0 2px 3px 0 rgba(0,0,0,.1);
}

.users_folder_list td{
  border-bottom:1px solid #f6f6f6;
  padding:5px 10px;
}

.users_folder_list td:nth-child(2){
  text-align: right;
  width: 40px;
}

/*.users_folder_list tr:last-child td{
  border:none;
  padding:30px 10px 10px;
  text-align: center;
}*/

.users_folder_list input[type=checkbox] {
  cursor: pointer;
  height: 30px;
  margin:4px 0 0;
  position: absolute;
  opacity: 0;
  width: 30px;
  z-index: 2;
}

.users_folder_list input[type=checkbox] + span {
  background: #e74c3c;
  border-radius: 50%;
  box-shadow: 0 2px 3px 0 rgba(0,0,0,.1);
  display: inline-block;
  height: 24px;
  margin:4px 0 0;
  position:relative;
  width: 24px;
  transition: all .2s ease;
}

.users_folder_list input[type=checkbox] + span::before,.users_folder_list input[type=checkbox] + span::after{
  background:#fff;
  content:'';
  display:block;
  position:absolute;
  width:4px;
  transition: all .2s ease;
}

.users_folder_list input[type=checkbox] + span::before{
  height:12px;
  left:10px;
  top:6px;
  -webkit-transform:rotate(-45deg);
  transform:rotate(-45deg);
}

.users_folder_list input[type=checkbox] + span::after{
  height:12px;
  right:10px;
  top:6px;
  -webkit-transform:rotate(45deg);
  transform:rotate(45deg);
}

.users_folder_list input[type=checkbox]:checked + span {
  background:#2ecc71;
}

.users_folder_list input[type=checkbox]:checked + span::before{
  height: 9px;
  left: 7px;
  top: 10px;
  -webkit-transform:rotate(-47deg);
  transform:rotate(-47deg);
}

.users_folder_list input[type=checkbox]:checked + span::after{
  height: 14px;
  right: 8px;
  top: 6px;
}

.users_folder_list input[type=submit] {
  background-color: #2ecc71;
  border: 0;
  border-radius: 4px;
  color: #FFF;
  cursor: pointer;
  display: inline-block;
  font-size:16px;
  text-align: center;
  padding: 12px 20px 14px;
}
.users_folder_list tr label{
  font-size: 10px;
  width: auto;
}
.users_folder_list tr{
  width: 50%;
  float: left;
}
.users_folder_list tr > td > label > div{
  float: right;
}
.italic_{font-size: 10px; font-style: italic}
input[type="checkbox"]:checked+label{ font-weight: bold; }

.check_noti input[type="checkbox"]:before {
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  content: "\f096";
  opacity: 1 !important;
  margin-top: -25px;
  appearance: none;
  background: #fff;
}

.check_noti input[type="checkbox"]:checked:before {
  content: "\f046";
}

.check_noti input[type="checkbox"] {
  font-size: 22px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
.checkStep ul,
.checkStep li {
  /*padding: 0;*/
  margin: 0;
  list-style: none;
}

.checkStep li:before {
  content: '\f019';
  font-family: 'FontAwesome';
  /*float: left;*/
  margin-left: -1.5em;
  color: #0074D9;
}

.checkStep li:has(> span[title="Descargado"]):before {
  content: '\f019';
  font-family: 'FontAwesome';
  /*float: left;*/
  margin-left: -1.5em;
  color: #6c757d ;
}

.checkStep li:has(> span[title="Movido"]):before {
  content: "\f56e";
  font-family: "Font Awesome 5 Free";
  /*float: left;*/
  margin-left: -1.5em;
  color: #6c757d ;
  font-weight: 900;
  box-sizing: border-box;
}

.checkStep li:has(> span[title="Copiado"]):before {
  content: "\f0c5";
  font-family: "Font Awesome 5 Free";
  /*float: left;*/
  margin-left: -1.5em;
  color: #6c757d ;
  font-weight: 900;
  box-sizing: border-box;
}
.checkStep li:has(> span[title="Compartido"]):before {
  content: "\f064";
  font-family: "Font Awesome 5 Free";
  /*float: left;*/
  margin-left: -1.5em;
  color: #6c757d ;
  font-weight: 900;
  box-sizing: border-box;
}

.checkStep li:has(> span[title="Renombrado"]):before {
  content: "\f044";
  font-family: "Font Awesome 5 Free";
  /*float: left;*/
  margin-left: -1.5em;
  color: #6c757d ;
  font-weight: 900;
  box-sizing: border-box;
}
/**********************************/
.flexy {
  display: block;
  width: 100%;
  border: 1px solid #eee;
  max-height: 320px;
  overflow: auto;
}

.flexy thead {
  display: -webkit-flex;
  -webkit-flex-flow: row;
}

.flexy thead tr {
  padding-right: 15px;
  display: -webkit-flex;
  width: 100%;
  -webkit-align-items: stretch;
}

.flexy tbody {
  display: table-cell;
  max-height: 120px;
  overflow: auto;
  -webkit-flex-flow: row wrap;
}
.flexy tbody tr{
  display: -webkit-flex;
  width: 50%;
  float:left;
}

.flexy tr td {
  width: 100%;
}

</style>
<style>
#treeview .e-list-text{ text-transform: none !important; }
#emailComments ul {
  list-style: none;
  width: 300px;
}

#emailComments li {
  border-left: 1px solid #000;
  margin: 0px 0px 10px 0px;
  padding: 0px 0px 0px 5px;
}
.modal-body {
  max-height: 500px;
  overflow-y: auto;
}

</style>
<style scoped>
#listView > .table tr[draggable="true"] {
  cursor: grab;
  user-select: none;
}
#listView > .table tr[draggable="true"]:active {
  cursor: grabbing;
}
/* The row stays in the listing while it is dragged, so it is faded to tell the copy
   under the pointer from the original. */
#listView > .table tr.cd-row-dragging {
  opacity: 0.45;
}

/* Ocultar completamente los radios */
.btn-check {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

/* Opcional: mejorar la separación entre botones */
.btn-group .btn {
  margin-right: 5px;
}

/* El último sin margen extra */
.btn-group .btn:last-child {
  margin-right: 0;
}

.badge{position: absolute;right: auto; left:55%; border-radius: 50%; border: 1px solid #cdcdcd}
.badge[id*='badge_list_'] {
  position: relative;/*left: 30px; top:-40px; */border-radius: 50%; border: 1px solid #cdcdcd;left: auto;
  right: 7px;
}

/* The name is in flow again so that the tags below it have something to clear:
   out of flow it left the cell empty and they would have been drawn over it. It
   keeps the band it had -- it floats left (.ellipsis_label), with the room of
   the menu of the row reserved at its right (#listView .ellipsis). */
#listView .first_td {
  position: relative;
}

/* The three-dot menu of the row is centred against the whole cell, not against
   the first line of it. Floating right it sat on the line of the name, so on a
   row carrying tags -- which open a second line underneath -- it was left stuck
   to the top edge while the row had grown twice as tall. Out of flow it takes
   no room, which costs nothing here: the band of the name already reserves the
   40px of the button (#listView .ellipsis) whether the button is on screen or
   not. The inset is the cell padding of Bootstrap ($table-cell-padding,
   .75rem), because an absolute box is placed against the padding edge of the
   cell and the float was placed against its content edge.
   The centring is done by stretching the box to the height of the cell and
   centring the button inside it, and not with a translate: a transform opens a
   stacking context, and the menu of the row -- which hangs from this button and
   has to be drawn over the columns beside it -- was trapped inside it and came
   out underneath their text. Stretched, the box covers the cell, so it lets the
   clicks of the name and of the row through and keeps only the ones that land
   on the button. */
#listView > table > tbody > tr > td:nth-child(4) {
  position: relative;
}
#listView > table > tbody > tr > td:nth-child(4) > .action_buttons {
  float: none;
  position: absolute;
  top: 0;
  bottom: 0;
  right: .75rem;
  display: flex;
  align-items: center;
  pointer-events: none;
}
#listView > table > tbody > tr > td:nth-child(4) > .action_buttons > * {
  pointer-events: auto;
}

/* The tags of the row are read on a second line, under the name. Floating over
   the middle of the cell they were cut off by the columns beside them and read
   as a column of their own, instead of as something that belongs to the file;
   in flow they open the row only for the rows that carry tags. */
.badge_tag {
  clear: both;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  /* Nothing in here is clicked, and what is underneath is: the cell marks the
     row and the row is dragged from anywhere. */
  pointer-events: none;
}

/* Smaller than the name they hang from, and nothing like the round counter of
   files of a folder that .badge is written for right above. */
.badge_tag > .badge {
  position: static !important;
  left: auto !important;
  right: auto !important;
  transform: none !important;

  border-radius: 3px !important;
  font-size: 8px !important;
  line-height: 1.5;
  border: none !important;
  padding: 1px 5px;
}
.badge-yellow{
  background: yellow;
}

</style>
<style scoped>
.storage-info {
  padding: 10px;
  background: transparent;
}

.progress {
  height: 25px;
}

.progress-bar {
  transition: width 0.6s ease;
  font-weight: bold;
}
.badge_custom{
  position: unset;
  border-radius: 0px;
  border: none;
  background-color: transparent !important;
}

.icon-stack {
  position: relative;
  width: 50px;                 /* Ajusta según tu TD */
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;         /* Centrar icono principal */
}

.main-icon {
  font-size: 30px;
}

.floating-icons {
  position: absolute;
  bottom: 0;                   /* Esquina inferior */
  right: 0;                    /* Esquina derecha */
  display: grid;
  gap: 4px;                    /* separación entre los iconos */
}

.floating-icons i {
  font-size: 14px;             /* más pequeños */
}

.badge-danger{
  background-color:#E44F4E;
}
.badge-warning{
  background-color:#FEBF00;
}
.badge-success{
  background-color:#B2C54A;
}
.badge-yellow{
  background-color:#fcfc67;
}
.container_{width: 100% !important}
</style>
<style scoped>

.floating-icons > i{
  cursor:pointer;
}


/* Pinned folders of the tree: a short stacked list of chips in the greens of the
   app, one per folder, each with its own cross. The block stays on top while the
   panel scrolls, so the shortcuts are always at hand. */
.cd-pinned-folders {
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 10px;
  padding-bottom: 6px;
  background-color: #fff;
}
.cd-pinned-folders__title {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0 0 2px;
  color: var(--cd-text-muted, #8a8f9c);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}
.cd-pinned-folders__title .fa-thumbtack {
  color: var(--cd-brand-green, #2E9E4F);
}
.cd-pinned-folder {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 6px 5px 10px;
  border: 1px solid var(--cd-border-green-soft, #cfe8d7);
  border-radius: 8px;
  background-color: var(--cd-surface-green-soft, #f2f8f3);
}
/* The chip is a button now: no chrome of its own, it just takes the room left by
   the cross so the whole strip is clickable. */
.cd-pinned-folder__go {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  gap: 8px;
  min-width: 0;
  padding: 0;
  border: 0;
  background: transparent;
  text-align: left;
  cursor: pointer;
}
.cd-pinned-folder__go:hover .cd-pinned-folder__text,
.cd-pinned-folder__go:focus .cd-pinned-folder__text {
  color: var(--cd-brand-green-hover, #24803f);
  text-decoration: underline;
}
.cd-pinned-folder__go:focus {
  outline: none;
}
.cd-pinned-folder__pin {
  flex: 0 0 auto;
  color: var(--cd-brand-green, #2E9E4F);
  font-size: 12px;
}
/* A long name is cut with an ellipsis rather than wrapping the chip; the full one
   is in the title of the button. */
.cd-pinned-folder__text {
  min-width: 0;
  overflow: hidden;
  color: var(--cd-text-body, #4a4f5a);
  font-size: 12px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* Quiet until hover, like the other bare icon buttons of the explorer. */
.cd-pinned-folder__unpin {
  flex: 0 0 auto;
  margin-left: auto;
  padding: 2px 5px;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: var(--cd-text-muted, #8a8f9c);
  font-size: 12px;
  line-height: 1;
  cursor: pointer;
}
.cd-pinned-folder__unpin:hover,
.cd-pinned-folder__unpin:focus {
  background-color: #fff;
  color: var(--cd-brand-green-hover, #24803f);
  outline: none;
}

.file-drop-tree {
  position: relative;
}

.file-drop-tree {
  min-height: 200px;
}

</style>

<style>

.control_wrapper {
  display: block;
  /*max-width: 400px;
  max-height: 350px;*/
  margin: auto;
  overflow: auto;
  /* Sin marco propio: el árbol ya vive dentro del panel, que tiene su propia
     línea a la derecha (ver sección 10 de variations.scss). */
  min-height: 100%;
}

#display {
  max-width: 500px;
  margin: auto;
  padding: 10px;
}

#app {
  width: 350px;
  margin: 0 auto;
}

.details {
  padding-left: 10px;
}

/*apply custom css to first level
.mytree .e-level-1>.e-text-content .e-list-text {
  font-style: italic;
}

.mytree .e-level-2>.e-text-content .e-list-text {
  color: darkmagenta;
}

.mytree .e-level-3>.e-text-content .e-list-text {
  font-weight: bold;
}*/

.badge-info2{
  background-color: #60abc1;
}

.badge-success2{
  background-color: #B2C54A;
}

.badge-yellow{
  background-color: #fcfc67;
}
.badge-warning{
  background-color: #FEBF00;
}
.badge-grey{
  background-color: #878686;
}
</style>
